import plugin$1 from '@spoketree-core-ui/plugin';
import { makeStore } from '@spoketree-core-ui/store';
import React, { useState, useEffect, createContext, useRef, useContext, useCallback, useReducer } from 'react';
import { styled, useTheme as useTheme$1, createTheme, adaptV4Theme, responsiveFontSizes } from '@mui/material/styles';
import { useTheme, Popover, Avatar, Typography, Button, Divider, ClickAwayListener, useScrollTrigger, useMediaQuery, AppBar, Toolbar, IconButton, Link, Drawer, List, Box as Box$1, InputBase as InputBase$1, Grid as Grid$1, Paper, Card, CardContent, Stack as Stack$2, CardActions, CardActionArea, FormControlLabel, Checkbox, ListItem as ListItem$1, ListItemButton, ListItemIcon as ListItemIcon$1, ListItemText as ListItemText$1, CardMedia as CardMedia$1, Chip, Switch, Snackbar as Snackbar$1, Alert as Alert$4, ListItemAvatar as ListItemAvatar$1, ToggleButtonGroup, ToggleButton, StyledEngineProvider, ThemeProvider, CssBaseline } from '@mui/material';
import assert from 'assert';
import { useLocation, useNavigate, Routes, Route, Navigate, useParams } from 'react-router-dom';
import * as Icons from '@mui/icons-material';
import { FaceOutlined, Menu, AccountCircleOutlined, CloseOutlined, Search, Send } from '@mui/icons-material';
import lodash from 'lodash';
import { makeAPI } from '@spoketree-core-lib/api';
import '@mui/icons-material/Storefront';
import SettingsIcon from '@mui/icons-material/Settings';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography$1 from '@mui/material/Typography';
import useMediaQuery$1 from '@mui/material/useMediaQuery';
import { blue, red, grey } from '@mui/material/colors';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ReportIcon from '@mui/icons-material/Summarize';
import '@mui/icons-material/Grid3x3';
import '@mui/icons-material/MailOutline';
import PersonIcon from '@mui/icons-material/Person';
import '@mui/icons-material/Lock';
import '@mui/icons-material/VpnKey';
import Box from '@mui/material/Box';
import Button$1 from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton$1 from '@mui/material/IconButton';
import Link$1 from '@mui/material/Link';
import EditIcon from '@mui/icons-material/Edit';
import MuiAlert from '@mui/material/Alert';
import ClickAwayListener$1 from '@mui/material/ClickAwayListener';
import InputBase from '@mui/material/InputBase';
import '@mui/material/TextField';
import '@mui/material/TextareaAutosize';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css';
import '@mui/material/AppBar';
import CardMedia from '@mui/material/CardMedia';
import Container from '@mui/material/Container';
import DialogContentText from '@mui/material/DialogContentText';
import '@mui/material/Toolbar';
import '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import { createApi } from 'unsplash-js';
import { Storage, API } from 'aws-amplify';
import { customAlphabet } from 'nanoid';
import Stack$1 from '@mui/material/Stack';
import CodeIcon from '@mui/icons-material/Code';
import RemoveIcon from '@mui/icons-material/Delete';
import { Container as Container$1, Draggable } from 'react-smooth-dnd';
import { arrayMoveImmutable } from 'array-move';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import List$1 from '@mui/material/List';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Select from '@mui/material/Select';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import '@mui/icons-material/Add';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import '@mui/icons-material/Spoke';
import TitleIcon from '@mui/icons-material/SettingsInputSvideo';
import Fab from '@mui/material/Fab';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import '@mui/icons-material/Share';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Avatar$1 from '@mui/material/Avatar';
import CardHeader from '@mui/material/CardHeader';
import '@mui/icons-material/ArrowBack';
import ExtensionsIcon from '@mui/icons-material/Extension';
import '@mui/icons-material/Widgets';
import RefreshIcon from '@mui/icons-material/Refresh';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Badge from '@mui/material/Badge';
import Chip$1 from '@mui/material/Chip';
import Divider$1 from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Menu$1 from '@mui/material/Menu';
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper$1 from '@mui/material/Paper';
import MenuIcon from '@mui/icons-material/MoreHoriz';
import SendIcon from '@mui/icons-material/Send';
import ViewIcon from '@mui/icons-material/OpenInNew';
import Pagination from '@mui/material/Pagination';
import '@mui/icons-material/NoteAdd';
import FileIcon from '@mui/icons-material/InsertDriveFile';
import { useDropzone } from 'react-dropzone';
import clipboardCopy from 'clipboard-copy';
import TableIcon from '@mui/icons-material/TableRows';
import ListIcon from '@mui/icons-material/FormatListBulleted';
import TableFooter from '@mui/material/TableFooter';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import '@mui/icons-material/HighlightOff';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import '@spoketree-core-ui/Copyright';
import BottomNavigation from '@mui/material/BottomNavigation';
import '@mui/material/BottomNavigationAction';
import FeatureIcon from '@mui/icons-material/Hub';
import ScenariosIcon from '@mui/icons-material/AccountTree';
import ReportsIcon from '@mui/icons-material/ViewList';
import SharingIcon from '@mui/icons-material/People';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var store$2 = makeStore();
var Context$l = store$2.Context;
var Provider$l = store$2.Provider;
var Consumer$f = store$2.Consumer;
var SpoketreeAuthStore = {
  Context: Context$l,
  Provider: Provider$l,
  Consumer: Consumer$f
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var store$1 = makeStore();
var Context$k = store$1.Context;
var Provider$k = store$1.Provider;
var Consumer$e = store$1.Consumer;
var SpoketreeSolutionStore = {
  Context: Context$k,
  Provider: Provider$k,
  Consumer: Consumer$e
};

/*
 *   Copyright (c) 2021 Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var store = makeStore();
var Provider$j = function Provider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  var defaultValue = {
    adjective: "efficient"
  };
  var providedValue = value ? value : defaultValue;
  return /*#__PURE__*/React.createElement(store.Provider, {
    value: providedValue
  }, children);
};
var Context$j = store.Context;
var Consumer$d = store.Consumer;
var PluginOptionsStore = {
  Context: Context$j,
  Provider: Provider$j,
  Consumer: Consumer$d
};

var useQueryParam = function useQueryParam(key, _default) {
  assert(key);
  var _useLocation = useLocation(),
    search = _useLocation.search;
  var _useState = useState(_default),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    if (search) {
      var v = querystring$7(key, search);
      setValue(v ? v : _default);
    } else {
      setValue(_default);
    }
  }, [search, setValue]);
  return value;
};

/*
const useQueryParam = (key, _default) => {
  assert(key);
  const windowLocation = useWindowLocation();
  const [ value, setValue ] = useState(undefined);

  useEffect(() => {
    console.log('qpqpqpqpqpqp');
    console.log('----');
    console.log(key);
    if (windowLocation) {
      console.log(windowLocation.href);
      const v = querystring(key, windowLocation.href);
      console.log(v);
      setValue(v ? v : _default);
    }
    console.log('----');
  }, [windowLocation, setValue]);

  return value;
};
*/

function querystring$7(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var Context$i = /*#__PURE__*/createContext(null);
var Provider$i = function Provider(_ref) {
  var children = _ref.children;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isListsDrawerOpen = _useState2[0],
    setListsDrawerOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNavBarOpen = _useState4[0],
    setNavBarOpen = _useState4[1];
  var _useState5 = useState("jobs-item-view"),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedJobsViewId = _useState6[0],
    setSelectedJobsViewId = _useState6[1];
  var q = useQueryParam('q', '');
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    searchTerm = _useState8[0],
    setSearchTerm = _useState8[1];
  useEffect(function (_) {
    (function (_) {
      if (q) {
        setSearchTerm(q);
      }
    })();
  }, [q]);
  var querystringmode = querystring$6("mode", window.location.href);
  var _useState9 = useState(querystringmode ? querystringmode : "view"),
    _useState10 = _slicedToArray(_useState9, 2),
    mode = _useState10[0],
    _setMode = _useState10[1];

  /*
  const [ url, setUrl ] = useState(window.location.href);
  useEffect(_ => {
    (_ => {
      if (url) {
        const mode = querystring("mode", url);
        setMode(mode ? mode : "view")
      }
    })();
  }, [ url ]);
  */
  var value = {
    isListsDrawerOpen: isListsDrawerOpen,
    isNavBarOpen: isNavBarOpen,
    toggleNavBar: function toggleNavBar() {
      return setNavBarOpen(!isNavBarOpen);
    },
    toggleListsDrawer: function toggleListsDrawer() {
      return setListsDrawerOpen(!isListsDrawerOpen);
    },
    selectedJobsViewId: selectedJobsViewId,
    setSelectedJobsViewId: setSelectedJobsViewId,
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm,
    mode: mode,
    setMode: function setMode(mode) {
      return _setMode(mode ? mode : 'view');
    }
  };
  return /*#__PURE__*/React.createElement(Context$i.Provider, {
    value: value
  }, children);
};
var Consumer$c = Context$i.Consumer;
var UISessionStore = {
  Provider: Provider$i,
  Consumer: Consumer$c,
  Context: Context$i
};
function querystring$6(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function makeItemsAPI(_ref) {
  var endpoint = _ref.endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set;
    _ref.keys;
  var itemsResource = function itemsResource(params) {
    return makeAPI(endpoint, "/partitions/".concat(partition, "/scopes/").concat(scope, "/levels/").concat(level, "/sets/").concat(set) + (params !== null && params !== void 0 && params.latest ? "/_latest/".concat(params === null || params === void 0 ? void 0 : params.latest) : ''));
  };
  var itemResource = function itemResource(_ref2) {
    var key = _ref2.key;
    return makeAPI(endpoint, "/partitions/".concat(partition, "/scopes/").concat(scope, "/levels/").concat(level, "/sets/").concat(set, "/keys/").concat(key));
  };
  var getItems = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return itemsResource(params).retrieve();
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getItems(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var postItems = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(items) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return itemsResource().post(items);
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function postItems(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var putItem = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref5) {
      var key, content, previousEventId;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            key = _ref5.key, content = _ref5.content, previousEventId = _ref5.previousEventId;
            _context3.next = 3;
            return itemResource({
              /*scope, level, set,*/key: key
            }).update({
              content: content,
              previousEventId: previousEventId
            });
          case 3:
            return _context3.abrupt("return", _context3.sent);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function putItem(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var deleteItem = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref7) {
      var key, previousEventId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            key = _ref7.key, previousEventId = _ref7.previousEventId;
            _context4.next = 3;
            return itemResource({
              key: key
            }).delete({
              previousEventId: previousEventId
            });
          case 3:
            return _context4.abrupt("return", _context4.sent);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function deleteItem(_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  return {
    getItems: getItems,
    postItems: postItems,
    putItem: putItem,
    deleteItem: deleteItem
  };
}

var wrapItems = function wrapItems(_ref) {
  var endpoint = _ref.endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set,
    keys = _ref.keys,
    items = _ref.items,
    setItems = _ref.setItems;
  if (items.constructor !== Array) {
    var api = makeItemsAPI({
      endpoint: endpoint,
      partition: partition,
      scope: scope,
      level: level,
      set: set
    });
    var _parseItemContent = function _parseItemContent(items, set, key) {
      var _items$;
      return items && items["".concat(set, ":").concat(key)] ? (_items$ = items["".concat(set, ":").concat(key)][0]) === null || _items$ === void 0 ? void 0 : _items$.Version_Content : undefined;
    };
    var _putItem = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(items, scope, level, set, key, content) {
        var existingItem, previousEventId, responseItems;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              existingItem = items["".concat(set, ":").concat(key)];
              previousEventId = existingItem ? existingItem[0].H_SK.split('#')[3] : undefined;
              _context.next = 5;
              return api.putItem({
                scope: scope,
                level: level,
                set: set,
                key: key,
                content: content,
                previousEventId: previousEventId
              });
            case 5:
              responseItems = _context.sent;
              setItems && setItems(_objectSpread2(_objectSpread2({}, items), responseItems));
              _context.next = 14;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.log('_putItem failed');
              console.log(_context.t0);
              throw _context.t0;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      return function _putItem(_x, _x2, _x3, _x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();

    // SETUP parser, mutators and creators
    var parsers = {};
    var mutators = {};
    keys === null || keys === void 0 ? void 0 : keys.forEach(function (key) {
      parsers[key] = function (items) {
        return function () {
          return _parseItemContent(items, set, key);
        };
      };
      mutators[key] = function (items) {
        return /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(content) {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _putItem(items, scope, level, set, key, content);
                case 2:
                  return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x7) {
            return _ref3.apply(this, arguments);
          };
        }();
      };
      /*creators[key] = items => content => {
        const existingItem = items[`${set}:${key}`];
        const previousEventId = existingItem ? existingItem[0].H_SK.split('#')[3] : undefined;
        return {
          scope,
          level,
          set,
          key, 
          content,
          previousEventId
        };
      }*/
    });

    // WRAP items
    return {
      _items: items,
      keys: function keys() {
        return Object.keys(items);
      } /*{
        return wrapped ? Object.entries(wrapped).map(([ key, value ]) => {
        key,
        value[0]?.Version_Content
        }) : [];
        }*/,

      parse: function parse(key) {
        return _parseItemContent(items, set, key);
      },
      //Object.keys(parsers).includes(key) ? parsers[key](items)() : undefined,
      parser: function parser(key) {
        return Object.keys(parsers).includes(key) ? parsers[key](items) : undefined;
      },
      mutate: function mutate() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (args.length === 2) {
          var key = args[0],
            content = args[1];
          _putItem(items, scope, level, set, key, content); //mutators[key](items)(content);
        } else if (args.length === 1 && _typeof(args[0]) === 'object') {
          var __items = Object.entries(args[0]).map(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
              key = _ref5[0],
              content = _ref5[1];
            var existingItem = items["".concat(set, ":").concat(key)];
            var previousEventId = existingItem ? existingItem[0].H_SK.split('#')[3] : undefined;
            return {
              scope: scope,
              level: level,
              set: set,
              key: key,
              content: content,
              previousEventId: previousEventId
            };
          });
          api.postItems(__items);
        } else {
          throw Error('Invalid arg count for mutate');
        }
      },
      mutator: function mutator(key) {
        if (Object.keys(mutators).includes(key)) {
          return mutators[key](items);
        } else {
          throw Error('Mutator not found');
        }
      },
      increment: function increment(key) {
        if (Object.keys(mutators).includes(key)) {
          var parsed = parsers[key](items)();
          var mutator = mutators[key](items);
          mutator(parsed + 1);
        } else {
          throw Error('Mutator not found');
        }
      },
      decrement: function decrement(key, min) {
        if (Object.keys(mutators).includes(key)) {
          var parsed = parsers[key](items)();
          var mutator = mutators[key](items);
          if (min < parsed - 1) {
            mutator(parsed - 1);
          }
        } else {
          throw Error('Mutator not found');
        }
      }
    };
  } else {
    return items;
  }
};

var _defaults$1 = {
  items: {},
  isInitialized: true,
  isRetrieveAttempted: false
};
var useSpoketreeDatabaseAuthItems = function useSpoketreeDatabaseAuthItems(_ref) {
  var _ref$endpoint = _ref.endpoint,
    endpoint = _ref$endpoint === void 0 ? 'spoketree-database-auth' : _ref$endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set,
    keys = _ref.keys,
    latest = _ref.latest,
    isAuthenticated = _ref.isAuthenticated,
    dependencies = _ref.dependencies,
    onInit = _ref.onInit,
    onError = _ref.onError,
    onLoad = _ref.onLoad;
  var api = makeItemsAPI({
    endpoint: endpoint,
    partition: partition,
    scope: scope,
    level: level,
    set: set
  });
  var _useState = useState(_defaults$1.items),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var isInitialized = useRef(_defaults$1.isInitialized);
  var isRetrieveAttempted = useRef(_defaults$1.isRetrieveAttempted);
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!dependencies || lodash.every(dependencies, Boolean))) {
                _context.next = 15;
                break;
              }
              if (!(!isAuthenticated && !isInitialized.current)) {
                _context.next = 8;
                break;
              }
              isInitialized.current = _defaults$1.isInitialized;
              isRetrieveAttempted.current = _defaults$1.isRetrieveAttempted;
              setItems(_defaults$1.items);
              onInit && onInit();
              _context.next = 15;
              break;
            case 8:
              if (!(isAuthenticated && !isRetrieveAttempted.current)) {
                _context.next = 15;
                break;
              }
              isInitialized.current = false;
              isRetrieveAttempted.current = true;
              _context.next = 13;
              return _loadItems();
            case 13:
              _context.next = 15;
              break;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [isAuthenticated].concat(_toConsumableArray(dependencies ? dependencies : [])));
  var _loadItems = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var receivedItems;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log('LOAD_ITEMS');
            _context2.prev = 1;
            _context2.next = 4;
            return api.getItems({
              latest: latest
            });
          case 4:
            receivedItems = _context2.sent;
            console.log('receivedItems');
            console.log(receivedItems);
            setItems(receivedItems);
            // call onLoad for actions that need to occur once when loaded
            // use this hook return value { items } for access to items
            _context2.t0 = onLoad;
            if (!_context2.t0) {
              _context2.next = 12;
              break;
            }
            _context2.next = 12;
            return onLoad(wrapItems({
              endpoint: endpoint,
              partition: partition,
              scope: scope,
              level: level,
              set: set,
              keys: keys,
              items: receivedItems,
              setItems: setItems
            }));
          case 12:
            _context2.next = 21;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t1 = _context2["catch"](1);
            console.log('EFEFEF');
            console.log("Error while retrieving items");
            console.log(_context2.t1);
            setItems(_defaults$1.items);
            onError && onError();
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 14]]);
    }));
    return function _loadItems() {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    items: wrapItems({
      endpoint: endpoint,
      partition: partition,
      scope: scope,
      level: level,
      set: set,
      keys: keys,
      items: items,
      setItems: setItems
    }),
    reloadItems: _loadItems
  };
};

//import { Context as SpoketreePaymentsContext } from './SpoketreePaymentsStore';

var Context$h = /*#__PURE__*/createContext([]);
var Provider$h = function Provider(_ref) {
  var children = _ref.children;
  var partition = '_me';
  var scope = 's_user';
  var set = 'setting';
  var _useContext = useContext(SpoketreeAuthStore.Context),
    authenticationEmail = _useContext.authenticationEmail,
    isAuthenticated = _useContext.isAuthenticated;
  //const { createCustomer } = useContext(SpoketreePaymentsContext);
  //const [ publicSettings, setPublicSettings ] = useState();
  //const [ privateSettings, setPrivateSettings ] = useState([]);

  var _useSpoketreeDatabase = useSpoketreeDatabaseAuthItems({
      partition: partition,
      scope: scope,
      level: 'l_private',
      set: set,
      keys: ['email', 'address_and_location', 'pickup:radius', 'stripe:customer:id', 'telephone'
      //'stripe:payment:intent' TODO: move to StripePaymentIntentStore
      ],

      isAuthenticated: isAuthenticated,
      onLoad: function onLoad(receivedItems) {
        (function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  console.log('receivedItems');
                  console.log(receivedItems);
                  // if the email address has not already been stored
                  if (!(receivedItems.parse && !receivedItems.parse('email'))) {
                    _context.next = 5;
                    break;
                  }
                  _context.next = 5;
                  return receivedItems.mutate('email', authenticationEmail);
                case 5:
                  // https://javascript.plainenglish.io/react-stripe-accept-payment-through-paymentintent-api-and-save-card-details-aa90c55fcdb2
                  // if the stripe customer id has not already been stored
                  if (receivedItems.parse && !receivedItems.parse('stripe:customer:id')) ;
                case 6:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        })()();
      }
    }),
    privateSettings = _useSpoketreeDatabase.items;
  var _useSpoketreeDatabase2 = useSpoketreeDatabaseAuthItems({
      partition: partition,
      scope: scope,
      level: 'l_public',
      set: set,
      keys: ['name', 'image'],
      isAuthenticated: isAuthenticated
    }),
    publicSettings = _useSpoketreeDatabase2.items;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    partyId = _useState2[0],
    setPartyId = _useState2[1];
  useEffect(function (_) {
    (function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (privateSettings && Object.values(privateSettings === null || privateSettings === void 0 ? void 0 : privateSettings._items).length) {
                setPartyId(Object.values(privateSettings._items)[0][0].E_PK);
              } else {
                setPartyId(undefined);
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    })()();
  }, [privateSettings]);
  var parse = function parse(items, key) {
    return items && items.parse ? items.parse(key) : undefined;
  };
  var mutate = function mutate(items, key, value) {
    return items && items.mutate ? items.mutate(key, value) : undefined;
  };
  var value = {
    getId: function getId() {
      return partyId;
    },
    // private settings
    getEmail: function getEmail() {
      return parse(privateSettings, 'email');
    },
    setEmail: function setEmail(email) {
      return mutate(privateSettings, 'email', email);
    },
    getAddress: function getAddress() {
      var _parse;
      return (_parse = parse(privateSettings, 'address_and_location')) === null || _parse === void 0 ? void 0 : _parse.address;
    },
    getLocation: function getLocation() {
      var _parse2;
      return (_parse2 = parse(privateSettings, 'address_and_location')) === null || _parse2 === void 0 ? void 0 : _parse2.location;
    },
    setAddress: function setAddress(address) {
      return mutate(privateSettings, 'address_and_location', {
        address: address,
        location: address ? parse(privateSettings, 'address_and_location').location : undefined
      });
    },
    setLocation: function setLocation(location) {
      var _parse3;
      return mutate(privateSettings, 'address_and_location', {
        address: (_parse3 = parse(privateSettings, 'address_and_location')) === null || _parse3 === void 0 ? void 0 : _parse3.address,
        location: location
      });
    },
    setAddressAndLocation: function setAddressAndLocation(_ref4) {
      var address = _ref4.address,
        location = _ref4.location;
      return mutate(privateSettings, 'address_and_location', {
        address: address,
        location: location
      });
    },
    getPickupRadius: function getPickupRadius() {
      return parse(privateSettings, 'pickup:radius');
    },
    setPickupRadius: function setPickupRadius(radius) {
      return mutate(privateSettings, 'pickup:radius', radius);
    },
    getStripeCustomerId: function getStripeCustomerId() {
      return parse(privateSettings, 'stripe:customer:id');
    },
    setStripeCustomerId: function setStripeCustomerId(id) {
      return mutate(privateSettings, 'stripe:customer:id', id);
    },
    //getStripePaymentIntent: () =>                       parse(privateSettings, 'stripe:payment:intent'),
    //setStripePaymentIntent: (intent) =>                 mutate(privateSettings, 'stripe:payment:intent', intent),
    // public settings
    getName: function getName() {
      var name = parse(publicSettings, 'name');
      return name;
    },
    setName: function setName(name) {
      return mutate(publicSettings, 'name', name);
    },
    getTelephone: function getTelephone() {
      return parse(publicSettings, 'telephone');
    },
    setTelephone: function setTelephone(telephone) {
      return mutate(publicSettings, 'telephone', telephone);
    },
    getImage: function getImage() {
      return parse(publicSettings, 'image');
    },
    setImage: function setImage(image) {
      return mutate(publicSettings, 'image', image);
    }
  };
  return /*#__PURE__*/React.createElement(Context$h.Provider, {
    value: value
  }, children);
};
var Consumer$b = Context$h.Consumer;
var PrincipalPartyStore = {
  Context: Context$h,
  Provider: Provider$h,
  Consumer: Consumer$b
};

var fontFamilyMetropolis$3 = {
  fontFamily: ["Metropolis", "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
  letterSpacing: "0.015rem"
};
var fontFamilyRoboto$1 = {
  fontFamily: ["Roboto", "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
};
var PREFIX$Y = 'ProfilePopover';
var classes$Y = {
  popover: "".concat(PREFIX$Y, "-popover"),
  container: "".concat(PREFIX$Y, "-container"),
  avatar: "".concat(PREFIX$Y, "-avatar"),
  userInfo: "".concat(PREFIX$Y, "-userInfo"),
  userName: "".concat(PREFIX$Y, "-userName"),
  userEmail: "".concat(PREFIX$Y, "-userEmail"),
  bar: "".concat(PREFIX$Y, "-bar"),
  buttonSettings: "".concat(PREFIX$Y, "-buttonSettings"),
  buttonSignout: "".concat(PREFIX$Y, "-buttonSignout")
};
var Root$O = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$Y.popover), {
    //background: theme.custom.palette.profilePopColor,
    width: theme.spacing(40),
    borderRadius: theme.shape.borderRadius
  }), _defineProperty(_ref2, "& .".concat(classes$Y.container), {
    display: "flex",
    padding: theme.spacing(2),
    flexDirection: "column",
    alignItems: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$Y.avatar), {
    width: theme.spacing(6),
    height: theme.spacing(6),
    margin: theme.spacing(1),
    background: theme.palette.background.default
  }), _defineProperty(_ref2, "& .".concat(classes$Y.userInfo), {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: theme.spacing(1)
  }), _defineProperty(_ref2, "& .".concat(classes$Y.userName), _objectSpread2(_objectSpread2({}, fontFamilyMetropolis$3), {}, {
    //theme.custom.fontFamily.metropolis,
    fontSize: "1rem",
    fontWeight: 500
  })), _defineProperty(_ref2, "& .".concat(classes$Y.userEmail), _objectSpread2(_objectSpread2({}, fontFamilyRoboto$1), {}, {
    //theme.custom.fontFamily.roboto,
    fontSize: "0.9rem"
  })), _defineProperty(_ref2, "& .".concat(classes$Y.bar), {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$Y.buttonSettings), _objectSpread2(_objectSpread2({}, fontFamilyMetropolis$3), {}, {
    //theme.custom.fontFamily.metropolis,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0.5, 2),
    fontSize: "0.8rem",
    fontWeight: 800,
    textTransform: "none"
  })), _defineProperty(_ref2, "& .".concat(classes$Y.buttonSignout), _objectSpread2(_objectSpread2({}, fontFamilyMetropolis$3), {}, {
    //theme.custom.fontFamily.metropolis,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 2),
    fontSize: "0.8rem",
    fontWeight: 500,
    textTransform: "none"
  })), _ref2;
});
var ProfilePopover = function ProfilePopover(_ref3) {
  var anchorEl = _ref3.anchorEl,
    isOpen = _ref3.isOpen,
    onClose = _ref3.onClose;
  var theme = useTheme();
  var navigate = useNavigate();
  var id = isOpen ? "profile-popover" : undefined;
  var principalParty = useContext(PrincipalPartyStore.Context);
  var _useContext = useContext(SpoketreeAuthStore.Context),
    authenticationEmail = _useContext.authenticationEmail,
    isAuthenticated = _useContext.isAuthenticated,
    signOut = _useContext.signOut;
  return isAuthenticated && /*#__PURE__*/React.createElement(Popover, {
    id: id,
    open: isOpen,
    anchorEl: anchorEl,
    onClose: onClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    classes: {
      paper: classes$Y.popover
    },
    style: {
      zIndex: 999999
    }
  }, /*#__PURE__*/React.createElement(Root$O, null, /*#__PURE__*/React.createElement("div", {
    className: classes$Y.container
  }, /*#__PURE__*/React.createElement(Avatar, {
    alt: 'TODO',
    className: classes$Y.avatar,
    src: principalParty.getImage()
  }, /*#__PURE__*/React.createElement(FaceOutlined, {
    htmlColor: theme.custom.palette.iconColor,
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes$Y.userInfo
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes$Y.userName,
    variant: "h6",
    component: "span",
    color: "textPrimary"
  }, principalParty.getName()), /*#__PURE__*/React.createElement(Typography, {
    className: classes$Y.userEmail,
    variant: "body1",
    component: "span",
    color: "textSecondary"
  }, authenticationEmail))), /*#__PURE__*/React.createElement("div", {
    className: classes$Y.bar
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onClose();
            //await signOut();
            navigate('/plugin/community/user/about');
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    classes: {
      root: classes$Y.buttonSignout
    }
  }, "Manage your Spoketree Profile")), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: '8px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes$Y.bar
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            onClose();
            _context2.next = 3;
            return signOut();
          case 3:
            navigate('/');
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })),
    classes: {
      root: classes$Y.buttonSignout
    }
  }, "Log Out"))));
};

/*
 *   Copyright (c) 2021 Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var HorizontalFillerUpper = (function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }, children);
});

var PREFIX$X = 'SearchBar';
var classes$X = {
  search: "".concat(PREFIX$X, "-search"),
  searchIcon: "".concat(PREFIX$X, "-searchIcon"),
  inputRoot: "".concat(PREFIX$X, "-inputRoot"),
  inputInput: "".concat(PREFIX$X, "-inputInput")
};
styled(ClickAwayListener)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$X.search), {
    display: "flex",
    justifyContent: "center",
    width: '100%',
    //maxWidth: 472,//"100%",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.shortest
    }),
    //marginLeft: theme.spacing(1)
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.1) !important',
    borderWidth: 'thin'
  }), _defineProperty(_ref2, "& .".concat(classes$X.searchIcon), {
    width: theme.spacing(7),
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$X.inputRoot), {
    flex: 1,
    alignItems: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$X.inputInput), {
    width: "100%",
    border: 1
  }), _ref2;
});

var PREFIX$W = 'AppBar';
var classes$W = {
  grow: "".concat(PREFIX$W, "-grow"),
  containerBorder: "".concat(PREFIX$W, "-containerBorder"),
  menuButton: "".concat(PREFIX$W, "-menuButton"),
  logoContainer: "".concat(PREFIX$W, "-logoContainer"),
  logo: "".concat(PREFIX$W, "-logo"),
  title: "".concat(PREFIX$W, "-title"),
  searchbarContainer: "".concat(PREFIX$W, "-searchbarContainer")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$N = styled('div')(function (_ref) {
  var _$concat, _objectSpread2$1, _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$W.grow), {
    flexGrow: 1
  }), _defineProperty(_ref2, "& .".concat(classes$W.containerBorder), {
    border: 0
    /*
    borderBottomStyle: "solid",
    borderBottomWidth: "1px",
    borderBottomColor: theme.palette.divider
    */
  }), _defineProperty(_ref2, "& .".concat(classes$W.menuButton), (_$concat = {}, _defineProperty(_$concat, theme.breakpoints.up("md"), {
    marginRight: theme.spacing(1)
  }), _defineProperty(_$concat, "marginRight", theme.spacing(1.5)), _$concat)), _defineProperty(_ref2, "& .".concat(classes$W.logoContainer), {
    display: "flex",
    justifyContent: "stretch"
  }), _defineProperty(_ref2, "& .".concat(classes$W.logo), {
    //display: "none",
    height: theme.spacing(4),
    padding: theme.spacing(0, 0, 0, 0),
    //marginLeft: '-8px',
    //[theme.breakpoints.up("sm")]: {
    display: "block",
    //},
    borderRadius: "4px"
  }), _defineProperty(_ref2, "& .".concat(classes$W.title), _objectSpread2(_objectSpread2({}, fontFamilyMetropolis$2), {}, (_objectSpread2$1 = {
    //theme.custom.fontFamily.metropolis,
    display: "none"
  }, _defineProperty(_objectSpread2$1, theme.breakpoints.up("xs"), {
    display: "flex",
    alignItems: "center"
  }), _defineProperty(_objectSpread2$1, "padding", theme.spacing(0, 0, 0, 0.5)), _objectSpread2$1))), _defineProperty(_ref2, "& .".concat(classes$W.searchbarContainer), _defineProperty({
    flexGrow: 1,
    marginLeft: theme.spacing(1)
  }, theme.breakpoints.up("md"), {
    flexGrow: 0,
    width: theme.spacing(90),
    marginLeft: theme.spacing(9)
  })), _ref2;
});

//import { Context as SelectedShopContext } from '../stores/SelectedShopStore';

var fontFamilyMetropolis$2 = {
  fontFamily: ["Metropolis", "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
  letterSpacing: "0.015rem"
};
var SpoketreeAppBar = function SpoketreeAppBar(_ref3) {
  _objectDestructuringEmpty(_ref3);
  var menuId = "primary-search-account-menu";
  var theme = useTheme$1();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isProfilePopoverOpen = _useState2[0],
    setProfilePopoverOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSearchShowingInMobile = _useState4[0];
    _useState4[1];
  var profileMenuRef = useRef();
  var trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0
  });
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  var _useContext = useContext(UISessionStore.Context),
    toggleNavBar = _useContext.toggleNavBar;
  var onNavBarToggle = useCallback(function () {
    toggleNavBar();
  }, [toggleNavBar]);
  return /*#__PURE__*/React.createElement(Root$N, null, /*#__PURE__*/React.createElement(SpoketreeAuthStore.Consumer, null, function (_ref4) {
    _ref4.isAuthenticated;
    return /*#__PURE__*/React.createElement(HorizontalFillerUpper, null, /*#__PURE__*/React.createElement(AppBar, {
      style: {
        backgroundColor: 'white' /*,zIndex:'9999'*/
      },
      elevation: trigger ? 4 : 0,
      className: trigger ? null : classes$W.containerBorder
    }, /*#__PURE__*/React.createElement(Toolbar, {
      style: {
        minHeight: '48px'
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, null,
    /*#__PURE__*/
    /*!isMobile &&*/
    React.createElement(IconButton, {
      edge: "start",
      className: classes$W.menuButton,
      style: {
        marginLeft: !!isMobile ? '-16px' : '-24px'
      },
      "aria-label": "open drawer",
      onClick: onNavBarToggle,
      size: "large"
    }, /*#__PURE__*/React.createElement(Menu, null), " "), isMobile ? isSearchShowingInMobile ? {/*<SearchContainer onSearchClose={() => setSearchShowing(false)} />*/} : /*#__PURE__*/React.createElement(LogoContainer$1, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LogoContainer$1, null)), /*#__PURE__*/React.createElement(HorizontalFillerUpper, null), /*#__PURE__*/React.createElement(SpoketreeAuthStore.Consumer, null, function (_ref5) {
      var isAuthenticated = _ref5.isAuthenticated;
      return isAuthenticated && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 0,
          //marginTop:'-8px',
          marginRight: '-12px'
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        ref: profileMenuRef,
        "aria-label": "account of current user",
        "aria-controls": menuId,
        "aria-haspopup": "true",
        onClick: function onClick() {
          return setProfilePopoverOpen(true);
        },
        size: "large"
      }, /*#__PURE__*/React.createElement(AccountCircleOutlined, null)));
    }))), /*#__PURE__*/React.createElement(ProfilePopover, {
      anchorEl: profileMenuRef.current,
      isOpen: isProfilePopoverOpen,
      onClose: function onClose() {
        return setProfilePopoverOpen(false);
      }
    })));
  }));
};
var LogoContainer$1 = function LogoContainer(_ref6) {
  _objectDestructuringEmpty(_ref6);
  var theme = useTheme$1();
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  //const { selectedShop } = useContext(SelectedShopContext);

  return /*#__PURE__*/React.createElement("div", {
    className: classes$W.logoContainer
  }, /*#__PURE__*/React.createElement(SpoketreeSolutionStore.Consumer, null, function (_ref7) {
    var system = _ref7.system,
      subsystem = _ref7.subsystem;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      href: "/"
    }, /*#__PURE__*/React.createElement("img", {
      className: classes$W.logo,
      src: subsystem !== null && subsystem !== void 0 && subsystem.icon ? subsystem === null || subsystem === void 0 ? void 0 : subsystem.icon : system === null || system === void 0 ? void 0 : system.icon,
      alt: "logo",
      style: {
        marginLeft: !!isMobile ? '-12px' : '-12px'
      }
    })), /*#__PURE__*/React.createElement(Link, {
      href: "/"
    }, /*#__PURE__*/React.createElement(Typography
    //color="textSecondary"
    , {
      style: {
        color: "#111",
        marginLeft: '3px',
        marginTop: '2px'
      },
      className: classes$W.title,
      variant: "h6",
      noWrap: true
    },
    //selectedShop ? (
    //  selectedShop.getName()
    //) : (
    subsystem !== null && subsystem !== void 0 && subsystem.title ? subsystem === null || subsystem === void 0 ? void 0 : subsystem.title : system === null || system === void 0 ? void 0 : system.title
    //)
    )));
  }));
};

var PREFIX$V = 'DrawerItem';
var classes$V = {
  listItemRoot: "".concat(PREFIX$V, "-listItemRoot"),
  listItemSelected: "".concat(PREFIX$V, "-listItemSelected")
};
var StyledListItem = styled(ListItem)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$V.listItemRoot), {
    borderRadius: theme.spacing(0, 3, 3, 0)
  }), _defineProperty(_ref2, "& .".concat(classes$V.listItemSelected), {
    backgroundColor: "".concat(theme.palette.secondary.light, " !important")
  }), _ref2;
});
var DrawerItem = function DrawerItem(_ref3) {
  var text = _ref3.text,
    icon = _ref3.icon,
    isSelected = _ref3.isSelected,
    onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(StyledListItem, {
    button: true,
    selected: isSelected,
    classes: {
      selected: classes$V.listItemSelected,
      root: classes$V.listItemRoot
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ListItemIcon, {
    style: {
      minWidth: '40px'
    }
  }, icon), /*#__PURE__*/React.createElement(ListItemText, {
    primary: text
  }));
};

var PREFIX$U = 'NavigationDrawer';
var classes$U = {
  drawer: "".concat(PREFIX$U, "-drawer"),
  drawerPaper: "".concat(PREFIX$U, "-drawerPaper"),
  sectionTitle: "".concat(PREFIX$U, "-sectionTitle"),
  toolbar: "".concat(PREFIX$U, "-toolbar")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$M = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$U.drawer), {
    //[theme.breakpoints.up('sm')]: {
    //  /*TAG:NAV*/width: '156px',//theme.mixins.drawer.minWidth,//drawerWidth,//'240px',
    //  flexShrink: 0,
    //},
    width: '156px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$U.drawerPaper), {
    background: theme.palette.background.default,
    width: '156px !important',
    //theme.mixins.drawer.minWidth,//280,
    border: 0
  }), _defineProperty(_ref2, "& .".concat(classes$U.sectionTitle), {
    padding: theme.spacing(2, 1, 0, 2),
    color: theme.palette.text.secondary
  }), _defineProperty(_ref2, "& .".concat(classes$U.toolbar), theme.mixins.toolbar), _ref2;
});
var SpoketreeNavigationDrawer = function SpoketreeNavigationDrawer(_ref3) {
  var plugin = _ref3.plugin;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var navigate = useNavigate();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var principalParty = useContext(PrincipalPartyStore.Context);
  //const { selectedShop } = useContext(SelectedShopStore.Context);

  var pluginPath = '/plugin/exchange';

  //const pages = lodash.filter(plugin.pages({ path: '/community' }), ({ tab }) => !!tab);
  var pages = plugin.pages({
    path: pluginPath
  });
  var _useContext2 = useContext(UISessionStore.Context),
    isNavBarOpen = _useContext2.isNavBarOpen,
    toggleNavBar = _useContext2.toggleNavBar;
  var activePageKey = pathname.split('/')[2];
  var _useState = useState(activePageKey),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setValue = _useState2[1];
  return /*#__PURE__*/React.createElement(Root$M, null, /*#__PURE__*/React.createElement("nav", {
    className: classes$U.drawer,
    "aria-label": "nav"
  }, /*#__PURE__*/React.createElement(Drawer, {
    variant: isMobile ? "temporary" : "persistent",
    anchor: "left",
    open: isNavBarOpen,
    onClose: toggleNavBar,
    classes: {
      root: classes$U.drawer,
      paper: classes$U.drawerPaper
    }
  }, false , /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '48px'
    }
  }), /*#__PURE__*/React.createElement(List, {
    style: {
      width: '156px',
      marginTop: !!isMobile && window.location.pathname.split('/').length >= 6 ? '80px' : ''
    }
  }, Object.entries(pages).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2);
      _ref5[0];
      var deny = _ref5[1].deny;
    return !deny || !deny({
      isAuthenticated: isAuthenticated,
      principalParty: principalParty,
      selectedFeature: selectedShop
    });
  }).filter(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2);
      _ref7[0];
      var tab = _ref7[1].tab;
    return !!tab;
  }).map(function (_ref8, index) {
    var _ref9 = _slicedToArray(_ref8, 2),
      key = _ref9[0],
      _ref9$ = _ref9[1],
      _ref9$$tab = _ref9$.tab,
      icon = _ref9$$tab.icon,
      title = _ref9$$tab.title,
      target = _ref9$.target;
    return /*#__PURE__*/React.createElement(DrawerItem, {
      key: key,
      text: title,
      icon: icon
      //icon={<MarketIcon htmlColor={theme.custom.palette.iconColor} />}
      ,
      onClick: function onClick() {
        setValue(key);
        if (!!isMobile) {
          toggleNavBar();
        }
        navigate(target ? target : "".concat(pluginPath, "/").concat(key));
      },
      isSelected: key === activePageKey
    });
  })))));
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var makeReducer = function makeReducer(options) {
  var DEFAULT_KEY = 'id';
  var key = options !== null && options !== void 0 && options.key ? options.key : DEFAULT_KEY;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (action.type === "LOADED") {
      var loaded = action.payload;
      state.length = 0;
      state.push.apply(state, _toConsumableArray(loaded));
    } else {
      var mutated = action.payload;
      if (!mutated) {
        return;
      }
      var mutatedIndex = state.findIndex(function (item) {
        return item[key] === mutated[key];
      });
      switch (action.type) {
        case "CREATED":
          if (mutatedIndex < 0) {
            state.push(mutated);
          }
          break;
        case "DELETED":
          if (mutatedIndex >= 0) {
            state.splice(mutatedIndex, 1);
          }
          break;
        case "UPDATED":
          //if (mutatedIndex >= 0) {
          state[mutatedIndex] = mutated;
          //}
          break;
      }
    }
    return _toConsumableArray(state);
  };
};

var _defaults = {
  items: {},
  isInitialized: true,
  isRetrieveAttempted: false
};
var useSpoketreeDatabaseUnauthItems = function useSpoketreeDatabaseUnauthItems(_ref) {
  var _ref$endpoint = _ref.endpoint,
    endpoint = _ref$endpoint === void 0 ? 'spoketree-database-unauth' : _ref$endpoint,
    partition = _ref.partition,
    scope = _ref.scope,
    level = _ref.level,
    set = _ref.set,
    keys = _ref.keys,
    isAuthenticating = _ref.isAuthenticating,
    onInit = _ref.onInit,
    onError = _ref.onError,
    onLoad = _ref.onLoad;
  console.log('BBBB');
  var api = makeItemsAPI({
    endpoint: endpoint,
    partition: partition,
    scope: scope,
    level: level,
    set: set
  });
  var _useState = useState(_defaults.items),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var isInitialized = useRef(_defaults.isInitialized);
  var isRetrieveAttempted = useRef(_defaults.isRetrieveAttempted);
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        var receivedItems;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(isAuthenticating && !isInitialized.current)) {
                _context.next = 7;
                break;
              }
              isInitialized.current = _defaults.isInitialized;
              isRetrieveAttempted.current = _defaults.isRetrieveAttempted;
              setItems(_defaults.items);
              onInit && onInit();
              _context.next = 29;
              break;
            case 7:
              if (!(!isAuthenticating && !isRetrieveAttempted.current)) {
                _context.next = 29;
                break;
              }
              isInitialized.current = false;
              isRetrieveAttempted.current = true;
              _context.prev = 10;
              _context.next = 13;
              return api.getItems();
            case 13:
              receivedItems = _context.sent;
              setItems(receivedItems);
              // call onLoad for actions that need to occur once when loaded
              // use this hook return value { items } for access to items
              _context.t0 = onLoad;
              if (!_context.t0) {
                _context.next = 19;
                break;
              }
              _context.next = 19;
              return onLoad(wrapItems({
                endpoint: endpoint,
                partition: partition,
                scope: scope,
                level: level,
                set: set,
                keys: keys,
                items: receivedItems,
                setItems: setItems
              }));
            case 19:
              _context.next = 27;
              break;
            case 21:
              _context.prev = 21;
              _context.t1 = _context["catch"](10);
              console.log("Error while retrieving items");
              console.log(_context.t1);
              setItems(_defaults.items);
              onError && onError();
            case 27:
              _context.next = 29;
              break;
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[10, 21]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [isAuthenticating]);
  return {
    items: wrapItems({
      endpoint: endpoint,
      partition: partition,
      scope: scope,
      level: level,
      set: set,
      keys: keys,
      items: items,
      setItems: setItems
    })
  };
};

var Context$g = /*#__PURE__*/createContext([]);
var Provider$g = function Provider(_ref) {
  var children = _ref.children;
    _ref.filter;
  var _useContext = useContext(SpoketreeAuthStore.Context),
    isAuthenticating = _useContext.isAuthenticating,
    isAuthenticated = _useContext.isAuthenticated;
  var principalParty = useContext(PrincipalPartyStore.Context);

  //const [ shopKeys, dispatchShopKeys ] = useReducer(makeReducer(), []);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    principalFeatureViewerGrants = _useState2[0],
    setPrincipalFeatureViewerGrants = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    principalFeatureViewerRequests = _useState4[0];
    _useState4[1];
  var _useReducer = useReducer(makeReducer(), []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    principalFeatureJoins = _useReducer2[0],
    dispatchPrincipalFeatureJoins = _useReducer2[1];
  var _useReducer3 = useReducer(makeReducer(), []),
    _useReducer4 = _slicedToArray(_useReducer3, 2),
    allFeatureJoinsPrivate = _useReducer4[0],
    dispatchAllFeatureJoinsPrivate = _useReducer4[1];
  var _useReducer5 = useReducer(makeReducer(), []),
    _useReducer6 = _slicedToArray(_useReducer5, 2),
    allFeatureSettingsSecret = _useReducer6[0],
    dispatchAllFeatureSettingsSecret = _useReducer6[1];
  var _useReducer7 = useReducer(makeReducer(), []),
    _useReducer8 = _slicedToArray(_useReducer7, 2),
    allFeatureSettingsPrivate = _useReducer8[0],
    dispatchAllFeatureSettingsPrivate = _useReducer8[1];
  var _useReducer9 = useReducer(makeReducer(), []),
    _useReducer10 = _slicedToArray(_useReducer9, 2),
    allFeatureSettingsProtected = _useReducer10[0],
    dispatchAllFeatureSettingsProtected = _useReducer10[1];
  var _useReducer11 = useReducer(makeReducer(), []),
    _useReducer12 = _slicedToArray(_useReducer11, 2),
    allFeatureSettingsPublic = _useReducer12[0],
    dispatchAllFeatureSettingsPublic = _useReducer12[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    allFeatures = _useState6[0],
    setAllFeatures = _useState6[1];
  var settingsDispatchers = {
    secret: dispatchAllFeatureSettingsSecret,
    private: dispatchAllFeatureSettingsPrivate,
    protected: dispatchAllFeatureSettingsProtected,
    public: dispatchAllFeatureSettingsPublic
  };
  var _retrieveFeatureItems = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
      var featureId, scope, level, set, keys, setAlias, dispatch, partition, api, retrievedItems, _dispatch;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            featureId = _ref2.featureId, scope = _ref2.scope, level = _ref2.level, set = _ref2.set, keys = _ref2.keys, setAlias = _ref2.setAlias, dispatch = _ref2.dispatch;
            partition = featureId;
            api = makeItemsAPI({
              endpoint: 'spoketree-database-auth',
              partition: partition,
              scope: scope,
              level: level,
              set: set,
              keys: keys
            });
            _context2.next = 5;
            return api.getItems();
          case 5:
            retrievedItems = _context2.sent;
            //const feature = features.find(({ id }) => id === featureId);
            _dispatch = function _dispatch(_ref4) {
              var type = _ref4.type,
                items = _ref4.items;
              return dispatch({
                type: type,
                payload: _defineProperty({
                  //...feature,
                  id: featureId
                }, setAlias, wrapItems({
                  endpoint: 'spoketree-database-auth',
                  partition: partition,
                  scope: scope,
                  level: level,
                  set: set,
                  keys: keys,
                  items: items,
                  setItems: function () {
                    var _setItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(updatedItems) {
                      return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            return _context.abrupt("return", _dispatch({
                              type: "UPDATED",
                              items: updatedItems
                            }));
                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee);
                    }));
                    function setItems(_x2) {
                      return _setItems.apply(this, arguments);
                    }
                    return setItems;
                  }()
                }))
              });
            };
            _dispatch({
              type: "CREATED",
              items: retrievedItems
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var settingKeys = {
    secret: ['iamUserSecretAccessKey'],
    private: ['iamUserEnabled', 'iamUserId',
    // AIDA123456789EXAMPLE
    'iamUserAccessKeyId'],
    protected: ['name',
    // Surteco Exchange
    'description', 'cardImage', 'extensions', 'useExtensionFeatureName', 'createableScenarios'],
    public: []
  };
  var joinType = "_join:feature"; //:c_exchange:k_instance`;

  // ALL FEATURE VIEWER GRANTS
  // load principal shop viewer grants
  useSpoketreeDatabaseAuthItems({
    partition: '_me',
    scope: 's_system',
    level: 'l_protected',
    set: "".concat(joinType, ":r_viewer:_flow:a_grant"),
    keys: [],
    isAuthenticating: isAuthenticating,
    onLoad: setPrincipalFeatureViewerGrants
  });
  // ALL FEATURE VIEWER REQUESTS
  // load principal shop viewer requests
  /*
  useSpoketreeDatabaseAuthItems({
    partition: '_me',
    scope: 's_system',
    level: 'l_protected',
    set: `${joinType}:r_viewer:_flow:a_request`,
    keys: [],
    isAuthenticating,
    onLoad: setPrincipalFeatureViewerRequests
  });
  */
  // load principal feature joins
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFeaturesReady = _useState8[0],
    setIsFeaturesReady = _useState8[1];
  useSpoketreeDatabaseAuthItems({
    partition: '_me',
    scope: 's_system',
    level: 'l_protected',
    set: "".concat(joinType),
    keys: [],
    isAuthenticated: isAuthenticated,
    onLoad: function onLoad(loaded) {
      console.log('LOADED');
      console.log(loaded);
      dispatchPrincipalFeatureJoins({
        type: "LOADED",
        payload: loaded.keys().map(function (key) {
          return {
            id: key,
            content: loaded._items[key][0].Version_Content
          };
        }) //.filter(({ id, content }) => content.capabilityId === 'c_exchange')
      });

      setIsFeaturesReady(true);
    }
  });
  // load feature user settings
  useEffect(function (_) {
    (function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_) {
        var featureIds;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!isAuthenticating && principalParty !== null && principalParty !== void 0 && principalParty.getId() && principalFeatureJoins) {
                featureIds = lodash.uniq(_toConsumableArray(principalFeatureJoins.map(function (_ref6) {
                  var id = _ref6.id;
                  return id;
                }).map(function (key) {
                  return key.split(':').pop().split('.')[1];
                })));
                featureIds.forEach(function (featureId) {
                  [].concat(_toConsumableArray(!!principalFeatureJoins.find(function (i) {
                    return i.id.startsWith("".concat(joinType, ":r_owner:_flow:a_grant:").concat(principalParty.getId(), ".").concat(featureId));
                  }) ? ['secret', 'private'] : []), _toConsumableArray(!!principalFeatureJoins.find(function (i) {
                    return i.id.startsWith("".concat(joinType, ":r_owner:_flow:a_grant:").concat(principalParty.getId(), ".").concat(featureId)) || i.id.startsWith("".concat(joinType, ":r_viewer:_flow:a_grant:").concat(principalParty.getId(), ".").concat(featureId));
                  }) ? ['protected'] : []), ['public']).forEach(function (level) {
                    return _retrieveFeatureItems({
                      featureId: featureId,
                      scope: 's_user',
                      level: "l_".concat(level),
                      set: 'setting',
                      keys: settingKeys[level],
                      setAlias: "".concat(level, "Settings"),
                      //features: allFeatures,
                      dispatch: settingsDispatchers[level]
                    });
                  });
                  _retrieveFeatureItems({
                    featureId: featureId,
                    scope: 's_system',
                    level: "l_protected",
                    set: "".concat(joinType),
                    keys: [],
                    setAlias: "protectedJoins",
                    //features: allFeatures,
                    dispatch: dispatchAllFeatureJoinsPrivate
                  });
                });
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    })()();
  }, [isAuthenticating, principalParty, principalFeatureJoins]);
  useEffect(function (_) {
    (function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_) {
        var merged, values;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              merged = lodash.merge(lodash.keyBy(allFeatureJoinsPrivate, 'id'), lodash.keyBy(allFeatureSettingsSecret, 'id'), lodash.keyBy(allFeatureSettingsPrivate, 'id'), lodash.keyBy(allFeatureSettingsProtected, 'id'), lodash.keyBy(allFeatureSettingsPublic, 'id'));
              values = lodash.values(merged);
              setAllFeatures(values);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    })()();
  }, [allFeatureJoinsPrivate, allFeatureSettingsSecret, allFeatureSettingsPrivate, allFeatureSettingsProtected, allFeatureSettingsPublic]);
  var _findFeature = function _findFeature(featureId) {
    var found = allFeatures ? wrapFeature(allFeatures.find(function (_ref8) {
      var id = _ref8.id;
      return id === featureId;
    })) : undefined;
    return found;
  };
  var _mapFeatures = function _mapFeatures(callback) {
    return allFeatures ? allFeatures.map(function (feature) {
      return callback(wrapFeature(feature));
    }) : undefined;
  };
  var editableFeaturesFilter = function editableFeaturesFilter(feature) {
    return !!principalFeatureJoins.find(function (i) {
      return (
        //i.id.startsWith(`${joinType}:r_creator:_flow:a_grant:p_`) ||
        i.id.startsWith("".concat(joinType, ":r_owner:_flow:a_grant:p_")) &&
        // TODO: check partyId is _me
        i.id.endsWith(".".concat(feature.id))
      );
    });
  };
  var isFeatureEditable = function isFeatureEditable(feature) {
    return feature && allFeatures.filter(editableFeaturesFilter).find(function (_ref9) {
      var id = _ref9.id;
      return id === feature.id;
    });
  };
  var viewableFeaturesFilter = function viewableFeaturesFilter(feature) {
    return !!principalFeatureJoins.find(function (i) {
      return i.id.startsWith("".concat(joinType, ":r_viewer:_flow:a_grant:p_")) && i.id.includes(principalParty.getId()) && i.id.endsWith(".".concat(feature.id));
    });
  };
  var isFeatureViewable = function isFeatureViewable(feature) {
    return feature && allFeatures.filter(viewableFeaturesFilter).find(function (_ref10) {
      var id = _ref10.id;
      return id === feature.id;
    });
  };
  var __getPrincipalViewerRequest = function __getPrincipalViewerRequest(featureId) {
    var roleAlias = 'r_viewer';
    var joinKeyPrefix = "".concat(joinType, ":").concat(roleAlias, ":_flow:a_request:");
    var joinKeySuffix = featureId;
    var foundJoinKey = principalFeatureViewerRequests === null || principalFeatureViewerRequests === void 0 ? void 0 : principalFeatureViewerRequests.keys().find(function (key) {
      return key.startsWith(joinKeyPrefix) && lodash.endsWith(key, joinKeySuffix);
    });
    if (foundJoinKey) {
      return {
        id: foundJoinKey,
        // { capabilityId, kindId, partyId, state }
        content: principalFeatureViewerRequests._items[foundJoinKey][0].Version_Content
      };
    }
  };
  var wrapFeature = function wrapFeature(wrapped) {
    return wrapped ? _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, wrapped), {}, {
      getId: function getId(_) {
        return wrapped.id;
      },
      getJoins: function getJoins() {
        var _wrapped$protectedJoi, _wrapped$protectedJoi2;
        return wrapped !== null && wrapped !== void 0 && (_wrapped$protectedJoi = wrapped.protectedJoins) !== null && _wrapped$protectedJoi !== void 0 && _wrapped$protectedJoi._items ? Object.keys(wrapped === null || wrapped === void 0 || (_wrapped$protectedJoi2 = wrapped.protectedJoins) === null || _wrapped$protectedJoi2 === void 0 ? void 0 : _wrapped$protectedJoi2._items).map(function (join) {
          // _join:feature:r_creator:_flow:a_grant:p_9sLuFXQH4i5CL5AB84wJdd.f_13nh6f
          var parts = join.split(':');
          return {
            roleAlias: parts[2],
            partyId: parts[5].split('.')[0]
          };
        }) : undefined;
      }
    }, Object.fromEntries(_toConsumableArray(new Map(settingKeys['secret'].map(function (key) {
      return [["get".concat(lodash.startCase(key).replace(/ /g, ''))], function (_) {
        return wrapped !== null && wrapped !== void 0 && wrapped.secretSettings ? wrapped.secretSettings.parse(key) : undefined;
      }];
    }))))), Object.fromEntries(new Map(settingKeys['secret'].map(function (key) {
      return [["set".concat(lodash.startCase(key).replace(/ /g, ''))], function (value) {
        var _wrapped$secretSettin;
        wrapped === null || wrapped === void 0 || (_wrapped$secretSettin = wrapped.secretSettings) === null || _wrapped$secretSettin === void 0 ? void 0 : _wrapped$secretSettin.mutate(key, value);
      }];
    })))), Object.fromEntries(_toConsumableArray(new Map(settingKeys['private'].map(function (key) {
      return [["get".concat(lodash.startCase(key).replace(/ /g, ''))], function (_) {
        return wrapped !== null && wrapped !== void 0 && wrapped.privateSettings ? wrapped.privateSettings.parse(key) : undefined;
      }];
    }))))), Object.fromEntries(new Map(settingKeys['private'].map(function (key) {
      return [["set".concat(lodash.startCase(key).replace(/ /g, ''))], function (value) {
        var _wrapped$privateSetti;
        wrapped === null || wrapped === void 0 || (_wrapped$privateSetti = wrapped.privateSettings) === null || _wrapped$privateSetti === void 0 ? void 0 : _wrapped$privateSetti.mutate(key, value);
      }];
    })))), Object.fromEntries(_toConsumableArray(new Map(settingKeys['protected'].map(function (key) {
      return [["get".concat(lodash.startCase(key).replace(/ /g, ''))], function (_) {
        return wrapped !== null && wrapped !== void 0 && wrapped.protectedSettings ? wrapped.protectedSettings.parse(key) : undefined;
      }];
    }))))), Object.fromEntries(new Map(settingKeys['protected'].map(function (key) {
      return [["set".concat(lodash.startCase(key).replace(/ /g, ''))], function (value) {
        var _wrapped$protectedSet;
        console.log('MUTATE');
        console.log(key, value);
        wrapped === null || wrapped === void 0 || (_wrapped$protectedSet = wrapped.protectedSettings) === null || _wrapped$protectedSet === void 0 ? void 0 : _wrapped$protectedSet.mutate(key, value);
      }];
    })))), Object.fromEntries(_toConsumableArray(new Map(settingKeys['public'].map(function (key) {
      return [["get".concat(lodash.startCase(key).replace(/ /g, ''))], function (_) {
        return wrapped !== null && wrapped !== void 0 && wrapped.publicSettings ? wrapped.publicSettings.parse(key) : undefined;
      }];
    }))))), Object.fromEntries(new Map(settingKeys['public'].map(function (key) {
      return [["set".concat(lodash.startCase(key).replace(/ /g, ''))], function (value) {
        var _wrapped$publicSettin;
        wrapped === null || wrapped === void 0 || (_wrapped$publicSettin = wrapped.publicSettings) === null || _wrapped$publicSettin === void 0 ? void 0 : _wrapped$publicSettin.mutate(key, value);
      }];
    })))), {}, {
      /*
      getAvatarImage: _ => (images => (image => (
        typeof image === 'string' ? (
          image.startsWith('http') ? image : (image.startsWith('/') ? image : '/' + image)
        ) : (
          image
        )))(images.find(i => !!i))
      )([
        wrapped?.protectedSettings?.parse('avatarImage'),
        wrapped?.protectedSettings?.parse('cardImage'),
        //'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80'
      ]),
      getCardImage: _ => (images => (image => (
        typeof image === 'string' ? (
          image.startsWith('http') ? image : (image.startsWith('/') ? image : '/' + image)
        ) : (
          image
        )))(images.find(i => !!i))
      )([
        wrapped?.protectedSettings?.parse('avatarImage'),
        wrapped?.protectedSettings?.parse('cardImage'),
      ]),
      */
      getPrincipalViewerRequest: function getPrincipalViewerRequest() {
        return __getPrincipalViewerRequest(wrapped.id);
      },
      getPrincipalViewerGrant: function getPrincipalViewerGrant() {
        var roleAlias = 'r_viewer';
        var joinKeyPrefix = "".concat(joinType, ":").concat(roleAlias, ":_flow:a_grant");
        var joinKeySuffix = wrapped.id;
        var foundJoinKey = principalFeatureViewerGrants === null || principalFeatureViewerGrants === void 0 ? void 0 : principalFeatureViewerGrants.keys().find(function (key) {
          return key.startsWith(joinKeyPrefix) && lodash.endsWith(key, joinKeySuffix);
        });
        if (foundJoinKey) {
          return {
            id: foundJoinKey,
            // { party, state }
            content: principalFeatureViewerGrants._items[foundJoinKey][0].Version_Content
          };
        }
      },
      // TODO
      createViewerGrant: function () {
        var _createViewerGrant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          var _request$content;
          var request, featureId, memberId, roleAlias, requestsApi, createdItems, joinKey, joinContent;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                request = __getPrincipalViewerRequest(wrapped.id);
                featureId = wrapped === null || wrapped === void 0 ? void 0 : wrapped.id;
                memberId = request === null || request === void 0 || (_request$content = request.content) === null || _request$content === void 0 ? void 0 : _request$content.party;
                roleAlias = 'r_viewer';
                requestsApi = makeAPI('spoketree-community-feature', "/features/".concat(featureId, "/parties/").concat(memberId, "/roles/").concat(roleAlias, "/grants"));
                _context5.next = 7;
                return requestsApi.post();
              case 7:
                createdItems = _context5.sent;
                joinKey = Object.keys(createdItems.versions)[0];
                joinContent = Object.values(createdItems.versions)[0][0].Version_Content;
                if (joinKey && joinContent) {
                  // reload so that joins are reloaded from API
                  window.location.reload();
                  /*
                  dispatchPrincipalFeatureJoins({
                    type: "CREATED",
                    payload: {
                      id: joinKey,
                      content: joinContent
                    }
                  });
                  */
                }
              case 11:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function createViewerGrant() {
          return _createViewerGrant.apply(this, arguments);
        }
        return createViewerGrant;
      }(),
      isEditable: function isEditable(_) {
        return isFeatureEditable(wrapped);
      },
      isViewable: function isViewable(_) {
        return isFeatureViewable(wrapped);
      }
    }) : undefined;
  };
  var _deleteFeature = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(feature) {
      var existingFeature, featureApi;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            existingFeature = _findFeature(feature.id);
            assert(existingFeature);
            //const previousEventId = existingFeature ? existingFeature[0].H_SK.split('#')[3] : undefined;

            /* DELETE VIEWERS */

            /* DELETE CREATOR, OWNER */
            featureApi = makeAPI('spoketree-community-feature', "/features/".concat(feature.id));
            _context6.next = 5;
            return featureApi.delete({
              key: existingFeature.id
              //previousEventId
            });
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function _deleteFeature(_x5) {
      return _ref11.apply(this, arguments);
    };
  }();
  var value = {
    features: allFeatures,
    mapFeatures: _mapFeatures,
    findFeature: _findFeature,
    deleteFeature: _deleteFeature,
    isFeaturesReady: isFeaturesReady,
    createViewerRequest: function () {
      var _createViewerRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(featureId) {
        var roleAlias, requestsApi, retrievedItems, joinKey, joinContent;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              //const featureId = wrapped?.id;
              roleAlias = 'r_viewer';
              requestsApi = makeAPI('spoketree-community-feature', "/capabilities/c_exchange/features/".concat(featureId, "/parties/_me/roles/").concat(roleAlias, "/requests"));
              _context7.next = 4;
              return requestsApi.post();
            case 4:
              retrievedItems = _context7.sent;
              joinKey = Object.keys(retrievedItems.versions)[0];
              joinContent = Object.values(retrievedItems.versions)[0][0].Version_Content;
              if (joinKey && joinContent) {
                // reload so that joins are reloaded from API
                window.location.reload();

                //console.log('window.location.reload();');
                /*
                dispatchPrincipalFeatureJoins({
                  type: "CREATED",
                  payload: {
                    id: joinKey,
                    content: joinContent
                  }
                });
                */
              }
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function createViewerRequest(_x6) {
        return _createViewerRequest.apply(this, arguments);
      }
      return createViewerRequest;
    }(),
    createGrant: function () {
      var _createGrant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref12) {
        var roleAlias, featureId, partyId, grantsApi, retrievedItems, joinKey, joinContent;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              roleAlias = _ref12.roleAlias, featureId = _ref12.featureId, partyId = _ref12.partyId;
              grantsApi = makeAPI('spoketree-community-feature', "/capabilities/c_exchange/features/".concat(featureId, "/parties/").concat(partyId, "/roles/").concat(roleAlias, "/grants"));
              _context8.next = 4;
              return grantsApi.post();
            case 4:
              retrievedItems = _context8.sent;
              joinKey = Object.keys(retrievedItems.versions)[0];
              joinContent = Object.values(retrievedItems.versions)[0][0].Version_Content;
              if (joinKey && joinContent) {
                // reload so that joins are reloaded from API
                window.location.reload();

                //console.log('window.location.reload();');
                /*
                dispatchPrincipalFeatureJoins({
                  type: "CREATED",
                  payload: {
                    id: joinKey,
                    content: joinContent
                  }
                });
                */
              }
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function createGrant(_x7) {
        return _createGrant.apply(this, arguments);
      }
      return createGrant;
    }()
  };
  return /*#__PURE__*/React.createElement(Context$g.Provider, {
    value: value
  }, children);
};
var Consumer$a = Context$g.Consumer;
var FeaturesStore = {
  Context: Context$g,
  Provider: Provider$g,
  Consumer: Consumer$a
};

var useFeature = function useFeature(featureId) {
  var _useState = useState(featureId),
    _useState2 = _slicedToArray(_useState, 2),
    _featureId = _useState2[0],
    setFeatureId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    feature = _useState4[0],
    setFeature = _useState4[1];
  var _useContext = useContext(Context$g),
    features = _useContext.features,
    findFeature = _useContext.findFeature;
  useEffect(function () {
    if (_featureId && features !== null && features !== void 0 && features.length && findFeature) {
      var _feature = findFeature(_featureId);
      if (_feature) {
        setFeature(_feature);
      }
    }
  }, [_featureId, features, findFeature, setFeature]);
  return [feature, setFeatureId];
};

var Context$f = /*#__PURE__*/createContext([]);
var Provider$f = function Provider(_ref) {
  var children = _ref.children,
    featureId = _ref.featureId;
  var _useFeature = useFeature(featureId),
    _useFeature2 = _slicedToArray(_useFeature, 2),
    selectedFeature = _useFeature2[0];
    _useFeature2[1];
  var value = {
    selectedFeatureId: featureId,
    selectedFeature: selectedFeature
  };
  return /*#__PURE__*/React.createElement(Context$f.Provider, {
    value: value
  }, children);
};
var Consumer$9 = Context$f.Consumer;
var SelectedFeatureStore = {
  Context: Context$f,
  Provider: Provider$f,
  Consumer: Consumer$9
};

var PREFIX$T = 'ShopBar';
var classes$T = {
  grow: "".concat(PREFIX$T, "-grow"),
  containerBorder: "".concat(PREFIX$T, "-containerBorder"),
  customToolBar: "".concat(PREFIX$T, "-customToolBar"),
  menuButton: "".concat(PREFIX$T, "-menuButton"),
  logoContainer: "".concat(PREFIX$T, "-logoContainer"),
  logo: "".concat(PREFIX$T, "-logo"),
  title: "".concat(PREFIX$T, "-title"),
  searchbarContainer: "".concat(PREFIX$T, "-searchbarContainer")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$L = styled('div')(function (_ref) {
  var _objectSpread2$1, _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$T.grow), {
    flexGrow: 1
  }), _defineProperty(_ref2, "& .".concat(classes$T.containerBorder), {
    border: 0
    /*
    borderBottomStyle: "solid",
    borderBottomWidth: "1px",
    borderBottomColor: theme.palette.divider
    */
  }), _defineProperty(_ref2, "& .".concat(classes$T.customToolBar), {
    minHeight: '48px',
    paddingRight: '0 !important',
    paddingLeft: '0 !important'
  }), _defineProperty(_ref2, "& .".concat(classes$T.menuButton), {
    /*[theme.breakpoints.up("md")]: {
      marginRight: theme.spacing(1),
      marginLeft: '-48px',
    },
    marginRight: theme.spacing(1),//(1.5)
    marginLeft: '-16px',
    */
    marginLeft: '0 !important',
    marginRight: '8px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$T.logoContainer), {
    display: "flex",
    justifyContent: "stretch"
  }), _defineProperty(_ref2, "& .".concat(classes$T.logo), {
    //display: "none",
    width: theme.spacing(4),
    height: theme.spacing(4),
    padding: theme.spacing(0, 0, 0, 0),
    marginLeft: '-8px',
    //[theme.breakpoints.up("sm")]: {
    display: "block",
    //},
    borderRadius: "4px"
  }), _defineProperty(_ref2, "& .".concat(classes$T.title), _objectSpread2(_objectSpread2({}, fontFamilyMetropolis$1), {}, (_objectSpread2$1 = {
    //theme.custom.fontFamily.metropolis,
    display: "none"
  }, _defineProperty(_objectSpread2$1, theme.breakpoints.up("xs"), {
    display: "flex",
    alignItems: "center"
  }), _defineProperty(_objectSpread2$1, "padding", theme.spacing(0, 0, 0, 0.5)), _objectSpread2$1))), _defineProperty(_ref2, "& .".concat(classes$T.searchbarContainer), _defineProperty({
    flexGrow: 1,
    marginLeft: theme.spacing(1)
  }, theme.breakpoints.up("md"), {
    flexGrow: 0,
    width: theme.spacing(90),
    marginLeft: theme.spacing(9)
  })), _ref2;
});
var fontFamilyMetropolis$1 = {
  fontFamily: ["Metropolis", "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
  letterSpacing: "0.015rem"
};
var PageBar = function PageBar(_ref3) {
  _objectDestructuringEmpty(_ref3);
  var menuId = "primary-search-account-menu";
  var theme = useTheme$1();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isProfilePopoverOpen = _useState2[0],
    setProfilePopoverOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    _useState6[1];
  var profileMenuRef = useRef();
  var trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0
  });
  useMediaQuery(theme.breakpoints.down('sm'));
  var _useContext = useContext(UISessionStore.Context);
    _useContext.isNavBarOpen;
    var toggleNavBar = _useContext.toggleNavBar;
  var onNavBarToggle = useCallback(function () {
    toggleNavBar();
  }, [toggleNavBar]);
  useQueryParam('mode', 'view');
  var _useContext2 = useContext(Context$f),
    selectedFeature = _useContext2.selectedFeature;
  //const { cartTotal } = useContext(CartContext);

  return /*#__PURE__*/React.createElement(Root$L, null, selectedFeature && /*#__PURE__*/React.createElement(SpoketreeAuthStore.Consumer, null, function (_ref4) {
    _ref4.isAuthenticated;
    return /*#__PURE__*/React.createElement(AppBar, {
      elevation: trigger ? 4 : 0,
      className: trigger ? null : classes$T.containerBorder,
      style: {
        paddingRight: '0 !important',
        paddingLeft: '0 !important'
      }
    }, /*#__PURE__*/React.createElement(Toolbar, {
      className: classes$T.customToolBar
    },
    /*#__PURE__*/
    /*!isAuthenticated ? (
     <></>
    ) : */
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    /*!isMobile &&*/
    React.createElement(IconButton, {
      edge: "start",
      className: classes$T.menuButton,
      "aria-label": "open drawer",
      onClick: onNavBarToggle,
      size: "large"
    }, /*#__PURE__*/React.createElement(Menu, null)), /*#__PURE__*/React.createElement(LogoContainer, null), /*#__PURE__*/React.createElement(HorizontalFillerUpper, null), /*#__PURE__*/React.createElement("div", {
      style: {
        padding: 0,
        //marginTop:'-8px',
        //marginRight: isNavBarOpen ? '-24px' : '-24px'
        marginRight: 0
      }
    }, /*#__PURE__*/React.createElement(SpoketreeAuthStore.Consumer, null, function (_ref5) {
      var isAuthenticated = _ref5.isAuthenticated;
      return isAuthenticated && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 0,
          //marginTop:'-8px',
          //marginRight:'-12px',
          marginRight: 0
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        ref: profileMenuRef,
        "aria-label": "account of current user",
        "aria-controls": menuId,
        "aria-haspopup": "true",
        onClick: function onClick() {
          return setProfilePopoverOpen(true);
        },
        size: "large"
      }, /*#__PURE__*/React.createElement(AccountCircleOutlined, null)));
    })))), /*#__PURE__*/React.createElement(ProfilePopover, {
      anchorEl: profileMenuRef.current,
      isOpen: isProfilePopoverOpen,
      onClose: function onClose() {
        return setProfilePopoverOpen(false);
      }
    }));
  }));
};
var LogoContainer = function LogoContainer(_ref6) {
  _objectDestructuringEmpty(_ref6);
  var _useContext3 = useContext(Context$f),
    selectedFeature = _useContext3.selectedFeature;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getName) && /*#__PURE__*/React.createElement("div", {
    className: classes$T.logoContainer
  }, /*#__PURE__*/React.createElement(SpoketreeSolutionStore.Consumer, null, function (_ref7) {
    var system = _ref7.system,
      subsystem = _ref7.subsystem;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      href: "/"
    }, !(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.getCardImage()) && /*#__PURE__*/React.createElement("img", {
      className: classes$T.logo,
      src: subsystem !== null && subsystem !== void 0 && subsystem.icon ? subsystem === null || subsystem === void 0 ? void 0 : subsystem.icon : system === null || system === void 0 ? void 0 : system.icon,
      alt: "logo"
    }), !!(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.getCardImage()) && /*#__PURE__*/React.createElement(Avatar, {
      "aria-label": selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(),
      className: classes$T.logo,
      src: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getCardImage(),
      variant: "rounded"
      //style={{color:'white',textDecoration:'none !important'}}
    })), /*#__PURE__*/React.createElement(Link, {
      href: "/"
    }, /*#__PURE__*/React.createElement(Typography
    //color="textSecondary"
    , {
      style: {
        color: "#111",
        marginLeft: '3px',
        marginTop: '2px' /*,
                         textOverflow: 'ellipsis', 
                         whiteSpace: 'nowrap', 
                         overflow: 'hidden',
                         maxWidth: '90%'*/
      },

      className: classes$T.title,
      variant: "h6",
      noWrap: true
    }, selectedFeature.getName() ? "".concat(selectedFeature.getName()) : subsystem !== null && subsystem !== void 0 && subsystem.title ? subsystem === null || subsystem === void 0 ? void 0 : subsystem.title : system === null || system === void 0 ? void 0 : system.title)));
  })));
};

var PREFIX$S = 'terms_of_service';
var classes$S = {
  root: "".concat(PREFIX$S, "-root")
};
var Root$K = styled('div')(function (_ref) {
  _ref.theme;
  return _defineProperty({}, "&.".concat(classes$S.root), {
    //maxWidth: 472,
    flexGrow: 1,
    overflow: 'hidden',
    margin: 0,
    padding: 0 //'8px'//theme.spacing(0, 3),
  });
});

var terms_of_service = (function (_ref3) {
  _ref3.googleMapDivRef;
  return /*#__PURE__*/React.createElement(Root$K, {
    className: classes$S.root
  }, /*#__PURE__*/React.createElement(Typography$1, {
    component: "h1",
    variant: "h5",
    style: {
      paddingBottom: '8px'
    }
  }, "Terms of Service"));
});

var SpoketreeButton = function SpoketreeButton(props) {
  console.log('props', props);
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    size: "small"
    //color="secondary" 
    ,
    variant: "outlined",
    style: _objectSpread2({
      borderColor: 'rgba(218, 220, 224, 1)',
      borderRadius: '4px',
      textTransform: 'capitalize',
      color: 'rgba(0, 0, 0, 0.54)'
    }, props === null || props === void 0 ? void 0 : props.style)
  }), props === null || props === void 0 ? void 0 : props.children);
};

var PREFIX$R = 'EditableTemplate';
var classes$R = {
  root: "".concat(PREFIX$R, "-root"),
  paper: "".concat(PREFIX$R, "-paper"),
  form: "".concat(PREFIX$R, "-form"),
  dialogRoot: "".concat(PREFIX$R, "-dialogRoot"),
  editorRoot: "".concat(PREFIX$R, "-editorRoot"),
  editorPaper: "".concat(PREFIX$R, "-editorPaper"),
  editorForm: "".concat(PREFIX$R, "-editorForm"),
  editorButton: "".concat(PREFIX$R, "-editorButton"),
  link: "".concat(PREFIX$R, "-link"),
  editLink: "".concat(PREFIX$R, "-editLink"),
  editLinkWarning: "".concat(PREFIX$R, "-editLinkWarning"),
  valueDisplay: "".concat(PREFIX$R, "-valueDisplay"),
  saveButtonRoot: "".concat(PREFIX$R, "-saveButtonRoot"),
  saveButtonText: "".concat(PREFIX$R, "-saveButtonText"),
  input: "".concat(PREFIX$R, "-input"),
  opaqueInput: "".concat(PREFIX$R, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$R, "-inputRoot"),
  inputNotchedOutline: "".concat(PREFIX$R, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$R, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$R, "-inputLabelRoot")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$J = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$R.root), {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$R.paper), {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), _defineProperty(_ref2, "& .".concat(classes$R.form), {
    width: '100%',
    // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  }), _defineProperty(_ref2, "& .".concat(classes$R.dialogRoot), {
    minWidth: '288px'
  }), _defineProperty(_ref2, "& .".concat(classes$R.editorRoot), {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$R.editorPaper), {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), _defineProperty(_ref2, "& .".concat(classes$R.editorForm), {
    padding: 8,
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$R.editorButton), {
    padding: 8
  }), _defineProperty(_ref2, "& .".concat(classes$R.link), {
    color: 'rgba(0, 0, 0, 0.87)',
    //theme.palette.secondary.main
    textDecoration: 'underline',
    fontSize: '1.125rem',
    fontFamily: 'Roboto,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    fontWeight: '500',
    lineHeight: '1.6'
  }), _defineProperty(_ref2, "& .".concat(classes$R.editLink), {
    color: theme.palette.secondary.main,
    textDecoration: "none",
    fontWeight: "bold",
    cursor: "pointer"
  }), _defineProperty(_ref2, "& .".concat(classes$R.editLinkWarning), {
    color: theme.palette.warning.main,
    textDecoration: "none",
    fontWeight: "bold",
    cursor: "pointer"
  }), _defineProperty(_ref2, "& .".concat(classes$R.valueDisplay), {
    wordBreak: 'break-word',
    marginBottom: '2px',
    fontSize: '0.875rem'
  }), _defineProperty(_ref2, "& .".concat(classes$R.saveButtonRoot), {
    //marginTop: theme.spacing(3)
  }), _defineProperty(_ref2, "& .".concat(classes$R.saveButtonText), _objectSpread2(_objectSpread2({}, theme.custom.fontFamily.metropolis), {}, {
    color: theme.palette.primary.main,
    // theme.palette.secondary.contrastText,
    textTransform: "capitalize"
  })), _defineProperty(_ref2, "& .".concat(classes$R.input), {}), _defineProperty(_ref2, "& .".concat(classes$R.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    marginTop: '8px'
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$R.inputRoot), {
    '&$inputFocused $inputNotchedOutline': {
      borderColor: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$R.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$R.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$R.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _ref2;
});
({
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
});
var EditableTemplate = (function (_ref3) {
  var editable = _ref3.editable,
    editKey = _ref3.editKey,
    label = _ref3.label,
    type = _ref3.type,
    value = _ref3.value,
    valueDisplayExpression = _ref3.valueDisplayExpression;
    _ref3.setValue;
    var viewLabel = _ref3.viewLabel,
    valuePrefix = _ref3.valuePrefix,
    valueSuffix = _ref3.valueSuffix,
    component = _ref3.component,
    variant = _ref3.variant,
    color = _ref3.color,
    subtle = _ref3.subtle;
    _ref3.deliveryMethod;
    var dialogTitle = _ref3.dialogTitle;
    _ref3.tabLabel;
    var makeEditComponent = _ref3.makeEditComponent,
    canSave = _ref3.canSave,
    handleSave = _ref3.handleSave,
    handleCancel = _ref3.handleCancel,
    Icon = _ref3.Icon,
    createValueInstruction = _ref3.createValueInstruction,
    _ref3$EditIcon = _ref3.EditIcon,
    EditIcon$1 = _ref3$EditIcon === void 0 ? EditIcon : _ref3$EditIcon;
  useTheme$1();
  //const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  var largerThan490px = useMediaQuery$1("(min-width: 490px)");
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];

  //https://codesandbox.io/s/material-demo-7zf07?file=/demo.js:410-488
  var _useState3 = useState(window.location.hash === "#".concat(editKey)),
    _useState4 = _slicedToArray(_useState3, 2),
    isEditing = _useState4[0],
    setIsEditing = _useState4[1];
  // set isEditing true when hash is #edit
  useEffect(function () {
    var onHashChange = function onHashChange() {
      return setIsEditing(window.location.hash === "#".concat(editKey));
    };
    window.addEventListener("hashchange", onHashChange);
    return function () {
      return window.removeEventListener("hashchange", onHashChange);
    };
  }, []);
  // set hash to #edit
  function startEditing() {
    window.location.hash = "#".concat(editKey);
  }
  // back to url without hash
  function stopEditing() {
    window.history.back();
  }
  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      handleCancel ? handleCancel() : undefined;
      stopEditing();
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      if (handleSave && !canSave || canSave()) {
        handleSave ? handleSave() : undefined;
        stopEditing();
      }
    }
  };
  return /*#__PURE__*/React.createElement(Root$J, null, (value || editable) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    key: "select-delivery-method",
    style: {
      margin: 0,
      padding: 0,
      width: "calc(100% - 0px)",
      marginLeft: '0px'
    }
  }, Icon && /*#__PURE__*/React.createElement(Icon, {
    style: {
      float: 'left',
      margin: "4px 4px 4px ".concat(label ? '0px' : '4px'),
      color: 'rgba(0, 0, 0, 0.44)'
    }
  }), (value || createValueInstruction) && label && /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    style: {
      fontWeight: '600',
      /*marginBottom:'8px',*/paddingTop: '6px',
      color: 'rgba(0, 0, 0, 0.44)'
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    style: {
      /*float:'left',paddingTop:'6px',*/paddingBottom: '3px' /*width:'calc(100% - 36px)',color: 'rgba(0, 0, 0, 0.54)'*/
    }
  }, !value ? /*#__PURE__*/React.createElement(Typography$1
  //gutterBottom 
  , {
    variant: variant ? variant : 'body2',
    component: component ? component : 'p'
    //color={color}
    ,
    color: "textSecondary",
    style: {
      marginTop: component === 'h2' ? '-8px' : undefined,
      float: 'left',
      width: "calc(100% - ".concat(32 + (Icon ? 24 : 0), "px)")
    }
  }, /*#__PURE__*/React.createElement(Link$1, {
    className: color === 'warning' ? classes$R.editLinkWarning : classes$R.editLink,
    variant: "body2",
    onClick: function onClick(_) {
      //setIsEditing(true)}
      startEditing();
    }
  }, createValueInstruction)) : /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '0px'
    }
  }, type === 'pre' ? valueDisplayExpression ? /*#__PURE__*/React.createElement(Typography$1
  //gutterBottom 
  , {
    variant: variant ? variant : 'body2',
    component: component ? component : 'p'
    //color={color}
    ,
    color: "textSecondary",
    style: {
      marginTop: component === 'h2' ? '-8px' : undefined,
      float: 'left',
      width: "calc(100% - ".concat(32 + (Icon ? 24 : 0), "px)")
    }
  }, valuePrefix, " ", valueDisplayExpression(value), " ", valueSuffix) : /*#__PURE__*/React.createElement("pre", null, value) : /*#__PURE__*/React.createElement(Typography$1
  //gutterBottom 
  , {
    variant: variant ? variant : 'body2',
    component: component ? component : 'p'
    //color={color}
    ,
    color: "textSecondary",
    style: {
      //marginTop: component === 'h2' ? '-8px' : undefined,
      marginTop: component === 'h2' ? '-8px' : !label ? '8px' : undefined,
      float: 'left',
      width: "calc(100% - ".concat(32 + (Icon ? 24 : 0), "px)"),
      color: !!subtle ? '#bbb' : undefined,
      lineHeight: component === 'h2' ? '20px' : undefined
    }
  }, viewLabel ? /*#__PURE__*/React.createElement(React.Fragment, null, viewLabel, ": ") : '', "".concat(viewLabel ? viewLabel + ':' : ''), type === 'password' ? '******' : value ? /*#__PURE__*/React.createElement(React.Fragment, null, valuePrefix, " ", valueDisplayExpression ? valueDisplayExpression(value) : value, " ", valueSuffix) : ''), editable && /*#__PURE__*/React.createElement(IconButton$1, {
    edge: "start",
    className: classes$R.menuButton,
    "aria-label": "Edit",
    onClick: function onClick(_) {
      return startEditing();
    },
    style: {
      marginTop: component === 'h2' && variant === 'h6' ? '-24px' // SpoketreeCard name property 
      : component === 'h2' ? '0px' : variant === 'h6' ? '12px' : label ? '-32px' : '8px',
      marginLeft: '4px',
      padding: 0
    },
    size: "large"
  }, /*#__PURE__*/React.createElement(EditIcon$1
  //color="secondary" 
  //htmlColor={theme.custom.palette.iconColor}
  , {
    style: {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  })))))), editable && /*#__PURE__*/React.createElement(React.Fragment, null, isEditing && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: !largerThan490px,
    open: isEditing,
    onClose: function onClose(e) {
      return setIsEditing(false);
    }
    /*TransitionComponent={Transition}*/,
    onKeyDown: onKeyDown,
    style: {
      zIndex: 5000
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: dialogTitle
  }, dialogTitle), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: '320px',
      marginTop: '16px',
      marginBottom: '16px'
    }
  }, makeEditComponent({
    stopEditing: stopEditing
  }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(SpoketreeButton, {
    autoFocus: true,
    onClick: function onClick(e) {
      e.preventDefault();
      handleCancel ? handleCancel() : undefined;
      stopEditing();
    },
    color: "secondary"
  }, handleSave ? 'Cancel' : 'Close'), handleSave && /*#__PURE__*/React.createElement(SpoketreeButton, {
    autoFocus: true,
    disabled: canSave && !canSave(),
    onClick: function onClick(e) {
      e.preventDefault();
      handleSave ? handleSave() : undefined;
      stopEditing();
    },
    color: "secondary"
  }, "Save")))))));
});

var PREFIX$Q = 'EditableTextField';
var classes$Q = {
  root: "".concat(PREFIX$Q, "-root"),
  form: "".concat(PREFIX$Q, "-form"),
  saveButtonRoot: "".concat(PREFIX$Q, "-saveButtonRoot"),
  input: "".concat(PREFIX$Q, "-input"),
  opaqueInput: "".concat(PREFIX$Q, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$Q, "-inputRoot"),
  inputInput: "".concat(PREFIX$Q, "-inputInput"),
  inputNotchedOutline: "".concat(PREFIX$Q, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$Q, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$Q, "-inputLabelRoot"),
  box: "".concat(PREFIX$Q, "-box")
};
var StyledGrid = styled(Grid)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$Q.root), {
    //color: 'rgba(0, 0, 0, 0.54)',
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$Q.form), {
    width: '100%' // Fix IE 11 issue.
    //marginTop: theme.spacing(1),
  }), _defineProperty(_ref2, "& .".concat(classes$Q.saveButtonRoot), {
    //marginTop: theme.spacing(3)
  }), _defineProperty(_ref2, "& .".concat(classes$Q.input), {
    height: '0.5em'
  }), _defineProperty(_ref2, "& .".concat(classes$Q.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    marginTop: '8px'
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    //marginTop: '8px',
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$Q.inputRoot), {
    backgroundColor: 'transparent',
    flex: 1,
    alignItems: "center",
    // "flex-start",
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$Q.inputInput), {
    backgroundColor: 'transparent',
    width: "100%"
  }), _defineProperty(_ref2, "& .".concat(classes$Q.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$Q.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$Q.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$Q.box), {
    display: "flex",
    justifyContent: "center",
    //maxWidth: 472,//"100%",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.shortest
    })
    //marginLeft: theme.spacing(1)
    //marginTop:'8px'
  }), _ref2;
});
function Alert$3(props) {
  return /*#__PURE__*/React.createElement(MuiAlert, _extends({
    elevation: 6,
    variant: "filled"
  }, props));
}
function EditableTextField(_ref3) {
  var label = _ref3.label,
    value = _ref3.value,
    setValue = _ref3.setValue;
    _ref3.validateValue;
    var placeholder = _ref3.placeholder,
    multiline = _ref3.multiline,
    variant = _ref3.variant;
    _ref3.component;
    _ref3.onClose;
    var warning = _ref3.warning,
    info = _ref3.info,
    Icon = _ref3.Icon,
    _ref3$autoFocus = _ref3.autoFocus,
    autoFocus = _ref3$autoFocus === void 0 ? true : _ref3$autoFocus,
    type = _ref3.type;
  var theme = useTheme$1();
  var inputRef = useRef();
  // https://stackoverflow.com/questions/37949394/how-to-set-focus-to-a-materialui-textfield
  useEffect(function () {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocussed = _useState2[0],
    setFocussed = _useState2[1];
  var onFocusLoss = function onFocusLoss() {
    setFocussed(false);
  };
  return /*#__PURE__*/React.createElement(StyledGrid, {
    container: true,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    style: variant === 'button' ? {
      paddingTop: '8px',
      paddingLeft: '16px',
      paddingRight: '16px'
    } : {}
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginBottom: '0px'
    }
  }, multiline ? /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    style: {
      fontWeight: '800',
      /*marginBottom:'8px',*/marginLeft: '7px',
      marginBottom: '3px'
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    style: {
      border: '1px solid #ccc'
    }
  }, /*#__PURE__*/React.createElement(Editor, {
    value: value,
    onValueChange: function onValueChange(value) {
      return setValue(value);
    },
    highlight: function highlight$1(code) {
      return highlight(code, languages.js);
    },
    padding: 1,
    style: {
      fontFamily: '"Fira code", "Fira Mono", monospace',
      fontSize: 12
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    style: {
      fontWeight: '800',
      /*marginBottom:'8px',*/marginLeft: '7px',
      marginBottom: '3px'
    }
  }, label), /*#__PURE__*/React.createElement(ClickAwayListener$1, {
    onClickAway: onFocusLoss
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes$Q.box,
    borderRadius: "undefinedpx",
    bgcolor: isFocussed ? theme.palette.background.default : theme.palette.background.highlight,
    boxShadow: isFocussed ? 2 : 0,
    height: "3rem"
  }, Icon && /*#__PURE__*/React.createElement(Icon, {
    htmlColor: theme.custom.palette.IconHighlight,
    style: {
      height: '24px',
      width: '24px',
      margin: '12px'
    }
  }), /*#__PURE__*/React.createElement(InputBase, {
    inputRef: inputRef,
    placeholder: placeholder,
    classes: {
      root: classes$Q.inputRoot,
      input: classes$Q.inputInput
    },
    style: {
      backgroundColor: 'transparent',
      margin: "0 16px 0 ".concat(Icon ? '0' : '16', "px")
    },
    value: value,
    onClick: function onClick(e) {
      setFocussed(true);
    },
    type: type !== 'pre' ? type : undefined
    //variant="outlined"
    //margin="normal"
    //fullWidth
    //className={classes.opaqueInput} //{variant === 'button' ? classes.opaqueInput : classes.input}
    ,
    autoFocus: autoFocus,
    id: label,
    label: label,
    name: label,
    onChange: function onChange(event) {
      //handleFieldChange(event);
      setValue(event.target.value);
    }
    //inputLabelProps={inputLabelProps} 
    //InputProps={inputProps}
  }), isFocussed ? /*#__PURE__*/React.createElement(IconButton$1, {
    hidden: !isFocussed,
    onClick: function onClick(e) {
      setValue('');
      inputRef.current.focus();
    },
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseOutlined, {
    htmlColor: theme.custom.palette.iconColor
  })) : null)))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, warning && /*#__PURE__*/React.createElement(Alert$3, {
    variant: "outlined",
    severity: "warning",
    style: {
      marginTop: '8px',
      marginBottom: '8px'
    }
  }, warning)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, info && /*#__PURE__*/React.createElement(Alert$3, {
    variant: "outlined",
    severity: "info",
    style: {
      marginTop: '8px',
      marginBottom: '8px'
    }
  }, info)));
}

function useFormFields(initialState) {
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    fields = _useState2[0],
    setValues = _useState2[1];
  var handleFieldChange = function handleFieldChange(event, adapt) {
    setValues(_objectSpread2(_objectSpread2({}, fields), {}, _defineProperty({}, event.target.id, adapt ? adapt(event.target.value) : event.target.value)));
  };
  return [fields,
  // handleFieldChange
  handleFieldChange,
  // setFieldValue
  function (k) {
    return function (v) {
      var values = _objectSpread2(_objectSpread2({}, fields), {}, _defineProperty({}, k, v));
      console.log('values:');
      console.log(values);
      setValues(values);
    };
  }];
}

var PREFIX$P = 'EditableText';
var classes$P = {
  root: "".concat(PREFIX$P, "-root")
};
var Root$I = styled('div')(function (_ref) {
  _ref.theme;
  return _defineProperty({}, "&.".concat(classes$P.root), {
    margin: 0,
    padding: 0
  });
});
var EditableText = (function (_ref3) {
  var editable = _ref3.editable,
    editKey = _ref3.editKey,
    label = _ref3.label,
    inputLabel = _ref3.inputLabel,
    value = _ref3.value,
    filterValue = _ref3.filterValue,
    setValue = _ref3.setValue,
    dialogTitle = _ref3.dialogTitle,
    tabLabel = _ref3.tabLabel,
    createValueInstruction = _ref3.createValueInstruction,
    inputInstruction = _ref3.inputInstruction,
    valueDisplayExpression = _ref3.valueDisplayExpression,
    validateValue = _ref3.validateValue,
    multiline = _ref3.multiline,
    variant = _ref3.variant,
    subtle = _ref3.subtle,
    component = _ref3.component,
    warning = _ref3.warning,
    info = _ref3.info,
    Icon = _ref3.Icon,
    EditIcon = _ref3.EditIcon,
    type = _ref3.type;
  useTheme$1();
  var _useFormFields = useFormFields({
      _value: value ? value : ''
    }),
    _useFormFields2 = _slicedToArray(_useFormFields, 3),
    fields = _useFormFields2[0];
    _useFormFields2[1];
    var _setValue = _useFormFields2[2];

  // buffer value until save
  /*
  const [ _value, _setValue ] = useState(''); 
  useEffect(_ => {
    (async _ => {
      _setValue(value);
    })();
  }, [ value ]);
  */

  return /*#__PURE__*/React.createElement(Root$I, {
    className: classes$P.root
  }, /*#__PURE__*/React.createElement(EditableTemplate, {
    editable: editable,
    editKey: editKey,
    Icon: Icon,
    EditIcon: EditIcon,
    label: label,
    createValueInstruction: createValueInstruction,
    value: value,
    valueDisplayExpression: valueDisplayExpression,
    dialogTitle: dialogTitle,
    tabLabel: tabLabel,
    variant: variant,
    subtle: subtle,
    component: component,
    type: type,
    makeEditComponent: function makeEditComponent(_ref4) {
      _ref4.stopEditing;
      return /*#__PURE__*/React.createElement(EditableTextField, {
        Icon: Icon,
        label: inputLabel,
        placeholder: inputInstruction,
        value: fields._value,
        setValue: function setValue(value) {
          return _setValue('_value')(filterValue ? filterValue(value) : value);
        },
        validateValue: validateValue,
        multiline: multiline
        //onClose={stopEditing}
        ,
        warning: warning,
        info: info,
        type: type
      });
    }
    // save buffer value
    ,
    handleSave: function handleSave(_) {
      return setValue(fields._value);
    }
    // revert
    ,
    handleCancel: function handleCancel(_) {
      return _setValue(value);
    }
  }));
});

var PREFIX$O = 'EditableTextForm';
var classes$O = {
  root: "".concat(PREFIX$O, "-root"),
  form: "".concat(PREFIX$O, "-form"),
  saveButtonRoot: "".concat(PREFIX$O, "-saveButtonRoot"),
  saveButtonText: "".concat(PREFIX$O, "-saveButtonText"),
  input: "".concat(PREFIX$O, "-input"),
  opaqueInput: "".concat(PREFIX$O, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$O, "-inputRoot"),
  inputInput: "".concat(PREFIX$O, "-inputInput"),
  inputNotchedOutline: "".concat(PREFIX$O, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$O, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$O, "-inputLabelRoot"),
  box: "".concat(PREFIX$O, "-box")
};
styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$O.root), {
    //color: 'rgba(0, 0, 0, 0.54)',
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$O.form), {
    width: '100%' // Fix IE 11 issue.
    //marginTop: theme.spacing(1),
  }), _defineProperty(_ref2, "& .".concat(classes$O.saveButtonRoot), {
    //marginTop: theme.spacing(3)
  }), _defineProperty(_ref2, "& .".concat(classes$O.saveButtonText), _objectSpread2(_objectSpread2({}, theme.custom.fontFamily.metropolis), {}, {
    color: theme.palette.primary.main,
    // theme.palette.secondary.contrastText,
    textTransform: "capitalize"
  })), _defineProperty(_ref2, "& .".concat(classes$O.input), {
    height: '0.5em'
  }), _defineProperty(_ref2, "& .".concat(classes$O.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    marginTop: '8px'
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    //marginTop: '8px',
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$O.inputRoot), {
    flex: 1,
    alignItems: "center",
    // "flex-start",
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$O.inputInput), {
    width: "100%"
  }), _defineProperty(_ref2, "& .".concat(classes$O.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$O.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$O.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$O.box), {
    //width:'100%',
    display: "flex",
    justifyContent: "center",
    maxWidth: 472,
    //"100%",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.shortest
    }),
    //marginLeft: theme.spacing(1)
    marginTop: '8px'
  }), _ref2;
});

var PREFIX$N = 'SearchField';
var classes$N = {
  search: "".concat(PREFIX$N, "-search"),
  searchIcon: "".concat(PREFIX$N, "-searchIcon"),
  inputRoot: "".concat(PREFIX$N, "-inputRoot"),
  inputInput: "".concat(PREFIX$N, "-inputInput")
};
var Root$H = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$N.search), {
    display: "flex",
    justifyContent: "center",
    maxWidth: "100%",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.shortest
    })
    //marginLeft: theme.spacing(1)
  }), _defineProperty(_ref2, "& .".concat(classes$N.searchIcon), {
    width: theme.spacing(7),
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$N.inputRoot), {
    flex: 1,
    alignItems: "center",
    padding: '16px'
  }), _defineProperty(_ref2, "& .".concat(classes$N.inputInput), {
    width: "100%"
  }), _ref2;
});
var SearchField = (function (_ref3) {
  var placeholder = _ref3.placeholder,
    searchExpression = _ref3.searchExpression,
    setSearchExpression = _ref3.setSearchExpression;
  var theme = useTheme$1();
  var navigate = useNavigate();
  var inputRef = useRef();
  var _useState = useState(searchExpression),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocussed = _useState4[0],
    setFocussed = _useState4[1];
  var onSearchClear = function onSearchClear() {
    setInputValue("");
    onSearchApply("");
    setFocussed(true);
    inputRef.current.focus();
  };
  var onSearchApply = function onSearchApply(immediateValue) {
    setSearchExpression(immediateValue ? immediateValue : inputValue);
    setFocussed(true);
  };
  var onKeyDown = function onKeyDown(event) {
    if (event.key === "Enter") ;
    if (event.key === "ArrowLeft" && event.metaKey) {
      navigate(-1);
    }
  };
  var onFocusLoss = function onFocusLoss() {
    setFocussed(false);
  };

  /*
  useEffect(_ => {
    (async () => {
      onSearchApply();
    })([inputValue]);
  });
  */

  return /*#__PURE__*/React.createElement(Root$H, {
    style: {
      marginBottom: '8px'
    }
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: onFocusLoss
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes$N.search,
    borderRadius: "undefinedpx",
    bgcolor: isFocussed ? theme.palette.background.default : theme.palette.background.highlight,
    boxShadow: isFocussed ? 2 : 0,
    height: "3rem"
  }, /*#__PURE__*/React.createElement(IconButton, {
    hidden: !isFocussed,
    onClick: function onClick(e) {
      return onSearchApply();
    },
    size: "large"
  }, /*#__PURE__*/React.createElement(Search, {
    htmlColor: theme.custom.palette.IconHighlight
  })), /*#__PURE__*/React.createElement(InputBase$1, {
    inputRef: inputRef,
    placeholder: placeholder,
    classes: {
      root: classes$N.inputRoot,
      input: classes$N.inputInput
    },
    style: {
      margin: '0 8px 0 -16px'
    },
    value: inputValue,
    inputProps: {
      "aria-label": "search"
    },
    onChange: function onChange(event) {
      setInputValue(event.target.value);
      onSearchApply(event.target.value);
    },
    onKeyDown: onKeyDown
    //autoFocus={selectedPanelId === 'products-panel'}
    //autoFocus={true}
    ,
    autoFocus: true
  }), /*#__PURE__*/React.createElement(IconButton, {
    hidden: !isFocussed,
    onClick: onSearchClear,
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseOutlined, {
    htmlColor: theme.custom.palette.iconColor
  })))));
});

var PREFIX$M = 'SearchUnsplash';
var classes$M = {
  root: "".concat(PREFIX$M, "-root"),
  container: "".concat(PREFIX$M, "-container"),
  form: "".concat(PREFIX$M, "-form"),
  card: "".concat(PREFIX$M, "-card"),
  cardImage: "".concat(PREFIX$M, "-cardImage"),
  cardList: "".concat(PREFIX$M, "-cardList")
};
var Root$G = styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$M.root), {
    width: '100%',
    maxWidth: '472'
  }), _defineProperty(_ref2, "& .".concat(classes$M.container), {
    margin: '0 auto',
    maxWidth: '1000px',
    padding: '40px'
  }), _defineProperty(_ref2, "& .".concat(classes$M.form), {
    //display: 'grid'
  }), _defineProperty(_ref2, "& .".concat(classes$M.card), {
    marginBottom: '8px',
    //'1rem',
    display: 'flex',
    '-webkit-column-break-inside': 'avoid',
    'page-break-inside': 'avoid',
    'break-inside': 'avoid'
  }), _defineProperty(_ref2, "& .".concat(classes$M.cardImage), {
    flex: '100%',
    //marginTop: '1rem',
    borderRadius: '0.5rem',
    //'10px',
    cursor: 'pointer'
  }), _defineProperty(_ref2, "& .".concat(classes$M.cardList), {
    columnCount: 2,
    columnGap: '8px'
  }), _ref2;
});

// https://www.digitalocean.com/community/tutorials/how-to-build-a-photo-search-app-with-react-using-the-unsplash-api
var unsplash = createApi({
  accessKey: "73gEZbtsC292r0CVA7m0WWXT7osgXvr0NVMeK7SxW0s"
});
var SearchUnsplash = (function (_ref3) {
  var _query = _ref3.query,
    value = _ref3.value,
    setValue = _ref3.setValue,
    imageWidth = _ref3.imageWidth,
    imageHeight = _ref3.imageHeight;
  var defaultQuery = "nature";
  var isInitialized = useRef(false);
  var _useState = useState(_query ? _query : defaultQuery),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    pics = _useState4[0],
    setPics = _useState4[1];
  var searchPhotos = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(immediateQuery) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            /*
            unsplash.search
            .photos(query)
            .then(toJson)
            .then((json) => {
              // console.log(json);
              setPics(json.results);
            });
            */
            unsplash.search.getPhotos({
              query: immediateQuery ? immediateQuery : query ? query : defaultQuery /*, orientation: "landscape"*/
            }).then(function (result) {
              setPics(result.response.results);
            }).catch(function (e) {
              console.log("something went wrong!");
              console.log(e);
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function searchPhotos(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function (_) {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isInitialized.current) {
              console.log('init SearchUnsplash');
              isInitialized.current = true;
              searchPhotos();
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))([]);
  });
  var onKeyDown = function onKeyDown(e) {
    console.log(e.key);
    if (e.key === 'Enter') {
      searchPhotos();
    }
  };
  return /*#__PURE__*/React.createElement(Root$G, {
    className: classes$M.root,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement("form", {
    className: classes$M.form,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      searchPhotos();
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    style: {
      /*maxHeight:'34px',*/width: '100%',
      maxWidth: '472px'
    }
  }, /*#__PURE__*/React.createElement(SearchField, {
    placeholder: "Photos",
    searchExpression: query,
    setSearchExpression: function setSearchExpression(query) {
      setQuery(query);
      searchPhotos(query);
    },
    style: {
      margin: '8px'
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes$M.cardList
  }, typeof value === 'string' && value.includes('unsplash.com') && /*#__PURE__*/React.createElement("div", {
    className: classes$M.card,
    key: 'current-pic'
  }, /*#__PURE__*/React.createElement("img", {
    className: classes$M.cardImage,
    alt: 'current',
    src: crop(value, imageWidth, imageHeight),
    width: "50%",
    height: "50%",
    onClick: function onClick(e) {
      setValue(value);
    }
  })), pics.map(function (pic) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes$M.card,
      key: pic.id
    }, /*#__PURE__*/React.createElement("img", {
      className: classes$M.cardImage,
      alt: pic.alt_description,
      src: crop(pic.urls.full, imageWidth, imageHeight),
      width: "50%",
      height: "50%",
      onClick: function onClick(e) {
        setValue(pic.urls.full);
      }
    }));
  }), " "));
});
var crop = function crop(unsplashUrl, width, height) {
  return unsplashUrl.replace('crop=entropy', 'crop_=_').replace('&w=', '&w_=').replace('&h=', '&h_=').replace('&fit=', '&fit_=') + '&w=' + width + '&h=' + height + '&fit=crop';
};

var _excluded$2 = ["children", "value", "index"];
var PREFIX$L = 'EditableCardMedia';
var classes$L = {
  mediaRoot: "".concat(PREFIX$L, "-mediaRoot"),
  editorRoot: "".concat(PREFIX$L, "-editorRoot"),
  editorPaper: "".concat(PREFIX$L, "-editorPaper"),
  editorForm: "".concat(PREFIX$L, "-editorForm"),
  editorButton: "".concat(PREFIX$L, "-editorButton"),
  link: "".concat(PREFIX$L, "-link")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$F = styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$L.mediaRoot), {
    //height: '110px',
  }), _defineProperty(_ref2, "& .".concat(classes$L.editorRoot), {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$L.editorPaper), {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), _defineProperty(_ref2, "& .".concat(classes$L.editorForm), {
    padding: 8,
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$L.editorButton), {
    padding: 8
  }), _defineProperty(_ref2, "& .".concat(classes$L.link), {
    color: 'rgba(0, 0, 0, 0.87)',
    //theme.palette.secondary.main
    textDecoration: 'underline',
    fontSize: '1.125rem',
    fontFamily: 'Roboto,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    fontWeight: '500',
    lineHeight: '1.6'
  }), _ref2;
});

//import S3Image from './S3Image';

function Alert$2(props) {
  return /*#__PURE__*/React.createElement(MuiAlert, _extends({
    elevation: 6,
    variant: "filled"
  }, props));
}
function TabPanel$1(props) {
  var children = props.children,
    value = props.value,
    index = props.index,
    other = _objectWithoutProperties(props, _excluded$2);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: "full-width-tabpanel-".concat(index),
    "aria-labelledby": "full-width-tab-".concat(index)
  }, other), value === index && /*#__PURE__*/React.createElement(Box, {
    p: 0,
    style: {
      marginTop: '8px'
    }
  }, children));
}
TabPanel$1.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};
var EditableCardMedia = function EditableCardMedia(_ref3) {
  var editable = _ref3.editable;
    _ref3.album;
    var value = _ref3.value,
    _setValue = _ref3.setValue,
    title = _ref3.title,
    isEditingDefault = _ref3.isEditingDefault,
    variant = _ref3.variant,
    query = _ref3.query;
  var theme = useTheme$1();
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tabValue = _React$useState2[0];
    _React$useState2[1];
  var fullScreen = useMediaQuery$1(theme.breakpoints.down('md'));
  var _useState = useState(isEditingDefault),
    _useState2 = _slicedToArray(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var handleCloseSearchDialog = function handleCloseSearchDialog(e) {
    e.preventDefault();
    setIsEditing(false);
  };
  var onKeyDown = function onKeyDown(e) {
    //e.preventDefault();
    console.log(e.key);
    if (e.key === 'Escape') {
      console.log('ESCAPE');
      e.preventDefault();
      setIsEditing(false);
    }
    if (e.key === 'Enter') {
      console.log('ENTER');
      e.preventDefault();
    }
  };
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    imageURL = _useState4[0],
    setImageURL = _useState4[1];
  useEffect(function (_) {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _value$storage, key, options;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!value) {
              _context.next = 10;
              break;
            }
            if (!(typeof value === 'string' && value.startsWith('http'))) {
              _context.next = 5;
              break;
            }
            setImageURL(value);
            _context.next = 9;
            break;
          case 5:
            if (!(value !== null && value !== void 0 && value.storage)) {
              _context.next = 9;
              break;
            }
            _value$storage = value.storage, key = _value$storage.key, options = _value$storage.options;
            _context.next = 9;
            return Storage.get(key, options).then(function (url) {
              setImageURL(url);
            }).catch(function (error) {
              console.error(error);
            });
          case 9:
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))([value]);
  });
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    storing = _useState6[0];
    _useState6[1];
  var _useState7 = useState('Uploading your photo'),
    _useState8 = _slicedToArray(_useState7, 2),
    storingMessage = _useState8[0];
    _useState8[1];
  return /*#__PURE__*/React.createElement(Root$F, null, /*#__PURE__*/React.createElement(CardMedia
  //classes={{ root: classes.mediaRoot }}
  , {
    image: imageURL //value}
    //title={title}
    ,
    style: variant === 'cover' ? {
      height: '110px',
      //width: undefined
      //borderTopLeftRadius: '',
      //borderTopRightRadius: '',
      borderBottomRightRadius: '0.5rem',
      borderBottomLeftRadius: '0.5rem'
    } : variant === 'card' ? {
      height: '110px',
      //width: undefined
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem'
      //borderBottomRightRadius: '',
      //borderBottomLeftRadius: ''
    } : variant === 'cell' ? {
      borderRadius: '0.5rem',
      height: '48px',
      width: '48px'
    } : {
      borderRadius: '0.5rem'
    }
  }, editable ? /*#__PURE__*/React.createElement(Container, {
    component: "div" /*maxWidth="xs"*/,
    className: classes$L.editorRoot,
    style: isEditing ? {
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.9)'
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: classes$L.editorPaper
  }, isEditing && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: fullScreen,
    open: isEditing,
    onClose: handleCloseSearchDialog,
    "aria-labelledby": "change-photo"
    /*TransitionComponent={Transition}*/,
    onKeyDown: onKeyDown,
    style: {
      zIndex: 5000
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "responsive-dialog-title"
  }, "Change photo"), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TabPanel$1, {
    value: tabValue,
    index: 0,
    dir: theme.direction
  }, /*#__PURE__*/React.createElement("div", {
    //style={{maxWidth:'944px', margin:'96px 8px 8px'}}
    style: {
      marginTop: '16px',
      marginBottom: '16px'
    }
  }, /*#__PURE__*/React.createElement(DialogContentText, null, "Photos by ", /*#__PURE__*/React.createElement(Link$1
  //className={classes.link}
  , {
    style: {
      color: tabValue === 0 ? blue[500] : 'rgba(0, 0, 0, 0.87)',
      textDecoration: 'underline'
    }
    //variant="body2"
    //onClick={handleLogInInstead}
    ,
    href: "https://unsplash.com",
    target: "_blank"
  }, "Unsplash"), ". The internet\u2019s source of freely-usable images. Powered by creators everywhere.")), /*#__PURE__*/React.createElement(SearchUnsplash, {
    query: query,
    value: value,
    setValue: function setValue(v) {
      _setValue(v);
      setIsEditing(false);
    },
    imageWidth: variant === 'cover' || variant === 'card' ? 472 : variant === 'cell' ? 472 : /*default*/472,
    imageHeight: variant === 'cover' || variant === 'card' ? 110 : variant === 'cell' ? 472 : /*default*/110
  })))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button$1, {
    autoFocus: true,
    onClick: handleCloseSearchDialog
  }, "Cancel")))), !isEditing && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes$L.editorButton,
    style: {/*maxHeight:'34px'*/}
  },
  /*#__PURE__*/
  /*title && */
  React.createElement(SpoketreeButton, {
    color: "secondary",
    variant: "outlined",
    "aria-label": "edit",
    onClick: function onClick(_) {
      return setIsEditing(true);
    },
    style: {
      float: 'right' /*,marginTop:'16px',marginRight:'16px'*/,
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      maxWidth: !title ? '32px' : undefined,
      minWidth: !title ? 'unset' : undefined,
      maxHeight: !title ? '32px' : undefined
    }
  }, /*#__PURE__*/React.createElement(EditIcon, null), title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: '4px'
    }
  }), title)), false  )))) : /*#__PURE__*/React.createElement(React.Fragment, null)), /*#__PURE__*/React.createElement(Snackbar, {
    open: storing
  }, /*#__PURE__*/React.createElement(Alert$2, {
    severity: "info"
  }, storingMessage)));
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var SPOKETREE_COM_AU = 'spoketree.com.au';
var NELLERCONNECT_ROOT_DOMAIN = 'nellerconnect.com.au';
var SPOKETREE_ROOT_DOMAIN = SPOKETREE_COM_AU;
var localhostNames = ['localhost', '127.0.0.1', '192.168.172.192'];
var systemAliases = ['www', 'prod', 'staging', 'dev', 'local'];
var hostname = window.location.hostname;
var port = window.location.host.split(':')[1];
var pathname = window.location.pathname;
var prefix = hostname.split('.')[0];
var host = function host() {
  var nellerconnectNames = systemAliases.map(function (alias) {
    return [alias, NELLERCONNECT_ROOT_DOMAIN].join('.');
  });
  var spoketreeNames = [].concat(_toConsumableArray(systemAliases.map(function (alias) {
    return [alias, SPOKETREE_ROOT_DOMAIN].join('.');
  })), [SPOKETREE_COM_AU]);
  var systemNames = [].concat(_toConsumableArray(nellerconnectNames), _toConsumableArray(spoketreeNames));
  var isLocalhostName = localhostNames.includes(hostname);
  var isSystemName = systemNames.includes(hostname);
  var isFeatureName = systemNames.find(function (suffix) {
    return [prefix, suffix].join('.') === hostname;
  });
  var isCustomName = !isLocalhostName && !isSystemName && !isFeatureName;
  var isMultiTenantName = isLocalhostName || isSystemName;
  var isSingleTenantName = !isMultiTenantName;
  var featureAlias = isFeatureName ? prefix && prefix === 'westsideflowers' ? process.env.REACT_APP_WESTSIDE_FLOWERS_SHOP_FEATURE_ID : "f_".concat(prefix) : isMultiTenantName && pathname.startsWith('/market/shops/f_') ? pathname.split('/market/shops/f_')[1].split('/')[0] : isMultiTenantName && pathname.startsWith('/plugin/exchange/features/f_') ? pathname.split('/plugin/exchange/features/f_')[1].split('/')[0] : undefined;
  var marketUrl = "".concat(window.location.protocol, "//").concat(isMultiTenantName ? window.location.host : isFeatureName ? hostname.split('.').slice(1).join('.') + (port ? ":".concat(port) : '') : 'spoketree.com.au');
  var shopUrl = function shopUrl(featureId) {
    return "".concat(window.location.protocol, "//").concat(featureId === null || featureId === void 0 ? void 0 : featureId.split('_').pop(), ".").concat(isLocalhostName ? 'local.spoketree.com.au:3000' : isMultiTenantName ? window.location.host : isFeatureName ? hostname.split('.').slice(1).join('.') + (port ? ":".concat(port) : '') : 'spoketree.com.au');
  };
  var value = {
    hostname: hostname,
    port: port,
    isLocalhostName: isLocalhostName,
    // isCustomerDomain or has featureAlias
    isSystemName: isSystemName,
    isCustomName: isCustomName,
    featureAlias: featureAlias,
    isMultiTenantName: isMultiTenantName,
    isSingleTenantName: isSingleTenantName,
    marketUrl: marketUrl,
    shopUrl: shopUrl
  };
  return value;
};

var alphabet$3 = '0123456789abcdefghijklmnopqrstuvwxyz';
var nanoid$3 = customAlphabet(alphabet$3, 6);
var generateId$3 = function generateId() {
  return nanoid$3();
};
var Context$e = /*#__PURE__*/createContext([]);
var Provider$e = function Provider(_ref) {
  var _useContext2;
  var children = _ref.children,
    feature = _ref.feature;
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  //const { selectedFeature } = useContext(SelectedFeatureContext);
  var selectedFeature = feature ? feature : (_useContext2 = useContext(Context$f)) === null || _useContext2 === void 0 ? void 0 : _useContext2.selectedFeature;
  var defaults = {
    isInitialized: true,
    isRetrieveAttempted: false,
    isDirty: false
  };
  var defaultLines = [/*{
                      id: '1',
                      content: {
                      labels: ['Fruit'],
                      description: 'Avocados',
                      price: {
                      EA: {
                      net: {
                      inc: 1.89
                      }
                      }
                      },
                      image: 'https://images.unsplash.com/photo-1519162808019-7de1683fa2ad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3350&q=80',
                      quantityAvailable: undefined
                      }
                      }*/];
  var isInitialized = useRef(defaults.isInitialized);
  var isRetrieveAttempted = useRef(defaults.isRetrieveAttempted);
  useRef(defaults.isDirty);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    apiParams = _useState2[0],
    setApiParams = _useState2[1];
  var _useReducer = useReducer(makeReducer(), []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    extensions = _useReducer2[0],
    dispatchExtensions = _useReducer2[1];
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (selectedFeature) {
                setApiParams({
                  partition: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(),
                  scope: 's_user',
                  level: 'l_public',
                  set: 'extensions',
                  keys: []
                });
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [selectedFeature]);
  var _adaptItem = function _adaptItem(items, key) {
    var id = key.split(':').pop();
    return {
      id: id,
      content: items.parse(id),
      mutate: function mutate(content) {
        return items.mutate(id, content);
      }
    };
  };
  var _dispatch = function _dispatch(_updatedItems) {
    var wrappedItems = wrapItems(_objectSpread2(_objectSpread2({
      endpoint: 'spoketree-database-auth'
    }, apiParams), {}, {
      items: _updatedItems,
      setItems: function () {
        var _setItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(updatedItems) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _dispatch(updatedItems));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function setItems(_x2) {
          return _setItems.apply(this, arguments);
        }
        return setItems;
      }()
    }));
    var adaptedItems = wrappedItems.keys().map(function (key) {
      return _adaptItem(wrappedItems, key);
    });
    wrappedItems.keys().forEach(function (key) {
      var adaptedItem = adaptedItems.find(function (_ref3) {
        var id = _ref3.id;
        return id === key.split(':').pop();
      });
      dispatchExtensions({
        type: "UPDATED",
        payload: adaptedItem
      });
    });
  };
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExtensionsReady = _useState4[0],
    setIsExtensionsReady = _useState4[1];
  useEffect(function (_) {
    (function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_) {
        var authApi, retrievedItems, wrappedLineItems, adaptedLineItems;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!apiParams && !isInitialized.current)) {
                _context4.next = 7;
                break;
              }
              console.log("init extensions");
              isInitialized.current = defaults.isInitialized;
              isRetrieveAttempted.current = defaults.isRetrieveAttempted;
              //isDirty.current = false;
              dispatchExtensions({
                type: "LOADED",
                payload: defaultLines
              });
              _context4.next = 31;
              break;
            case 7:
              if (!(apiParams && !isRetrieveAttempted.current)) {
                _context4.next = 31;
                break;
              }
              //console.log("retrieve extensions");
              isInitialized.current = false;
              isRetrieveAttempted.current = true;
              _context4.prev = 10;
              /*
              const unauthApi = makeItemsAPI({
                endpoint: 'spoketree-database-unauth',  // public read access
                ...apiParams
              });
              const retrievedItems = await unauthApi.getItems();
              */
              authApi = makeItemsAPI(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams));
              _context4.next = 14;
              return authApi.getItems();
            case 14:
              retrievedItems = _context4.sent;
              console.log('retrievedItems');
              console.log(retrievedItems);
              wrappedLineItems = wrapItems(_objectSpread2(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams), {}, {
                items: retrievedItems,
                setItems: function () {
                  var _setItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(updatedItems) {
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", isAuthenticated /*AND IS FEATURE OWNER*/ ? _dispatch(updatedItems) : undefined);
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function setItems(_x4) {
                    return _setItems2.apply(this, arguments);
                  }
                  return setItems;
                }()
              })); //isDirty.current = false;
              adaptedLineItems = wrappedLineItems.keys().map(function (key) {
                return _adaptItem(wrappedLineItems, key);
              });
              if (adaptedLineItems && Array.isArray(adaptedLineItems) && adaptedLineItems.length > 0) {
                console.log('ccc');
                dispatchExtensions({
                  type: "LOADED",
                  payload: adaptedLineItems
                });
              } else {
                console.log('ddd');
                dispatchExtensions({
                  type: "LOADED",
                  payload: defaultLines
                });
              }
              setIsExtensionsReady(true);
              _context4.next = 29;
              break;
            case 23:
              _context4.prev = 23;
              _context4.t0 = _context4["catch"](10);
              console.log('eee');
              console.log(_context4.t0);
              dispatchExtensions({
                type: "LOADED",
                payload: defaultLines
              });
              throw _context4.t0;
            case 29:
              _context4.next = 31;
              break;
            case 31:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[10, 23]]);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    })()();
  }, [isAuthenticated, apiParams, defaults, defaultLines]);

  // extension: { id, content }
  var putExtension = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(extension) {
      var existingExtension, newExtension, authApi, createdExtensions, wrappedExtensions, adaptedExtensions;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            console.log('GGGG');
            console.log(extension);
            assert(extension);
            console.log('HHHH');
            existingExtension = extension !== null && extension !== void 0 && extension.id ? extensions.find(function (e) {
              var _extension$content;
              return e.content.pluginAlias === (extension === null || extension === void 0 || (_extension$content = extension.content) === null || _extension$content === void 0 ? void 0 : _extension$content.pluginAlias);
            }) : undefined;
            console.log('PUT_EXTENSION');
            console.log(existingExtension);
            newExtension = null;
            if (!existingExtension) {
              _context6.next = 13;
              break;
            }
            _context6.next = 11;
            return existingExtension === null || existingExtension === void 0 ? void 0 : existingExtension.mutate(extension === null || extension === void 0 ? void 0 : extension.content);
          case 11:
            _context6.next = 25;
            break;
          case 13:
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context6.next = 16;
            return authApi.putItem({
              key: 'extension_' + generateId$3(),
              content: extension === null || extension === void 0 ? void 0 : extension.content
            });
          case 16:
            createdExtensions = _context6.sent;
            wrappedExtensions = wrapItems(_objectSpread2(_objectSpread2({}, apiParams), {}, {
              items: createdExtensions,
              setItems: function () {
                var _setItems3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(updatedItems) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", _dispatch(updatedItems));
                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                function setItems(_x6) {
                  return _setItems3.apply(this, arguments);
                }
                return setItems;
              }()
            }));
            adaptedExtensions = wrappedExtensions.keys().map(function (key) {
              return _adaptItem(wrappedExtensions, key);
            });
            console.log('createdExtensions:CREATED');
            console.log(createdExtensions);
            console.log(wrappedExtensions);
            console.log(adaptedExtensions);
            if (adaptedExtensions && Array.isArray(adaptedExtensions) && adaptedExtensions.length > 0) {
              console.log('fff');
              dispatchExtensions({
                type: "CREATED",
                payload: adaptedExtensions[0]
              });
            }
            newExtension = adaptedExtensions[0];
          case 25:
            return _context6.abrupt("return", existingExtension ? existingExtension : newExtension);
          case 26:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function putExtension(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var deleteExtension = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(extension) {
      var existingExtension, authApi;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            console.log('deleteExtension');
            console.log(extensions);
            console.log(extension);
            existingExtension = extension !== null && extension !== void 0 && extension.id ? extensions.find(function (e) {
              var _extension$content2;
              return e.content.pluginAlias === (extension === null || extension === void 0 || (_extension$content2 = extension.content) === null || _extension$content2 === void 0 ? void 0 : _extension$content2.pluginAlias);
            }) : undefined;
            console.log('existingExtension');
            console.log(existingExtension);
            assert(existingExtension);
            //const previousEventId = existingExtensionExtension ? existingExtension[0].H_SK.split('#')[3] : undefined;
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context7.next = 10;
            return authApi.deleteItem({
              key: existingExtension.id
              //previousEventId
            });
          case 10:
            console.log('ggg');
            dispatchExtensions({
              type: "DELETED",
              payload: existingExtension
            });
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function deleteExtension(_x7) {
      return _ref6.apply(this, arguments);
    };
  }();
  var _findExtension = function _findExtension(extensionId) {
    var found = extensions ? extensions.find(function (_ref7) {
      var id = _ref7.id;
      return id === extensionId;
    }) : undefined;
    return found;
  };
  var value = {
    extensions: extensions,
    isExtensionsReady: isExtensionsReady,
    findExtension: _findExtension,
    putExtension: putExtension,
    deleteExtension: deleteExtension
  };
  return /*#__PURE__*/React.createElement(Context$e.Provider, {
    value: value
  }, children);
};
var Consumer$8 = Context$e.Consumer;
var ExtensionsStore = {
  Context: Context$e,
  Provider: Provider$e,
  Consumer: Consumer$8
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var useExtensions = function useExtensions(_) {
  var _useContext = useContext(Context$e),
    extensions = _useContext.extensions,
    putExtension = _useContext.putExtension,
    deleteExtension = _useContext.deleteExtension;
  return [extensions, putExtension, deleteExtension];
};

var alias$2 = "messageeditor";
var name$2 = "Spoketree Message Editor";
var description$2 = "Edit the content of messages in Spoketree";
var image$2 = "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";
var roles$2 = [
	{
		alias: "r_admin",
		name: "Administrators"
	}
];
var actions$2 = [
	{
		object: "message",
		name: "Edit Message",
		match: {
			exchangePhase: "produced",
			suffix: "json"
		},
		disposition: "iframe",
		fullScreen: true
	}
];
var configuration$2 = {
	groups: [
		{
			name: "Message Editing",
			description: "To edit a message, click the '...' menu on a message that has the state 'pending' and then click 'Edit'. The message will be displayed in the Spoketree Message Editor."
		}
	]
};
var messageeditor = {
	alias: alias$2,
	name: name$2,
	description: description$2,
	image: image$2,
	roles: roles$2,
	actions: actions$2,
	configuration: configuration$2
};

var alias$1 = "messagereprocessor";
var name$1 = "Spoketree Message Reprocessor";
var description$1 = "Reprocess messages in Spoketree";
var image$1 = "https://images.unsplash.com/photo-1417733403748-83bbc7c05140?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";
var roles$1 = [
	{
		alias: "r_admin",
		name: "Administrators"
	}
];
var actions$1 = [
	{
		object: "message",
		name: "Reprocess Message",
		match: {
			exchangePhase: "consumed"
		},
		disposition: "iframe"
	}
];
var configuration$1 = {
	groups: [
		{
			name: "Message Reprocessing",
			description: "To reprocess a message, click the '...' menu on a message that has the state 'sent' and then click 'Reprocess'. The message will then have the state 'pending'."
		}
	]
};
var messagereprocessor = {
	alias: alias$1,
	name: name$1,
	description: description$1,
	image: image$1,
	roles: roles$1,
	actions: actions$1,
	configuration: configuration$1
};

var alias = "supplierportal";
var name = "EZYB2B Supplier Portal";
var description = "Empower your smaller suppliers with seamless web browser access to effortlessly receive your orders and submit invoices. Unlock the full potential of your EDI investment and optimize business efficiencies within your supplier network. Experience hassle-free order processing and streamlined communication for enhanced collaboration.";
var image = "https://images.unsplash.com/photo-1590247813693-5541d1c609fd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80";
var roles = [
	{
		alias: "r_customer",
		name: "Customers"
	},
	{
		alias: "r_supplier",
		name: "Suppliers"
	}
];
var actions = [
	{
		object: "message",
		name: "Manage Order",
		match: {
			exchangeZone: "depot",
			exchangePhase: "produced",
			messageType: "stash",
			exchangeStage: "received",
			kitId: "k_exchange",
			workflowName: "stash-order"
		}
	},
	{
		object: "message",
		name: "View Order",
		match: {
			exchangeZone: "depot",
			exchangePhase: "consumed",
			messageType: "stash",
			exchangeStage: "received",
			kitId: "k_exchange",
			workflowName: "stash-order"
		},
		examples: [
			"s3://spoketreeexchanges3storagedev/depot/produced/stash_received/k_exchange/stash-order/AIDAYRJMDSEG2UN5HXGFN/sussextaps-abksupplies/ORD000001.json",
			"s3://spoketreeexchanges3storagedev/depot/consumed/stash_received/k_exchange/stash-order/AIDAYRJMDSEG2UN5HXGFN/sussextaps-abksupplies/ORD000001.json"
		]
	}
];
var featureNameTemplate = [
	{
		roleAlias: "r_customer",
		pattern: "{settings['supplier-name']} Portal"
	},
	{
		roleAlias: "r_supplier",
		pattern: "{settings['customer-name']} Portal"
	}
];
var configuration = {
	groups: [
		{
			name: "Participant Names",
			description: "The Exchange name displayed to the customer is derived from the supplier name and vice verca.",
			settings: [
				{
					alias: "customer-name",
					icon: "Business",
					label: "Customer",
					inputLabel: "Customer Name"
				},
				{
					alias: "supplier-name",
					icon: "Factory",
					label: "Supplier",
					inputLabel: "Supplier Name"
				}
			]
		}
	]
};
var supplierportal = {
	alias: alias,
	name: name,
	description: description,
	image: image,
	roles: roles,
	actions: actions,
	featureNameTemplate: featureNameTemplate,
	configuration: configuration
};

/*
 *   Copyright (c) 2023 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var extensionPlugins = {
  messageeditor: messageeditor,
  messagereprocessor: messagereprocessor,
  supplierportal: supplierportal
};

var PREFIX$K = 'SpoketreeDialog';
var classes$K = {
  container: "".concat(PREFIX$K, "-container"),
  paper: "".concat(PREFIX$K, "-paper")
};
var Root$E = styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$K.container), {
    margin: 0,
    padding: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  }), _defineProperty(_ref2, "& .".concat(classes$K.paper), {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), _ref2;
});
var SpoketreeDialog = function SpoketreeDialog(_ref3) {
  var isVisible = _ref3.isVisible,
    setIsVisible = _ref3.setIsVisible,
    title = _ref3.title,
    content = _ref3.content,
    buttons = _ref3.buttons;
  useTheme$1();

  //const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  // larger than 490px
  var fullScreen = useMediaQuery$1("(min-width: 490px)");
  var handleClose = function handleClose(e) {
    e.preventDefault();
    setIsVisible(false);
  };
  var handleKeyDown = function handleKeyDown(e) {
    //e.preventDefault();
    if (e.key === 'Escape') {
      e.preventDefault();
      setIsVisible(false);
    }
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };
  return isVisible ? /*#__PURE__*/React.createElement(Root$E, null, /*#__PURE__*/React.createElement(Container, {
    component: "div",
    className: classes$K.container,
    style: isVisible ? {
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.9)'
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: classes$K.paper
  }, /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: fullScreen,
    open: isVisible,
    onClose: handleClose,
    onKeyDown: handleKeyDown,
    style: {
      zIndex: 5000
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, null, title), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Stack$1, null, /*#__PURE__*/React.createElement(DialogContentText, null, content === null || content === void 0 ? void 0 : content.text), /*#__PURE__*/React.createElement("div", null, content === null || content === void 0 ? void 0 : content.body))), /*#__PURE__*/React.createElement(DialogActions, null, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button) {
    var _onClick = _typeof(button) === 'object' ? Object.values(button)[0] : undefined;
    var label = _typeof(button) === 'object' ? Object.keys(button)[0] : /*string*/button;
    return /*#__PURE__*/React.createElement(SpoketreeButton, {
      label: label,
      onClick: function onClick(e) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
        setIsVisible(false);
      }
    }, label);
  })))))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};

var _excluded$1 = ["label", "icon", "dialogHash", "dialog"];
var SpoketreeButtonWithDialog = function SpoketreeButtonWithDialog(props) {
  var buttonLabel = props.label,
    buttonIcon = props.icon,
    _props$dialogHash = props.dialogHash,
    dialogHash = _props$dialogHash === void 0 ? "dialog" : _props$dialogHash,
    _props$dialog = props.dialog,
    dialogTitle = _props$dialog.title,
    dialogContent = _props$dialog.content,
    _props$dialog$buttons = _props$dialog.buttons,
    dialogButtons = _props$dialog$buttons === void 0 ? [] : _props$dialog$buttons,
    rest = _objectWithoutProperties(props, _excluded$1);
  var _useState = useState(window.location.hash === dialogHash),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  useEffect(function () {
    var checkHash = function checkHash() {
      setIsVisible(window.location.hash === "#".concat(dialogHash));
    };
    window.addEventListener('hashchange', checkHash);
    checkHash();
    return function () {
      window.removeEventListener('hashchange', checkHash);
    };
  }, []);
  var _setIsVisible = function _setIsVisible(visible) {
    window.location.hash = visible ? dialogHash : '';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!buttonIcon && !buttonLabel ? /*#__PURE__*/React.createElement(IconButton, {
    edge: "start"
    //className={classes.menuButton}
    ,
    onClick: function onClick(e) {
      return _setIsVisible(true);
    },
    size: "small",
    style: {
      padding: 0,
      margin: 0
    }
  }, buttonIcon) : /*#__PURE__*/React.createElement(SpoketreeButton, _extends({}, rest, {
    onClick: function onClick(e) {
      return _setIsVisible(true);
    }
  }), buttonIcon, buttonLabel), /*#__PURE__*/React.createElement(SpoketreeDialog, {
    isVisible: isVisible,
    setIsVisible: _setIsVisible,
    title: dialogTitle,
    content: dialogContent,
    buttons: dialogButtons
  }));
};

var alphabet$2 = '0123456789abcdefghijklmnopqrstuvwxyz';
var nanoid$2 = customAlphabet(alphabet$2, 6);
var generateId$2 = function generateId() {
  return nanoid$2();
};
var Context$d = /*#__PURE__*/createContext([]);
var Provider$d = function Provider(_ref) {
  var _useContext2;
  var children = _ref.children,
    feature = _ref.feature;
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var selectedFeature = feature ? feature : (_useContext2 = useContext(Context$f)) === null || _useContext2 === void 0 ? void 0 : _useContext2.selectedFeature;
  var defaults = {
    isInitialized: true,
    isRetrieveAttempted: false,
    isDirty: false
  };
  var defaultLines = [/*{
                      id: '1',
                      content: {
                      labels: ['Fruit'],
                      description: 'Avocados',
                      price: {
                      EA: {
                      net: {
                      inc: 1.89
                      }
                      }
                      },
                      image: 'https://images.unsplash.com/photo-1519162808019-7de1683fa2ad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3350&q=80',
                      quantityAvailable: undefined
                      }
                      }*/];
  var isInitialized = useRef(defaults.isInitialized);
  var isRetrieveAttempted = useRef(defaults.isRetrieveAttempted);
  useRef(defaults.isDirty);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    apiParams = _useState2[0],
    setApiParams = _useState2[1];
  var _useReducer = useReducer(makeReducer(), []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    scenarios = _useReducer2[0],
    dispatchScenarios = _useReducer2[1];
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (selectedFeature) {
                setApiParams({
                  partition: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(),
                  scope: 's_user',
                  level: 'l_protected',
                  set: 'scenarios',
                  keys: []
                });
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [selectedFeature]);
  var _adaptItem = function _adaptItem(items, key) {
    var id = key.split(':').pop();
    return {
      id: id,
      content: items.parse(id),
      mutate: function mutate(content) {
        return items.mutate(id, content);
      }
    };
  };
  var _dispatch = function _dispatch(_updatedItems) {
    var wrappedItems = wrapItems(_objectSpread2(_objectSpread2({
      endpoint: 'spoketree-database-auth'
    }, apiParams), {}, {
      items: _updatedItems,
      setItems: function () {
        var _setItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(updatedItems) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _dispatch(updatedItems));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function setItems(_x2) {
          return _setItems.apply(this, arguments);
        }
        return setItems;
      }()
    }));
    var adaptedItems = wrappedItems.keys().map(function (key) {
      return _adaptItem(wrappedItems, key);
    });
    wrappedItems.keys().forEach(function (key) {
      var adaptedItem = adaptedItems.find(function (_ref3) {
        var id = _ref3.id;
        return id === key.split(':').pop();
      });
      dispatchScenarios({
        type: "UPDATED",
        payload: adaptedItem
      });
    });
  };
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isScenariosReady = _useState4[0],
    setIsScenariosReady = _useState4[1];
  useEffect(function (_) {
    (function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_) {
        var authApi, retrievedItems, wrappedLineItems, adaptedLineItems;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!apiParams && !isInitialized.current)) {
                _context4.next = 7;
                break;
              }
              console.log("init scenarios");
              isInitialized.current = defaults.isInitialized;
              isRetrieveAttempted.current = defaults.isRetrieveAttempted;
              //isDirty.current = false;
              dispatchScenarios({
                type: "LOADED",
                payload: defaultLines
              });
              _context4.next = 31;
              break;
            case 7:
              if (!(apiParams && !isRetrieveAttempted.current)) {
                _context4.next = 31;
                break;
              }
              //console.log("retrieve scenarios");
              isInitialized.current = false;
              isRetrieveAttempted.current = true;
              _context4.prev = 10;
              /*
              const unauthApi = makeItemsAPI({
                endpoint: 'spoketree-database-unauth',  // public read access
                ...apiParams
              });
              const retrievedItems = await unauthApi.getItems();
              */
              authApi = makeItemsAPI(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams));
              _context4.next = 14;
              return authApi.getItems();
            case 14:
              retrievedItems = _context4.sent;
              console.log('retrievedItems');
              console.log(retrievedItems);
              wrappedLineItems = wrapItems(_objectSpread2(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams), {}, {
                items: retrievedItems,
                setItems: function () {
                  var _setItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(updatedItems) {
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", isAuthenticated /*AND IS FEATURE OWNER*/ ? _dispatch(updatedItems) : undefined);
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function setItems(_x4) {
                    return _setItems2.apply(this, arguments);
                  }
                  return setItems;
                }()
              })); //isDirty.current = false;
              adaptedLineItems = wrappedLineItems.keys().map(function (key) {
                return _adaptItem(wrappedLineItems, key);
              });
              if (adaptedLineItems && Array.isArray(adaptedLineItems) && adaptedLineItems.length > 0) {
                console.log('ccc');
                dispatchScenarios({
                  type: "LOADED",
                  payload: adaptedLineItems
                });
              } else {
                console.log('ddd');
                dispatchScenarios({
                  type: "LOADED",
                  payload: defaultLines
                });
              }
              setIsScenariosReady(true);
              _context4.next = 29;
              break;
            case 23:
              _context4.prev = 23;
              _context4.t0 = _context4["catch"](10);
              console.log('eee');
              console.log(_context4.t0);
              dispatchScenarios({
                type: "LOADED",
                payload: defaultLines
              });
              throw _context4.t0;
            case 29:
              _context4.next = 31;
              break;
            case 31:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[10, 23]]);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    })()();
  }, [isAuthenticated, apiParams, defaults, defaultLines]);

  // scenario: { id, content }
  var putScenario = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(scenario) {
      var existingScenario, newScenario, authApi, createdScenarios, wrappedScenarios, adaptedScenarios;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            assert(scenario);
            existingScenario = scenario !== null && scenario !== void 0 && scenario.id ? scenarios.find(function (e) {
              return !!(e !== null && e !== void 0 && e.id) && !!(scenario !== null && scenario !== void 0 && scenario.id) && e.id === (scenario === null || scenario === void 0 ? void 0 : scenario.id);
            }) : undefined;
            newScenario = null;
            if (!existingScenario) {
              _context6.next = 8;
              break;
            }
            _context6.next = 6;
            return existingScenario === null || existingScenario === void 0 ? void 0 : existingScenario.mutate(scenario === null || scenario === void 0 ? void 0 : scenario.content);
          case 6:
            _context6.next = 16;
            break;
          case 8:
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context6.next = 11;
            return authApi.putItem({
              key: 'fs_' + generateId$2(),
              content: scenario === null || scenario === void 0 ? void 0 : scenario.content
            });
          case 11:
            createdScenarios = _context6.sent;
            wrappedScenarios = wrapItems(_objectSpread2(_objectSpread2({}, apiParams), {}, {
              items: createdScenarios,
              setItems: function () {
                var _setItems3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(updatedItems) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", _dispatch(updatedItems));
                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                function setItems(_x6) {
                  return _setItems3.apply(this, arguments);
                }
                return setItems;
              }()
            }));
            adaptedScenarios = wrappedScenarios.keys().map(function (key) {
              return _adaptItem(wrappedScenarios, key);
            });
            if (adaptedScenarios && Array.isArray(adaptedScenarios) && adaptedScenarios.length > 0) {
              dispatchScenarios({
                type: "CREATED",
                payload: adaptedScenarios[0]
              });
            }
            newScenario = adaptedScenarios[0];
          case 16:
            return _context6.abrupt("return", existingScenario ? existingScenario : newScenario);
          case 17:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function putScenario(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var deleteScenario = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(scenario) {
      var existingScenario, authApi;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            console.log('deleteScenario');
            console.log(scenarios);
            console.log(scenario);
            existingScenario = scenario !== null && scenario !== void 0 && scenario.id ? scenarios.find(function (e) {
              return e.id === (scenario === null || scenario === void 0 ? void 0 : scenario.id);
            }) : undefined;
            console.log('existingScenario');
            console.log(existingScenario);
            assert((existingScenario === null || existingScenario === void 0 ? void 0 : existingScenario.id) === (scenario === null || scenario === void 0 ? void 0 : scenario.id));
            //const previousEventId = existingScenario ? existingScenario[0].H_SK.split('#')[3] : undefined;
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context7.next = 10;
            return authApi.deleteItem({
              key: existingScenario.id
              //previousEventId
            });
          case 10:
            console.log('ggg');
            dispatchScenarios({
              type: "DELETED",
              payload: existingScenario
            });
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function deleteScenario(_x7) {
      return _ref6.apply(this, arguments);
    };
  }();
  var _findScenario = function _findScenario(scenarioId) {
    var found = scenarios ? scenarios.find(function (_ref7) {
      var id = _ref7.id;
      return id === scenarioId;
    }) : undefined;
    return found;
  };
  var value = {
    scenarios: scenarios,
    isScenariosReady: isScenariosReady,
    findScenario: _findScenario,
    putScenario: putScenario,
    deleteScenario: deleteScenario
  };
  return /*#__PURE__*/React.createElement(Context$d.Provider, {
    value: value
  }, children);
};
var Consumer$7 = Context$d.Consumer;
var ScenariosStore = {
  Context: Context$d,
  Provider: Provider$d,
  Consumer: Consumer$7
};

var Context$c = /*#__PURE__*/createContext([]);
var Provider$c = function Provider(_ref) {
  var children = _ref.children;
    _ref.filter;
  var _useContext = useContext(SpoketreeAuthStore.Context),
    isAuthenticating = _useContext.isAuthenticating;
    _useContext.isAuthenticated;

  //const [ shopKeys, dispatchShopKeys ] = useReducer(makeReducer(), []);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    systemCapabilityCreatorGrants = _useState2[0],
    _setSystemCapabilityCreatorGrants = _useState2[1];
  var setSystemCapabilityCreatorGrants = function setSystemCapabilityCreatorGrants(v) {
    _setSystemCapabilityCreatorGrants(v);
  };
  var _useReducer = useReducer(makeReducer(), []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    allCapabilitySettingsSecret = _useReducer2[0],
    dispatchAllCapabilitySettingsSecret = _useReducer2[1];
  var _useReducer3 = useReducer(makeReducer(), []),
    _useReducer4 = _slicedToArray(_useReducer3, 2),
    allCapabilitySettingsPrivate = _useReducer4[0],
    dispatchAllCapabilitySettingsPrivate = _useReducer4[1];
  var _useReducer5 = useReducer(makeReducer(), []),
    _useReducer6 = _slicedToArray(_useReducer5, 2),
    allCapabilitySettingsProtected = _useReducer6[0],
    dispatchAllCapabilitySettingsProtected = _useReducer6[1];
  var _useReducer7 = useReducer(makeReducer(), []),
    _useReducer8 = _slicedToArray(_useReducer7, 2),
    allCapabilitySettingsPublic = _useReducer8[0],
    dispatchAllCapabilitySettingsPublic = _useReducer8[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    allCapabilities = _useState4[0],
    setAllCapabilities = _useState4[1];
  var _useReducer9 = useReducer(makeReducer(), []),
    _useReducer10 = _slicedToArray(_useReducer9, 2),
    scenarios = _useReducer10[0],
    dispatchScenarios = _useReducer10[1];
  var _useReducer11 = useReducer(makeReducer(), []),
    _useReducer12 = _slicedToArray(_useReducer11, 2),
    reports = _useReducer12[0],
    dispatchReports = _useReducer12[1];
  var settingsDispatchers = {
    secret: dispatchAllCapabilitySettingsSecret,
    private: dispatchAllCapabilitySettingsPrivate,
    protected: dispatchAllCapabilitySettingsProtected,
    public: dispatchAllCapabilitySettingsPublic
  };
  var collectionDispatchers = {
    scenarios: dispatchScenarios,
    reports: dispatchReports
  };
  var _retrieveCapabilityItems = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
      var capabilityId, scope, level, set, keys, setAlias, dispatch, partition, api, retrievedItems, _dispatch;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            capabilityId = _ref2.capabilityId, scope = _ref2.scope, level = _ref2.level, set = _ref2.set, keys = _ref2.keys, setAlias = _ref2.setAlias, dispatch = _ref2.dispatch;
            partition = capabilityId;
            api = makeItemsAPI({
              endpoint: 'spoketree-database-unauth',
              partition: partition,
              scope: scope,
              level: level,
              set: set,
              keys: keys
            });
            _context2.next = 5;
            return api.getItems();
          case 5:
            retrievedItems = _context2.sent;
            //const capability = capabilities.find(({ id }) => id === capabilityId);
            _dispatch = function _dispatch(_ref4) {
              var type = _ref4.type,
                items = _ref4.items;
              return dispatch({
                type: type,
                payload: _defineProperty({
                  //...capability,
                  id: capabilityId
                }, setAlias, wrapItems({
                  endpoint: 'spoketree-database-unauth',
                  partition: partition,
                  scope: scope,
                  level: level,
                  set: set,
                  keys: keys,
                  items: items,
                  setItems: function () {
                    var _setItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(updatedItems) {
                      return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            return _context.abrupt("return", _dispatch({
                              type: "UPDATED",
                              items: updatedItems
                            }));
                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee);
                    }));
                    function setItems(_x2) {
                      return _setItems.apply(this, arguments);
                    }
                    return setItems;
                  }()
                }))
              });
            };
            _dispatch({
              type: "CREATED",
              items: retrievedItems
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var settingKeys = {
    /*secret: [
      
    ],
    private: [
      
    ],
    protected: [
    ],*/
    public: ['name',
    // Spoketree Supplier Portal
    'description', 'cardImage', 'published'
    //'scenarios',
    //'reports'
    ]
  };

  var joinType = "_join:capability"; //:c_exchange:k_instance`;

  // load capabilities list
  useSpoketreeDatabaseUnauthItems({
    partition: 's_community',
    scope: 's_system',
    level: 'l_public',
    set: "".concat(joinType, ":r_creator:_flow:a_grant"),
    keys: [],
    isAuthenticating: isAuthenticating,
    onLoad: setSystemCapabilityCreatorGrants
  });

  // load capability user settings
  useEffect(function (_) {
    (function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_) {
        var capabilityIds;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (systemCapabilityCreatorGrants) {
                console.log('systemCapabilityCreatorGrants');
                console.log(systemCapabilityCreatorGrants);
                capabilityIds = systemCapabilityCreatorGrants.keys().map(function (key) {
                  return key.split(':').pop().split('.').pop();
                });
                console.log(capabilityIds);
                capabilityIds.forEach(function (capabilityId) {
                  [
                  /*...((!!principalCapabilityJoins.find(i => (
                      i.id.startsWith(`${joinType}:r_owner:_flow:a_grant:${principalParty.getId()}.${capabilityId}`)
                    )
                  )) ? [
                    'secret', 
                    'private'
                  ] : []),
                  ...((!!principalCapabilityJoins.find(i => (
                    i.id.startsWith(`${joinType}:r_owner:_flow:a_grant:${principalParty.getId()}.${capabilityId}`) ||
                    i.id.startsWith(`${joinType}:r_viewer:_flow:a_grant:${principalParty.getId()}.${capabilityId}`)
                  ))) ? [
                    'protected'
                  ] : []),*/
                  'public'].forEach(function (level) {
                    return _retrieveCapabilityItems({
                      capabilityId: capabilityId,
                      scope: 's_user',
                      level: "l_".concat(level),
                      set: 'setting',
                      keys: settingKeys[level],
                      setAlias: "".concat(level, "Settings"),
                      //capabilities: allCapabilities,
                      dispatch: settingsDispatchers[level]
                    });
                  });
                  ['scenarios', 'reports'].forEach(function (collection) {
                    return _retrieveCapabilityItems({
                      capabilityId: capabilityId,
                      scope: 's_user',
                      level: "l_public",
                      set: collection,
                      keys: [],
                      setAlias: "".concat(collection, "Collection"),
                      //capabilities: allCapabilities,
                      dispatch: collectionDispatchers[collection]
                    });
                  });
                });
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    })()();
  }, [isAuthenticating, systemCapabilityCreatorGrants]);
  useEffect(function (_) {
    (function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_) {
        var merged, values;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              merged = lodash.merge(lodash.keyBy(allCapabilitySettingsSecret, 'id'), lodash.keyBy(allCapabilitySettingsPrivate, 'id'), lodash.keyBy(allCapabilitySettingsProtected, 'id'), lodash.keyBy(allCapabilitySettingsPublic, 'id'), lodash.keyBy(scenarios, 'id'), lodash.keyBy(reports, 'id'));
              values = lodash.values(merged);
              setAllCapabilities(values);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    })()();
  }, [allCapabilitySettingsSecret, allCapabilitySettingsPrivate, allCapabilitySettingsProtected, allCapabilitySettingsPublic, scenarios, reports]);
  var _findCapability = function _findCapability(capabilityId) {
    var found = allCapabilities ? wrapCapability(allCapabilities.find(function (_ref7) {
      var id = _ref7.id;
      return id === capabilityId;
    })) : undefined;
    return found;
  };
  var _mapCapabilities = function _mapCapabilities(callback) {
    return allCapabilities ? allCapabilities.map(function (capability) {
      return callback(wrapCapability(capability));
    }) : undefined;
  };
  var wrapCapability = function wrapCapability(wrapped) {
    return wrapped ? _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, wrapped), {}, {
      getId: function getId(_) {
        return wrapped.id;
      }
    }, Object.fromEntries(_toConsumableArray(new Map(settingKeys['public'].map(function (key) {
      return [["get".concat(lodash.startCase(key).replace(/ /g, ''))], function (_) {
        return wrapped !== null && wrapped !== void 0 && wrapped.publicSettings ? wrapped.publicSettings.parse(key) : undefined;
      }];
    }))))), Object.fromEntries(new Map(settingKeys['public'].map(function (key) {
      return [["set".concat(lodash.startCase(key).replace(/ /g, ''))], function (value) {
        var _wrapped$publicSettin;
        wrapped === null || wrapped === void 0 || (_wrapped$publicSettin = wrapped.publicSettings) === null || _wrapped$publicSettin === void 0 ? void 0 : _wrapped$publicSettin.mutate(key, value);
      }];
    })))), {}, {
      getScenarios: function getScenarios(_) {
        return wrapped === null || wrapped === void 0 ? void 0 : wrapped.scenariosCollection;
      },
      getReports: function getReports(_) {
        return wrapped === null || wrapped === void 0 ? void 0 : wrapped.reportsCollection;
      },
      getAvatarImage: function getAvatarImage(_) {
        return function (images) {
          return function (image) {
            return typeof image === 'string' ? image.startsWith('http') ? image : image.startsWith('/') ? image : '/' + image : image;
          }(images.find(function (i) {
            return !!i;
          }));
        }([wrapped !== null && wrapped !== void 0 && wrapped.publicSettings ? wrapped.publicSettings.parse('avatarImage') : undefined, wrapped !== null && wrapped !== void 0 && wrapped.publicSettings ? wrapped.publicSettings.parse('cardImage') : undefined, 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80']);
      },
      getCardImage: function getCardImage(_) {
        return function (images) {
          return function (image) {
            return typeof image === 'string' ? image.startsWith('http') ? image : image.startsWith('/') ? image : '/' + image : image;
          }(images.find(function (i) {
            return !!i;
          }));
        }([wrapped !== null && wrapped !== void 0 && wrapped.publicSettings ? wrapped.publicSettings.parse('cardImage') : undefined, wrapped !== null && wrapped !== void 0 && wrapped.publicSettings ? wrapped.publicSettings.parse('avatarImage') : undefined]);
      },
      isEditable: function isEditable(_) {
        return isCapabilityEditable(wrapped);
      }
    }) : undefined;
  };
  var value = {
    capabilities: allCapabilities,
    mapCapabilities: _mapCapabilities,
    findCapability: _findCapability
  };
  return /*#__PURE__*/React.createElement(Context$c.Provider, {
    value: value
  }, children);
};
var Consumer$6 = Context$c.Consumer;
var CapabilitiesStore = {
  Context: Context$c,
  Provider: Provider$c,
  Consumer: Consumer$6
};

var PREFIX$J = 'SpoketreeCard';
var classes$J = {
  root: "".concat(PREFIX$J, "-root"),
  checked: "".concat(PREFIX$J, "-checked"),
  root2: "".concat(PREFIX$J, "-root2"),
  media: "".concat(PREFIX$J, "-media"),
  topCardContentRoot: "".concat(PREFIX$J, "-topCardContentRoot"),
  topCardContentRoot_edit: "".concat(PREFIX$J, "-topCardContentRoot_edit"),
  topCardContentContainerRoot: "".concat(PREFIX$J, "-topCardContentContainerRoot"),
  paper: "".concat(PREFIX$J, "-paper")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$D = styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$J.root), {
    maxWidth: '472px'
  }), _defineProperty(_ref2, "& .".concat(classes$J.paper), {}), _defineProperty(_ref2, "& .".concat(classes$J.card), {
    height: '110px'
  }), _defineProperty(_ref2, "& .".concat(classes$J.media), {
    //height: '110px',
  }), _defineProperty(_ref2, "& .".concat(classes$J.topCardContentRoot), {
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$J.topCardContentRoot_edit), {
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '8px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$J.topCardContentContainerRoot), {
    padding: 0,
    margin: 0
  }), _ref2;
});
var SpoketreeCard$1 = function SpoketreeCard(_ref3) {
  var _ref3$mode = _ref3.mode,
    mode = _ref3$mode === void 0 ? 'view' : _ref3$mode,
    _ref3$editable = _ref3.editable,
    editable = _ref3$editable === void 0 ? false : _ref3$editable,
    resourceObject = _ref3.resourceObject,
    _ref3$resourcePropert = _ref3.resourcePropertiesStrategy,
    resourcePropertiesStrategy = _ref3$resourcePropert === void 0 ? 'getter-setter' : _ref3$resourcePropert,
    putResource = _ref3.putResource,
    deleteResource = _ref3.deleteResource,
    resourceItemUrl = _ref3.resourceItemUrl,
    resourceCollectionUrl = _ref3.resourceCollectionUrl,
    resourceCreateUrl = _ref3.resourceCreateUrl,
    cardImagePosition = _ref3.cardImagePosition,
    cardImageDefault = _ref3.cardImageDefault,
    cardImageAlbum = _ref3.cardImageAlbum,
    cardImageQuery = _ref3.cardImageQuery,
    resourceType = _ref3.resourceType,
    displayCardImage = _ref3.displayCardImage,
    displayName = _ref3.displayName,
    displayId = _ref3.displayId,
    ExtraCardcontent = _ref3.ExtraCardcontent,
    ExtraCardActions = _ref3.ExtraCardActions;
  var navigate = useNavigate();
  var isEditing = function isEditing(_) {
    return mode === 'edit' && editable;
  };

  /* resourceObject interface:
      getId
      getName
      getCardImage
  */
  var properties = resourcePropertiesStrategy === 'getter-setter' ? {
    // getter-setter strategy
    getProperty: function getProperty(name, _default) {
      return resourceObject["get".concat(lodash.upperFirst(name))]() ? resourceObject["get".concat(lodash.upperFirst(name))]() : _default;
    },
    setProperty: function setProperty(name) {
      return /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return resourceObject["set".concat(lodash.upperFirst(name))](value);
              case 2:
                return _context.abrupt("return", _context.sent);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }();
    }
  } : resourcePropertiesStrategy === 'content' ? {
    // content strategy
    getProperty: function getProperty(name, _default) {
      var _resourceObject$conte, _resourceObject$conte2;
      return resourceObject !== null && resourceObject !== void 0 && (_resourceObject$conte = resourceObject.content) !== null && _resourceObject$conte !== void 0 && _resourceObject$conte[name] ? resourceObject === null || resourceObject === void 0 || (_resourceObject$conte2 = resourceObject.content) === null || _resourceObject$conte2 === void 0 ? void 0 : _resourceObject$conte2[name] : _default;
    },
    setProperty: function setProperty(name) {
      return /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(value) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return putResource({
                  id: resourceObject.id,
                  content: _objectSpread2(_objectSpread2({}, resourceObject === null || resourceObject === void 0 ? void 0 : resourceObject.content), {}, _defineProperty({}, name, value))
                });
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }();
    }
  } : {
    getProperty: function getProperty(name) {
      throw Error('Unsupported property strategy');
    },
    setProperty: function setProperty(name, value) {
      throw Error('Unsupported property strategy');
    }
  };
  var DynamicCardActionArea = mode === 'list' ? CardActionArea : function (_ref6) {
    var children = _ref6.children;
    return /*#__PURE__*/React.createElement("div", null, children);
  };
  return /*#__PURE__*/React.createElement(Root$D, {
    className: classes$J.root
  }, (resourcePropertiesStrategy !== 'getter-setter' || (resourceObject === null || resourceObject === void 0 ? void 0 : resourceObject.getName)) && /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: classes$J.paper
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes$J.card,
    elevation: 0,
    variant: "outlined",
    style: {
      border: cardImagePosition === 'left' ? 0 : undefined
    }
  }, /*#__PURE__*/React.createElement(DynamicCardActionArea, {
    onClick: function onClick(e) {
      return navigate("".concat(resourceItemUrl, "?mode=view"));
    }
  }, cardImagePosition !== 'none' && (!cardImagePosition || cardImagePosition === 'top') && /*#__PURE__*/React.createElement(EditableCardMedia, {
    className: classes$J.media,
    editable: isEditing(),
    album: cardImageAlbum,
    title: "Change photo",
    value: !!displayCardImage ? displayCardImage : properties === null || properties === void 0 ? void 0 : properties.getProperty('cardImage', cardImageDefault),
    setValue: properties === null || properties === void 0 ? void 0 : properties.setProperty('cardImage'),
    variant: "card",
    query: cardImageQuery
  }), /*#__PURE__*/React.createElement(CardContent, {
    style: {
      width: '100%',
      marginBottom: '0px'
    },
    classes: {
      root: isEditing() ? classes$J.topCardContentRoot_edit : classes$J.topCardContentRoot
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    wrap: "nowrap",
    spacing: 2,
    classes: {
      root: classes$J.topCardContentContainerRoot
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: true,
    zeroMinWidth: true,
    style: {
      padding: 0,
      margin: '8px 8px 0 0',
      marginBottom: mode !== 'edit' ? '0px' : undefined
    }
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row"
  }, cardImagePosition === 'left' && /*#__PURE__*/React.createElement(Avatar, {
    src: !!displayCardImage ? displayCardImage : properties === null || properties === void 0 ? void 0 : properties.getProperty('cardImage', cardImageDefault),
    variant: "rounded",
    style: {
      height: mode === 'list' ? '80px' : '40px',
      width: mode === 'list' ? '80px' : '40px',
      marginTop: '-24px',
      marginRight: '16px',
      marginLeft: mode === 'list' ? '-16px' : 0
    }
  }), /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column",
    style: {
      width: '100%',
      marginTop: cardImagePosition === 'left' ? '-8px' : undefined
    }
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    justifyContent: "space-between",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'name',
    style: _defineProperty({
      float: 'left',
      width: '100%',
      paddingLeft: '0',
      marginBottom: !(properties !== null && properties !== void 0 && properties.getProperty('name')) ? '2px' : '-6px'
    }, "marginBottom", '8px')
  }, /*#__PURE__*/React.createElement(EditableText, {
    editable: isEditing(),
    label: "",
    value: mode !== "edit" && displayName ? displayName : properties === null || properties === void 0 ? void 0 : properties.getProperty('name'),
    setValue: properties === null || properties === void 0 ? void 0 : properties.setProperty('name'),
    dialogTitle: "".concat(properties !== null && properties !== void 0 && properties.getProperty('name') ? 'Change the' : 'Add a', " name")
    //tabLabel={`Exchange Instance Name`}
    ,
    createValueInstruction: "Add a name",
    inputInstruction: "Type the name here",
    variant: "h6",
    component: "h2"
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'id',
    style: {
      float: 'left',
      width: '100%',
      paddingLeft: '0',
      paddingBottom: '0px',
      fontSize: '11px',
      marginTop: mode === 'edit' ? undefined /*'-32px'*/ : '-16px',
      marginBottom: '8px'
    }
  }, /*#__PURE__*/React.createElement(EditableText, _extends({}, isEditing() ? {
    label: "".concat(lodash.startCase(resourceType), " ID")
  } : {}, {
    value: displayId ? displayId : resourceObject.id,
    variant: "p",
    component: "p",
    subtle: true
  })))), mode === 'view' && !!editable &&
  /*#__PURE__*/
  //<SpoketreeButton href={`${resourceItemUrl}?mode=edit`}>EDIT</SpoketreeButton>
  React.createElement(IconButton, {
    edge: "start",
    href: "".concat(resourceItemUrl, "?mode=edit"),
    size: "small",
    style: {
      padding: 0,
      margin: '-44px 0 0 0',
      color: 'rgba(0, 0, 0, 0.54)'
    }
    //color="secondary"
  }, /*#__PURE__*/React.createElement(SettingsIcon, null))), /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, isEditing() && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'description',
    style: {
      float: 'left',
      width: '100%',
      paddingLeft: '0',
      paddingTop: '0',
      marginTop: mode === 'edit' && !(properties !== null && properties !== void 0 && properties.getProperty('description')) ? '8px' : 0,
      marginBottom: mode === 'edit' && !(properties !== null && properties !== void 0 && properties.getProperty('description')) ? '16px' : '8px'
    }
  }, /*#__PURE__*/React.createElement(EditableText, {
    editable: isEditing(),
    editKey: 'description',
    inputLabel: "Description",
    value: properties === null || properties === void 0 ? void 0 : properties.getProperty('description'),
    setValue: properties === null || properties === void 0 ? void 0 : properties.setProperty('description'),
    dialogTitle: "".concat(properties !== null && properties !== void 0 && properties.getProperty('description') ? 'Change the' : 'Add a', " description"),
    createValueInstruction: "Add a description",
    inputInstruction: "Type the description here",
    variant: "body2",
    component: "p"
  })), !isEditing() && (properties === null || properties === void 0 ? void 0 : properties.getProperty('description')) && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'description',
    style: {
      float: 'left',
      width: '100%',
      paddingLeft: '0',
      paddingTop: '0',
      marginTop: cardImagePosition === 'left' ? '-12px' : 0,
      marginBottom: '8px'
    }
  }, /*#__PURE__*/React.createElement(EditableText, {
    editable: false,
    value: properties === null || properties === void 0 ? void 0 : properties.getProperty('description')
  }))))))), !!ExtraCardcontent && /*#__PURE__*/React.createElement(ExtraCardcontent, _extends({}, properties, {
    isEditing: isEditing
  })))), mode === 'create' && /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "".concat(resourceCreateUrl)
  }, "Create ".concat(resourceType)))), (['edit'].includes(mode) || !!ExtraCardActions) && /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1,
    style: {
      marginBottom: '0px'
    }
  }, mode === 'edit' && /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "".concat(resourceItemUrl, "?mode=view")
  }, "View"), ['edit'].includes(mode) && /*#__PURE__*/React.createElement(SpoketreeButtonWithDialog, {
    label: /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'rgba(256, 0, 0, 0.8)'
      }
    }, "Remove"),
    icon: /*#__PURE__*/React.createElement(RemoveIcon, {
      style: {
        color: 'rgba(256, 0, 0, 0.8)'
      }
      //color="secondary"
    }),

    dialogHash: "remove",
    dialog: {
      title: "Remove ".concat(properties !== null && properties !== void 0 && properties.getProperty('name') ? properties === null || properties === void 0 ? void 0 : properties.getProperty('name') : resourceType === null || resourceType === void 0 ? void 0 : resourceType.toLowerCase(), "?"),
      buttons: ['Cancel', {
        'Remove': function () {
          var _Remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return deleteResource(resourceObject);
                case 2:
                  //navigate(resourceCollectionUrl);
                  window.location.href = resourceCollectionUrl;
                case 3:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function Remove() {
            return _Remove.apply(this, arguments);
          }
          return Remove;
        }()
      }]
    }
  }), !!ExtraCardActions && /*#__PURE__*/React.createElement(ExtraCardActions, null)), editable && /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 'auto',
      marginRight: '4px'
    }
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
    //style={{marginBottom: !!ExtraCardActions ? '-8px' : 0}}
  }, ['edit'].includes(mode) && resourcePropertiesStrategy === 'content' && /*#__PURE__*/React.createElement(EditableText, {
    editable: true,
    editKey: 'content',
    value: JSON.stringify(resourceObject === null || resourceObject === void 0 ? void 0 : resourceObject.content, null, 2),
    valueDisplayExpression: function valueDisplayExpression(json) {
      return '';
    },
    setValue: /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(contentJson) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return putResource({
                id: resourceObject.id,
                content: JSON.parse(contentJson)
              });
            case 2:
              return _context4.abrupt("return", _context4.sent);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x3) {
        return _ref8.apply(this, arguments);
      };
    }(),
    dialogTitle: "Configure ".concat(resourceType.toLowerCase()),
    type: "pre",
    multiline: true,
    EditIcon: function EditIcon() {
      return /*#__PURE__*/React.createElement(CodeIcon, {
        color: "secondary",
        style: {
          marginRight: '0px',
          marginTop: '0px',
          color: 'rgba(0, 0, 0, 0.54)'
        }
      });
    }
  })))))));
};

var ScenariosList = function ScenariosList(_ref) {
  var readOnly = _ref.readOnly,
    items = _ref.items,
    setItems = _ref.setItems;
  var _useContext = useContext(Context$d),
    featureScenarios = _useContext.scenarios,
    findScenario = _useContext.findScenario;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    addedScenario = _useState2[0],
    setAddedScenario = _useState2[1];
  var onDrop = function onDrop(_ref2) {
    var removedIndex = _ref2.removedIndex,
      addedIndex = _ref2.addedIndex;
    console.log('onDrop');
    console.log(items);
    console.log({
      removedIndex: removedIndex,
      addedIndex: addedIndex
    });
    setItems(arrayMoveImmutable(items, removedIndex, addedIndex));
  };
  var handleDelete = function handleDelete(itemToDelete) {
    var newItems = items.filter(function (item) {
      return item.id !== itemToDelete.id;
    });
    setItems(newItems);
  };
  var DynamicDraggable = !readOnly ? Draggable : function (_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/React.createElement("div", null, children);
  };
  //const DynamicDragHandleIcon = !readOnly ? DragHandleIcon : ({ children }) => <div>{children}</div>;

  return /*#__PURE__*/React.createElement(List$1, null, /*#__PURE__*/React.createElement(Container$1, {
    dragHandleSelector: ".drag-handle",
    lockAxis: "y",
    onDrop: onDrop
  }, items === null || items === void 0 ? void 0 : items.map(function (item) {
    var _findScenario;
    return /*#__PURE__*/React.createElement(DynamicDraggable, {
      key: item === null || item === void 0 ? void 0 : item.id
    }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(FormControl, {
      sx: {
        width: "calc(100% - 60px)"
      },
      size: "small"
    }, /*#__PURE__*/React.createElement(EditableText, {
      editable: false
      //editKey={`report${item?.id}`}
      //Icon={Icons[icon]}
      //label={'Report'}
      //inputLabel={'Report ID'}
      ,
      value: (_findScenario = findScenario(item === null || item === void 0 ? void 0 : item.id)) === null || _findScenario === void 0 || (_findScenario = _findScenario.content) === null || _findScenario === void 0 ? void 0 : _findScenario.name
      //setValue={value => { handleChange(item?.id, value); }}
      //dialogTitle={`${false ? 'Change the' : 'Add '} ${getIndefiniteArticle('Report')} ${'report'}`}
      //tabLabel={`IAM User ID`}
      //createValueInstruction={`Add ${getIndefiniteArticle('Report')} ${'report name'}`}
      //inputInstruction={`Type ${getIndefiniteArticle('Report')} ${'report'} ID here`}
    })), !readOnly && /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(IconButton$1, {
      edge: "end",
      onClick: function onClick() {
        return handleDelete(item);
      },
      style: {
        marginTop: '-16px',
        marginRight: '0px'
      }
    }, /*#__PURE__*/React.createElement(RemoveIcon, {
      color: "secondary"
    })), /*#__PURE__*/React.createElement(ListItemIcon, {
      className: "drag-handle"
    }, /*#__PURE__*/React.createElement(DragHandleIcon, {
      color: "secondary"
    })))));
  }), !readOnly && /*#__PURE__*/React.createElement(DynamicDraggable, {
    key: 'add'
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(FormControl, {
    sx: {
      width: "calc(100% - ".concat(addedScenario ? '64px' : '96px', ")")
    },
    size: "small"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "demo-select-small"
  }, "Add a scenario"), /*#__PURE__*/React.createElement(Select, {
    labelId: "demo-select-small",
    id: "demo-select-small",
    value: addedScenario,
    label: "Add a scenario",
    onChange: function onChange(event) {
      setAddedScenario(event.target.value);
      if (!!event.target.value) {
        setItems([].concat(_toConsumableArray(items ? items : []), [{
          id: event.target.value
        }]));
      }
      setAddedScenario('');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("b", null, "Add a scenario")), featureScenarios === null || featureScenarios === void 0 ? void 0 : featureScenarios.map(function (scenario) {
    var _scenario$content, _scenario$content2, _scenario$content3;
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: scenario.id
    }, scenario !== null && scenario !== void 0 && (_scenario$content = scenario.content) !== null && _scenario$content !== void 0 && _scenario$content.name ? scenario === null || scenario === void 0 || (_scenario$content2 = scenario.content) === null || _scenario$content2 === void 0 ? void 0 : _scenario$content2.name : scenario === null || scenario === void 0 || (_scenario$content3 = scenario.content) === null || _scenario$content3 === void 0 ? void 0 : _scenario$content3.id);
  }))), false   ))));
};

var PREFIX$I = 'FeatureCard';
var classes$I = {
  root: "".concat(PREFIX$I, "-root"),
  checked: "".concat(PREFIX$I, "-checked"),
  root2: "".concat(PREFIX$I, "-root2"),
  media: "".concat(PREFIX$I, "-media"),
  counterButtonWrapper: "".concat(PREFIX$I, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$I, "-checkboxRoot"),
  checkboxRootColorfulPickup: "".concat(PREFIX$I, "-checkboxRootColorfulPickup"),
  checkboxRootDelivery: "".concat(PREFIX$I, "-checkboxRootDelivery"),
  checkboxRootColorfulDelivery: "".concat(PREFIX$I, "-checkboxRootColorfulDelivery"),
  formControl: "".concat(PREFIX$I, "-formControl"),
  packingHoursEdit: "".concat(PREFIX$I, "-packingHoursEdit"),
  timeEdit: "".concat(PREFIX$I, "-timeEdit"),
  timeView: "".concat(PREFIX$I, "-timeView"),
  dayOfWeekEdit: "".concat(PREFIX$I, "-dayOfWeekEdit"),
  shopTypeEdit: "".concat(PREFIX$I, "-shopTypeEdit"),
  expand: "".concat(PREFIX$I, "-expand"),
  expandOpen: "".concat(PREFIX$I, "-expandOpen"),
  topCardContentRoot: "".concat(PREFIX$I, "-topCardContentRoot"),
  topCardContentRoot_edit: "".concat(PREFIX$I, "-topCardContentRoot_edit"),
  topCardContentContainerRoot: "".concat(PREFIX$I, "-topCardContentContainerRoot"),
  paper: "".concat(PREFIX$I, "-paper")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$C = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$I.root2), {
    maxWidth: '472px'
    //padding: '8px',
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$I.media), {
    height: '110px'
  }), _defineProperty(_ref2, "& .".concat(classes$I.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$I.checkboxRoot), {
    verticalAlign: 'top',
    //margin: `auto ${theme.spacing(1.5)}px`,
    //marginTop: theme.spacing(0),
    //marginTop: '3px',
    //marginLeft: '4px !important',
    marginTop: '-2px',
    //marginLeft:'8px',
    marginLeft: '10px',
    marginRight: '3px',
    padding: "0 !important",
    //paddingTop: '9px !important',
    //paddingBottom: '9px !important',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$I.checkboxRootColorfulPickup), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$I.checkboxRootDelivery), {
    marginRight: '-7px',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$I.checkboxRootColorfulDelivery), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$I.formControl), {
    backgroundColor: 'lightBlue'
  }), _defineProperty(_ref2, "& .".concat(classes$I.packingHoursEdit), {
    width: '64px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$I.timeEdit), {
    width: '92px',
    height: '24px',
    marginTop: '-1px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$I.timeView), {
    width: '92px',
    height: '24px',
    marginTop: '2px'
    //color: 'rgba(0, 0, 0, 0.54) !important'
  }), _defineProperty(_ref2, "& .".concat(classes$I.dayOfWeekEdit), {
    width: '80px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$I.shopTypeEdit), {
    paddingLeft: '8px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$I.expand), _defineProperty({
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    padding: 0,
    marginTop: '32px'
  }, "marginLeft", '4px')), _defineProperty(_ref2, "& .".concat(classes$I.expandOpen), {
    transform: 'rotate(180deg)',
    padding: 0,
    marginTop: '32px',
    marginLeft: '4px'
  }), _defineProperty(_ref2, "& .".concat(classes$I.topCardContentRoot), {
    //padding: 0,
    //margin: 0
    //paddingBottom: '17px !important',
    marginRight: '16px',
    paddingTop: '16px',
    marginTop: '-8px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$I.topCardContentRoot_edit), {
    //paddingBottom: '8px !important',
    marginRight: '16px',
    paddingTop: '16px',
    marginTop: '-8px',
    paddingBottom: '8px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$I.topCardContentContainerRoot), {
    padding: 0,
    margin: 0
  }), _defineProperty(_ref2, "& .".concat(classes$I.paper), {/*
                                                           borderStyle: "solid",
                                                           borderWidth: theme.spacing(0.1),
                                                           borderColor: theme.custom.palette.itemBorderColor,
                                                           */
  }), _ref2;
});
var FeatureCard = function FeatureCard(_ref3) {
  var _extensionWithFeature, _pluginWithFeatureNam, _feature$getCreateabl;
  var feature = _ref3.feature,
    _ref3$mode = _ref3.mode,
    mode = _ref3$mode === void 0 ? 'view' : _ref3$mode;
    _ref3.showExtensions;
  useNavigate();
  var principalParty = useContext(PrincipalPartyStore.Context);
  host().isMultiTenantName ? '/plugin/exchange/features/' + (feature === null || feature === void 0 ? void 0 : feature.getId()) : '/plugin/exchange/feature';
  var getMode = function getMode() {
    return !mode ? 'view' : mode;
  };
  var isMode = function isMode(mode) {
    return mode === getMode();
  };
  var _useExtensions = useExtensions(),
    _useExtensions2 = _slicedToArray(_useExtensions, 1),
    extensions = _useExtensions2[0];
  var extensionWithFeatureNameTemplate = extensions === null || extensions === void 0 ? void 0 : extensions.find(function (extension) {
    var _extension$content, _extensionPlugins$ext, _extension$content2;
    return (extension === null || extension === void 0 || (_extension$content = extension.content) === null || _extension$content === void 0 ? void 0 : _extension$content.enabled) && ((_extensionPlugins$ext = extensionPlugins[extension === null || extension === void 0 || (_extension$content2 = extension.content) === null || _extension$content2 === void 0 ? void 0 : _extension$content2.pluginAlias]) === null || _extensionPlugins$ext === void 0 ? void 0 : _extensionPlugins$ext.featureNameTemplate);
  });
  var pluginWithFeatureNameTemplate = extensionPlugins[extensionWithFeatureNameTemplate === null || extensionWithFeatureNameTemplate === void 0 || (_extensionWithFeature = extensionWithFeatureNameTemplate.content) === null || _extensionWithFeature === void 0 ? void 0 : _extensionWithFeature.pluginAlias];
  var featureNameTemplateRoleAlias = pluginWithFeatureNameTemplate === null || pluginWithFeatureNameTemplate === void 0 || (_pluginWithFeatureNam = pluginWithFeatureNameTemplate.roles) === null || _pluginWithFeatureNam === void 0 || (_pluginWithFeatureNam = _pluginWithFeatureNam.find(function (role) {
    var _feature$getJoins;
    return !!(feature !== null && feature !== void 0 && (_feature$getJoins = feature.getJoins()) !== null && _feature$getJoins !== void 0 && _feature$getJoins.find(function (_ref4) {
      var roleAlias = _ref4.roleAlias,
        partyId = _ref4.partyId;
      return role.alias === roleAlias && (principalParty === null || principalParty === void 0 ? void 0 : principalParty.getId()) === partyId;
    }));
  })) === null || _pluginWithFeatureNam === void 0 ? void 0 : _pluginWithFeatureNam.alias;
  var _useContext = useContext(Context$c);
    _useContext.mapCapabilities;
    var findCapability = _useContext.findCapability;
  var _useContext2 = useContext(Context$d),
    scenarios = _useContext2.scenarios;
    _useContext2.putScenario;
  var getCapabilityScenario = function getCapabilityScenario(capabilityId, capabilityScenarioId) {
    var _capability$getScenar, _capability$getScenar2;
    var capability = findCapability(capabilityId);
    var capabilityScenarios = (capability !== null && capability !== void 0 && (_capability$getScenar = capability.getScenarios()) !== null && _capability$getScenar !== void 0 && _capability$getScenar._items ? Object.values(capability === null || capability === void 0 || (_capability$getScenar2 = capability.getScenarios()) === null || _capability$getScenar2 === void 0 ? void 0 : _capability$getScenar2._items) : []).map(function (i) {
      return i[0];
    }).map(function (i) {
      return {
        id: i.E_SK.split(':').pop(),
        content: i.Version_Content
      };
    });
    var capabilityScenario = capabilityScenarios === null || capabilityScenarios === void 0 ? void 0 : capabilityScenarios.find(function (scenario) {
      return scenario.id === capabilityScenarioId;
    });
    return capabilityScenario;
  };
  var resourceCollectionUrl = '/plugin/exchange/features';
  var resourceItemUrl = (host().isMultiTenantName ? '/plugin/exchange/features/' + (feature === null || feature === void 0 ? void 0 : feature.id) : '/plugin/feature/feature') + '/properties';
  var cardImageDefault = 'https://images.unsplash.com/photo-1565267172527-5cad7255d962?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1630&q=80';
  var cardImageAlbum = "spoketree/features/".concat(feature === null || feature === void 0 ? void 0 : feature.id, "/photos/card");
  var cardImageQuery = 'business';
  var _useContext3 = useContext(Context$g),
    putFeature = _useContext3.putFeature,
    deleteFeature = _useContext3.deleteFeature;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    displayName = _React$useState2[0],
    setDisplayName = _React$useState2[1];
  useEffect(function (_) {
    (function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        var _pluginWithFeatureNam2, _extensionWithFeature2, _pluginWithFeatureNam3, _extensionWithFeature3, _pluginWithFeatureNam4, _extensionWithFeature4, _pluginWithFeatureNam5, _extensionWithFeature5;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", setDisplayName(pluginWithFeatureNameTemplate && feature.getUseExtensionFeatureName() ?
              // CUSTOMER
              featureNameTemplateRoleAlias === 'r_customer' ? pluginWithFeatureNameTemplate !== null && pluginWithFeatureNameTemplate !== void 0 && (_pluginWithFeatureNam2 = pluginWithFeatureNameTemplate.featureNameTemplate) !== null && _pluginWithFeatureNam2 !== void 0 && (_pluginWithFeatureNam2 = _pluginWithFeatureNam2.find(function (_ref7) {
                var roleAlias = _ref7.roleAlias;
                return roleAlias === 'r_customer';
              })) !== null && _pluginWithFeatureNam2 !== void 0 && _pluginWithFeatureNam2.pattern && !!(extensionWithFeatureNameTemplate !== null && extensionWithFeatureNameTemplate !== void 0 && (_extensionWithFeature2 = extensionWithFeatureNameTemplate.content) !== null && _extensionWithFeature2 !== void 0 && (_extensionWithFeature2 = _extensionWithFeature2.settings) !== null && _extensionWithFeature2 !== void 0 && _extensionWithFeature2["supplier-name"]) ? pluginWithFeatureNameTemplate === null || pluginWithFeatureNameTemplate === void 0 || (_pluginWithFeatureNam3 = pluginWithFeatureNameTemplate.featureNameTemplate) === null || _pluginWithFeatureNam3 === void 0 || (_pluginWithFeatureNam3 = _pluginWithFeatureNam3.find(function (_ref8) {
                var roleAlias = _ref8.roleAlias;
                return roleAlias === 'r_customer';
              })) === null || _pluginWithFeatureNam3 === void 0 || (_pluginWithFeatureNam3 = _pluginWithFeatureNam3.pattern) === null || _pluginWithFeatureNam3 === void 0 ? void 0 : _pluginWithFeatureNam3.replace("{settings['supplier-name']}", extensionWithFeatureNameTemplate === null || extensionWithFeatureNameTemplate === void 0 || (_extensionWithFeature3 = extensionWithFeatureNameTemplate.content) === null || _extensionWithFeature3 === void 0 || (_extensionWithFeature3 = _extensionWithFeature3.settings) === null || _extensionWithFeature3 === void 0 ? void 0 : _extensionWithFeature3['supplier-name']) : pluginWithFeatureNameTemplate === null || pluginWithFeatureNameTemplate === void 0 ? void 0 : pluginWithFeatureNameTemplate.name :
              // SUPPLIER
              featureNameTemplateRoleAlias === 'r_supplier' ? pluginWithFeatureNameTemplate !== null && pluginWithFeatureNameTemplate !== void 0 && (_pluginWithFeatureNam4 = pluginWithFeatureNameTemplate.featureNameTemplate) !== null && _pluginWithFeatureNam4 !== void 0 && (_pluginWithFeatureNam4 = _pluginWithFeatureNam4.find(function (_ref9) {
                var roleAlias = _ref9.roleAlias;
                return roleAlias === 'r_supplier';
              })) !== null && _pluginWithFeatureNam4 !== void 0 && _pluginWithFeatureNam4.pattern && !!(extensionWithFeatureNameTemplate !== null && extensionWithFeatureNameTemplate !== void 0 && (_extensionWithFeature4 = extensionWithFeatureNameTemplate.content) !== null && _extensionWithFeature4 !== void 0 && (_extensionWithFeature4 = _extensionWithFeature4.settings) !== null && _extensionWithFeature4 !== void 0 && _extensionWithFeature4["customer-name"]) ? pluginWithFeatureNameTemplate === null || pluginWithFeatureNameTemplate === void 0 || (_pluginWithFeatureNam5 = pluginWithFeatureNameTemplate.featureNameTemplate) === null || _pluginWithFeatureNam5 === void 0 || (_pluginWithFeatureNam5 = _pluginWithFeatureNam5.find(function (_ref10) {
                var roleAlias = _ref10.roleAlias;
                return roleAlias === 'r_supplier';
              })) === null || _pluginWithFeatureNam5 === void 0 || (_pluginWithFeatureNam5 = _pluginWithFeatureNam5.pattern) === null || _pluginWithFeatureNam5 === void 0 ? void 0 : _pluginWithFeatureNam5.replace("{settings['customer-name']}", extensionWithFeatureNameTemplate === null || extensionWithFeatureNameTemplate === void 0 || (_extensionWithFeature5 = extensionWithFeatureNameTemplate.content) === null || _extensionWithFeature5 === void 0 || (_extensionWithFeature5 = _extensionWithFeature5.settings) === null || _extensionWithFeature5 === void 0 ? void 0 : _extensionWithFeature5['customer-name']) : pluginWithFeatureNameTemplate === null || pluginWithFeatureNameTemplate === void 0 ? void 0 : pluginWithFeatureNameTemplate.name : // OTHERWISE
              pluginWithFeatureNameTemplate === null || pluginWithFeatureNameTemplate === void 0 ? void 0 : pluginWithFeatureNameTemplate.name : feature.getName()));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    })()();
  }, [pluginWithFeatureNameTemplate, feature.getUseExtensionFeatureName(), featureNameTemplateRoleAlias, extensionWithFeatureNameTemplate]);
  return /*#__PURE__*/React.createElement(Root$C, {
    className: classes$I.root
  }, !!scenarios && (feature === null || feature === void 0 ? void 0 : feature.getName) && /*#__PURE__*/React.createElement(SpoketreeCard$1, {
    mode: mode,
    editable: feature.isEditable(),
    resourceType: "feature",
    resourceObject: feature,
    resourcePropertiesStrategy: 'getter-setter',
    putResource: putFeature,
    deleteResource: deleteFeature,
    resourceItemUrl: resourceItemUrl,
    resourceCollectionUrl: resourceCollectionUrl,
    cardImagePosition: mode === 'list' ? 'left' : mode === 'view' ? 'none' : 'top',
    cardImageDefault: cardImageDefault,
    cardImageAlbum: cardImageAlbum,
    cardImageQuery: cardImageQuery,
    displayName: displayName,
    displayCardImage: feature === null || feature === void 0 ? void 0 : feature.getCardImage(),
    ExtraCardcontent: function ExtraCardcontent(_ref11) {
      var _scenarios$sort;
      _ref11.getProperty;
        _ref11.setProperty;
        var isEditing = _ref11.isEditing;
      return mode !== 'list' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, isEditing() && pluginWithFeatureNameTemplate && /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'name',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/paddingLeft: '0',
          paddingBottom: '8px',
          marginBottom: '-4px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        component: "h5",
        style: {
          fontSize: '16px',
          marginTop: '8px',
          marginBottom: '8px',
          color: 'rgba(0, 0, 0, 0.44)'
        }
      }, /*#__PURE__*/React.createElement("b", null, "Display Name"))), isEditing() && pluginWithFeatureNameTemplate && /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'name',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/paddingLeft: '0',
          paddingBottom: '16px',
          marginBottom: '-4px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        component: "p",
        style: {
          padding: '0 0 0px'
        }
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, {
          name: "useExtensionFeatureName",
          id: "useExtensionFeatureName",
          checked: feature.getUseExtensionFeatureName(),
          onChange: function onChange(e) {
            return feature.setUseExtensionFeatureName(e.target.checked);
          },
          color: "secondary",
          classes: {
            root: classes$I.checkboxRoot
          }
        }),
        label: /*#__PURE__*/React.createElement(Typography, {
          fontSize: "0.875rem"
        }, "Use ".concat(pluginWithFeatureNameTemplate === null || pluginWithFeatureNameTemplate === void 0 ? void 0 : pluginWithFeatureNameTemplate.name, " display names"))
      }))), false  , isMode('view') && !!(scenarios !== null && scenarios !== void 0 && scenarios.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'solutionsHeading',
        style: {
          float: 'left',
          width: '100%',
          paddingLeft: '0',
          marginTop: '8px',
          paddingBottom: '0px',
          marginBottom: '-4px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        component: "h5",
        style: {
          fontSize: '16px',
          marginLeft: '0px',
          marginTop: '0px !important',
          marginBottom: '0px',
          color: 'rgba(0, 0, 0, 0.44)'
        }
      }, /*#__PURE__*/React.createElement("b", null, "Scenarios"))), /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'scenariosList',
        style: {
          float: 'left',
          width: '100%',
          marginLeft: '0px',
          paddingBottom: '0px',
          marginTop: '0px',
          marginBottom: '8px'
        }
      }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement(List, null, scenarios === null || scenarios === void 0 || (_scenarios$sort = scenarios.sort(function (a, b) {
        var _a$content, _b$content;
        return a === null || a === void 0 || (_a$content = a.content) === null || _a$content === void 0 ? void 0 : _a$content.name.localeCompare(b === null || b === void 0 || (_b$content = b.content) === null || _b$content === void 0 ? void 0 : _b$content.name);
      })) === null || _scenarios$sort === void 0 ? void 0 : _scenarios$sort.map(function (scenario) {
        var _scenario$content5, _scenario$content6, _getCapabilityScenari2, _scenario$content7, _scenario$content8, _getCapabilityScenari3, _scenario$content9, _scenario$content10, _scenario$content11, _scenario$content12, _getCapabilityScenari4, _scenario$content13, _scenario$content14;
        return /*#__PURE__*/React.createElement(ListItem$1, {
          disablePadding: true,
          style: {
            margin: 0,
            padding: 0,
            paddingBottom: '0px'
          },
          component: "a",
          href: "/plugin/exchange/features/".concat(feature === null || feature === void 0 ? void 0 : feature.getId(), "/scenarios/").concat(scenario.id)
        }, /*#__PURE__*/React.createElement(ListItemButton, null, /*#__PURE__*/React.createElement(ListItemIcon$1, null, /*#__PURE__*/React.createElement(Avatar, {
          src: scenario !== null && scenario !== void 0 && (_scenario$content5 = scenario.content) !== null && _scenario$content5 !== void 0 && _scenario$content5.cardImage ? scenario === null || scenario === void 0 || (_scenario$content6 = scenario.content) === null || _scenario$content6 === void 0 ? void 0 : _scenario$content6.cardImage : (_getCapabilityScenari2 = getCapabilityScenario(scenario === null || scenario === void 0 || (_scenario$content7 = scenario.content) === null || _scenario$content7 === void 0 ? void 0 : _scenario$content7.capabilityId, scenario === null || scenario === void 0 || (_scenario$content8 = scenario.content) === null || _scenario$content8 === void 0 ? void 0 : _scenario$content8.capabilityScenarioId)) !== null && _getCapabilityScenari2 !== void 0 && (_getCapabilityScenari2 = _getCapabilityScenari2.content) !== null && _getCapabilityScenari2 !== void 0 && _getCapabilityScenari2.cardImage ? (_getCapabilityScenari3 = getCapabilityScenario(scenario === null || scenario === void 0 || (_scenario$content9 = scenario.content) === null || _scenario$content9 === void 0 ? void 0 : _scenario$content9.capabilityId, scenario === null || scenario === void 0 || (_scenario$content10 = scenario.content) === null || _scenario$content10 === void 0 ? void 0 : _scenario$content10.capabilityScenarioId)) === null || _getCapabilityScenari3 === void 0 || (_getCapabilityScenari3 = _getCapabilityScenari3.content) === null || _getCapabilityScenari3 === void 0 ? void 0 : _getCapabilityScenari3.cardImage : cardImageDefault,
          variant: "rounded",
          style: {
            height: '40px',
            width: '40px',
            //marginTop:'-24px',
            marginRight: '16px',
            marginLeft: '-16px'
          }
        })), /*#__PURE__*/React.createElement(ListItemText$1
        //style={{color:blue[500]}}
        , {
          style: {
            color: 'rgba(0, 0, 0, 0.54)'
          },
          primary: scenario !== null && scenario !== void 0 && (_scenario$content11 = scenario.content) !== null && _scenario$content11 !== void 0 && _scenario$content11.name ? scenario === null || scenario === void 0 || (_scenario$content12 = scenario.content) === null || _scenario$content12 === void 0 ? void 0 : _scenario$content12.name : (_getCapabilityScenari4 = getCapabilityScenario(scenario === null || scenario === void 0 || (_scenario$content13 = scenario.content) === null || _scenario$content13 === void 0 ? void 0 : _scenario$content13.capabilityId, scenario === null || scenario === void 0 || (_scenario$content14 = scenario.content) === null || _scenario$content14 === void 0 ? void 0 : _scenario$content14.capabilityScenarioId)) === null || _getCapabilityScenari4 === void 0 || (_getCapabilityScenari4 = _getCapabilityScenari4.content) === null || _getCapabilityScenari4 === void 0 ? void 0 : _getCapabilityScenari4.name
        })));
      }))))))));
    },
    ExtraCardActions: feature !== null && feature !== void 0 && feature.isEditable() && isMode('view') && !!(feature !== null && feature !== void 0 && (_feature$getCreateabl = feature.getCreateableScenarios()) !== null && _feature$getCreateabl !== void 0 && _feature$getCreateabl.length) ? function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack$2, {
        direction: "row",
        spacing: 1
      }, feature.getCreateableScenarios().map(function (cs) {
        var _getCapabilityScenari5;
        var _cs$split = cs.split(':'),
          _cs$split2 = _slicedToArray(_cs$split, 2),
          capabilityId = _cs$split2[0],
          capabilityScenarioId = _cs$split2[1];
        console.log('FEATURE');
        console.log(feature);
        return /*#__PURE__*/React.createElement(SpoketreeButton, {
          href: "/plugin/exchange/features/".concat(feature === null || feature === void 0 ? void 0 : feature.getId(), "/scenarios/create?cs=").concat(capabilityId, ":").concat(capabilityScenarioId, ":", "/plugin/exchange/features/".concat(feature === null || feature === void 0 ? void 0 : feature.getId()))
        }, "Create ", (_getCapabilityScenari5 = getCapabilityScenario(capabilityId, capabilityScenarioId)) === null || _getCapabilityScenari5 === void 0 || (_getCapabilityScenari5 = _getCapabilityScenari5.content) === null || _getCapabilityScenari5 === void 0 ? void 0 : _getCapabilityScenari5.name);
        /*
        return <SpoketreeButton onClick={async e => {
          var createdScenario;
          try {
            createdScenario = await putScenario({
              content: {
                //name: getCapabilityScenario(capabilityId, capabilityScenarioId)?.content?.name,
                capabilityId,
                capabilityScenarioId
              }
            });
          } catch (error) {
            alert('Failed to create scenario');
            throw error;
          }
          if (selectedFeature?.getId() && createdScenario?.id) {
            navigate(`/plugin/exchange/features/${selectedFeature?.getId()}/scenarios/${createdScenario?.id}`);
          }
         }}>Create {getCapabilityScenario(capabilityId, capabilityScenarioId)?.content?.name}</SpoketreeButton>;
        */
      })));
    } : undefined
  }));

  /*
                      {false && isEditing() && feature.getUseExtensionFeatureName() && extensionWithFeatureNameTemplate && <Grid item key={'id'} style={{float:'left',width:'100%',paddingLeft:'0',paddingBottom:'8px',fontSize:'11px'}}>
                        <EditableText
                          Icon={ExchangeNameIcon}
                          label={`Name displayed to customer`}
                          value={
                            (
                              pluginWithFeatureNameTemplate?.featureNameTemplate?.find(({ roleAlias }) => roleAlias === 'r_customer')?.pattern &&
                              !!extensionWithFeatureNameTemplate?.content?.settings?.[`supplier-name`]
                            )
                            ? pluginWithFeatureNameTemplate?.featureNameTemplate?.find(({ roleAlias }) => roleAlias === 'r_customer')
                              ?.pattern
                              .replace(`{settings['supplier-name']}`, extensionWithFeatureNameTemplate?.content?.settings?.['supplier-name'])
                            : pluginWithFeatureNameTemplate?.name
                          }
                        />
                      </Grid>}
                      {false && isEditing() && feature.getUseExtensionFeatureName() && pluginWithFeatureNameTemplate && feature.getUseExtensionFeatureName() && <Grid item key={'id'} style={{float:'left',width:'100%',paddingLeft:'0',paddingBottom:'8px',fontSize:'11px'}}>
                        <EditableText
                          Icon={ExchangeNameIcon}
                          label={`Name displayed to supplier`}
                          value={
                            (
                              pluginWithFeatureNameTemplate?.featureNameTemplate?.find(({ roleAlias }) => roleAlias === 'r_supplier')?.pattern &&
                              !!extensionWithFeatureNameTemplate?.content?.settings?.[`customer-name`]
                            )
                            ? pluginWithFeatureNameTemplate?.featureNameTemplate?.find(({ roleAlias }) => roleAlias === 'r_supplier')?.pattern
                              .replace(`{settings['customer-name']}`, extensionWithFeatureNameTemplate?.content?.settings?.['customer-name'])
                            : pluginWithFeatureNameTemplate?.name
                          }
                        />
                      </Grid>}
                    </Grid>
                    {false && isEditing() && <Divider />}
                    {false && showExtensions && (<>
                      <Stack direction="row" spacing={1}>{
                        extensions
                        ?.filter(({ content: { enabled, pluginAlias }}) => !!enabled && !!pluginAlias)
                        ?.sort((a, b) => extensionPlugins[a?.content?.pluginAlias]?.name.localeCompare(extensionPlugins[b?.content?.pluginAlias]?.name))
                        ?.map(extension => (
                          <div style={{paddingBottom:'8px'}}>
                            <Chip 
                              label={extensionPlugins[extension?.content?.pluginAlias]?.name} 
                              size="small"
                              style={{
                                backgroundColor:'#FFAC1C',
                                fontSize: '10px',
                                color: 'darkbrown'
                              }} 
                            />
                          </div>
                        ))}
                      </Stack>
                    </>)}
                */
};

var PREFIX$H = 'LoginCard';
var classes$H = {
  root: "".concat(PREFIX$H, "-root"),
  media: "".concat(PREFIX$H, "-media"),
  counterButtonWrapper: "".concat(PREFIX$H, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$H, "-checkboxRoot"),
  action: "".concat(PREFIX$H, "-action")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$B = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$H.root), {
    maxWidth: 472
    //padding: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$H.media), {
    height: '110px'
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$H.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$H.checkboxRoot), {
    verticalAlign: 'top',
    margin: "auto ".concat(theme.spacing(1.5)),
    //marginTop: theme.spacing(0),
    marginTop: '3px',
    marginLeft: '4px !important',
    padding: "0 !important",
    color: "".concat(theme.custom.palette.notesCheckbox, " !important"),
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$H.action), {
    margin: theme.spacing(3, 0, 2)
  }), _ref2;
});
var LoginCard = function LoginCard(_ref3) {
  _ref3.setSelectedPanelId;
  var handleClick = function handleClick(e) {
    window.location.href = host().marketUrl + '/auth/login?redirect=/plugin/exchange/features';
  };
  var CardActionArea = function CardActionArea(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/React.createElement("div", null, children);
  };
  return /*#__PURE__*/React.createElement(Root$B, null,
  /*#__PURE__*/
  //process.env.REACT_APP_SPOKETREE_RELEASE_PHASE !== 'ALPHA_LEAN' && 
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes$H.root,
    elevation: 0,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(CardActionArea, {
    href: "/plugin/exchange/features/create"
  }, /*#__PURE__*/React.createElement(CardMedia$1, {
    className: classes$H.media,
    image: "/jachan-devol-xY_6ZENqcfo-unsplash.jpg" //'/spoketree-screenshot.png'
    //image='https://images.unsplash.com/photo-1548092372-0d1bd40894a3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80'
    ,
    title: "log in to spoketree"
  })), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(CardActionArea, {
    href: "/plugin/exchange/features/create"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textSecondary",
    component: "p",
    style: {
      marginBottom: '8px'
    }
  }, "Spoketree"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    style: {
      marginBottom: '8px'
    }
  }, "Log in to Spoketree"))), /*#__PURE__*/React.createElement(CardActions /*disableSpacing*/, {
    style: {
      marginTop: '-24px',
      padding: '0 16px 0px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    classes: {
      root: classes$H.actionButtonRoot,
      label: classes$H.actionButtonText
    },
    className: classes$H.action,
    style: {
      marginRight: '8px'
    } //, fontWeight:800
    ,
    color: "secondary",
    size: "small",
    variant: "outlined",
    "aria-label": "create-exchange-feature",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(LockOpenIcon, null), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: '4px'
    }
  }), "Log in")))));
};

var PREFIX$G = 'ExchangeFeaturesCard';
var classes$G = {
  root: "".concat(PREFIX$G, "-root"),
  media: "".concat(PREFIX$G, "-media"),
  counterButtonWrapper: "".concat(PREFIX$G, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$G, "-checkboxRoot"),
  action: "".concat(PREFIX$G, "-action")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$G.root), {
    maxWidth: 472
    //padding: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$G.media), {
    height: '110px'
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$G.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$G.checkboxRoot), {
    verticalAlign: 'top',
    margin: "auto ".concat(theme.spacing(1.5)),
    //marginTop: theme.spacing(0),
    marginTop: '3px',
    marginLeft: '4px !important',
    padding: "0 !important",
    color: "".concat(theme.custom.palette.notesCheckbox, " !important"),
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$G.action), {
    margin: theme.spacing(3, 0, 2)
  }), _ref2;
});

var useFeatures = function useFeatures(_) {
  var _useContext = useContext(Context$g),
    mapFeatures = _useContext.mapFeatures;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    wrappedFeatures = _useState2[0],
    setWrappedFeatures = _useState2[1];
  useEffect(function () {
    if (mapFeatures) {
      setWrappedFeatures(mapFeatures(function (feature) {
        return feature;
      }));
    }
  }, [mapFeatures]);
  return [wrappedFeatures];
};

/*
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));
*/

var ExchangeFilters = (function (_ref) {
  var selected = _ref.selected,
    setSelected = _ref.setSelected,
    feature = _ref.feature;
  //const classes = useStyles();

  var _useFeatures = useFeatures(),
    _useFeatures2 = _slicedToArray(_useFeatures, 1),
    features = _useFeatures2[0];
  var handleClick = function handleClick(key) {
    console.info(key);
    setSelected(key);
  };
  return /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, [features !== null && features !== void 0 && features.length ? {
    key: 'mine',
    label: 'My Exchanges'
  } : undefined].concat([
  //selectedFeature?.isEditable() ? 
  {
    key: 'gallery',
    label: 'Exchange Gallery'
  } // : undefined
  ], [/*!['mine', 'gallery'].includes(selected) &&*/feature ? {
    key: feature === null || feature === void 0 ? void 0 : feature.id,
    label: feature !== null && feature !== void 0 && feature.getName() ? feature === null || feature === void 0 ? void 0 : feature.getName() : feature === null || feature === void 0 ? void 0 : feature.id
  } : undefined]).filter(function (item) {
    return !!item;
  }).map(function (_ref2) {
    var key = _ref2.key,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(Chip, {
      key: key,
      label: label,
      onClick: function onClick(_) {
        return handleClick(key);
      },
      variant: selected === key ? undefined : 'outlined',
      color: selected === key ? 'secondary' : undefined
    });
  }));
});

var alphabet$1 = '0123456789abcdefghijklmnopqrstuvwxyz';
var nanoid$1 = customAlphabet(alphabet$1, 6);
var generateId$1 = function generateId() {
  return nanoid$1();
};
var Context$b = /*#__PURE__*/createContext([]);
var Provider$b = function Provider(_ref) {
  var children = _ref.children;
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var _useContext2 = useContext(Context$f),
    selectedFeature = _useContext2.selectedFeature;
  var defaults = {
    isInitialized: true,
    isRetrieveAttempted: false,
    isDirty: false
  };
  var defaultLines = [/*{
                      id: '1',
                      content: {
                      labels: ['Fruit'],
                      description: 'Avocados',
                      price: {
                      EA: {
                      net: {
                      inc: 1.89
                      }
                      }
                      },
                      image: 'https://images.unsplash.com/photo-1519162808019-7de1683fa2ad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3350&q=80',
                      quantityAvailable: undefined
                      }
                      }*/];
  var isInitialized = useRef(defaults.isInitialized);
  var isRetrieveAttempted = useRef(defaults.isRetrieveAttempted);
  useRef(defaults.isDirty);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    apiParams = _useState2[0],
    setApiParams = _useState2[1];
  var _useReducer = useReducer(makeReducer(), []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    reports = _useReducer2[0],
    dispatchReports = _useReducer2[1];
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (selectedFeature) {
                setApiParams({
                  partition: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(),
                  scope: 's_user',
                  level: 'l_protected',
                  set: 'reports',
                  keys: []
                });
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [selectedFeature]);
  var _adaptItem = function _adaptItem(items, key) {
    var id = key.split(':').pop();
    return {
      id: id,
      content: items.parse(id),
      mutate: function mutate(content) {
        return items.mutate(id, content);
      }
    };
  };
  var _dispatch = function _dispatch(_updatedItems) {
    var wrappedItems = wrapItems(_objectSpread2(_objectSpread2({
      endpoint: 'spoketree-database-auth'
    }, apiParams), {}, {
      items: _updatedItems,
      setItems: function () {
        var _setItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(updatedItems) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _dispatch(updatedItems));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function setItems(_x2) {
          return _setItems.apply(this, arguments);
        }
        return setItems;
      }()
    }));
    var adaptedItems = wrappedItems.keys().map(function (key) {
      return _adaptItem(wrappedItems, key);
    });
    wrappedItems.keys().forEach(function (key) {
      var adaptedItem = adaptedItems.find(function (_ref3) {
        var id = _ref3.id;
        return id === key.split(':').pop();
      });
      dispatchReports({
        type: "UPDATED",
        payload: adaptedItem
      });
    });
  };
  useEffect(function (_) {
    (function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_) {
        var authApi, retrievedItems, wrappedLineItems, adaptedLineItems;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!apiParams && !isInitialized.current)) {
                _context4.next = 7;
                break;
              }
              console.log("init reports");
              isInitialized.current = defaults.isInitialized;
              isRetrieveAttempted.current = defaults.isRetrieveAttempted;
              //isDirty.current = false;
              dispatchReports({
                type: "LOADED",
                payload: defaultLines
              });
              _context4.next = 30;
              break;
            case 7:
              if (!(apiParams && !isRetrieveAttempted.current)) {
                _context4.next = 30;
                break;
              }
              //console.log("retrieve reports");
              isInitialized.current = false;
              isRetrieveAttempted.current = true;
              _context4.prev = 10;
              /*
              const unauthApi = makeItemsAPI({
                endpoint: 'spoketree-database-unauth',  // public read access
                ...apiParams
              });
              const retrievedItems = await unauthApi.getItems();
              */
              authApi = makeItemsAPI(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams));
              _context4.next = 14;
              return authApi.getItems();
            case 14:
              retrievedItems = _context4.sent;
              console.log('retrievedItems');
              console.log(retrievedItems);
              wrappedLineItems = wrapItems(_objectSpread2(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams), {}, {
                items: retrievedItems,
                setItems: function () {
                  var _setItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(updatedItems) {
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", isAuthenticated /*AND IS FEATURE OWNER*/ ? _dispatch(updatedItems) : undefined);
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function setItems(_x4) {
                    return _setItems2.apply(this, arguments);
                  }
                  return setItems;
                }()
              })); //isDirty.current = false;
              adaptedLineItems = wrappedLineItems.keys().map(function (key) {
                return _adaptItem(wrappedLineItems, key);
              });
              if (adaptedLineItems && Array.isArray(adaptedLineItems) && adaptedLineItems.length > 0) {
                console.log('ccc');
                dispatchReports({
                  type: "LOADED",
                  payload: adaptedLineItems
                });
              } else {
                console.log('ddd');
                dispatchReports({
                  type: "LOADED",
                  payload: defaultLines
                });
              }
              _context4.next = 28;
              break;
            case 22:
              _context4.prev = 22;
              _context4.t0 = _context4["catch"](10);
              console.log('eee');
              console.log(_context4.t0);
              dispatchReports({
                type: "LOADED",
                payload: defaultLines
              });
              throw _context4.t0;
            case 28:
              _context4.next = 30;
              break;
            case 30:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[10, 22]]);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    })()();
  }, [isAuthenticated, apiParams, defaults, defaultLines]);

  // report: { id, content }
  var putReport = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(report) {
      var _report$content, name, query, existingReport, newReport, authApi, createdReports, wrappedReports, adaptedReports;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            console.log('putReport');
            console.log(report);
            assert(report);
            _report$content = report.content, name = _report$content.name, query = _report$content.query; //assert(id);
            assert(name);
            assert(query);
            existingReport = report !== null && report !== void 0 && report.id ? reports.find(function (_ref6) {
              var id = _ref6.id;
              return id === report.id;
            }) : undefined;
            console.log('PUT_REPORT');
            console.log(existingReport);
            newReport = null;
            if (!existingReport) {
              _context6.next = 15;
              break;
            }
            _context6.next = 13;
            return existingReport.mutate(report.content);
          case 13:
            _context6.next = 27;
            break;
          case 15:
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context6.next = 18;
            return authApi.putItem({
              key: 'report_' + generateId$1(),
              content: report.content
            });
          case 18:
            createdReports = _context6.sent;
            wrappedReports = wrapItems(_objectSpread2(_objectSpread2({}, apiParams), {}, {
              items: createdReports,
              setItems: function () {
                var _setItems3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(updatedItems) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", _dispatch(updatedItems));
                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                function setItems(_x6) {
                  return _setItems3.apply(this, arguments);
                }
                return setItems;
              }()
            }));
            adaptedReports = wrappedReports.keys().map(function (key) {
              return _adaptItem(wrappedReports, key);
            });
            console.log('createdReports:CREATED');
            console.log(createdReports);
            console.log(wrappedReports);
            console.log(adaptedReports);
            if (adaptedReports && Array.isArray(adaptedReports) && adaptedReports.length > 0) {
              console.log('fff');
              dispatchReports({
                type: "CREATED",
                payload: adaptedReports[0]
              });
            }
            newReport = adaptedReports[0];
          case 27:
            return _context6.abrupt("return", existingReport ? existingReport : newReport);
          case 28:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function putReport(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var deleteReport = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(report) {
      var existingReport, authApi;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            console.log('deleteReport');
            console.log(reports);
            console.log(report);
            existingReport = reports.find(function (_ref8) {
              var id = _ref8.id;
              return id === report.id;
            });
            console.log('existingReport');
            console.log(existingReport);
            assert(existingReport);
            //const previousEventId = existingReport ? existingReport[0].H_SK.split('#')[3] : undefined;
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context7.next = 10;
            return authApi.deleteItem({
              key: existingReport.id
              //previousEventId
            });
          case 10:
            console.log('ggg');
            dispatchReports({
              type: "DELETED",
              payload: existingReport
            });
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function deleteReport(_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
  var _findReport = function _findReport(reportId) {
    var found = reports ? reports.find(function (_ref9) {
      var id = _ref9.id;
      return id === reportId;
    }) : undefined;
    return found;
  };
  var value = {
    reports: reports,
    findReport: _findReport,
    putReport: putReport,
    deleteReport: deleteReport
  };
  return /*#__PURE__*/React.createElement(Context$b.Provider, {
    value: value
  }, children);
};
Context$b.Consumer;

var PREFIX$F = 'CapabilityCard';
var classes$F = {
  root: "".concat(PREFIX$F, "-root")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$A = styled('div')(function (_ref) {
  _ref.theme;
  return _defineProperty({}, "& .".concat(classes$F.root), {
    maxWidth: '472px'
    //padding: '8px',
    //marginLeft: '8px',
    //marginRight: '8px'
  });
});

var CapabilityCard = function CapabilityCard(_ref3) {
  var _capability$getScenar, _Object$keys, _capability$getScenar2;
  var mode = _ref3.mode,
    capability = _ref3.capability;
  var resourceItemUrl = (host().isMultiTenantName ? '/plugin/capability/capabilities/' + (capability === null || capability === void 0 ? void 0 : capability.id) : '/plugin/capability/capability') + '/properties';
  var cardImageDefault = 'https://images.unsplash.com/photo-1497211419994-14ae40a3c7a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
  var cardImageAlbum = "spoketree/capabilities/".concat(capability === null || capability === void 0 ? void 0 : capability.id, "/photos/card");
  var cardImageQuery = 'business';
  var _useContext = useContext(Context$c),
    putCapability = _useContext.putCapability,
    deleteCapability = _useContext.deleteCapability;
  var _useContext2 = useContext(Context$d),
    scenarios = _useContext2.scenarios;
  var _useContext3 = useContext(Context$b);
    _useContext3.reports;
  var createableScenarios = capability !== null && capability !== void 0 && (_capability$getScenar = capability.getScenarios()) !== null && _capability$getScenar !== void 0 && _capability$getScenar._items ? (_Object$keys = Object.keys(capability === null || capability === void 0 || (_capability$getScenar2 = capability.getScenarios()) === null || _capability$getScenar2 === void 0 ? void 0 : _capability$getScenar2._items)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (k) {
    return [capability.id, k.split(':')[1]].join(':');
  }) : undefined;
  console.log('KKKKKK');
  console.log(capability === null || capability === void 0 ? void 0 : capability.getScenarios());
  console.log(createableScenarios);
  return /*#__PURE__*/React.createElement(Root$A, {
    className: classes$F.root
  }, /*#__PURE__*/React.createElement(SpoketreeCard$1, {
    mode: mode,
    editable: false //{capability.isEditable()}
    ,
    resourceType: "capability",
    resourceObject: capability,
    resourcePropertiesStrategy: 'getter-setter',
    putResource: putCapability,
    deleteResource: deleteCapability,
    resourceItemUrl: resourceItemUrl,
    cardImageDefault: cardImageDefault,
    cardImageAlbum: cardImageAlbum,
    cardImageQuery: cardImageQuery,
    ExtraCardcontentDISABLED: function ExtraCardcontentDISABLED(_ref4) {
      _ref4.getProperty;
        _ref4.setProperty;
        _ref4.isEditing;
      return mode !== 'list' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'scenariosHeading',
        style: {
          float: 'left',
          width: '100%',
          paddingLeft: '0',
          paddingBottom: '0px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        component: "h5",
        style: {
          fontSize: '16px',
          marginTop: '0px !important',
          marginBottom: '0px',
          color: 'rgba(0, 0, 0, 0.44)'
        }
      }, /*#__PURE__*/React.createElement("b", null, "Scenarios"))),
      /*#__PURE__*/
      /*!!scenarios?.length && */
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'scenariosList',
        style: {
          float: 'left',
          width: '100%',
          paddingLeft: '0',
          paddingBottom: '0px'
        }
      }, /*#__PURE__*/React.createElement(ScenariosList, {
        readOnly: true,
        options: {
          enableLink: true,
          enableAdd: mode === 'edit'
        },
        items: scenarios
      })))));
    },
    ExtraCardActions: mode === 'gallery' && function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack$2, {
        direction: "row",
        spacing: 1
      }, /*#__PURE__*/React.createElement(SpoketreeButtonWithDialog, {
        label: "CREATE EXCHANGE",
        dialogHash: "add-".concat(capability.id),
        dialog: {
          title: "Add \"".concat(capability === null || capability === void 0 ? void 0 : capability.getName(), "\"?"),
          buttons: ["Cancel", {
            "Add Exchange": function () {
              var _AddExchange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
                var featuresResource, featureId, createdFeature;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      featuresResource = makeAPI('spoketree-community-feature', "/capabilities/c_exchange/features");
                      _context.prev = 1;
                      _context.next = 4;
                      return featuresResource.post({
                        user: {
                          protected: {
                            setting: {
                              name: capability === null || capability === void 0 ? void 0 : capability.getName(),
                              createableScenarios: createableScenarios
                            }
                          } /*,
                            private: {
                             setting: {
                               iamUserId,
                               iamUserAccessKeyId
                             }
                            },
                            secret: {
                             setting: {
                               iamUserSecretAccessKey
                             }
                            }
                            */
                        }
                      });
                    case 4:
                      createdFeature = _context.sent;
                      console.log('createdFeature:');
                      console.log(createdFeature);
                      featureId = Object.values(createdFeature.versions)[0][0].H_PK;
                      console.log(featureId);
                      //reset();
                      _context.next = 16;
                      break;
                    case 11:
                      _context.prev = 11;
                      _context.t0 = _context["catch"](1);
                      alert('Failed to create feature');
                      console.error(_context.t0);
                      throw _context.t0;
                    case 16:
                      if (featureId) {
                        window.location.href = "".concat(host().marketUrl, "/plugin/exchange/features/").concat(featureId, "?mode=view");
                      }
                    case 17:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[1, 11]]);
              }));
              function AddExchange(_x) {
                return _AddExchange.apply(this, arguments);
              }
              return AddExchange;
            }()
          }]
        }
      })));
    }
  }));
};

var PREFIX$E = 'Collection';
var classes$E = {
  root: "".concat(PREFIX$E, "-root"),
  columnsWrapper: "".concat(PREFIX$E, "-columnsWrapper"),
  fab: "".concat(PREFIX$E, "-fab"),
  todoWrapper: "".concat(PREFIX$E, "-todoWrapper"),
  icon: "".concat(PREFIX$E, "-icon")
};
var Root$z = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$E.root), {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    //justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$E.columnsWrapper), {
    //margin: "0 auto",
    //columnWidth: theme.spacing(29),
    columnGap: "16px" //"0.5rem"
  }), _defineProperty(_ref2, "& .".concat(classes$E.fab), {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }), _defineProperty(_ref2, "& .".concat(classes$E.todoWrapper), {
    //: theme.spacing(29),
    //margin: "0 auto",
    breakInside: "avoid",
    pageBreakInside: "avoid",
    //padding: "0.5rem 0",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.standard
    })
    //paddingBottom:'4px'
  }), _defineProperty(_ref2, "& .".concat(classes$E.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var Collection$4 = function Collection(_ref3) {
  var _mapCapabilities, _features$filter, _mapCapabilities2;
  _ref3.selectedPanelId;
    _ref3.setSelectedPanelId;
  var theme = useTheme$1();
  var navigate = useNavigate();

  //const [ capabilities ] = useCapabilities();
  var _useContext = useContext(CapabilitiesStore.Context),
    mapCapabilities = _useContext.mapCapabilities;
  console.log('CCCC');
  console.log(mapCapabilities(function (c) {
    return c;
  }));
  var _useContext2 = useContext(Context$l);
    _useContext2.authenticationEmail;
    var isAuthenticated = _useContext2.isAuthenticated;

  /*
  const MARGIN_LEFT = 16;
  const MARGIN_RIGHT = MARGIN_LEFT;
  const BREAKPOINT_MOBILE = 0;      // 16 288 16     320px (https://screensiz.es/iphone-3gs)
  const BREAKPOINT_TABLET = 600;    // 16 568 16
  const BREAKPOINT_LAPTOP = 960;    // 16 464 16 464 16 
  const BREAKPOINT_LAPTOPL = 1280;  // 16 416 16 416 16 416 16
  const BREAKPOINT_IS4K = 1920;     // 16 472 16 472 16 472 16 472 16
  */

  var isMobile = useMediaQuery$1(theme.breakpoints.down('sm')); // 0px
  var isTablet = useMediaQuery$1(theme.breakpoints.up("sm")); // 600px
  var isLaptop = useMediaQuery$1(theme.breakpoints.up("md")); // 960px
  var isLaptopL = useMediaQuery$1(theme.breakpoints.up("lg")); // 1280px
  var is4K = useMediaQuery$1(theme.breakpoints.up("xl")); // 1920px
  var width = is4K ? "1888px" : isLaptopL ? "1248px" : isLaptop ? "928px" : isTablet ? "568px" : "100%";
  var _false = false,
    isListView = _false.isListView; //useContext(UISettingsContext);
  width = isListView ? isLaptop || isLaptopL ? theme.spacing(75) : "100%" : width;
  useRef();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var _setSelectedFilter = _useState2[1];
  var getSelectedFilter = function getSelectedFilter() {
    return querystring$5('filter') ? querystring$5('filter') : !!(features !== null && features !== void 0 && features.length) ? 'mine' : 'gallery';
  };
  var setSelectedFilter = function setSelectedFilter(filter) {
    _setSelectedFilter(filter);
    var pathname = "/plugin/exchange/features";
    navigate({
      pathname: pathname,
      search: "?filter=".concat(filter)
    });
  };
  var _useFeatures = useFeatures(),
    _useFeatures2 = _slicedToArray(_useFeatures, 1),
    features = _useFeatures2[0];
  var _useContext3 = useContext(Context$g),
    isFeaturesReady = _useContext3.isFeaturesReady;
  console.log('features');
  console.log(features);
  var q = useQueryParam('q', '');
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    searchTerm = _useState4[0],
    setSearchTerm = _useState4[1];
  useEffect(function (_) {
    (function (_) {
      if (q) {
        setSearchTerm(q);
      }
    })();
  }, [q]);
  return (!isAuthenticated || !!isFeaturesReady && !!((_mapCapabilities = mapCapabilities(function (c) {
    return c;
  })) !== null && _mapCapabilities !== void 0 && _mapCapabilities.length)) && /*#__PURE__*/React.createElement(Root$z, null,
  /*#__PURE__*/
  /*features?.length &&*/
  React.createElement("div", {
    className: classes$E.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, false  , false  , !!isAuthenticated && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'filters',
    style: {
      float: 'left',
      marginLeft: '8px',
      marginTop: '8px',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingleft: '8px !important'
    }
  }, /*#__PURE__*/React.createElement(ExchangeFilters, {
    selected: getSelectedFilter(),
    setSelected: setSelectedFilter
  }))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    style: {
      width: '100%' /*,paddingTop:'8px'*/
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes$E.columnsWrapper,
    style: {
      columns: 1,
      //columnWidth + ' ' + (isListView ? 1 : numberOfColumns),
      width: width
    }
  }, !isAuthenticated && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'logincard',
    style: {
      minWidth: '232px',
      maxWidth: '472px',
      marginLeft: '8px',
      marginRight: '8px',
      marginTop: '8px',
      marginBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement(LoginCard, null)), getSelectedFilter() === 'mine' && (features === null || features === void 0 || (_features$filter = features.filter(function (feature) {
    var _feature$getName;
    return searchTerm ? feature === null || feature === void 0 || (_feature$getName = feature.getName()) === null || _feature$getName === void 0 ? void 0 : _feature$getName.toUpperCase().includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toUpperCase()) : feature;
  })) === null || _features$filter === void 0 || (_features$filter = _features$filter.sort(function (a, b) {
    var _a$getName;
    return (_a$getName = a.getName()) === null || _a$getName === void 0 ? void 0 : _a$getName.localeCompare(b.getName());
  })) === null || _features$filter === void 0 ? void 0 : _features$filter.map(function (feature) {
    return /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: feature === null || feature === void 0 ? void 0 : feature.getId(),
      style: {
        /*width:'100%',*/minWidth: '232px',
        maxWidth: '472px',
        marginLeft: '8px',
        marginRight: '8px',
        marginTop: '8px',
        marginBottom: '0px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: feature === null || feature === void 0 ? void 0 : feature.getId(),
      className: classes$E.todoWrapper,
      style: {
        width: isMobile || isListView ? "100%" : null
      }
    }, /*#__PURE__*/React.createElement(Provider$d, {
      feature: feature
    }, /*#__PURE__*/React.createElement(Provider$e, {
      feature: feature
    }, /*#__PURE__*/React.createElement(FeatureCard, {
      feature: feature,
      style: {
        maxWidth: '472px',
        float: 'left',
        paddingTop: 0
      },
      actions: "list-actions",
      mode: "list",
      showExtensions: true
    })))));
  })), false    , !!isAuthenticated && getSelectedFilter() === 'gallery' && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, (_mapCapabilities2 = mapCapabilities(function (c) {
    return c;
  })) === null || _mapCapabilities2 === void 0 || (_mapCapabilities2 = _mapCapabilities2.filter(function (c) {
    return !!(c !== null && c !== void 0 && c.getPublished());
  })) === null || _mapCapabilities2 === void 0 || (_mapCapabilities2 = _mapCapabilities2.sort(function (a, b) {
    var _a$getName2;
    return a === null || a === void 0 || (_a$getName2 = a.getName()) === null || _a$getName2 === void 0 ? void 0 : _a$getName2.localeCompare(b === null || b === void 0 ? void 0 : b.getName());
  })) === null || _mapCapabilities2 === void 0 ? void 0 : _mapCapabilities2.map(function (capability) {
    return /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: capability === null || capability === void 0 ? void 0 : capability.id,
      style: {
        /*width:'100%',*/minWidth: '232px',
        maxWidth: '472px',
        marginLeft: '8px',
        marginRight: '8px',
        marginTop: '8px',
        marginBottom: '0px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: capability === null || capability === void 0 ? void 0 : capability.id,
      className: classes$E.todoWrapper,
      style: {
        width: isMobile || isListView ? "100%" : null
      }
    }, /*#__PURE__*/React.createElement(CapabilityCard, {
      capability: capability
      //setCapability={setValue}
      ,
      mode: 'gallery'
      //highlighted={plugin.alias === capability?.alias}
    })));
  })))))));
};
function querystring$5(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var Context$a = /*#__PURE__*/createContext([]);
var Provider$a = function Provider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    featureName = _useState2[0],
    setFeatureName = _useState2[1];
  //const [ iamUserId, setIamUserId ] = useState('');
  /*
  const [ iamUserAccessKeyId, setIamUserAccessKeyId ] = useState('');
  const [ iamUserSecretAccessKey, setIamUserSecretAccessKey ] = useState('');
  const [ isTermsAccepted, setIsTermsAccepted ] = useState(false);
  */

  var reset = function reset(_) {
    setFeatureName('');
    /*
    setIamUserId('');
    setIamUserAccessKeyId('');
    setIamUserSecretAccessKey('');
    setIsTermsAccepted(false);
    */
  };

  var value = {
    featureName: featureName,
    setFeatureName: setFeatureName,
    /*
    iamUserId,
    setIamUserId,
    iamUserAccessKeyId,
    setIamUserAccessKeyId,
    iamUserSecretAccessKey,
    setIamUserSecretAccessKey,
    */
    isFeatureValid: function isFeatureValid(_) {
      return featureName /*&& 
                         iamUserId && 
                         iamUserAccessKeyId && 
                         iamUserSecretAccessKey*/;
    },

    //isTermsAccepted,
    //setIsTermsAccepted,
    reset: reset
  };
  return /*#__PURE__*/React.createElement(Context$a.Provider, {
    value: value
  }, children);
};
var Consumer$5 = Context$a.Consumer;
var CreateFeatureStore = {
  Context: Context$a,
  Provider: Provider$a,
  Consumer: Consumer$5
};

var PREFIX$D = 'WorkflowStepCard';
var classes$D = {
  root: "".concat(PREFIX$D, "-root"),
  paper: "".concat(PREFIX$D, "-paper"),
  avatar: "".concat(PREFIX$D, "-avatar"),
  card: "".concat(PREFIX$D, "-card"),
  fab: "".concat(PREFIX$D, "-fab"),
  lastCard: "".concat(PREFIX$D, "-lastCard"),
  input: "".concat(PREFIX$D, "-input"),
  opaqueInput: "".concat(PREFIX$D, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$D, "-inputRoot"),
  inputNotchedOutline: "".concat(PREFIX$D, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$D, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$D, "-inputLabelRoot"),
  link: "".concat(PREFIX$D, "-link")
};
var Root$y = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$D.root), {
    width: '100%',
    maxWidth: 472,
    flexGrow: 1,
    overflow: 'hidden',
    margin: 0,
    padding: 0 //'8px'//theme.spacing(0, 3),
  }), _defineProperty(_ref2, "& .".concat(classes$D.paper), {
    //maxWidth: 400,
    //margin: '8px',//`${theme.spacing(1)} auto`,
    padding: '16px' //theme.spacing(2),
  }), _defineProperty(_ref2, "& .".concat(classes$D.avatar), {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: '3px'
  }), _defineProperty(_ref2, "& .".concat(classes$D.card), {
    marginBottom: '8px',
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$D.fab), {
    position: 'fixed',
    bottom: '64px',
    //theme.spacing(2),
    right: '16px',
    //theme.spacing(2),
    zIndex: 9999
  }), _defineProperty(_ref2, "& .".concat(classes$D.lastCard), {
    marginBottom: 0
  }), _defineProperty(_ref2, "& .".concat(classes$D.input), {}), _defineProperty(_ref2, "& .".concat(classes$D.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    marginTop: '8px'
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$D.inputRoot), {
    '&$inputFocused $inputNotchedOutline': {
      borderColor: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$D.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$D.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$D.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$D.link), {
    color: theme.palette.secondary.main
  }), _ref2;
});
var WorkflowStepCard = (function (_ref3) {
  var stepNumber = _ref3.stepNumber,
    stepTitle = _ref3.stepTitle,
    stepDescription = _ref3.stepDescription,
    stepComponents = _ref3.stepComponents;
  return /*#__PURE__*/React.createElement(Root$y, {
    className: classes$D.root
  }, /*#__PURE__*/React.createElement(CardContent, {
    style: {
      paddingBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    wrap: "nowrap",
    spacing: 2
  }, stepNumber && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: "avatar"
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: classes$D.avatar,
    style: {
      fontSize: '11px'
    }
  }, stepNumber)), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: "title",
    xs: true,
    zeroMinWidth: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "textSecondary",
    component: "p",
    style: {
      fontSize: '20px'
    }
  }, stepTitle)))), stepDescription && /*#__PURE__*/React.createElement(CardContent, {
    style: {
      paddingBottom: 0
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: "description",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    style: {}
  }, stepDescription)))), stepComponents && stepComponents.map(function (component, index) {
    return /*#__PURE__*/React.createElement(CardContent, {
      key: index,
      style: {
        paddingTop: '8px',
        paddingBottom: 0
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: "component",
      style: {
        width: '100%'
      }
    }, component)));
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '16px'
    }
  }));
});

var PREFIX$C = 'CreateFeatureCard';
var classes$C = {
  root: "".concat(PREFIX$C, "-root"),
  paper: "".concat(PREFIX$C, "-paper"),
  avatar: "".concat(PREFIX$C, "-avatar"),
  card: "".concat(PREFIX$C, "-card"),
  fab: "".concat(PREFIX$C, "-fab"),
  lastCard: "".concat(PREFIX$C, "-lastCard"),
  input: "".concat(PREFIX$C, "-input"),
  opaqueInput: "".concat(PREFIX$C, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$C, "-inputRoot"),
  inputNotchedOutline: "".concat(PREFIX$C, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$C, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$C, "-inputLabelRoot"),
  link: "".concat(PREFIX$C, "-link")
};
var Root$x = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$C.root), {
    width: '100%',
    maxWidth: 472,
    flexGrow: 1,
    overflow: 'hidden',
    margin: 0,
    padding: 0 //'8px'//theme.spacing(0, 3),
  }), _defineProperty(_ref2, "& .".concat(classes$C.paper), {
    //maxWidth: 400,
    //margin: '8px',//`${theme.spacing(1)} auto`,
    padding: '16px' //theme.spacing(2),
  }), _defineProperty(_ref2, "& .".concat(classes$C.avatar), {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: '3px'
  }), _defineProperty(_ref2, "& .".concat(classes$C.card), {
    marginBottom: '16px',
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$C.fab), {
    position: 'fixed',
    bottom: '64px',
    //theme.spacing(2),
    right: '16px',
    //theme.spacing(2),
    zIndex: 9999
  }), _defineProperty(_ref2, "& .".concat(classes$C.lastCard), {
    marginBottom: 0
  }), _defineProperty(_ref2, "& .".concat(classes$C.input), {}), _defineProperty(_ref2, "& .".concat(classes$C.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    marginTop: '8px'
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$C.inputRoot), {
    '&$inputFocused $inputNotchedOutline': {
      borderColor: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$C.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$C.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$C.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$C.link), {
    color: theme.palette.secondary.main
  }), _ref2;
});
var CreateFeatureCard = (function (_ref3 /*googleMapDivRef*/) {
  _objectDestructuringEmpty(_ref3);
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var _useContext2 = useContext(Context$g);
    _useContext2.createFeature;
  //const { placeId, setAddress } = useContext(GoogleMapContext);
  var _useContext3 = useContext(Context$a),
    featureName = _useContext3.featureName,
    setFeatureName = _useContext3.setFeatureName,
    isFeatureValid = _useContext3.isFeatureValid,
    reset = _useContext3.reset;
  var handleClickCreateFeature = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var featuresResource, featureId, createdFeature;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isAuthenticated) {
              _context.next = 3;
              break;
            }
            _context.next = 21;
            break;
          case 3:
            featuresResource = makeAPI('spoketree-community-feature', "/capabilities/c_exchange/features");
            _context.prev = 4;
            _context.next = 7;
            return featuresResource.post({
              user: {
                protected: {
                  setting: {
                    name: featureName
                  }
                } /*,
                  private: {
                   setting: {
                     iamUserId,
                     iamUserAccessKeyId
                   }
                  },
                  secret: {
                   setting: {
                     iamUserSecretAccessKey
                   }
                  }
                  */
              }
            });
          case 7:
            createdFeature = _context.sent;
            console.log('createdFeature:');
            console.log(createdFeature);
            featureId = Object.values(createdFeature.versions)[0][0].H_PK;
            console.log(featureId);
            reset();
            _context.next = 20;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](4);
            alert('Failed to create feature');
            console.error(_context.t0);
            throw _context.t0;
          case 20:
            if (featureId) {
              //history.push(`/plugin/exchange/features/${featureId}/about`);
              window.location.href = "".concat(host().marketUrl, "/plugin/exchange/features/").concat(featureId, "?mode=edit");
            }
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 15]]);
    }));
    return function handleClickCreateFeature(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  useRef(null);
  return /*#__PURE__*/React.createElement(Root$x, {
    className: classes$C.root
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes$C.root,
    elevation: 0,
    variant: "outlined" /*style={{...(highlighted ? { borderWidth: 'thick', borderColor: 'limegreen' }: {})}}*/
  }, /*#__PURE__*/React.createElement(CardContent, {
    style: {
      /*backgroundColor:'#f8f8f8',*/width: '100%',
      marginBottom: '0px'
    },
    classes: {
      root: /*isEditing() ? classes.topCardContentRoot_edit : */classes$C.topCardContentRoot
    }
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'name',
    style: {
      float: 'left',
      width: '100%',
      paddingLeft: '0',
      paddingTop: '0'
    }
  }, /*#__PURE__*/React.createElement(EditableText, {
    label: "",
    value: 'Create Exchange',
    variant: "h6",
    component: "p"
  })), /*#__PURE__*/React.createElement(WorkflowStepCard
  //stepNumber={1}
  //stepTitle={`Exchange`}
  , {
    stepDescription: "Provide a name for your exchange",
    stepComponents: [/*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '8px'
      }
    }, /*#__PURE__*/React.createElement(EditableTextField, {
      Icon: TitleIcon,
      label: 'Name',
      placeholder: 'Exchange Name',
      value: featureName,
      setValue: setFeatureName,
      autoFocus: true,
      autoComplete: "off"
    })))]
  }))), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "/plugin/exchange/features"
  }, "Cancel"), isFeatureValid() && /*#__PURE__*/React.createElement(SpoketreeButton, {
    onClick: handleClickCreateFeature
  }, "Create Exchange")))));
});

var PREFIX$B = 'Create';
var classes$B = {
  root: "".concat(PREFIX$B, "-root"),
  icon: "".concat(PREFIX$B, "-icon")
};
var Root$w = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$B.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$B.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesCreate = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  return (
    /*#__PURE__*/
    /*selectedFeature &&*/
    React.createElement(Root$w, {
      className: classes$B.root
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: 'createFeature',
      style: {
        maxWidth: '472px',
        width: '100%',
        marginTop: '8px',
        marginBottom: '4px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: 'createFeature',
      className: classes$B.todoWrapper,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(CreateFeatureCard, null)))))
  );
});

var PREFIX$A = 'ItemFloating';
var classes$A = {
  root: "".concat(PREFIX$A, "-root"),
  alertMessage: "".concat(PREFIX$A, "-alertMessage"),
  extendedIcon: "".concat(PREFIX$A, "-extendedIcon"),
  snackbarRoot: "".concat(PREFIX$A, "-snackbarRoot")
};
var Root$v = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$A.root), {
    '& > *': {
      margin: theme.spacing(1)
    },
    position: 'fixed',
    marginLeft: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$A.alertMessage), {
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$A.extendedIcon), {
    marginRight: theme.spacing(1)
  }), _defineProperty(_ref2, "& .".concat(classes$A.snackbarRoot), {
    top: '64px' //theme.spacing(2) + 48,
    //right: theme.spacing(2) - 8,
  }), _ref2;
});
function Alert$1(props) {
  return /*#__PURE__*/React.createElement(MuiAlert, _extends({
    elevation: 6,
    variant: "filled"
  }, props, {
    style: {
      width: '100%'
    }
  }));
}
function FloatingActionButtons() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var show = function show(key) {
    return function (event) {
      return setOpen(_objectSpread2(_objectSpread2({}, open), {}, _defineProperty({}, key, true)));
    };
  };
  var hide = function hide(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen({});
  };
  var steps = {
    cart: {
      icon: /*#__PURE__*/React.createElement(ShoppingCartIcon, null)
    } /*,
      location: {
       icon: <LocationOnIcon />
      },
      schedule: {
       icon: <ScheduleIcon />
      },
      confirm: {
       icon: <ShopIcon />
      }*/
  };

  return /*#__PURE__*/React.createElement(Root$v, {
    className: classes$A.root
  }, Object.entries(steps).map(function (_ref3, index) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      icon = _ref4[1].icon;
    return /*#__PURE__*/React.createElement(Fab, {
      color: open[key] ? 'secondary' : 'primary',
      "aria-label": key,
      onClick: show(key)
    }, icon);
  }), Object.entries(steps).map(function (_ref5, index) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0];
      _ref6[1].icon;
    return open[key] ? /*#__PURE__*/React.createElement(Snackbar, {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      open: Object.values(open).find(function (key) {
        return key;
      })
      //classes={{ root: classes.snackbarRoot }}
      ,
      style: {
        marginTop: /*64 + */56 + 'px'
      }
    }, /*#__PURE__*/React.createElement(Alert$1, {
      severity: "info",
      onClose: hide
      //classes={{ message: classes.alertMessage }} 
      //icon={<ShoppingCartIcon />}
    }, /*#__PURE__*/React.createElement("div", null, "TODO"))) : /*#__PURE__*/React.createElement(React.Fragment, null);
  }));
}

var Context$9 = /*#__PURE__*/createContext([]);
var Provider$9 = function Provider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    solutionName = _useState2[0],
    setSolutionName = _useState2[1];
  var reset = function reset(_) {
    setSolutionName('');
  };
  var value = {
    solutionName: solutionName,
    setSolutionName: setSolutionName,
    isSolutionValid: function isSolutionValid(_) {
      return !!solutionName;
    },
    reset: reset
  };
  return /*#__PURE__*/React.createElement(Context$9.Provider, {
    value: value
  }, children);
};
Context$9.Consumer;

var Context$8 = /*#__PURE__*/createContext([]);
var Provider$8 = function Provider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    scenarioName = _useState2[0],
    setScenarioName = _useState2[1];
  var reset = function reset(_) {
    setScenarioName('');
  };
  var value = {
    scenarioName: scenarioName,
    setScenarioName: setScenarioName,
    isScenarioValid: function isScenarioValid(_) {
      return scenarioName;
    },
    reset: reset
  };
  return /*#__PURE__*/React.createElement(Context$8.Provider, {
    value: value
  }, children);
};
Context$8.Consumer;

var Context$7 = /*#__PURE__*/createContext([]);
var Provider$7 = function Provider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    customerName = _useState2[0],
    setCustomerName = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    supplierName = _useState4[0],
    setSupplierName = _useState4[1];
  var reset = function reset(_) {
    setCustomerName('');
    setSupplierName('');
  };
  var value = {
    customerName: customerName,
    supplierName: supplierName,
    setCustomerName: setCustomerName,
    setSupplierName: setSupplierName,
    isExtensionValid: function isExtensionValid() {
      return customerName && supplierName;
    },
    reset: reset
  };
  return /*#__PURE__*/React.createElement(Context$7.Provider, {
    value: value
  }, children);
};
Context$7.Consumer;

var Context$6 = /*#__PURE__*/createContext([]);
var Provider$6 = function Provider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    reportName = _useState2[0],
    setReportName = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    var setReportQuery = _useState4[1];
  var reset = function reset(_) {
    setReportName('');
    setReportQuery('');
  };
  var value = {
    reportName: reportName,
    //reportQuery,
    setReportName: setReportName,
    //setReportQuery,
    isReportValid: function isReportValid(_) {
      return reportName //&&
      //reportQuery
      ;
    },

    reset: reset
  };
  return /*#__PURE__*/React.createElement(Context$6.Provider, {
    value: value
  }, children);
};
Context$6.Consumer;

var alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
var nanoid = customAlphabet(alphabet, 6);
var generateId = function generateId() {
  return nanoid();
};
var Context$5 = /*#__PURE__*/createContext([]);
var Provider$5 = function Provider(_ref) {
  var _useContext2;
  var children = _ref.children,
    feature = _ref.feature;
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  //const { selectedFeature } = useContext(SelectedFeatureContext);
  var selectedFeature = feature ? feature : (_useContext2 = useContext(Context$f)) === null || _useContext2 === void 0 ? void 0 : _useContext2.selectedFeature;
  var defaults = {
    isInitialized: true,
    isRetrieveAttempted: false,
    isDirty: false
  };
  var defaultLines = [/*{
                      id: '1',
                      content: {
                      labels: ['Fruit'],
                      description: 'Avocados',
                      price: {
                      EA: {
                      net: {
                      inc: 1.89
                      }
                      }
                      },
                      image: 'https://images.unsplash.com/photo-1519162808019-7de1683fa2ad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3350&q=80',
                      quantityAvailable: undefined
                      }
                      }*/];
  var isInitialized = useRef(defaults.isInitialized);
  var isRetrieveAttempted = useRef(defaults.isRetrieveAttempted);
  useRef(defaults.isDirty);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    apiParams = _useState2[0],
    setApiParams = _useState2[1];
  var _useReducer = useReducer(makeReducer(), []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    solutions = _useReducer2[0],
    dispatchSolutions = _useReducer2[1];
  useEffect(function (_) {
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (selectedFeature) {
                setApiParams({
                  partition: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(),
                  scope: 's_user',
                  level: 'l_protected',
                  set: 'solutions',
                  keys: []
                });
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()();
  }, [selectedFeature]);
  var _adaptItem = function _adaptItem(items, key) {
    var id = key.split(':').pop();
    return {
      id: id,
      content: items.parse(id),
      mutate: function mutate(content) {
        return items.mutate(id, content);
      }
    };
  };
  var _dispatch = function _dispatch(_updatedItems) {
    var wrappedItems = wrapItems(_objectSpread2(_objectSpread2({
      endpoint: 'spoketree-database-auth'
    }, apiParams), {}, {
      items: _updatedItems,
      setItems: function () {
        var _setItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(updatedItems) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _dispatch(updatedItems));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function setItems(_x2) {
          return _setItems.apply(this, arguments);
        }
        return setItems;
      }()
    }));
    var adaptedItems = wrappedItems.keys().map(function (key) {
      return _adaptItem(wrappedItems, key);
    });
    wrappedItems.keys().forEach(function (key) {
      var adaptedItem = adaptedItems.find(function (_ref3) {
        var id = _ref3.id;
        return id === key.split(':').pop();
      });
      dispatchSolutions({
        type: "UPDATED",
        payload: adaptedItem
      });
    });
  };
  useEffect(function (_) {
    (function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_) {
        var authApi, retrievedItems, wrappedLineItems, adaptedLineItems;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!apiParams && !isInitialized.current)) {
                _context4.next = 7;
                break;
              }
              console.log("init solutions");
              isInitialized.current = defaults.isInitialized;
              isRetrieveAttempted.current = defaults.isRetrieveAttempted;
              //isDirty.current = false;
              dispatchSolutions({
                type: "LOADED",
                payload: defaultLines
              });
              _context4.next = 30;
              break;
            case 7:
              if (!(apiParams && !isRetrieveAttempted.current)) {
                _context4.next = 30;
                break;
              }
              //console.log("retrieve solutions");
              isInitialized.current = false;
              isRetrieveAttempted.current = true;
              _context4.prev = 10;
              /*
              const unauthApi = makeItemsAPI({
                endpoint: 'spoketree-database-unauth',  // public read access
                ...apiParams
              });
              const retrievedItems = await unauthApi.getItems();
              */
              authApi = makeItemsAPI(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams));
              _context4.next = 14;
              return authApi.getItems();
            case 14:
              retrievedItems = _context4.sent;
              console.log('retrievedItems');
              console.log(retrievedItems);
              wrappedLineItems = wrapItems(_objectSpread2(_objectSpread2({
                endpoint: 'spoketree-database-auth'
              }, apiParams), {}, {
                items: retrievedItems,
                setItems: function () {
                  var _setItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(updatedItems) {
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", isAuthenticated /*AND IS FEATURE OWNER*/ ? _dispatch(updatedItems) : undefined);
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  function setItems(_x4) {
                    return _setItems2.apply(this, arguments);
                  }
                  return setItems;
                }()
              })); //isDirty.current = false;
              adaptedLineItems = wrappedLineItems.keys().map(function (key) {
                return _adaptItem(wrappedLineItems, key);
              });
              if (adaptedLineItems && Array.isArray(adaptedLineItems) && adaptedLineItems.length > 0) {
                console.log('ccc');
                dispatchSolutions({
                  type: "LOADED",
                  payload: adaptedLineItems
                });
              } else {
                console.log('ddd');
                dispatchSolutions({
                  type: "LOADED",
                  payload: defaultLines
                });
              }
              _context4.next = 28;
              break;
            case 22:
              _context4.prev = 22;
              _context4.t0 = _context4["catch"](10);
              console.log('eee');
              console.log(_context4.t0);
              dispatchSolutions({
                type: "LOADED",
                payload: defaultLines
              });
              throw _context4.t0;
            case 28:
              _context4.next = 30;
              break;
            case 30:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[10, 22]]);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    })()();
  }, [isAuthenticated, apiParams, defaults, defaultLines]);

  // solution: { id, content }
  var putSolution = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(solution) {
      var existingSolution, newSolution, authApi, createdSolutions, wrappedSolutions, adaptedSolutions;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            console.log('GGGG');
            console.log(solution);
            assert(solution);
            console.log('HHHH');
            existingSolution = solution !== null && solution !== void 0 && solution.id ? solutions.find(function (e) {
              var _solution$content;
              return e.content.pluginAlias === (solution === null || solution === void 0 || (_solution$content = solution.content) === null || _solution$content === void 0 ? void 0 : _solution$content.pluginAlias);
            }) : undefined;
            console.log('PUT_SOLUTION');
            console.log(existingSolution);
            newSolution = null;
            if (!existingSolution) {
              _context6.next = 13;
              break;
            }
            _context6.next = 11;
            return existingSolution === null || existingSolution === void 0 ? void 0 : existingSolution.mutate(solution === null || solution === void 0 ? void 0 : solution.content);
          case 11:
            _context6.next = 25;
            break;
          case 13:
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context6.next = 16;
            return authApi.putItem({
              key: 'solution_' + generateId(),
              content: solution === null || solution === void 0 ? void 0 : solution.content
            });
          case 16:
            createdSolutions = _context6.sent;
            wrappedSolutions = wrapItems(_objectSpread2(_objectSpread2({}, apiParams), {}, {
              items: createdSolutions,
              setItems: function () {
                var _setItems3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(updatedItems) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", _dispatch(updatedItems));
                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                function setItems(_x6) {
                  return _setItems3.apply(this, arguments);
                }
                return setItems;
              }()
            }));
            adaptedSolutions = wrappedSolutions.keys().map(function (key) {
              return _adaptItem(wrappedSolutions, key);
            });
            console.log('createdSolutions:CREATED');
            console.log(createdSolutions);
            console.log(wrappedSolutions);
            console.log(adaptedSolutions);
            if (adaptedSolutions && Array.isArray(adaptedSolutions) && adaptedSolutions.length > 0) {
              console.log('fff');
              dispatchSolutions({
                type: "CREATED",
                payload: adaptedSolutions[0]
              });
            }
            newSolution = adaptedSolutions[0];
          case 25:
            return _context6.abrupt("return", existingSolution ? existingSolution : newSolution);
          case 26:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function putSolution(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var deleteSolution = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(solution) {
      var existingSolution, authApi;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            console.log('deleteSolution');
            console.log(solutions);
            console.log(solution);
            existingSolution = solution !== null && solution !== void 0 && solution.id ? solutions.find(function (s) {
              return s.id === (solution === null || solution === void 0 ? void 0 : solution.id);
            }) : undefined;
            console.log('existingSolution');
            console.log(existingSolution);
            assert(existingSolution);
            //const previousEventId = existingSolution ? existingSolution[0].H_SK.split('#')[3] : undefined;
            authApi = makeItemsAPI(_objectSpread2({
              endpoint: 'spoketree-database-auth'
            }, apiParams));
            _context7.next = 10;
            return authApi.deleteItem({
              key: existingSolution.id
              //previousEventId
            });
          case 10:
            console.log('ggg');
            dispatchSolutions({
              type: "DELETED",
              payload: existingSolution
            });
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function deleteSolution(_x7) {
      return _ref6.apply(this, arguments);
    };
  }();
  var _findSolution = function _findSolution(solutionId) {
    var found = solutions ? solutions.find(function (_ref7) {
      var id = _ref7.id;
      return id === solutionId;
    }) : undefined;
    return found;
  };
  var value = {
    solutions: solutions,
    findSolution: _findSolution,
    putSolution: putSolution,
    deleteSolution: deleteSolution
  };
  return /*#__PURE__*/React.createElement(Context$5.Provider, {
    value: value
  }, children);
};
Context$5.Consumer;

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var CompositeSelectedFeatureProvider = (function (_ref) {
  var featureId = _ref.featureId,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, featureId && /*#__PURE__*/React.createElement(Provider$f, {
    featureId: featureId
  }, /*#__PURE__*/React.createElement(Provider$9, null, /*#__PURE__*/React.createElement(Provider$8, null, /*#__PURE__*/React.createElement(Provider$7, null, /*#__PURE__*/React.createElement(Provider$6, null, /*#__PURE__*/React.createElement(Provider$5, null, /*#__PURE__*/React.createElement(Provider$d, null, /*#__PURE__*/React.createElement(Provider$e, null, /*#__PURE__*/React.createElement(Provider$b, null, children))))))))));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var FeaturesItemProvider = (function (_ref) {
  var children = _ref.children,
    itemId = _ref.itemId;
  return /*#__PURE__*/React.createElement(CompositeSelectedFeatureProvider, {
    featureId: itemId
  }, children);
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var FeaturesItemHeader = (function (_ref) {
  _ref.children;
    _ref.itemId;
  var _useContext = useContext(SelectedFeatureStore.Context);
    _useContext.selectedFeature;
  return /*#__PURE__*/React.createElement(React.Fragment, null);
});

var PREFIX$z = 'FeatureEditButton';
var classes$z = {
  root: "".concat(PREFIX$z, "-root"),
  list: "".concat(PREFIX$z, "-list"),
  avatar: "".concat(PREFIX$z, "-avatar"),
  text: "".concat(PREFIX$z, "-text"),
  subtext: "".concat(PREFIX$z, "-subtext"),
  actionButtonRoot: "".concat(PREFIX$z, "-actionButtonRoot"),
  actionButtonText: "".concat(PREFIX$z, "-actionButtonText")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$u = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$z.root), {
    margin: 0,
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$z.list), {
    backgroundColor: theme.palette.primary.backgroundColor,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$z.avatar), {
    float: 'left'
  }), _defineProperty(_ref2, "& .".concat(classes$z.text), {
    fontWeight: 500,
    fontSize: "0.875rem",
    verticalAlign: "middle",
    color: "".concat(theme.palette.text.secondary, " !important")
  }), _defineProperty(_ref2, "& .".concat(classes$z.subtext), {
    fontWeight: 300,
    fontSize: "0.775rem",
    verticalAlign: "middle",
    color: "".concat(theme.palette.text.primary, " !important")
  }), _defineProperty(_ref2, "& .".concat(classes$z.actionButtonRoot), {
    //marginTop: theme.spacing(3)
  }), _defineProperty(_ref2, "& .".concat(classes$z.actionButtonText), _objectSpread2(_objectSpread2({}, theme.custom.fontFamily.metropolis), {}, {
    color: theme.palette.primary.main // theme.palette.secondary.contrastText,
    //textTransform: "capitalize"
  })), _ref2;
});
var FeatureEditButton = (function (_ref3) {
  _ref3.variant;
    var feature = _ref3.feature;
  var handleClick = function handleClick(_ref4) {
    var feature = _ref4.feature;
      _ref4.mode;
    // https://spoketree.au/plugin/exchange/features/f_FFFFFFF
    var urlPrefix = "".concat(host().platformUrl(), "/plugin/exchange/features/").concat(feature === null || feature === void 0 ? void 0 : feature.getId());
    window.location.href = urlPrefix + '/properties';
  };
  var mode = useQueryParam('mode', 'view');
  var ButtonComponent = Button$1; //variant === 'contained' ? Button : IconButton;
  //const ButtonComponent = Button;

  return /*#__PURE__*/React.createElement(Root$u, null, (feature === null || feature === void 0 ? void 0 : feature.isEditable()) && /*#__PURE__*/React.createElement(React.Fragment, null, mode === 'view' && /*#__PURE__*/React.createElement(IconButton$1 /*ButtonComponent*/, {
    edge: "start"
    //classes={{ root: classes.actionButtonRoot, label: classes.actionButtonText }}
    ,
    "aria-label": "Edit Feature",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleClick({
        feature: feature,
        mode: 'edit'
      });
    },
    color: "secondary",
    variant: "outlined"
    //variant={variant}
    ,
    size: "small"
    //style={variant === 'outlined' ? {/*fontWeight:800,*/marginTop:'2px'/*,fontSize:'0.875rem'*/} : undefined}
  }, /*#__PURE__*/React.createElement(SettingsIcon /*htmlColor={theme.custom.palette.iconColor}*/ /*style={{paddingRight:'4px'}}*/, null)), mode === 'edit' && /*#__PURE__*/React.createElement(ButtonComponent, {
    edge: "start"
    //classes={{ root: classes.actionButtonRoot, label: classes.actionButtonText }}
    ,
    "aria-label": "View Feature",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleClick({
        feature: feature,
        mode: 'view'
      });
      /*if (selectedPanelId !== 'feature-panel') {
        setSelectedPanelId("feature-panel");
      }*/
    },

    color: "secondary",
    variant: "outlined"
    //variant={variant}
    ,
    size: "small"
    //style={variant === 'outlined' ? {/*fontWeight:800,*/marginTop:'2px'/*,fontSize:'0.875rem'*/} : undefined}
  }, /*#__PURE__*/React.createElement(VisibilityIcon /*htmlColor={theme.custom.palette.iconColor}*/, {
    style: {
      paddingRight: '4px'
    }
  }), 'View' /*variant === 'contained' ? 'View' : undefined*/)));
});

var PREFIX$y = 'HighlightableAvatar';
var classes$y = {
  root: "".concat(PREFIX$y, "-root"),
  avatar: "".concat(PREFIX$y, "-avatar"),
  avatarHighlight: "".concat(PREFIX$y, "-avatarHighlight")
};
var Root$t = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$y.root), {
    //marginLeft: '-16px'
  }), _defineProperty(_ref2, "& .".concat(classes$y.avatar), {}), _defineProperty(_ref2, "& .".concat(classes$y.avatarHighlight), {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500]
  }), _ref2;
});
var HighlightableAvatar = (function (_ref3) {
  _ref3.variant;
    var icon = _ref3.icon,
    highlight = _ref3.highlight;
  useTheme$1();
  return /*#__PURE__*/React.createElement(Root$t, {
    className: classes$y.root
  }, /*#__PURE__*/React.createElement(Avatar$1 /*variant={variant ? variant : 'rounded'}*/, {
    "aria-label": "avatar",
    className: highlight ? classes$y.avatarHighlight : classes$y.avatar
  }, icon));
});

var PREFIX$x = 'Summary';
var classes$x = {
  root: "".concat(PREFIX$x, "-root"),
  avatar: "".concat(PREFIX$x, "-avatar"),
  avatarHighlight: "".concat(PREFIX$x, "-avatarHighlight"),
  cardHeaderRoot: "".concat(PREFIX$x, "-cardHeaderRoot")
};
var Root$s = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$x.root), {
    marginLeft: '3px'
  }), _defineProperty(_ref2, "& .".concat(classes$x.avatar), {
    float: 'left'
  }), _defineProperty(_ref2, "& .".concat(classes$x.avatarHighlight), {
    float: 'left',
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500]
  }), _defineProperty(_ref2, "& .".concat(classes$x.cardHeaderRoot), {
    padding: 0,
    margin: 0
  }), _ref2;
});
var Summary = (function (_ref3) {
  var avatar = _ref3.avatar,
    icon = _ref3.icon,
    action = _ref3.action,
    title = _ref3.title,
    subheader = _ref3.subheader,
    highlight = _ref3.highlight;
  useTheme$1();
  return /*#__PURE__*/React.createElement(Root$s, {
    className: classes$x.root
  }, /*#__PURE__*/React.createElement(CardHeader, {
    avatar: avatar ? avatar : icon ? /*#__PURE__*/React.createElement(HighlightableAvatar, {
      icon: icon,
      highlight: highlight
    }) : /*#__PURE__*/React.createElement(Avatar$1, {
      variant: "rounded",
      "aria-label": "avatar",
      className: classes$x.avatar
    }),
    action: action,
    title: /*#__PURE__*/React.createElement(Typography$1, {
      style: {
        ///*width:'calc(100% - 36px)',
        fontSize: '0.875rem',
        fontWeight: 'bold',
        color: '#666',
        marginLeft: '-11px'
      },
      noWrap: true
    }, title),
    subheader: /*#__PURE__*/React.createElement(Typography$1, {
      style: {
        /*width:'calc(100% - 36px)',*/fontSize: '0.875rem',
        color: '#777',
        marginTop: '-11px',
        marginLeft: '-11px'
      },
      noWrap: true
    }, subheader ? subheader : ' '),
    classes: {
      root: classes$x.cardHeaderRoot
      //avatar: highlight ? classes.avatarHighlight : classes.avatar
    }
  }));
});

var PREFIX$w = 'PropertiesSummary';
var classes$w = {
  root: "".concat(PREFIX$w, "-root"),
  icon: "".concat(PREFIX$w, "-icon")
};
var Root$r = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$w.root), {
    width: '100% !important',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$w.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesPropertiesSummary = (function (_ref3) {
  var _panel$tab;
  _ref3.page;
    var panel = _ref3.panel,
    panelKey = _ref3.panelKey,
    selectedPanelKey = _ref3.selectedPanelKey;
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var theme = useTheme$1();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  return selectedFeature && /*#__PURE__*/React.createElement(Root$r, {
    className: classes$w.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'feature',
    style: {
      float: 'left',
      width: 'calc(100% - 28px)'
    }
  },
  /*#__PURE__*/
  //panelKey !== selectedPanelKey && (
  React.createElement(Summary, {
    icon: panel === null || panel === void 0 || (_panel$tab = panel.tab) === null || _panel$tab === void 0 ? void 0 : _panel$tab.icon
    //avatar={selectedFeature.parse('avatarImage')}
    //avatar={<Avatar variant="rounded" aria-label={selectedFeature.getId()} className={classes.avatar} src={selectedFeature.parse('avatarImage')} />}
    //action
    ,
    title: selectedFeature.getName()
    //subheader={selectedFeature.parse('summary')}
    ,
    highlight: panelKey === selectedPanelKey
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    style: {
      float: 'right' /*,marginTop:'4px'*/
    }
  }, selectedFeature.isEditable() && /*#__PURE__*/React.createElement(FeatureEditButton, {
    feature: selectedFeature
  }))));
});

var PREFIX$v = 'PropertiesDetail';
var classes$v = {
  root: "".concat(PREFIX$v, "-root"),
  icon: "".concat(PREFIX$v, "-icon")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$q = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$v.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$v.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesPropertiesDetail = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var theme = useTheme$1();
  var navigate = useNavigate();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var urlPrefix = host().isMultiTenantName ? '/plugin/exchange/features/' : '/plugin/exchange/feature';
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFilter = _useState2[0],
    _setSelectedFilter = _useState2[1];
  var setSelectedFilter = function setSelectedFilter(filter) {
    _setSelectedFilter(filter);
    var pathname = null;
    if (filter === (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id)) {
      pathname = "".concat(urlPrefix, "/").concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id);
    } else {
      pathname = "".concat(urlPrefix);
    }
    navigate({
      pathname: pathname,
      search: "?filter=".concat(filter)
    });
  };
  useEffect(function (_) {
    (function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", querystring$4('filter') ? querystring$4('filter') : _setSelectedFilter(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    })()();
  }, [selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id]);
  var mode = useQueryParam('mode', 'view');
  return /*#__PURE__*/React.createElement(Root$q, {
    style: {
      maxWidth: '472px'
    }
  }, selectedFeature /* && selectedFeature?.getExtensions() */ && /*#__PURE__*/React.createElement("div", {
    className: classes$v.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      maxWidth: '472px',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'list',
    style: {
      float: 'left',
      marginTop: '8px',
      width: 'calc(100% - 100px)'
    }
  }, /*#__PURE__*/React.createElement(ExchangeFilters, {
    selected: selectedFilter,
    setSelected: setSelectedFilter,
    feature: selectedFeature
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'feature',
    style: {
      maxWidth: '472px',
      width: '100%',
      marginTop: '8px',
      marginRight: '0'
    }
  }, /*#__PURE__*/React.createElement(FeatureCard, {
    feature: selectedFeature,
    mode: mode
    //showExtensions={!selectedFeature.isEditable()}
  })))));
});

function querystring$4(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var PREFIX$u = 'ExtensionDetails';
var classes$u = {
  mediaRoot: "".concat(PREFIX$u, "-mediaRoot"),
  editorRoot: "".concat(PREFIX$u, "-editorRoot"),
  editorPaper: "".concat(PREFIX$u, "-editorPaper"),
  editorForm: "".concat(PREFIX$u, "-editorForm"),
  editorButton: "".concat(PREFIX$u, "-editorButton"),
  link: "".concat(PREFIX$u, "-link")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$u.mediaRoot), {
    //height: '110px',
  }), _defineProperty(_ref2, "& .".concat(classes$u.editorRoot), {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$u.editorPaper), {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), _defineProperty(_ref2, "& .".concat(classes$u.editorForm), {
    padding: 8,
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$u.editorButton), {
    padding: 8
  }), _defineProperty(_ref2, "& .".concat(classes$u.link), {
    color: 'rgba(0, 0, 0, 0.87)',
    //theme.palette.secondary.main
    textDecoration: 'underline',
    fontSize: '1.125rem',
    fontFamily: 'Roboto,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    fontWeight: '500',
    lineHeight: '1.6'
  }), _ref2;
});
({
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
});
function getIndefiniteArticle(noun) {
  var vowels = ["a", "e", "i", "o", "u"];
  var firstLetter = noun.charAt(0).toLowerCase();
  var article = vowels.includes(firstLetter) ? "an" : "a";
  return article;
}
var ExtensionDetails = function ExtensionDetails(_ref3) {
  var _extension$content, _extensionPlugin$conf;
  var extension = _ref3.extension;
  useTheme$1();
  var extensionPlugin = extensionPlugins[extension === null || extension === void 0 || (_extension$content = extension.content) === null || _extension$content === void 0 ? void 0 : _extension$content.pluginAlias];
  console.log('HHHHHH');
  console.log('extensionPlugins', extensionPlugins);
  console.log('extension', extension);
  console.log('extensionPlugin', extensionPlugin);
  assert(extensionPlugin);
  var _useContext = useContext(Context$e),
    setExtension = _useContext.putExtension;
  return /*#__PURE__*/React.createElement(React.Fragment, null, extensionPlugin === null || extensionPlugin === void 0 || (_extensionPlugin$conf = extensionPlugin.configuration) === null || _extensionPlugin$conf === void 0 ? void 0 : _extensionPlugin$conf.groups.map(function (group) {
    var _group$settings;
    return /*#__PURE__*/React.createElement(Stack$1, {
      direction: "column",
      spacing: 1
    }, (group === null || group === void 0 ? void 0 : group.name) && /*#__PURE__*/React.createElement(Typography$1, {
      variant: "h6",
      component: "h6",
      style: {
        color: 'rgba(0, 0, 0, 0.44)'
      }
    }, group === null || group === void 0 ? void 0 : group.name), (group === null || group === void 0 ? void 0 : group.description) && /*#__PURE__*/React.createElement(Typography$1, {
      variant: "body2",
      component: "p",
      style: {
        color: 'rgba(0, 0, 0, 0.44)'
      }
    }, group === null || group === void 0 ? void 0 : group.description), group === null || group === void 0 || (_group$settings = group.settings) === null || _group$settings === void 0 ? void 0 : _group$settings.map(function (_ref4) {
      var _extension$content2, _extension$content3, _extension$content5, _extension$content6;
      var alias = _ref4.alias,
        icon = _ref4.icon,
        label = _ref4.label,
        inputLabel = _ref4.inputLabel;
      return /*#__PURE__*/React.createElement(EditableText, {
        editable: true,
        editKey: alias,
        Icon: Icons[icon],
        label: label,
        inputLabel: inputLabel,
        value: extension !== null && extension !== void 0 && (_extension$content2 = extension.content) !== null && _extension$content2 !== void 0 && _extension$content2.settings ? extension === null || extension === void 0 || (_extension$content3 = extension.content) === null || _extension$content3 === void 0 ? void 0 : _extension$content3.settings[alias] : undefined,
        setValue: function setValue(value) {
          var _extension$content4;
          return setExtension(_objectSpread2(_objectSpread2({}, extension), {}, {
            content: _objectSpread2(_objectSpread2({}, extension === null || extension === void 0 ? void 0 : extension.content), {}, {
              settings: _objectSpread2(_objectSpread2({}, extension === null || extension === void 0 || (_extension$content4 = extension.content) === null || _extension$content4 === void 0 ? void 0 : _extension$content4.settings), {}, _defineProperty({}, alias, value))
            })
          }));
        },
        dialogTitle: "".concat(extension !== null && extension !== void 0 && (_extension$content5 = extension.content) !== null && _extension$content5 !== void 0 && _extension$content5.settings && extension !== null && extension !== void 0 && (_extension$content6 = extension.content) !== null && _extension$content6 !== void 0 && _extension$content6.settings[alias] ? 'Change the' : 'Add ', " ").concat(getIndefiniteArticle(inputLabel), " ").concat(inputLabel)
        //tabLabel={`IAM User ID`}
        ,
        createValueInstruction: "Add ".concat(getIndefiniteArticle(inputLabel), " ").concat(inputLabel),
        inputInstruction: "Type a ".concat(getIndefiniteArticle(inputLabel), " ").concat(inputLabel, " here")
      });
    }));
  }));
};

var PREFIX$t = 'extensionCard';
var classes$t = {
  root: "".concat(PREFIX$t, "-root"),
  checked: "".concat(PREFIX$t, "-checked"),
  root2: "".concat(PREFIX$t, "-root2"),
  media: "".concat(PREFIX$t, "-media"),
  counterButtonWrapper: "".concat(PREFIX$t, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$t, "-checkboxRoot"),
  checkboxRootColorfulPickup: "".concat(PREFIX$t, "-checkboxRootColorfulPickup"),
  checkboxRootDelivery: "".concat(PREFIX$t, "-checkboxRootDelivery"),
  checkboxRootColorfulDelivery: "".concat(PREFIX$t, "-checkboxRootColorfulDelivery"),
  formControl: "".concat(PREFIX$t, "-formControl"),
  packingHoursEdit: "".concat(PREFIX$t, "-packingHoursEdit"),
  timeEdit: "".concat(PREFIX$t, "-timeEdit"),
  timeView: "".concat(PREFIX$t, "-timeView"),
  dayOfWeekEdit: "".concat(PREFIX$t, "-dayOfWeekEdit"),
  shopTypeEdit: "".concat(PREFIX$t, "-shopTypeEdit"),
  expand: "".concat(PREFIX$t, "-expand"),
  expandOpen: "".concat(PREFIX$t, "-expandOpen"),
  topCardContentRoot: "".concat(PREFIX$t, "-topCardContentRoot"),
  topCardContentRoot_edit: "".concat(PREFIX$t, "-topCardContentRoot_edit"),
  topCardContentContainerRoot: "".concat(PREFIX$t, "-topCardContentContainerRoot"),
  paper: "".concat(PREFIX$t, "-paper")
};
styled(CardActions)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px'
});
var StyledButton$2 = styled(Button)({
  borderRadius: '2px',
  backgroundColor: '#f1f1f1',
  color: '#202124',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#e1e1e1'
  }
});
styled(StyledButton$2)({
  backgroundColor: '#fbbc05',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#f9a825'
  }
});
var StyledSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#2196f3',
    '&:hover': {
      backgroundColor: 'rgba(76, 175, 80, 0.08)'
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#2196f3'
  }
});

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$p = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$t.root2), {
    maxWidth: '454px' //472px
    //padding: '8px',
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$t.media), {
    height: '110px'
  }), _defineProperty(_ref2, "& .".concat(classes$t.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$t.checkboxRoot), {
    verticalAlign: 'top',
    //margin: `auto ${theme.spacing(1.5)}px`,
    //marginTop: theme.spacing(0),
    //marginTop: '3px',
    //marginLeft: '4px !important',
    marginTop: '-2px',
    //marginLeft:'8px',
    marginLeft: '10px',
    marginRight: '3px',
    padding: "0 !important",
    //paddingTop: '9px !important',
    //paddingBottom: '9px !important',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$t.checkboxRootColorfulPickup), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$t.checkboxRootDelivery), {
    marginRight: '-7px',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$t.checkboxRootColorfulDelivery), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$t.formControl), {
    backgroundColor: 'lightBlue'
  }), _defineProperty(_ref2, "& .".concat(classes$t.packingHoursEdit), {
    width: '64px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$t.timeEdit), {
    width: '92px',
    height: '24px',
    marginTop: '-1px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$t.timeView), {
    width: '92px',
    height: '24px',
    marginTop: '2px'
    //color: 'rgba(0, 0, 0, 0.54) !important'
  }), _defineProperty(_ref2, "& .".concat(classes$t.dayOfWeekEdit), {
    width: '80px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$t.shopTypeEdit), {
    paddingLeft: '8px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$t.expand), _defineProperty({
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    padding: 0,
    marginTop: '32px'
  }, "marginLeft", '4px')), _defineProperty(_ref2, "& .".concat(classes$t.expandOpen), {
    transform: 'rotate(180deg)',
    padding: 0,
    marginTop: '32px',
    marginLeft: '4px'
  }), _defineProperty(_ref2, "& .".concat(classes$t.topCardContentRoot), {
    //padding: 0,
    //margin: 0
    //paddingBottom: '17px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$t.topCardContentRoot_edit), {
    //paddingBottom: '8px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '8px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$t.topCardContentContainerRoot), {
    padding: 0,
    margin: 0
  }), _defineProperty(_ref2, "& .".concat(classes$t.paper), {/*
                                                           borderStyle: "solid",
                                                           borderWidth: theme.spacing(0.1),
                                                           borderColor: theme.custom.palette.itemBorderColor,
                                                           */
  }), _ref2;
});
var ExtensionCard = function ExtensionCard(_ref3) {
  var _extension$content, _extensionPlugins$ext, _extension$content2, _extensionPlugins$ext2, _extension$content3, _extensionPlugins$ext3, _extension$content4, _extensionPlugins$ext4, _extension$content5, _extension$content6, _extension$content7, _extensionPlugins$ext5, _extension$content8;
  _ref3.actions;
    var condensed = _ref3.condensed,
    extension = _ref3.extension,
    _ref3$mode = _ref3.mode,
    mode = _ref3$mode === void 0 ? 'view' : _ref3$mode,
    highlighted = _ref3.highlighted;
  var navigate = useNavigate();
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var urlPrefix = host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  //const mode = useQueryParam('mode', 'view');

  var _useState = useState(!condensed),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var isEditing = function isEditing(_) {
    return mode === 'edit' //&&
    //feature.isEditable()
    ;
  };
  var _useContext2 = useContext(SpoketreeAuthStore.Context);
    _useContext2.authenticationEmail;

  //const DynamicCardActionArea = mode === 'gallery' ? CardActionArea : ({ children }) => <div>{children}</div>;
  var DynamicCardActionArea = function DynamicCardActionArea(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/React.createElement("div", null, children);
  };
  var onToggleEnabled = function onToggleEnabled(event) {
    setExtension(_objectSpread2(_objectSpread2({}, extension), {}, {
      content: _objectSpread2(_objectSpread2({}, extension === null || extension === void 0 ? void 0 : extension.content), {}, {
        enabled: event.target.checked
      })
    }));
  };
  var _useContext3 = useContext(Context$e),
    setExtension = _useContext3.putExtension,
    deleteExtension = _useContext3.deleteExtension;
  //console.log('EEEE');
  //console.log('putExtension', putExtension);
  //console.log('extension', extension);

  console.log('PPPP');
  console.log(extensionPlugins);
  console.log(extension);
  console.log(extensionPlugins[extension === null || extension === void 0 || (_extension$content = extension.content) === null || _extension$content === void 0 ? void 0 : _extension$content.pluginAlias]);
  return /*#__PURE__*/React.createElement(Root$p, null, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: classes$t.paper
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes$t.root,
    elevation: 0,
    variant: "outlined",
    style: _objectSpread2({}, highlighted ? {
      borderWidth: 'thick',
      borderColor: 'limegreen'
    } : {})
  }, /*#__PURE__*/React.createElement(DynamicCardActionArea, {
    onClick: function onClick(e) {
      return setExtension(extension);
    }
  }, /*#__PURE__*/React.createElement(CardMedia$1, {
    className: classes$t.media,
    image: mode === 'create' ? 'https://images.unsplash.com/photo-1608982528344-38f3d906fc28?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80'
    //'https://images.unsplash.com/photo-1461773518188-b3e86f98242f?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=472&q=80'
    : (_extensionPlugins$ext = extensionPlugins[extension === null || extension === void 0 || (_extension$content2 = extension.content) === null || _extension$content2 === void 0 ? void 0 : _extension$content2.pluginAlias]) === null || _extensionPlugins$ext === void 0 ? void 0 : _extensionPlugins$ext.image
  })), /*#__PURE__*/React.createElement(CardContent, {
    style: {
      /*backgroundColor:'#f8f8f8',*/width: '100%',
      marginBottom: '0px'
    },
    classes: {
      root: isEditing() ? classes$t.topCardContentRoot_edit : classes$t.topCardContentRoot
    }
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column",
    spacing: 1
  }, /*#__PURE__*/React.createElement(DynamicCardActionArea, {
    onClick: function onClick(e) {
      return setExtension(extension);
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textSecondary",
    component: "p",
    style: {
      marginBottom: '8px'
    }
  }, mode !== 'create' ? (_extensionPlugins$ext2 = extensionPlugins[extension === null || extension === void 0 || (_extension$content3 = extension.content) === null || _extension$content3 === void 0 ? void 0 : _extension$content3.pluginAlias]) === null || _extensionPlugins$ext2 === void 0 ? void 0 : _extensionPlugins$ext2.name : 'Spoketree Extensions'
  //extension?.content?.name
  ), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    component: "p",
    style: {
      marginBottom: '8px'
    }
  }, mode !== 'create' ? (_extensionPlugins$ext3 = extensionPlugins[extension === null || extension === void 0 || (_extension$content4 = extension.content) === null || _extension$content4 === void 0 ? void 0 : _extension$content4.pluginAlias]) === null || _extensionPlugins$ext3 === void 0 ? void 0 : _extensionPlugins$ext3.description : 'Extend your exchange with an extension'
  //extension?.content?.description
  )), mode === 'details' && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '16px'
    }
  }, /*#__PURE__*/React.createElement(ExtensionDetails, {
    extension: extension
  })))), mode === 'edit' && /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1,
    style: {
      marginBottom: '-8px'
    }
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "".concat(urlPrefix, "/extensions/").concat(extension === null || extension === void 0 ? void 0 : extension.id)
  }, "Details"), /*#__PURE__*/React.createElement(SpoketreeButtonWithDialog, {
    label: "Remove",
    dialogHash: "remove",
    dialog: {
      title: "Remove \"".concat((_extensionPlugins$ext4 = extensionPlugins[extension === null || extension === void 0 || (_extension$content5 = extension.content) === null || _extension$content5 === void 0 ? void 0 : _extension$content5.pluginAlias]) === null || _extensionPlugins$ext4 === void 0 ? void 0 : _extensionPlugins$ext4.name, "\"?"),
      buttons: ['Cancel', {
        'Remove': function Remove() {
          return deleteExtension(extension);
        }
      }]
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 'auto'
    }
  }, /*#__PURE__*/React.createElement(StyledSwitch, {
    checked: extension === null || extension === void 0 || (_extension$content6 = extension.content) === null || _extension$content6 === void 0 ? void 0 : _extension$content6.enabled,
    onChange: onToggleEnabled
  }))), mode === 'create' && /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "".concat(urlPrefix, "/extensions?filter=unused")
  }, "Find Extension"))), mode === 'gallery' && /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(SpoketreeButtonWithDialog, {
    label: "ADD TO EXCHANGE",
    dialogHash: "add-".concat(extension === null || extension === void 0 || (_extension$content7 = extension.content) === null || _extension$content7 === void 0 ? void 0 : _extension$content7.pluginAlias),
    dialog: {
      title: "Add \"".concat((_extensionPlugins$ext5 = extensionPlugins[extension === null || extension === void 0 || (_extension$content8 = extension.content) === null || _extension$content8 === void 0 ? void 0 : _extension$content8.pluginAlias]) === null || _extensionPlugins$ext5 === void 0 ? void 0 : _extensionPlugins$ext5.name, "\"?"),
      buttons: ["Cancel", {
        "Add Extension": function () {
          var _AddExtension = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
            var _createdExtension;
            var createdExtension, _createdExtension2;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  console.log('FFFF');
                  console.log('extension', extension);
                  _context.next = 5;
                  return setExtension(extension);
                case 5:
                  createdExtension = _context.sent;
                  _context.next = 13;
                  break;
                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](0);
                  alert('Failed to create extension');
                  console.error(_context.t0);
                  throw _context.t0;
                case 13:
                  if (selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.getId() && (_createdExtension = createdExtension) !== null && _createdExtension !== void 0 && _createdExtension.id) {
                    navigate("/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/extensions/").concat((_createdExtension2 = createdExtension) === null || _createdExtension2 === void 0 ? void 0 : _createdExtension2.id));
                  }
                  //}
                case 14:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 8]]);
          }));
          function AddExtension(_x) {
            return _AddExtension.apply(this, arguments);
          }
          return AddExtension;
        }()
      }]
    }
  }))), mode === 'details' && /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(SpoketreeButton
  //onClick={e => window.history.back()}
  , {
    onClick: function onClick(e) {
      return navigate("/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/extensions"));
    }
  }, "CLOSE"))))));
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */

/*
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));
*/

var ExtensionFilters = (function (_ref) {
  var selected = _ref.selected,
    setSelected = _ref.setSelected;
  //const classes = useStyles();

  var _useContext = useContext(Context$e),
    extensions = _useContext.extensions;
  var handleClick = function handleClick(key) {
    console.info(key);
    setSelected(key);
  };
  return /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, [!!(extensions !== null && extensions !== void 0 && extensions.length) ? {
    key: 'used',
    label: 'My Extensions'
  } : undefined].concat([{
    key: 'unused',
    label: 'Extension Gallery'
  }]).filter(function (i) {
    return !!i;
  }).map(function (_ref2) {
    var key = _ref2.key,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(Chip, {
      key: key,
      label: label,
      onClick: function onClick(_) {
        return handleClick(key);
      },
      variant: selected === key ? undefined : 'outlined',
      color: selected === key ? 'secondary' : undefined
    });
  }));
});

var PREFIX$s = 'Collection';
var classes$s = {
  root: "".concat(PREFIX$s, "-root"),
  columnsWrapper: "".concat(PREFIX$s, "-columnsWrapper"),
  fab: "".concat(PREFIX$s, "-fab"),
  todoWrapper: "".concat(PREFIX$s, "-todoWrapper"),
  icon: "".concat(PREFIX$s, "-icon")
};
var Root$o = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$s.root), {
    width: '100%',
    maxWidth: '472px'
    //height: '100%',
    //display: 'flex',
    //flexWrap: 'wrap',
    //justifyContent: 'space-around',
    //overflow: 'hidden',
    //backgroundColor: theme.palette.background.paper,
  }), _defineProperty(_ref2, "& .".concat(classes$s.columnsWrapper), {
    //margin: "0 auto",
    //columnWidth: theme.spacing(29),
    columnGap: "16px" //"0.5rem"
  }), _defineProperty(_ref2, "& .".concat(classes$s.fab), {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }), _defineProperty(_ref2, "& .".concat(classes$s.todoWrapper), {
    //: theme.spacing(29),
    //margin: "0 auto",
    breakInside: "avoid",
    pageBreakInside: "avoid",
    //padding: "0.5rem 0",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.standard
    })
    //paddingBottom:'4px'
  }), _defineProperty(_ref2, "& .".concat(classes$s.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var Collection$3 = function Collection(_ref3) {
  var _extensions$sort, _Object$values;
  _objectDestructuringEmpty(_ref3);
  var navigate = useNavigate();
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useExtensions = useExtensions(),
    _useExtensions2 = _slicedToArray(_useExtensions, 3),
    extensions = _useExtensions2[0],
    putExtension = _useExtensions2[1],
    deleteExtension = _useExtensions2[2];
  var _useContext2 = useContext(ExtensionsStore.Context),
    isExtensionsReady = _useContext2.isExtensionsReady;
  host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var _setSelectedFilter = _useState2[1];
  var getSelectedFilter = function getSelectedFilter() {
    return querystring$3('filter') ? querystring$3('filter') : !!(extensions !== null && extensions !== void 0 && extensions.length) ? 'used' : 'unused';
  };
  var setSelectedFilter = function setSelectedFilter(filter) {
    _setSelectedFilter(filter);
    var pathname = "/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/extensions");
    navigate({
      pathname: pathname,
      search: "?filter=".concat(filter)
    });
  };
  return !!isExtensionsReady && /*#__PURE__*/React.createElement(Root$o, {
    className: classes$s.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'filters',
    style: {
      float: 'left',
      marginTop: '8px',
      width: 'calc(100% - 100px)'
    }
  }, /*#__PURE__*/React.createElement(ExtensionFilters, {
    selected: getSelectedFilter(),
    setSelected: setSelectedFilter
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'createFeature',
    style: {
      maxWidth: '472px',
      width: '100%',
      marginTop: '8px',
      marginBottom: '4px'
    }
  }, getSelectedFilter() === 'used' && !!extensions.length && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, extensions === null || extensions === void 0 || (_extensions$sort = extensions.sort(function (a, b) {
    var _extensionPlugins$a$c, _a$content, _extensionPlugins$b$c, _b$content;
    return (_extensionPlugins$a$c = extensionPlugins[a === null || a === void 0 || (_a$content = a.content) === null || _a$content === void 0 ? void 0 : _a$content.pluginAlias]) === null || _extensionPlugins$a$c === void 0 ? void 0 : _extensionPlugins$a$c.name.localeCompare((_extensionPlugins$b$c = extensionPlugins[b === null || b === void 0 || (_b$content = b.content) === null || _b$content === void 0 ? void 0 : _b$content.pluginAlias]) === null || _extensionPlugins$b$c === void 0 ? void 0 : _extensionPlugins$b$c.name);
  })) === null || _extensions$sort === void 0 ? void 0 : _extensions$sort.map(function (extension) {
    return /*#__PURE__*/React.createElement(ExtensionCard, {
      extension: extension,
      setExtension: putExtension,
      deleteExtension: deleteExtension,
      mode: "edit"
    });
  })), getSelectedFilter() === 'used' && !extensions.length && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && /*#__PURE__*/React.createElement(ExtensionCard, {
    setExtension: putExtension,
    mode: "create"
  })), getSelectedFilter() === 'unused' && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, (_Object$values = Object.values(extensionPlugins)) === null || _Object$values === void 0 || (_Object$values = _Object$values.filter(function (plugin) {
    return !extensions.find(function (extension) {
      var _extension$content;
      return (extension === null || extension === void 0 || (_extension$content = extension.content) === null || _extension$content === void 0 ? void 0 : _extension$content.pluginAlias) === plugin.alias;
    });
  })) === null || _Object$values === void 0 || (_Object$values = _Object$values.sort(function (a, b) {
    return a === null || a === void 0 ? void 0 : a.name.localeCompare(b === null || b === void 0 ? void 0 : b.name);
  })) === null || _Object$values === void 0 ? void 0 : _Object$values.map(function (plugin) {
    return /*#__PURE__*/React.createElement(ExtensionCard, {
      extension: {
        content: {
          pluginAlias: plugin.alias,
          enabled: true
        }
      }
      //setExtension={setValue}
      ,
      mode: 'gallery'
      //highlighted={plugin.alias === extension?.alias}
    });
  })))));
};
function querystring$3(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var PREFIX$r = 'SearchExtensions';
var classes$r = {
  root: "".concat(PREFIX$r, "-root"),
  container: "".concat(PREFIX$r, "-container"),
  form: "".concat(PREFIX$r, "-form"),
  card: "".concat(PREFIX$r, "-card"),
  cardImage: "".concat(PREFIX$r, "-cardImage"),
  cardList: "".concat(PREFIX$r, "-cardList")
};
var Root$n = styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$r.root), {
    width: '100%',
    maxWidth: '472'
  }), _defineProperty(_ref2, "& .".concat(classes$r.container), {
    margin: '0 auto',
    maxWidth: '1000px',
    padding: '40px'
  }), _defineProperty(_ref2, "& .".concat(classes$r.form), {
    //display: 'grid'
  }), _defineProperty(_ref2, "& .".concat(classes$r.card), {
    marginBottom: '8px',
    //'1rem',
    display: 'flex',
    '-webkit-column-break-inside': 'avoid',
    'page-break-inside': 'avoid',
    'break-inside': 'avoid'
  }), _defineProperty(_ref2, "& .".concat(classes$r.cardImage), {
    flex: '100%',
    //marginTop: '1rem',
    borderRadius: '0.5rem',
    //'10px',
    cursor: 'pointer'
  }), _defineProperty(_ref2, "& .".concat(classes$r.cardList), {
    columnCount: 1,
    columnGap: '8px'
  }), _ref2;
});
var SearchExtensions = (function (_ref3) {
  var _query = _ref3.query,
    extension = _ref3.value;
    _ref3.setValue;
    _ref3.imageWidth;
    _ref3.imageHeight;
  var defaultQuery = "nature";
  var isInitialized = useRef(false);
  var _useState = useState(_query ? _query : defaultQuery),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    filteredPlugins = _useState4[0],
    setFilteredPlugins = _useState4[1];
  /*const extensionDefinitions = [{
    id: 'supplierportal',
    content: {
      enabled: true,
      settings: {
        'customer-name': null,
        'supplier-name': null
      },
      name: 'EZYB2B Supplier Portal',
      description: 'Enable your smaller suppliers to use a web browser to receive your orders and send you invoices.  Realise the benefits of your EDI investment and achieve the intended business efficiencies with your supplier network.',
      image: 'https://images.unsplash.com/photo-1590247813693-5541d1c609fd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
      roles: [{
        alias: 'r_customer',
        name: 'Customers'
      }, {
        alias: 'r_supplier',
        name: 'Suppliers'
      }],
      featureNameTemplate: [{
        roleAlias: 'r_customer',
        pattern: `{settings['supplier-name']} Portal`,
      },{
        roleAlias: 'r_supplier',
        pattern: `{settings['customer-name']} Portal`,
      }]
    }
  }, {
    id: 'messageeditor',
    content: {
      enabled: true,
      name: 'Spoketree Message Editor',
      description: 'Edit the content of messages in Spoketree',
      image: 'https://images.unsplash.com/photo-1581431886288-e216ea4ccf3f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
    }
  }, {
    enabled: true,
    alias: 'order',
    name: 'Order',
    description: 'View orders and generate invoices from orders',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80'
  }, {
    enabled: true,
    alias: 'invoice',
    name: 'Invoice',
    description: 'View invoices and corresponding orders',
    image: 'https://images.unsplash.com/photo-1560264418-c4445382edbc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80'
  }];
  */

  var searchExtensions = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(immediateQuery) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setFilteredPlugins(immediateQuery ? extensionPlugins === null || extensionPlugins === void 0 ? void 0 : extensionPlugins.filter(function (e) {
              return Object.keys(e).join('~~~~');
            }).includes(immediateQuery) : extensionPlugins);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function searchExtensions(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function (_) {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isInitialized.current) {
              console.log('init SearchExtensions');
              isInitialized.current = true;
              searchExtensions();
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))([]);
  });
  var onKeyDown = function onKeyDown(e) {
    console.log(e.key);
    if (e.key === 'Enter') {
      searchExtensions();
    }
  };
  console.log('PLUGINS');
  console.log(filteredPlugins);
  console.log('EXTENSION');
  console.log(extension);
  var _useExtensions = useExtensions(),
    _useExtensions2 = _slicedToArray(_useExtensions, 1),
    extensions = _useExtensions2[0];
  return /*#__PURE__*/React.createElement(Root$n, {
    className: classes$r.root,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, filteredPlugins === null || filteredPlugins === void 0 ? void 0 : filteredPlugins.filter(function (plugin) {
    return !extensions.find(function (extension) {
      var _extension$content;
      return (extension === null || extension === void 0 || (_extension$content = extension.content) === null || _extension$content === void 0 ? void 0 : _extension$content.pluginAlias) === plugin.alias;
    });
  }).map(function (plugin) {
    return /*#__PURE__*/React.createElement(ExtensionCard, {
      extension: plugin
      //setExtension={setValue}
      ,
      mode: 'gallery'
      //highlighted={plugin.alias === extension?.alias}
    });
  })));
});

var PREFIX$q = 'Create';
var classes$q = {
  root: "".concat(PREFIX$q, "-root"),
  icon: "".concat(PREFIX$q, "-icon")
};
var Root$m = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$q.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$q.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesExtensionsCreate = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  useTheme$1();
  var navigate = useNavigate();
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useState = useState('unused'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFilter = _useState2[0],
    _setSelectedFilter = _useState2[1];
  var setSelectedFilter = function setSelectedFilter(filter) {
    _setSelectedFilter(filter);
    var pathname = "/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/extensions").concat(filter === 'unused' ? '/create' : '');
    navigate({
      pathname: pathname
      //search: `?filter=${filter}`
    });
  };

  return (
    /*#__PURE__*/
    /*selectedFeature &&*/
    React.createElement(Root$m, {
      className: classes$q.root
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: 'filters',
      style: {
        float: 'left',
        marginTop: '8px',
        width: 'calc(100% - 100px)'
      }
    }, /*#__PURE__*/React.createElement(ExtensionFilters, {
      selected: selectedFilter,
      setSelected: setSelectedFilter
    })), /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: 'createFeature',
      style: {
        maxWidth: '472px',
        width: '100%',
        marginTop: '8px',
        marginBottom: '4px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: 'createFeature',
      className: classes$q.todoWrapper
      //style={{ width: isMobile || isListView ? "100%" : null }}
      ,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(SearchExtensions, null)))))
  );
});

var useExtension = function useExtension(extensionId) {
  var _useState = useState(extensionId),
    _useState2 = _slicedToArray(_useState, 2),
    _extensionId = _useState2[0],
    setExtensionId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    extension = _useState4[0],
    setExtension = _useState4[1];
  var _useContext = useContext(Context$e),
    extensions = _useContext.extensions,
    findExtension = _useContext.findExtension;
  useEffect(function () {
    if (_extensionId && extensions !== null && extensions !== void 0 && extensions.length && findExtension) {
      var _extension = findExtension(_extensionId);
      if (_extension) {
        setExtension(_extension);
      }
    }
  }, [_extensionId, extensions, findExtension, setExtension]);
  return [extension, setExtensionId];
};

var Context$4 = /*#__PURE__*/createContext([]);
var Provider$4 = function Provider(_ref) {
  var children = _ref.children,
    extensionId = _ref.extensionId;
  var _useExtension = useExtension(extensionId),
    _useExtension2 = _slicedToArray(_useExtension, 2),
    selectedExtension = _useExtension2[0];
    _useExtension2[1];
  var value = {
    selectedExtension: selectedExtension
  };
  return /*#__PURE__*/React.createElement(Context$4.Provider, {
    value: value
  }, children);
};
var Consumer$4 = Context$4.Consumer;
var SelectedExtensionStore = {
  Context: Context$4,
  Provider: Provider$4,
  Consumer: Consumer$4
};

var PREFIX$p = 'Item';
var classes$p = {
  root: "".concat(PREFIX$p, "-root"),
  icon: "".concat(PREFIX$p, "-icon")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$l = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$p.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$p.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesExtensionsItem = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var theme = useTheme$1();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedExtensionStore.Context),
    selectedExtension = _useContext.selectedExtension;
  useQueryParam('mode', 'view');
  console.log('selectedExtension', selectedExtension);
  return /*#__PURE__*/React.createElement(Root$l, null, selectedExtension && /*#__PURE__*/React.createElement("div", {
    className: classes$p.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'extension',
    style: {
      width: '100%',
      minWidth: '232px',
      maxWidth: '472px',
      marginTop: '8px',
      marginBottom: '0'
    }
  }, /*#__PURE__*/React.createElement(ExtensionCard, {
    extension: selectedExtension,
    mode: "details"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '400px'
    }
  })));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var CompositeSelectedExtensionProvider = (function (_ref) {
  var featureId = _ref.featureId,
    extensionId = _ref.extensionId,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, featureId && extensionId && /*#__PURE__*/React.createElement(Provider$f, {
    featureId: featureId
  }, /*#__PURE__*/React.createElement(Provider$7, null, /*#__PURE__*/React.createElement(Provider$e, null, /*#__PURE__*/React.createElement(Provider$4, {
    extensionId: extensionId
  }, children)))));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var FeaturesExtensionsItemProvider = (function (_ref) {
  var children = _ref.children,
    itemId = _ref.itemId,
    subitemId = _ref.subitemId;
  console.log('extensions item provider');
  console.log('itemId', itemId, 'subitemId', subitemId);
  return /*#__PURE__*/React.createElement(CompositeSelectedExtensionProvider, {
    featureId: itemId,
    extensionId: subitemId
  }, children);
});

var useReportResult = function useReportResult(_ref) {
  var report = _ref.report,
    trigger = _ref.trigger;
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    reportResult = _useState2[0],
    setReportResult = _useState2[1];
  console.log('report', report);
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _report$content, _report$content2, executionsApi, _yield$executionsApi$, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!report) {
              _context.next = 15;
              break;
            }
            _context.prev = 1;
            executionsApi = makeAPI("spoketree-exchange-report-execution", "/features/".concat(selectedFeature.getId(), "/reports/").concat(report.id, "/executions"));
            _context.next = 5;
            return executionsApi.create({
              query: report !== null && report !== void 0 && (_report$content = report.content) !== null && _report$content !== void 0 && _report$content.query ? report === null || report === void 0 || (_report$content2 = report.content) === null || _report$content2 === void 0 ? void 0 : _report$content2.query : report === null || report === void 0 ? void 0 : report.query,
              includeContent: report.content.includeContent
            });
          case 5:
            _yield$executionsApi$ = _context.sent;
            result = _yield$executionsApi$.result;
            setReportResult(result);
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            console.error('An error occurred:', _context.t0);
          case 13:
            _context.next = 16;
            break;
          case 15:
            setReportResult([]);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }))();
  }, [report, trigger]);
  return {
    reportResult: reportResult
  };
};

function Iframe(_ref) {
  var src = _ref.src,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("iframe", {
    src: src,
    width: width,
    height: height,
    style: {
      border: 0
    }
  }));
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$k = styled('div')(function (_ref2) {
  _ref2.theme;
  return _defineProperty({}, ".MuiTableCell-root", {
    padding: '6px',
    fontSize: '.875rem'
  });
});
var ReportResultList = function ReportResultList(_ref4) {
  var _report$content4, _ref13, _report$content5, _report$content8, _getPluginActionsForM2, _getPluginActionsForM3, _getPluginActionsForM4, _getPluginActionsForM5;
  var feature = _ref4.feature,
    report = _ref4.report,
    searchTerm = _ref4.searchTerm,
    size = _ref4.size,
    reportTrigger = _ref4.reportTrigger;
    _ref4.setReportTrigger;
  var bottomRef = useRef(null);
  console.log('report', report);
  var theme = useTheme$1();
  var navigate = useNavigate();
  var isSmallMobile = useMediaQuery$1(theme.breakpoints.down('sm400')); // 0px
  useMediaQuery$1(theme.breakpoints.up('sm400')); // 400px
  var isTablet = useMediaQuery$1(theme.breakpoints.up("sm")); // 600px
  var isLaptop = useMediaQuery$1(theme.breakpoints.up("md")); // 960px
  var isLaptopL = useMediaQuery$1(theme.breakpoints.up("lg")); // 1280px
  var is4K = useMediaQuery$1(theme.breakpoints.up("xl")); // 1920px

  var width = is4K ? "1888px" : isLaptopL ? "1248px" : isLaptop ? "928px" : isTablet ? "568px" : "100%";
  var _false = false,
    isListView = _false.isListView; //useContext(UISettingsContext);
  width = isListView ? isLaptop || isLaptopL ? theme.spacing(75) : "100%" : width;
  var _useReportResult = useReportResult({
      report: report,
      trigger: reportTrigger
    }),
    reportResult = _useReportResult.reportResult;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    pageMessages = _useState4[0],
    setPageMessages = _useState4[1];
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    page = _useState6[0],
    setPage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    iframeUrl = _useState8[0],
    setIframeUrl = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    iframeFullScreen = _useState10[0],
    setIframeFullScreen = _useState10[1];
  useEffect(function (_) {
    (function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        var _JSON$parse, _report$content2;
        var sortedMessages, reversedMessages;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              sortedMessages = reportResult ? (_JSON$parse = JSON.parse(reportResult)) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.messages) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.filter(function (message) {
                var _message$id, _report$content, _JSON$parse2, _JSON$parse3, _JSON$parse4, _message$content;
                return !searchTerm || (message === null || message === void 0 || (_message$id = message.id) === null || _message$id === void 0 || (_message$id = _message$id.toUpperCase()) === null || _message$id === void 0 ? void 0 : _message$id.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toUpperCase())) || !!(report !== null && report !== void 0 && (_report$content = report.content) !== null && _report$content !== void 0 && _report$content.includeContent) && (isJson(message === null || message === void 0 ? void 0 : message.content) ?
                // handle json content
                (_JSON$parse2 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) !== null && _JSON$parse2 !== void 0 && (_JSON$parse2 = _JSON$parse2.data) !== null && _JSON$parse2 !== void 0 && (_JSON$parse2 = _JSON$parse2.response_dispatched) !== null && _JSON$parse2 !== void 0 && _JSON$parse2.responseText ? (_JSON$parse3 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse3 === void 0 || (_JSON$parse3 = _JSON$parse3.data) === null || _JSON$parse3 === void 0 || (_JSON$parse3 = _JSON$parse3.response_dispatched) === null || _JSON$parse3 === void 0 || (_JSON$parse3 = _JSON$parse3.responseText) === null || _JSON$parse3 === void 0 || (_JSON$parse3 = _JSON$parse3.toUpperCase()) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toUpperCase()) : (_JSON$parse4 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse4 === void 0 || (_JSON$parse4 = _JSON$parse4.data) === null || _JSON$parse4 === void 0 || (_JSON$parse4 = _JSON$parse4.request_received) === null || _JSON$parse4 === void 0 || (_JSON$parse4 = _JSON$parse4.requestText) === null || _JSON$parse4 === void 0 || (_JSON$parse4 = _JSON$parse4.toUpperCase()) === null || _JSON$parse4 === void 0 ? void 0 : _JSON$parse4.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toUpperCase()) : // handle text
                message === null || message === void 0 || (_message$content = message.content) === null || _message$content === void 0 || (_message$content = _message$content.toUpperCase()) === null || _message$content === void 0 ? void 0 : _message$content.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toUpperCase()));
              })) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.sort(function (a, b) {
                return a.lastModified.localeCompare(b.lastModified);
              }) : [];
              reversedMessages = (report === null || report === void 0 || (_report$content2 = report.content) === null || _report$content2 === void 0 ? void 0 : _report$content2.sortOrder) === 'descending' ? sortedMessages.reverse() : sortedMessages;
              setMessages(reversedMessages);

              /*?.sort((a,b) => report?.content?.sortOrder === 'descending' ? (
                !(`${a?.id}-${_.last(Object.keys(a?.content?.data))}`).localeCompare((`${b?.id}-${_.last(Object.keys(b?.content?.data))}`))
              ) : (
                (`${a?.id}-${_.last(Object.keys(a?.content?.data))}`).localeCompare((`${b?.id}-${_.last(Object.keys(b?.content?.data))}`))
              ))*/
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    })()();
  }, [reportResult]);
  var PAGE_SIZE = 10;
  useEffect(function (_) {
    (function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setPageMessages(messages.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref6.apply(this, arguments);
      };
    })()();
    var timerId = setTimeout(function () {
      var _report$content3;
      if ((report === null || report === void 0 || (_report$content3 = report.content) === null || _report$content3 === void 0 ? void 0 : _report$content3.sortOrder) !== 'descending') {
        bottomRef.current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 1000);
    return function () {
      clearTimeout(timerId);
    };
  }, [messages, page]);
  var reportQuery = report ? typeof report.content.query === 'string' ? JSON.parse(report === null || report === void 0 || (_report$content4 = report.content) === null || _report$content4 === void 0 ? void 0 : _report$content4.query) : report.content.query : undefined;
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedMessage = _useState12[0],
    setSelectedMessage = _useState12[1];

  // https://mui.com/material-ui/react-menu/
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    anchorEl_Produced = _useState14[0],
    setAnchorEl_Produced = _useState14[1];
  var open_Produced = Boolean(anchorEl_Produced);
  var handleItemMenuClick_Produced = function handleItemMenuClick_Produced(event, message) {
    setAnchorEl_Produced(event.currentTarget);
    setSelectedMessage(message);
  };
  var handleItemMenuClose_Produced = function handleItemMenuClose_Produced() {
    setAnchorEl_Produced(null);
    setSelectedMessage(null);
  };
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    anchorEl_Consumed = _useState16[0],
    setAnchorEl_Consumed = _useState16[1];
  var open_Consumed = Boolean(anchorEl_Consumed);
  var handleItemMenuClick_Consumed = function handleItemMenuClick_Consumed(event, message) {
    setAnchorEl_Consumed(event.currentTarget);
    setSelectedMessage(message);
  };
  var handleItemMenuClose_Consumed = function handleItemMenuClose_Consumed() {
    setAnchorEl_Consumed(null);
    setSelectedMessage(null);
  };
  var _useContext = useContext(SelectedFeatureStore.Context);
    _useContext.selectedFeature;
  var _useExtensions = useExtensions(),
    _useExtensions2 = _slicedToArray(_useExtensions, 1),
    extensions = _useExtensions2[0];
  var getActionsGroupedByPlugin = function getActionsGroupedByPlugin() {
    var _extensions$filter;
    return extensions === null || extensions === void 0 || (_extensions$filter = extensions.filter(function (extension) {
      var _extensionPlugins$ext, _extension$content;
      return (_extensionPlugins$ext = extensionPlugins[extension === null || extension === void 0 || (_extension$content = extension.content) === null || _extension$content === void 0 ? void 0 : _extension$content.pluginAlias]) === null || _extensionPlugins$ext === void 0 ? void 0 : _extensionPlugins$ext.actions.find(function (_ref7) {
        var object = _ref7.object;
        return object === 'message';
      });
    })) === null || _extensions$filter === void 0 ? void 0 : _extensions$filter.map(function (extension) {
      var _extension$content2, _extensionPlugins$ext2, _extension$content3;
      return {
        pluginAlias: extension === null || extension === void 0 || (_extension$content2 = extension.content) === null || _extension$content2 === void 0 ? void 0 : _extension$content2.pluginAlias,
        actions: (_extensionPlugins$ext2 = extensionPlugins[extension === null || extension === void 0 || (_extension$content3 = extension.content) === null || _extension$content3 === void 0 ? void 0 : _extension$content3.pluginAlias]) === null || _extensionPlugins$ext2 === void 0 || (_extensionPlugins$ext2 = _extensionPlugins$ext2.actions) === null || _extensionPlugins$ext2 === void 0 ? void 0 : _extensionPlugins$ext2.filter(function (_ref8) {
          var object = _ref8.object;
          return object === 'message';
        })
      };
    });
  };
  function matchFilters(reportQueryFilterMatch, pluginActionMatch) {
    console.log('reportQueryFilterMatch, pluginActionMatch');
    console.log(reportQueryFilterMatch, pluginActionMatch);
    return Object.keys(pluginActionMatch).filter(function (key) {
      if (!reportQueryFilterMatch.hasOwnProperty(key)) {
        return false;
      }
      if (reportQueryFilterMatch[key] !== pluginActionMatch[key]) {
        return false;
      }
      return true;
      //}).length === Object.keys(reportQueryFilterMatch).length;
    }).length === Object.keys(pluginActionMatch).length;
  }
  var filterPluginActions = function filterPluginActions(phase, pluginAlias, pluginActions, message) {
    return pluginActions === null || pluginActions === void 0 ? void 0 : pluginActions.filter(function (_ref9) {
      var _$find, _$find2;
      var pluginActionMatch = _ref9.match;
      return (
        //true
        // filter by phase
        ((_$find = lodash.find(reportQuery === null || reportQuery === void 0 ? void 0 : reportQuery.filters, function (filter) {
          var _message$filter;
          return filter.key === (message === null || message === void 0 || (_message$filter = message.filter) === null || _message$filter === void 0 ? void 0 : _message$filter.key);
        })) === null || _$find === void 0 || (_$find = _$find.match) === null || _$find === void 0 ? void 0 : _$find.exchangePhase) === phase && (
        // suffix is ok
        !(pluginActionMatch !== null && pluginActionMatch !== void 0 && pluginActionMatch.suffix) || (message === null || message === void 0 ? void 0 : message.id.endsWith(pluginActionMatch === null || pluginActionMatch === void 0 ? void 0 : pluginActionMatch.suffix))) &&
        // match report filter and action filter
        matchFilters( // reportQueryFilterMatch
        (_$find2 = lodash.find(reportQuery === null || reportQuery === void 0 ? void 0 : reportQuery.filters, function (filter) {
          var _message$filter2;
          return filter.key === (message === null || message === void 0 || (_message$filter2 = message.filter) === null || _message$filter2 === void 0 ? void 0 : _message$filter2.key);
        })) === null || _$find2 === void 0 ? void 0 : _$find2.match,
        // pluginActionMatch
        Object.fromEntries(Object.entries(pluginActionMatch).filter(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
            key = _ref11[0];
            _ref11[1];
          return key !== 'suffix';
        })))
      );
    });
  };
  var getPluginActionsForMessage = function getPluginActionsForMessage(message, phase) {
    var _getActionsGroupedByP;
    return (_getActionsGroupedByP = getActionsGroupedByPlugin()) === null || _getActionsGroupedByP === void 0 ? void 0 : _getActionsGroupedByP.map(function (_ref12) {
      var pluginAlias = _ref12.pluginAlias,
        actions = _ref12.actions;
      return {
        pluginAlias: pluginAlias,
        actions: phase ? filterPluginActions(phase, pluginAlias, actions, message) : actions
      };
    });
  };
  var handleMessageAction = function handleMessageAction(pluginAlias, action) {
    var _selectedMessage$filt;
    var url = "/plugin/".concat(pluginAlias, "/features/").concat(feature === null || feature === void 0 ? void 0 : feature.getId(), "/reports/").concat(report === null || report === void 0 ? void 0 : report.id, "/filters/").concat(selectedMessage === null || selectedMessage === void 0 || (_selectedMessage$filt = selectedMessage.filter) === null || _selectedMessage$filt === void 0 ? void 0 : _selectedMessage$filt.key, "/messages/").concat(selectedMessage === null || selectedMessage === void 0 ? void 0 : selectedMessage.id, "?query=").concat(encodeURIComponent(JSON.stringify(reportQuery)));
    if (!(action !== null && action !== void 0 && action.disposition)) {
      navigate(url);
    } else {
      setIframeFullScreen(action === null || action === void 0 ? void 0 : action.fullScreen);
      setIframeUrl(url);
    }
  };
  var _useState17 = useState(),
    _useState18 = _slicedToArray(_useState17, 2);
    _useState18[0];
    _useState18[1];
  console.log('RRRRRRRR');
  console.log(report);
  console.log(pageMessages);
  return /*#__PURE__*/React.createElement(Root$k, null, extensions && /*#__PURE__*/React.createElement(React.Fragment, null, !(messages !== null && messages !== void 0 && messages.length) && /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: 'grey',
      padding: '8px'
    }
  }, "There are no items to display"), !!(messages !== null && messages !== void 0 && messages.length) && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true,
    style: {
      float: 'left',
      width: '100%',
      padding: 0,
      margin: 0
    }
  }, /*#__PURE__*/React.createElement(List$1, {
    sx: {
      width: '100%' /*, maxWidth: 360*/,
      bgcolor: 'background.paper'
    }
  }, (_ref13 = !!(report !== null && report !== void 0 && (_report$content5 = report.content) !== null && _report$content5 !== void 0 && _report$content5.pageMessages) ? pageMessages : messages) === null || _ref13 === void 0 ? void 0 : _ref13.map(function (message, index) {
    var _JSON$parse5, _JSON$parse6, _JSON$parse7, _JSON$parse8, _JSON$parse9, _JSON$parse10, _JSON$parse11, _filter$match, _report$content6, _JSON$parse12, _JSON$parse13, _JSON$parse14, _message$filter4, _getPluginActionsForM, _message$filter5, _report$content7;
    var filter = lodash.find(reportQuery === null || reportQuery === void 0 ? void 0 : reportQuery.filters, function (filter) {
      var _message$filter3;
      return filter.key === (message === null || message === void 0 || (_message$filter3 = message.filter) === null || _message$filter3 === void 0 ? void 0 : _message$filter3.key);
    });
    var owner = isJson(message === null || message === void 0 ? void 0 : message.content) ?
    // handle json content
    (_JSON$parse5 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) !== null && _JSON$parse5 !== void 0 && (_JSON$parse5 = _JSON$parse5.data) !== null && _JSON$parse5 !== void 0 && (_JSON$parse5 = _JSON$parse5.response_dispatched) !== null && _JSON$parse5 !== void 0 && _JSON$parse5.responseText ? 'Assistant' : (_JSON$parse6 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) !== null && _JSON$parse6 !== void 0 && (_JSON$parse6 = _JSON$parse6.data) !== null && _JSON$parse6 !== void 0 && (_JSON$parse6 = _JSON$parse6.request_received) !== null && _JSON$parse6 !== void 0 && (_JSON$parse6 = _JSON$parse6.user) !== null && _JSON$parse6 !== void 0 && _JSON$parse6.partyName && ((_JSON$parse7 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse7 === void 0 || (_JSON$parse7 = _JSON$parse7.data) === null || _JSON$parse7 === void 0 || (_JSON$parse7 = _JSON$parse7.request_received) === null || _JSON$parse7 === void 0 || (_JSON$parse7 = _JSON$parse7.user) === null || _JSON$parse7 === void 0 ? void 0 : _JSON$parse7.partyName) !== "undefined" ? (_JSON$parse8 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse8 === void 0 || (_JSON$parse8 = _JSON$parse8.data) === null || _JSON$parse8 === void 0 || (_JSON$parse8 = _JSON$parse8.request_received) === null || _JSON$parse8 === void 0 || (_JSON$parse8 = _JSON$parse8.user) === null || _JSON$parse8 === void 0 ? void 0 : _JSON$parse8.partyName : (_JSON$parse9 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) !== null && _JSON$parse9 !== void 0 && (_JSON$parse9 = _JSON$parse9.data) !== null && _JSON$parse9 !== void 0 && (_JSON$parse9 = _JSON$parse9.request_received) !== null && _JSON$parse9 !== void 0 && (_JSON$parse9 = _JSON$parse9.user) !== null && _JSON$parse9 !== void 0 && _JSON$parse9.partyEmail ? (_JSON$parse10 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse10 === void 0 || (_JSON$parse10 = _JSON$parse10.data) === null || _JSON$parse10 === void 0 || (_JSON$parse10 = _JSON$parse10.request_received) === null || _JSON$parse10 === void 0 || (_JSON$parse10 = _JSON$parse10.user) === null || _JSON$parse10 === void 0 ? void 0 : _JSON$parse10.partyEmail : (_JSON$parse11 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse11 === void 0 || (_JSON$parse11 = _JSON$parse11.data) === null || _JSON$parse11 === void 0 || (_JSON$parse11 = _JSON$parse11.request_received) === null || _JSON$parse11 === void 0 || (_JSON$parse11 = _JSON$parse11.user) === null || _JSON$parse11 === void 0 ? void 0 : _JSON$parse11.partyId : // handle text
    filter === null || filter === void 0 ? void 0 : filter.label;
    var ownerInitial = owner ? (owner.startsWith('p_') ? owner.charAt(2) : owner.charAt(0)).toUpperCase() : 'U';
    return /*#__PURE__*/React.createElement("div", {
      key: message === null || message === void 0 ? void 0 : message.id
    }, /*#__PURE__*/React.createElement(ListItem, {
      key: message === null || message === void 0 ? void 0 : message.id,
      alignItems: "flex-start"
      /*secondaryAction={
        <div style={{top:'20px'}}>
          <IconButton edge="end" aria-label="menu">
            <MenuIcon fontSize="inherit" />
          </IconButton>
        </div>
      }*/
    }, /*#__PURE__*/React.createElement(ListItemAvatar, null, (filter === null || filter === void 0 || (_filter$match = filter.match) === null || _filter$match === void 0 ? void 0 : _filter$match.exchangePhase) === 'produced' ? /*#__PURE__*/React.createElement(Badge
    //variant="dot" 
    , {
      badgeContent: "NEW",
      color: "secondary",
      sx: {
        "& .MuiBadge-badge": {
          fontSize: 7,
          height: 12,
          minWidth: 12
        }
      }
    }, /*#__PURE__*/React.createElement(Avatar$1, {
      sx: {
        bgcolor: charToRGB(ownerInitial)
      }
    }, ownerInitial)) : /*#__PURE__*/React.createElement(Avatar$1, {
      sx: {
        bgcolor: charToRGB(ownerInitial)
      }
    }, ownerInitial)), /*#__PURE__*/React.createElement(ListItemText, {
      disableTypography: true,
      primary: !!(report !== null && report !== void 0 && (_report$content6 = report.content) !== null && _report$content6 !== void 0 && _report$content6.includeContent) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        style: {
          color: '#444'
        }
      }, isJson(message === null || message === void 0 ? void 0 : message.content) && (_JSON$parse12 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) !== null && _JSON$parse12 !== void 0 && (_JSON$parse12 = _JSON$parse12.data) !== null && _JSON$parse12 !== void 0 && (_JSON$parse12 = _JSON$parse12.response_dispatched) !== null && _JSON$parse12 !== void 0 && _JSON$parse12.responseText ? (_JSON$parse13 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse13 === void 0 || (_JSON$parse13 = _JSON$parse13.data) === null || _JSON$parse13 === void 0 || (_JSON$parse13 = _JSON$parse13.response_dispatched) === null || _JSON$parse13 === void 0 ? void 0 : _JSON$parse13.responseText : (_JSON$parse14 = JSON.parse(message === null || message === void 0 ? void 0 : message.content)) === null || _JSON$parse14 === void 0 || (_JSON$parse14 = _JSON$parse14.data) === null || _JSON$parse14 === void 0 || (_JSON$parse14 = _JSON$parse14.request_received) === null || _JSON$parse14 === void 0 ? void 0 : _JSON$parse14.requestText)) : /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(TableContainer, {
        component: Paper$1,
        style: {
          boxShadow: 'none'
        }
      }, /*#__PURE__*/React.createElement(Table, {
        size: "small",
        "aria-label": "report results"
      }, /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, {
        key: "".concat(message === null || message === void 0 || (_message$filter4 = message.filter) === null || _message$filter4 === void 0 ? void 0 : _message$filter4.key, "-").concat(message === null || message === void 0 ? void 0 : message.id)
        //style={{marginTop:'-16px'}}
      }, /*#__PURE__*/React.createElement(TableCell, {
        align: "left",
        style: {
          border: 'none',
          padding: 0
        }
      }, /*THEREISEXTENSION ? USEEXENTION(message?.id) : */message === null || message === void 0 ? void 0 : message.id), /*#__PURE__*/React.createElement(TableCell, {
        align: "right" /*colspan={filter?.match.exchangePhase === 'produced' ? 2 : undefined}*/,
        style: {
          border: 'none',
          width: '24px'
        }
      }, !!!((_getPluginActionsForM = getPluginActionsForMessage(message, filter === null || filter === void 0 ? void 0 : filter.match.exchangePhase)) !== null && _getPluginActionsForM !== void 0 && _getPluginActionsForM.find(function (_ref14) {
        var actions = _ref14.actions;
        return !!actions.length;
      })) ? /*#__PURE__*/React.createElement("div", {
        style: {
          border: 'none',
          width: '24px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          minWidth: '24px'
        }
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          border: 'none',
          width: '24px'
        }
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton$1, {
        color: "secondary",
        style: {
          padding: 0,
          paddingLeft: '1px',
          marginRight: '2px'
        },
        onClick: function onClick(event) {
          return (filter === null || filter === void 0 ? void 0 : filter.match.exchangePhase) === 'consumed' ? handleItemMenuClick_Consumed(event, message) : handleItemMenuClick_Produced(event, message);
        }
      }, /*#__PURE__*/React.createElement(MenuIcon, {
        fontSize: "inherit"
      })))))))))),
      secondary: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start"
        //style={{marginTop: filter?.match.exchangePhase === 'consumed' ? '-8px' : undefined,width:'100%'}}
      }, (size === 'small' || isSmallMobile) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        key: 'filter-label',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/padding: '0',
          marginTop: '-4px',
          marginBottom: '-2px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          float: 'left',
          paddingLeft: '0',
          paddingBottom: '0',
          display: 'inline-block',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        sx: {
          display: 'inline'
        },
        component: "span",
        variant: "body2",
        color: "text.primary",
        style: {
          fontSize: '.75rem'
        },
        noWrap: true
      }, owner))), size !== 'small' && !isSmallMobile && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        key: 'detail',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/padding: '0'
        }
      }, /*#__PURE__*/React.createElement(TableContainer, {
        component: Paper$1,
        style: {
          boxShadow: 'none'
        }
      }, /*#__PURE__*/React.createElement(Table, {
        size: "small",
        "aria-label": "report results"
      }, /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, {
        key: "".concat(message === null || message === void 0 || (_message$filter5 = message.filter) === null || _message$filter5 === void 0 ? void 0 : _message$filter5.key, "-").concat(message === null || message === void 0 ? void 0 : message.id)
      }, /*#__PURE__*/React.createElement(TableCell, {
        align: "left",
        style: {
          border: 'none',
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        style: {
          minWidth: '96px',
          fontSize: '.75rem',
          fontWeight: '500',
          color: '#aaa'
        }
      }, owner)), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
        //colspan={filter?.match.exchangePhase === 'produced' ? 2 : undefined}
        ,
        style: {
          border: 'none',
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        justifyContent: "flex-end",
        alignItems: "flex-end"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        key: 'name',
        style: {
          float: 'left',
          paddingTop: 0,
          paddingLeft: '0',
          paddingBottom: '0',
          paddingRight: '8px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        noWrap: true,
        style: {
          fontSize: '.7rem',
          color: '#aaa'
        }
      }, new Date(message === null || message === void 0 ? void 0 : message.lastModified).toLocaleString().split(',').join(' '))))))))))))
    })), index + 1 != (!!(report !== null && report !== void 0 && (_report$content7 = report.content) !== null && _report$content7 !== void 0 && _report$content7.pageMessages) ? pageMessages : messages).length && /*#__PURE__*/React.createElement(Divider$1, {
      variant: "inset",
      component: "li",
      key: "".concat(message === null || message === void 0 ? void 0 : message.id, "-divider")
    }));
  }))), (report === null || report === void 0 || (_report$content8 = report.content) === null || _report$content8 === void 0 ? void 0 : _report$content8.pageMessages) > 5 && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      float: 'left',
      width: '100%',
      padding: 0,
      margin: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      paddingTop: '8px',
      paddingRight: '8px'
    }
  }, /*#__PURE__*/React.createElement(Pagination, {
    count: Math.ceil(messages.length / PAGE_SIZE),
    showFirstButton: true,
    showLastButton: true,
    size: "small",
    style: {
      float: 'right'
    },
    onChange: function onChange(e, page) {
      return setPage(page);
    },
    page: page
  })))), !!((_getPluginActionsForM2 = getPluginActionsForMessage(selectedMessage, 'produced')) !== null && _getPluginActionsForM2 !== void 0 && _getPluginActionsForM2.find(function (_ref15) {
    var actions = _ref15.actions;
    return !!actions.length;
  })) && /*#__PURE__*/React.createElement(Menu$1, {
    id: "produced-menu",
    "aria-labelledby": "produced-menu-button",
    anchorEl: anchorEl_Produced,
    open: open_Produced,
    onClose: handleItemMenuClose_Produced,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, (_getPluginActionsForM3 = getPluginActionsForMessage(selectedMessage, 'produced')) === null || _getPluginActionsForM3 === void 0 ? void 0 : _getPluginActionsForM3.map(function (_ref16) {
    var pluginAlias = _ref16.pluginAlias,
      actions = _ref16.actions;
    return actions === null || actions === void 0 ? void 0 : actions.map(function (action) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        onClick: function onClick(event) {
          handleItemMenuClose_Produced();
          handleMessageAction(pluginAlias, action);
        }
      }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(ViewIcon, {
        fontSize: "small"
      })), /*#__PURE__*/React.createElement(ListItemText, null, console.log('selectedMessage', selectedMessage), action.name));
    });
  })), !!((_getPluginActionsForM4 = getPluginActionsForMessage(selectedMessage, 'consumed')) !== null && _getPluginActionsForM4 !== void 0 && _getPluginActionsForM4.find(function (_ref17) {
    var actions = _ref17.actions;
    return !!actions.length;
  })) && /*#__PURE__*/React.createElement(Menu$1, {
    id: "consumed-menu",
    "aria-labelledby": "consumed-menu-button",
    anchorEl: anchorEl_Consumed,
    open: open_Consumed,
    onClose: handleItemMenuClose_Consumed,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, (_getPluginActionsForM5 = getPluginActionsForMessage(selectedMessage, 'consumed')) === null || _getPluginActionsForM5 === void 0 ? void 0 : _getPluginActionsForM5.map(function (_ref18) {
    var pluginAlias = _ref18.pluginAlias,
      actions = _ref18.actions;
    return actions === null || actions === void 0 ? void 0 : actions.map(function (action) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        onClick: function onClick(event) {
          handleItemMenuClose_Consumed();
          handleMessageAction(pluginAlias, action);
        }
      }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(ViewIcon, {
        fontSize: "small"
      })), /*#__PURE__*/React.createElement(ListItemText, null, console.log('selectedMessage', selectedMessage), action.name));
    });
  })), !!iframeUrl && /*#__PURE__*/React.createElement(Modal, {
    open: !!iframeUrl,
    onClose: function onClose() {
      return setIframeUrl(null);
    },
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 0
    }
  }, /*#__PURE__*/React.createElement(Iframe, {
    src: iframeUrl,
    width: iframeFullScreen ? '100%' : '400px',
    height: iframeFullScreen ? '100%' : '200px'
  }))), /*#__PURE__*/React.createElement("div", {
    ref: bottomRef
  }));
};
var isJson = function isJson(body) {
  return !!body && body.startsWith('{') && body.endsWith('}');
};
function charToRGB(char) {
  // Step 1: Convert the character to a numerical value (ASCII value)
  var charCode = char.charCodeAt(0);

  // Step 2: Use the numerical value to calculate the RGB components
  // You can use any method you like to map the character code to RGB values.
  // For this example, we'll simply use the modulo operator and some constants.
  var red = charCode % 256;
  var green = charCode * 2 % 256;
  var blue = charCode * 3 % 256;

  // Return the RGB color as a string
  return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}

var FileUploader = function FileUploader(_ref) {
  var onDrop = _ref.onDrop,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options;
  var handleDrop = useCallback(function (acceptedFiles) {
    !!onDrop ? onDrop(acceptedFiles) : console.warn('onDrop is not defined');
  }, []);
  var _useDropzone = useDropzone({
      onDrop: handleDrop
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive;
  var inactivePrompt = options.inactivePrompt,
    activePrompt = options.activePrompt;
  var defaultActivePrompt = 'Drop the files here...';
  var defaultInactivePrompt = 'Drag and drop files here or click to select files';
  return /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
    style: {
      border: '1px dashed var(--color-border-item-focused-n5kd8g,#0073bb)',
      textAlign: 'center',
      background: 'var(--color-background-control-default-8xmy94,#fff)',
      fontSize: '14px',
      padding: '16px'
    }
  }), /*#__PURE__*/React.createElement("input", getInputProps()), isDragActive ? /*#__PURE__*/React.createElement("p", null, activePrompt ? activePrompt : defaultActivePrompt) : /*#__PURE__*/React.createElement("p", null, inactivePrompt ? inactivePrompt : defaultInactivePrompt));
};

var PREFIX$o = 'ScenarioDetails';
var classes$o = {
  mediaRoot: "".concat(PREFIX$o, "-mediaRoot"),
  editorRoot: "".concat(PREFIX$o, "-editorRoot"),
  editorPaper: "".concat(PREFIX$o, "-editorPaper"),
  editorForm: "".concat(PREFIX$o, "-editorForm"),
  editorButton: "".concat(PREFIX$o, "-editorButton"),
  link: "".concat(PREFIX$o, "-link")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$o.mediaRoot), {
    //height: '110px',
  }), _defineProperty(_ref2, "& .".concat(classes$o.editorRoot), {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$o.editorPaper), {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), _defineProperty(_ref2, "& .".concat(classes$o.editorForm), {
    padding: 8,
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$o.editorButton), {
    padding: 8
  }), _defineProperty(_ref2, "& .".concat(classes$o.link), {
    color: 'rgba(0, 0, 0, 0.87)',
    //theme.palette.secondary.main
    textDecoration: 'underline',
    fontSize: '1.125rem',
    fontFamily: 'Roboto,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    fontWeight: '500',
    lineHeight: '1.6'
  }), _ref2;
});
({
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
});

var PREFIX$n = 'FileSender';
var classes$n = {
  send: "".concat(PREFIX$n, "-send"),
  sendIcon: "".concat(PREFIX$n, "-sendIcon"),
  inputRoot: "".concat(PREFIX$n, "-inputRoot"),
  inputInput: "".concat(PREFIX$n, "-inputInput")
};
var StyledClickAwayListener$1 = styled(ClickAwayListener)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$n.send), {
    display: "flex",
    justifyContent: "center",
    width: '100%',
    //maxWidth: 472,//"100%",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.shortest
    }),
    //marginLeft: theme.spacing(1)
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.1) !important',
    borderWidth: 'thin'
  }), _defineProperty(_ref2, "& .".concat(classes$n.sendIcon), {
    width: theme.spacing(7),
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$n.inputRoot), {
    flex: 1,
    alignItems: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$n.inputInput), {
    width: "100%",
    border: 1
  }), _ref2;
});
var FileSender = function FileSender(_ref3) {
  var onSendApply = _ref3.onSendApply;
  var theme = useTheme$1();
  var inputRef = useRef(null);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    sendTerm = _useState2[0],
    setSendTerm = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocussed = _useState4[0],
    setFocussed = _useState4[1];

  var handleSend = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!onSendApply) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return onSendApply(sendTerm);
          case 3:
            setSendTerm("");
            setFocussed(false);
            inputRef.current.blur();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSend() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleKeyDown = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setFocussed(true);
            if (event.key === "Enter") {
              handleSend();
            }
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleKeyDown(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var onFocusLoss = function onFocusLoss() {
    //onSendClose ? onSendClose() : undefined;
    setFocussed(false);
  };
  return /*#__PURE__*/React.createElement(StyledClickAwayListener$1, {
    onClickAway: onFocusLoss
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      maxWidth: '472px',
      width: '100%'
    },
    className: classes$n.send,
    borderRadius: "undefined",
    bgcolor: isFocussed ? theme.palette.background.default : theme.palette.background.highlight,
    boxShadow: isFocussed ? 2 : 0,
    height: "3rem"
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacking: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: classes$n.searchIcon,
    style: {
      margin: '8px'
    }
  }), /*#__PURE__*/React.createElement(InputBase$1, {
    ref: inputRef,
    placeholder: "Send a message",
    classes: {
      root: classes$n.inputRoot,
      input: classes$n.inputInput
    },
    style: {
      marginTop: '-4px',
      width: '100%',
      paddingTop: isFocussed ? '4px' : '12px'
    },
    value: sendTerm,
    onClick: function onClick(e) {
      /*if (selectedPanelId !== 'products-panel') {
        setSelectedPanelId('products-panel');
      }*/
      setFocussed(true);
    },
    inputProps: {
      "aria-label": "send"
    },
    onChange: function onChange(event) {
      setSendTerm(event.target.value);
      //setFocussed(true);
    },

    onKeyDown: handleKeyDown,
    autoFocus: false //{selectedPanelId === 'products-panel'}
    ,
    autoComplete: "off"
  }), isFocussed ? /*#__PURE__*/React.createElement(IconButton, {
    autoFocus: !isFocussed,
    hidden: !isFocussed,
    disabled: !sendTerm,
    onClick: /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSend();
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref6.apply(this, arguments);
      };
    }(),
    size: "large"
  }, /*#__PURE__*/React.createElement(Send, {
    htmlColor: theme.custom.palette[!!sendTerm ? 'iconHighlight' : 'rgb(250,250,250)']
  })) : null)));
};

var PREFIX$m = 'SearchBar';
var classes$m = {
  search: "".concat(PREFIX$m, "-search"),
  searchIcon: "".concat(PREFIX$m, "-searchIcon"),
  inputRoot: "".concat(PREFIX$m, "-inputRoot"),
  inputInput: "".concat(PREFIX$m, "-inputInput")
};
var StyledClickAwayListener = styled(ClickAwayListener)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$m.search), {
    display: "flex",
    justifyContent: "center",
    width: '100%',
    //maxWidth: 472,//"100%",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.shortest
    }),
    //marginLeft: theme.spacing(1)
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.1) !important',
    borderWidth: 'thin'
  }), _defineProperty(_ref2, "& .".concat(classes$m.searchIcon), {
    width: theme.spacing(7),
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$m.inputRoot), {
    flex: 1,
    alignItems: "center"
  }), _defineProperty(_ref2, "& .".concat(classes$m.inputInput), {
    width: "100%",
    border: 1
  }), _ref2;
});
var SearchBar = function SearchBar(_ref3) {
  var onSearchClose = _ref3.onSearchClose,
    searchTerm = _ref3.searchTerm,
    setSearchTerm = _ref3.setSearchTerm;
  var theme = useTheme$1();

  //const { searchTerm, setSearchTerm } = useContext(UISessionStore.Context);

  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocussed = _useState2[0],
    setFocussed = _useState2[1];
  var onSearchCancel = function onSearchCancel() {
    setSearchTerm("");
    setFocussed(false);
    onSearchClose ? onSearchClose() : undefined;
  };
  var onSearch = function onSearch(event) {
    setFocussed(true);
    if (event.key === "Enter") {
      //showToast(true);
      //setFocussed(false);
      onSearchClose ? onSearchClose() : undefined;
    }
  };
  var onFocusLoss = function onFocusLoss() {
    onSearchClose ? onSearchClose() : undefined;
    setFocussed(false);
  };
  return /*#__PURE__*/React.createElement(StyledClickAwayListener, {
    onClickAway: onFocusLoss
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      maxWidth: '472px',
      width: '100%'
    },
    className: classes$m.search,
    borderRadius: "undefined",
    bgcolor: isFocussed ? theme.palette.background.default : theme.palette.background.highlight,
    boxShadow: isFocussed ? 2 : 0,
    height: "3rem"
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacking: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: classes$m.searchIcon,
    style: {
      margin: '12px'
    }
  }, /*#__PURE__*/React.createElement(Search, null)), /*#__PURE__*/React.createElement(InputBase$1, {
    placeholder: "Find item",
    classes: {
      root: classes$m.inputRoot,
      input: classes$m.inputInput
    },
    style: {
      marginTop: '-4px',
      width: '100%'
    },
    value: searchTerm,
    onClick: function onClick(e) {
      /*if (selectedPanelId !== 'products-panel') {
        setSelectedPanelId('products-panel');
      }*/
      setFocussed(true);
    },
    inputProps: {
      "aria-label": "search"
    },
    onChange: function onChange(event) {
      setSearchTerm(event.target.value);
      //setFocussed(true);
    },

    onKeyDown: onSearch
    //autoFocus={true}//{selectedPanelId === 'products-panel'}
    ,
    autoComplete: "off"
  }), isFocussed ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '0px'
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    hidden: !isFocussed,
    onClick: onSearchCancel,
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseOutlined, {
    htmlColor: theme.custom.palette.iconColor
  }))) : null)));
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$j = styled('div')(function (_ref2) {
  _ref2.theme;
  return _defineProperty({}, ".MuiTableCell-root", {
    padding: '6px',
    fontSize: '.875rem'
  });
});
var SelectedFilesList = function SelectedFilesList(_ref4) {
  var selectedFiles = _ref4.selectedFiles;
    _ref4.size;
  useRef(null);
  var theme = useTheme$1();
  useNavigate();
  useMediaQuery$1(theme.breakpoints.down('sm400')); // 0px
  useMediaQuery$1(theme.breakpoints.up('sm400')); // 400px
  var isTablet = useMediaQuery$1(theme.breakpoints.up("sm")); // 600px
  var isLaptop = useMediaQuery$1(theme.breakpoints.up("md")); // 960px
  var isLaptopL = useMediaQuery$1(theme.breakpoints.up("lg")); // 1280px
  var is4K = useMediaQuery$1(theme.breakpoints.up("xl")); // 1920px

  var width = is4K ? "1888px" : isLaptopL ? "1248px" : isLaptop ? "928px" : isTablet ? "568px" : "100%";
  var _false = false,
    isListView = _false.isListView; //useContext(UISettingsContext);
  width = isListView ? isLaptop || isLaptopL ? theme.spacing(75) : "100%" : width;
  return /*#__PURE__*/React.createElement(Root$j, null, !(selectedFiles !== null && selectedFiles !== void 0 && selectedFiles.length) && /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: 'grey',
      padding: '8px'
    }
  }, "You have not chosen any files or folders to upload."), !!(selectedFiles !== null && selectedFiles !== void 0 && selectedFiles.length) && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true,
    style: {
      float: 'left',
      width: '100%',
      padding: 0,
      margin: 0
    }
  }, /*#__PURE__*/React.createElement(List$1, {
    sx: {
      width: '100%' /*, maxWidth: 360*/,
      bgcolor: 'background.paper'
    }
  }, selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.map(function (selectedFile, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.id
    }, /*#__PURE__*/React.createElement(ListItem, {
      key: selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.path,
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(FileIcon, null)), /*#__PURE__*/React.createElement(ListItemText, {
      disableTypography: true,
      primary: selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name
    })), index + 1 != selectedFiles.length && /*#__PURE__*/React.createElement(Divider$1, {
      variant: "inset",
      component: "li",
      key: "".concat(selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.path, "-divider")
    }));
  })))));
};

var PREFIX$l = 'ScenarioCard';
var classes$l = {
  root: "".concat(PREFIX$l, "-root"),
  buttonContainer: "".concat(PREFIX$l, "-buttonContainer"),
  checked: "".concat(PREFIX$l, "-checked"),
  root2: "".concat(PREFIX$l, "-root2"),
  media: "".concat(PREFIX$l, "-media"),
  counterButtonWrapper: "".concat(PREFIX$l, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$l, "-checkboxRoot"),
  checkboxRootColorfulPickup: "".concat(PREFIX$l, "-checkboxRootColorfulPickup"),
  checkboxRootDelivery: "".concat(PREFIX$l, "-checkboxRootDelivery"),
  checkboxRootColorfulDelivery: "".concat(PREFIX$l, "-checkboxRootColorfulDelivery"),
  formControl: "".concat(PREFIX$l, "-formControl"),
  packingHoursEdit: "".concat(PREFIX$l, "-packingHoursEdit"),
  timeEdit: "".concat(PREFIX$l, "-timeEdit"),
  timeView: "".concat(PREFIX$l, "-timeView"),
  dayOfWeekEdit: "".concat(PREFIX$l, "-dayOfWeekEdit"),
  shopTypeEdit: "".concat(PREFIX$l, "-shopTypeEdit"),
  expand: "".concat(PREFIX$l, "-expand"),
  expandOpen: "".concat(PREFIX$l, "-expandOpen"),
  topCardContentRoot: "".concat(PREFIX$l, "-topCardContentRoot"),
  topCardContentRoot_edit: "".concat(PREFIX$l, "-topCardContentRoot_edit"),
  topCardContentContainerRoot: "".concat(PREFIX$l, "-topCardContentContainerRoot"),
  paper: "".concat(PREFIX$l, "-paper")
};
styled(CardActions)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px'
});
var StyledButton$1 = styled(Button)({
  borderRadius: '2px',
  backgroundColor: '#f1f1f1',
  color: '#202124',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#e1e1e1'
  }
});
styled(StyledButton$1)({
  backgroundColor: '#fbbc05',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#f9a825'
  }
});
styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#2196f3',
    '&:hover': {
      backgroundColor: 'rgba(76, 175, 80, 0.08)'
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#2196f3'
  }
});

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$i = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$l.buttonContainer), {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  }), _defineProperty(_ref2, "& .".concat(classes$l.root2), {
    maxWidth: '454px' //472px
    //padding: '8px',
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$l.media), {
    height: '110px'
  }), _defineProperty(_ref2, "& .".concat(classes$l.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$l.checkboxRoot), {
    verticalAlign: 'top',
    //margin: `auto ${theme.spacing(1.5)}px`,
    //marginTop: theme.spacing(0),
    //marginTop: '3px',
    //marginLeft: '4px !important',
    marginTop: '-2px',
    //marginLeft:'8px',
    marginLeft: '10px',
    marginRight: '3px',
    padding: "0 !important",
    //paddingTop: '9px !important',
    //paddingBottom: '9px !important',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$l.checkboxRootColorfulPickup), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$l.checkboxRootDelivery), {
    marginRight: '-7px',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$l.checkboxRootColorfulDelivery), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$l.formControl), {
    backgroundColor: 'lightBlue'
  }), _defineProperty(_ref2, "& .".concat(classes$l.packingHoursEdit), {
    width: '64px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$l.timeEdit), {
    width: '92px',
    height: '24px',
    marginTop: '-1px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$l.timeView), {
    width: '92px',
    height: '24px',
    marginTop: '2px'
    //color: 'rgba(0, 0, 0, 0.54) !important'
  }), _defineProperty(_ref2, "& .".concat(classes$l.dayOfWeekEdit), {
    width: '80px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$l.shopTypeEdit), {
    paddingLeft: '8px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$l.expand), _defineProperty({
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    padding: 0,
    marginTop: '32px'
  }, "marginLeft", '4px')), _defineProperty(_ref2, "& .".concat(classes$l.expandOpen), {
    transform: 'rotate(180deg)',
    padding: 0,
    marginTop: '32px',
    marginLeft: '4px'
  }), _defineProperty(_ref2, "& .".concat(classes$l.topCardContentRoot), {
    //padding: 0,
    //margin: 0
    //paddingBottom: '17px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$l.topCardContentRoot_edit), {
    //paddingBottom: '8px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '8px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$l.topCardContentContainerRoot), {
    padding: 0,
    margin: 0
  }), _defineProperty(_ref2, "& .".concat(classes$l.paper), {/*
                                                           borderStyle: "solid",
                                                           borderWidth: theme.spacing(0.1),
                                                           borderColor: theme.custom.palette.itemBorderColor,
                                                           */
  }), _ref2;
});
var ScenarioCard = function ScenarioCard(_ref3) {
  var _scenario$content4, _scenario$content5, _scenario$content6, _scenario$content7, _getCapabilityScenari, _scenario$content8, _scenario$content9, _getCapabilityScenari2, _scenario$content10, _scenario$content11, _getCapabilityScenari19, _getCapabilityScenari20;
  _ref3.actions;
    var condensed = _ref3.condensed,
    scenario = _ref3.scenario,
    _ref3$mode = _ref3.mode,
    mode_param = _ref3$mode === void 0 ? 'view' : _ref3$mode;
    _ref3.highlighted;
  console.log('JJJJ');
  console.log(scenario);
  useNavigate();
  var _useContext = useContext(CapabilitiesStore.Context),
    capabilities = _useContext.capabilities,
    findCapability = _useContext.findCapability;
  var _useContext2 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext2.selectedFeature;
  var urlPrefix = host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var mode = useQueryParam('mode', mode_param);
  var _useState = useState(!condensed),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useContext3 = useContext(SpoketreeAuthStore.Context);
    _useContext3.authenticationEmail;
  var principalParty = useContext(PrincipalPartyStore.Context);
  var _useContext4 = useContext(Context$d),
    putScenario = _useContext4.putScenario,
    deleteScenario = _useContext4.deleteScenario;
  var getCapabilityReport = function getCapabilityReport(reportId) {
    var _scenario$content, _capability$getReport, _capability$getReport2;
    var capability = findCapability(scenario === null || scenario === void 0 || (_scenario$content = scenario.content) === null || _scenario$content === void 0 ? void 0 : _scenario$content.capabilityId);
    var capabilityReports = (capability !== null && capability !== void 0 && (_capability$getReport = capability.getReports()) !== null && _capability$getReport !== void 0 && _capability$getReport._items ? Object.values(capability === null || capability === void 0 || (_capability$getReport2 = capability.getReports()) === null || _capability$getReport2 === void 0 ? void 0 : _capability$getReport2._items) : []).map(function (i) {
      return i[0];
    }).map(function (i) {
      return {
        id: i.E_SK.split(':').pop(),
        content: i.Version_Content
      };
    });
    var capabilityReport = capabilityReports === null || capabilityReports === void 0 ? void 0 : capabilityReports.find(function (report) {
      return report.id === reportId;
    });
    return capabilityReport;
  };
  var getCapabilityScenario = function getCapabilityScenario() {
    var _scenario$content2, _capability$getScenar, _capability$getScenar2;
    var capability = findCapability(scenario === null || scenario === void 0 || (_scenario$content2 = scenario.content) === null || _scenario$content2 === void 0 ? void 0 : _scenario$content2.capabilityId);
    var capabilityScenarios = (capability !== null && capability !== void 0 && (_capability$getScenar = capability.getScenarios()) !== null && _capability$getScenar !== void 0 && _capability$getScenar._items ? Object.values(capability === null || capability === void 0 || (_capability$getScenar2 = capability.getScenarios()) === null || _capability$getScenar2 === void 0 ? void 0 : _capability$getScenar2._items) : []).map(function (i) {
      return i[0];
    }).map(function (i) {
      return {
        id: i.E_SK.split(':').pop(),
        content: i.Version_Content
      };
    });
    var capabilityScenario = capabilityScenarios === null || capabilityScenarios === void 0 ? void 0 : capabilityScenarios.find(function (cs) {
      var _scenario$content3;
      return cs.id === (scenario === null || scenario === void 0 || (_scenario$content3 = scenario.content) === null || _scenario$content3 === void 0 ? void 0 : _scenario$content3.capabilityScenarioId);
    });
    return capabilityScenario;
  };
  var capabilityScenarioKey = "".concat(scenario === null || scenario === void 0 || (_scenario$content4 = scenario.content) === null || _scenario$content4 === void 0 ? void 0 : _scenario$content4.capabilityId, ":").concat(scenario === null || scenario === void 0 || (_scenario$content5 = scenario.content) === null || _scenario$content5 === void 0 ? void 0 : _scenario$content5.capabilityScenarioId);
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    enableCreateScenario = _useState4[0],
    setEnableCreateScenario = _useState4[1];
  useEffect(function (_) {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _selectedFeature$getC;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", setEnableCreateScenario(!!(selectedFeature !== null && selectedFeature !== void 0 && (_selectedFeature$getC = selectedFeature.getCreateableScenarios()) !== null && _selectedFeature$getC !== void 0 && _selectedFeature$getC.find(function (value) {
              return value === capabilityScenarioKey;
            }))));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))([selectedFeature]);
  });
  var handleEnableCreateScenarioCheckboxChange = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setEnableCreateScenario(e.target.checked);
            _context2.next = 3;
            return selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.setCreateableScenarios(e.target.checked ?
            // add capability:scenario to array
            lodash.union(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getCreateableScenarios(), [capabilityScenarioKey]) :
            // remove capability:scenario from array
            lodash.remove(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getCreateableScenarios(), capabilityScenarioKey));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleEnableCreateScenarioCheckboxChange(_x) {
      return _ref6.apply(this, arguments);
    };
  }();
  var resourceCollectionUrl = "".concat(host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id) : '/plugin/exchange/feature', "/scenarios");
  var resourceItemUrl = "".concat(resourceCollectionUrl, "/").concat(scenario.id);
  var cardImageDefault = 'https://images.unsplash.com/photo-1497211419994-14ae40a3c7a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
  var cardImageAlbum = "spoketree/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id, "/scenarios/").concat(scenario.id, "/photos/card");
  var cardImageQuery = 'business';
  var displayCardImage = scenario !== null && scenario !== void 0 && (_scenario$content6 = scenario.content) !== null && _scenario$content6 !== void 0 && _scenario$content6.cardImage ? scenario === null || scenario === void 0 || (_scenario$content7 = scenario.content) === null || _scenario$content7 === void 0 ? void 0 : _scenario$content7.cardImage : (_getCapabilityScenari = getCapabilityScenario()) === null || _getCapabilityScenari === void 0 || (_getCapabilityScenari = _getCapabilityScenari.content) === null || _getCapabilityScenari === void 0 ? void 0 : _getCapabilityScenari.cardImage;
  var displayName = scenario !== null && scenario !== void 0 && (_scenario$content8 = scenario.content) !== null && _scenario$content8 !== void 0 && _scenario$content8.name ? scenario === null || scenario === void 0 || (_scenario$content9 = scenario.content) === null || _scenario$content9 === void 0 ? void 0 : _scenario$content9.name : [/*scenario?.content?.capabilityName,*/(_getCapabilityScenari2 = getCapabilityScenario()) === null || _getCapabilityScenari2 === void 0 || (_getCapabilityScenari2 = _getCapabilityScenari2.content) === null || _getCapabilityScenari2 === void 0 ? void 0 : _getCapabilityScenari2.name].join(' ');
  var displayId = scenario.id ? scenario.id : "".concat(scenario === null || scenario === void 0 || (_scenario$content10 = scenario.content) === null || _scenario$content10 === void 0 ? void 0 : _scenario$content10.capabilityId, ":").concat(scenario === null || scenario === void 0 || (_scenario$content11 = scenario.content) === null || _scenario$content11 === void 0 ? void 0 : _scenario$content11.capabilityScenarioId);
  console.log('LLLLLL');
  console.log(displayCardImage);
  console.log(scenario);
  var createObject = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref7) {
      var _scenario$content12;
      var workflowName, depotName, messageId, body, kitId;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            workflowName = _ref7.workflowName, depotName = _ref7.depotName, messageId = _ref7.messageId, _ref7.messageIdExtension, body = _ref7.body;
            kitId = scenario === null || scenario === void 0 || (_scenario$content12 = scenario.content) === null || _scenario$content12 === void 0 ? void 0 : _scenario$content12.capabilityId;
            console.log('FFFF');
            console.log('body');
            console.log(body);
            _context5.next = 7;
            return API[!!messageId ? 'put' : 'post']("spoketree-exchange-message", "/features/".concat(selectedFeature.getId(), "/kits/").concat(kitId, "/").concat(workflowName ? "workflows/".concat(workflowName) : "depots/".concat(depotName), "/scenarios/").concat(scenario.id, "/requests").concat(!!messageId ? "/".concat(messageId) : ''), {
              //headers: !!messageIdExtension ? {
              //  Messageextension: messageIdExtension
              //} : undefined,
              body: body
            }).then( /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref9) {
                var ok;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      ok = _ref9.ok;
                      if (ok) {
                        _context3.next = 3;
                        break;
                      }
                      throw new Error('Failed to post');
                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x3) {
                return _ref10.apply(this, arguments);
              };
            }()).catch( /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      throw e;
                    case 1:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x4) {
                return _ref11.apply(this, arguments);
              };
            }());
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function createObject(_x2) {
      return _ref8.apply(this, arguments);
    };
  }();
  var uploadFiles = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_ref12) {
      var files, workflowName, depotName;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            files = _ref12.files, workflowName = _ref12.workflowName, depotName = _ref12.depotName;
            _context7.next = 3;
            return Promise.all(files === null || files === void 0 ? void 0 : files.map(function (file) {
              var reader = new FileReader();
              reader.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                var arrayBuffer, contentType, body;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      arrayBuffer = reader.result; // Reader result as ArrayBuffer
                      contentType = isJson(file.name) ? 'application/json' : getContentType(file.name);
                      body = isJson(file.name) ? arrayBuffer : new Blob([arrayBuffer], {
                        type: contentType
                      });
                      _context6.next = 5;
                      return createObject({
                        workflowName: workflowName,
                        depotName: depotName,
                        messageId: file.name,
                        body: body
                      });
                    case 5:
                      // trigger report reload by changing the value of reportTrigger
                      setReportTrigger(reportTrigger + 1);
                      // delay 5 seconds to allow spoketree exchange to process the message in a workflow
                      setTimeout(function () {
                        return setReportTrigger(reportTrigger + 2);
                      }, 5000);
                      setTimeout(function () {
                        return setReportTrigger(reportTrigger + 2);
                      }, 15000);
                    case 8:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              reader.readAsArrayBuffer(file);
            }));
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function uploadFiles(_x5) {
      return _ref13.apply(this, arguments);
    };
  }();
  var isJson = function isJson(Key) {
    return Key.endsWith('json');
  };
  function getContentType(key) {
    var ext = key.split('.').pop().toLowerCase();
    switch (ext) {
      case 'pdf':
        return 'application/pdf';
      case 'png':
        return 'image/png';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'gif':
        return 'image/gif';
      // Add other file extensions and their corresponding content types here
      default:
        return 'application/octet-stream';
    }
  }
  var sendMessage = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref15) {
      var _JSON$stringify;
      var messageContent, workflowName, depotName, messageIdExtension, template, request, body;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            messageContent = _ref15.messageContent, workflowName = _ref15.workflowName, depotName = _ref15.depotName, messageIdExtension = _ref15.messageIdExtension, template = _ref15.template;
            request = !!template ? (_JSON$stringify = JSON.stringify(template)) === null || _JSON$stringify === void 0 || (_JSON$stringify = _JSON$stringify.replaceAll("{requestText}", messageContent)) === null || _JSON$stringify === void 0 || (_JSON$stringify = _JSON$stringify.replaceAll("{partyId}", principalParty.getId())) === null || _JSON$stringify === void 0 || (_JSON$stringify = _JSON$stringify.replaceAll('"{partyName}"', !!principalParty.getName() ? "\"".concat(principalParty.getName(), "\"") : 'null')) === null || _JSON$stringify === void 0 ? void 0 : _JSON$stringify.replaceAll("{partyEmail}", principalParty.getEmail()) : messageContent;
            body = {
              data: {
                request_received: JSON.parse(request)
              }
            };
            _context8.next = 5;
            return createObject({
              workflowName: workflowName,
              depotName: depotName,
              body: body,
              messageIdExtension: messageIdExtension
            });
          case 5:
            // trigger report reload by changing the value of reportTrigger
            setReportTrigger(reportTrigger + 1);
            // delay 5 seconds to allow spoketree exchange to process the message in a workflow
            setTimeout(function () {
              return setReportTrigger(reportTrigger + 2);
            }, 5000);
            setTimeout(function () {
              return setReportTrigger(reportTrigger + 2);
            }, 15000);
          case 8:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function sendMessage(_x6) {
      return _ref16.apply(this, arguments);
    };
  }();
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    reportTrigger = _useState6[0],
    setReportTrigger = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    searchTerm = _useState8[0],
    setSearchTerm = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    uploadParams = _useState10[0],
    setUploadParams = _useState10[1];
  var buildMessagePath = function buildMessagePath(exchangeZonePath, exchangePhase, exchangeStage, kitId, workflowName, userId, scenarioName) {
    return [exchangeZonePath, exchangePhase, exchangeStage, kitId, workflowName, userId, scenarioName].join('/');
  };
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    copiedVisible = _useState12[0],
    setCopiedVisible = _useState12[1];
  var copyS3Uri = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(_ref17) {
      var _scenario$content13;
      var workflowName, depotName, iamUserApi, _yield$iamUserApi$ret, userId, Key;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            workflowName = _ref17.workflowName, depotName = _ref17.depotName;
            iamUserApi = makeAPI("spoketree-exchange-iam-user", "/features/".concat(selectedFeature.getId(), "/iam-user"));
            _context9.next = 4;
            return iamUserApi.retrieve();
          case 4:
            _yield$iamUserApi$ret = _context9.sent;
            userId = _yield$iamUserApi$ret.userId;
            Key = "s3://spoketreeexchanges3storagedev/".concat(buildMessagePath('gateway', 'produced', "".concat(workflowName ? 'request' : 'stash', "_received"), scenario === null || scenario === void 0 || (_scenario$content13 = scenario.content) === null || _scenario$content13 === void 0 ? void 0 : _scenario$content13.capabilityId, workflowName ? workflowName : depotName, userId, "".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "-").concat(scenario.id)));
            clipboardCopy(Key);
            setCopiedVisible(true);
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function copyS3Uri(_x7) {
      return _ref18.apply(this, arguments);
    };
  }();
  var handleCloseCopied = function handleCloseCopied(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setCopiedVisible(false);
  };
  return /*#__PURE__*/React.createElement(Root$i, {
    className: classes$l.root
  }, !!capabilities && !!selectedFeature && /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(SpoketreeCard$1, {
    mode: mode,
    editable: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable(),
    resourceType: "scenario",
    resourceObject: scenario,
    resourcePropertiesStrategy: 'content',
    putResource: putScenario,
    deleteResource: deleteScenario,
    resourceCollectionUrl: resourceCollectionUrl,
    resourceItemUrl: resourceItemUrl,
    cardImagePosition: mode === 'list' ? 'left' : mode === 'view' ? 'left' : 'top',
    cardImageDefault: cardImageDefault,
    cardImageAlbum: cardImageAlbum,
    cardImageQuery: cardImageQuery,
    displayCardImage: displayCardImage,
    displayName: displayName,
    displayId: displayId,
    ExtraCardcontent: function ExtraCardcontent(_ref19) {
      var _getCapabilityScenari3, _getCapabilityScenari4, _getCapabilityScenari5, _getCapabilityScenari6, _getCapabilityScenari7, _getCapabilityScenari8, _getCapabilityScenari9, _getCapabilityScenari10, _getCapabilityScenari11, _getCapabilityScenari12, _getCapabilityScenari13, _getCapabilityScenari14, _getCapabilityScenari15, _getCapabilityScenari16, _getCapabilityScenari17;
      _ref19.getProperty;
        _ref19.setProperty;
        _ref19.isEditing;
      return mode !== 'list' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, mode === 'gallery' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "row",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'name',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/paddingLeft: '0',
          paddingBottom: '16px',
          marginTop: '0px',
          marginBottom: '0px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        component: "p",
        style: {
          padding: '0 0 0px'
        }
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, {
          name: "enableCreateScenario",
          id: "enableCreateScenario",
          checked: enableCreateScenario,
          onChange: handleEnableCreateScenarioCheckboxChange,
          color: "secondary",
          classes: {
            root: classes$l.checkboxRoot
          }
        }),
        label: /*#__PURE__*/React.createElement(Typography, {
          fontSize: "0.875rem"
        }, "Show \"Create ".concat((_getCapabilityScenari3 = getCapabilityScenario()) === null || _getCapabilityScenari3 === void 0 || (_getCapabilityScenari3 = _getCapabilityScenari3.content) === null || _getCapabilityScenari3 === void 0 ? void 0 : _getCapabilityScenari3.name, "\" button on exchange"))
      })))), mode === 'view' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1,
        style: {
          marginTop: '8px'
        }
      }, /*#__PURE__*/React.createElement(Box$1, {
        className: classes$l.buttonContainer
      }, /*#__PURE__*/React.createElement("div", {
        key: "reload-page",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/React.createElement(SpoketreeButton, {
        onClick: function onClick() {
          return window.location.reload();
        },
        style: {
          minWidth: '44px'
        }
      }, /*#__PURE__*/React.createElement(RefreshIcon, null))), (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && ((_getCapabilityScenari4 = getCapabilityScenario()) === null || _getCapabilityScenari4 === void 0 || (_getCapabilityScenari4 = _getCapabilityScenari4.content) === null || _getCapabilityScenari4 === void 0 || (_getCapabilityScenari4 = _getCapabilityScenari4.workflows) === null || _getCapabilityScenari4 === void 0 ? void 0 : _getCapabilityScenari4.map(function (workflow, workflowIndex) {
        var _workflow$controls;
        return workflow === null || workflow === void 0 || (_workflow$controls = workflow.controls) === null || _workflow$controls === void 0 ? void 0 : _workflow$controls.filter(function (_ref20) {
          var type = _ref20.type;
          return type === 'copys3uri';
        }).map(function (_ref21, filterIndex) {
          _ref21.options;
          return /*#__PURE__*/React.createElement("div", {
            key: "workflow-".concat(workflowIndex, "-").concat(filterIndex),
            style: {
              float: 'left'
            }
          }, /*#__PURE__*/React.createElement(SpoketreeButton, {
            onClick: /*#__PURE__*/function () {
              var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
                return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      _context10.next = 2;
                      return copyS3Uri({
                        workflowName: workflow === null || workflow === void 0 ? void 0 : workflow.name
                      });
                    case 2:
                      return _context10.abrupt("return", _context10.sent);
                    case 3:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              return function (_x8) {
                return _ref22.apply(this, arguments);
              };
            }()
          }, /*#__PURE__*/React.createElement(ContentCopyIcon, {
            style: {
              width: '22px',
              height: '22px',
              paddingRight: '4px'
            }
          }), "Copy ", workflow === null || workflow === void 0 ? void 0 : workflow.name, " URI"));
        });
      })), (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && ((_getCapabilityScenari5 = getCapabilityScenario()) === null || _getCapabilityScenari5 === void 0 || (_getCapabilityScenari5 = _getCapabilityScenari5.content) === null || _getCapabilityScenari5 === void 0 || (_getCapabilityScenari5 = _getCapabilityScenari5.depots) === null || _getCapabilityScenari5 === void 0 ? void 0 : _getCapabilityScenari5.map(function (depot, depotIndex) {
        var _depot$controls;
        return depot === null || depot === void 0 || (_depot$controls = depot.controls) === null || _depot$controls === void 0 ? void 0 : _depot$controls.filter(function (_ref23) {
          var type = _ref23.type;
          return type === 'copys3uri';
        }).map(function (_ref24, filterIndex) {
          _ref24.options;
          return /*#__PURE__*/React.createElement("div", {
            key: "depot-".concat(depotIndex, "-").concat(filterIndex),
            style: {
              float: 'left'
            }
          }, /*#__PURE__*/React.createElement(SpoketreeButton, {
            onClick: /*#__PURE__*/function () {
              var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
                return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      _context11.next = 2;
                      return copyS3Uri({
                        depotName: depot === null || depot === void 0 ? void 0 : depot.name
                      });
                    case 2:
                      return _context11.abrupt("return", _context11.sent);
                    case 3:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11);
              }));
              return function (_x9) {
                return _ref25.apply(this, arguments);
              };
            }()
          }, /*#__PURE__*/React.createElement(ContentCopyIcon, {
            style: {
              width: '22px',
              height: '22px',
              paddingRight: '4px'
            }
          }), "Copy ", depot === null || depot === void 0 ? void 0 : depot.name, " URI"));
        });
      })), /*#__PURE__*/React.createElement(Snackbar$1, {
        open: copiedVisible,
        autoHideDuration: 3000,
        onClose: handleCloseCopied
      }, /*#__PURE__*/React.createElement(Alert$4, {
        onClose: handleCloseCopied,
        severity: "success"
      }, "URI copied")), (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && (!!((_getCapabilityScenari6 = getCapabilityScenario()) !== null && _getCapabilityScenari6 !== void 0 && (_getCapabilityScenari6 = _getCapabilityScenari6.content) !== null && _getCapabilityScenari6 !== void 0 && (_getCapabilityScenari6 = _getCapabilityScenari6.depots) !== null && _getCapabilityScenari6 !== void 0 && (_getCapabilityScenari6 = _getCapabilityScenari6.filter(function (depot) {
        var _depot$controls2;
        return !!(depot !== null && depot !== void 0 && (_depot$controls2 = depot.controls) !== null && _depot$controls2 !== void 0 && (_depot$controls2 = _depot$controls2.filter(function (_ref26) {
          var type = _ref26.type;
          return type === 'upload';
        })) !== null && _depot$controls2 !== void 0 && _depot$controls2.length);
      })) !== null && _getCapabilityScenari6 !== void 0 && _getCapabilityScenari6.length) || !!((_getCapabilityScenari7 = getCapabilityScenario()) !== null && _getCapabilityScenari7 !== void 0 && (_getCapabilityScenari7 = _getCapabilityScenari7.content) !== null && _getCapabilityScenari7 !== void 0 && (_getCapabilityScenari7 = _getCapabilityScenari7.workflows) !== null && _getCapabilityScenari7 !== void 0 && (_getCapabilityScenari7 = _getCapabilityScenari7.filter(function (workflow) {
        var _workflow$controls2;
        return !!(workflow !== null && workflow !== void 0 && (_workflow$controls2 = workflow.controls) !== null && _workflow$controls2 !== void 0 && (_workflow$controls2 = _workflow$controls2.filter(function (_ref27) {
          var type = _ref27.type;
          return type === 'upload';
        })) !== null && _workflow$controls2 !== void 0 && _workflow$controls2.length);
      })) !== null && _getCapabilityScenari7 !== void 0 && _getCapabilityScenari7.length)) && /*#__PURE__*/React.createElement("div", {
        key: "upload",
        style: {
          float: 'left'
        }
      }, /*#__PURE__*/React.createElement(SpoketreeButtonWithDialog, {
        label: "Upload",
        dialogHash: "upload",
        dialog: {
          title: 'Upload',
          content: {
            text: 'Add the files you want to upload to Spoketree Exchange.',
            body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack$2, {
              direction: "column",
              spacing: 1,
              style: {
                marginTop: '8px'
              }
            }, (_getCapabilityScenari8 = getCapabilityScenario()) === null || _getCapabilityScenari8 === void 0 || (_getCapabilityScenari8 = _getCapabilityScenari8.content) === null || _getCapabilityScenari8 === void 0 || (_getCapabilityScenari8 = _getCapabilityScenari8.workflows) === null || _getCapabilityScenari8 === void 0 ? void 0 : _getCapabilityScenari8.map(function (workflow) {
              var _workflow$controls3;
              return workflow === null || workflow === void 0 || (_workflow$controls3 = workflow.controls) === null || _workflow$controls3 === void 0 ? void 0 : _workflow$controls3.filter(function (_ref28) {
                var type = _ref28.type;
                return type === 'upload';
              }).map(function (_ref29) {
                var options = _ref29.options;
                return /*#__PURE__*/React.createElement("div", {
                  style: {
                    marginTop: '8px',
                    marginBottom: '8px'
                  }
                }, /*#__PURE__*/React.createElement(FileUploader, {
                  onDrop: function onDrop(files) {
                    return setUploadParams({
                      files: files,
                      workflowName: workflow === null || workflow === void 0 ? void 0 : workflow.name
                    });
                  },
                  options: options
                }));
              });
            }), (_getCapabilityScenari9 = getCapabilityScenario()) === null || _getCapabilityScenari9 === void 0 || (_getCapabilityScenari9 = _getCapabilityScenari9.content) === null || _getCapabilityScenari9 === void 0 || (_getCapabilityScenari9 = _getCapabilityScenari9.depots) === null || _getCapabilityScenari9 === void 0 ? void 0 : _getCapabilityScenari9.map(function (depot) {
              var _depot$controls3;
              return depot === null || depot === void 0 || (_depot$controls3 = depot.controls) === null || _depot$controls3 === void 0 ? void 0 : _depot$controls3.filter(function (_ref30) {
                var type = _ref30.type;
                return type === 'upload';
              }).map(function (_ref31) {
                var options = _ref31.options;
                return /*#__PURE__*/React.createElement("div", {
                  style: {
                    marginTop: '8px',
                    marginBottom: '8px'
                  }
                }, /*#__PURE__*/React.createElement(FileUploader, {
                  onDrop: function onDrop(files) {
                    return setUploadParams({
                      files: files,
                      depotName: depot === null || depot === void 0 ? void 0 : depot.name
                    });
                  },
                  options: options
                }));
              });
            }), /*#__PURE__*/React.createElement(Stack$2, {
              direction: "column",
              spacing: 1,
              style: {
                marginTop: '8px'
              }
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6",
              style: {
                fontSize: '16px'
              }
            }, "Files"), /*#__PURE__*/React.createElement(SelectedFilesList, {
              selectedFiles: uploadParams === null || uploadParams === void 0 ? void 0 : uploadParams.files,
              size: "small"
            }))))
          },
          buttons: ["Cancel", {
            "Upload": function () {
              var _Upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e) {
                return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                  while (1) switch (_context12.prev = _context12.next) {
                    case 0:
                      _context12.next = 2;
                      return uploadFiles(uploadParams);
                    case 2:
                    case "end":
                      return _context12.stop();
                  }
                }, _callee12);
              }));
              function Upload(_x10) {
                return _Upload.apply(this, arguments);
              }
              return Upload;
            }()
          }]
        }
      }))), ((_getCapabilityScenari10 = getCapabilityScenario()) === null || _getCapabilityScenari10 === void 0 || (_getCapabilityScenari10 = _getCapabilityScenari10.content) === null || _getCapabilityScenari10 === void 0 || (_getCapabilityScenari10 = _getCapabilityScenari10.controls) === null || _getCapabilityScenari10 === void 0 ? void 0 : _getCapabilityScenari10.find(function (control) {
        var _control$options;
        return (control === null || control === void 0 ? void 0 : control.type) === 'find' && (control === null || control === void 0 || (_control$options = control.options) === null || _control$options === void 0 ? void 0 : _control$options.position) === 'top';
      })) && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '-8px'
        }
      }, /*#__PURE__*/React.createElement(SearchBar, {
        ml: 8,
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm
      }))), mode === 'view' && !!((_getCapabilityScenari11 = getCapabilityScenario()) !== null && _getCapabilityScenari11 !== void 0 && (_getCapabilityScenari11 = _getCapabilityScenari11.content) !== null && _getCapabilityScenari11 !== void 0 && (_getCapabilityScenari11 = _getCapabilityScenari11.depots) !== null && _getCapabilityScenari11 !== void 0 && _getCapabilityScenari11.length) && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, (_getCapabilityScenari12 = getCapabilityScenario()) === null || _getCapabilityScenari12 === void 0 || (_getCapabilityScenari12 = _getCapabilityScenari12.content) === null || _getCapabilityScenari12 === void 0 || (_getCapabilityScenari12 = _getCapabilityScenari12.depots) === null || _getCapabilityScenari12 === void 0 ? void 0 : _getCapabilityScenari12.map(function (depot) {
        var _depot$controls4;
        return depot === null || depot === void 0 || (_depot$controls4 = depot.controls) === null || _depot$controls4 === void 0 ? void 0 : _depot$controls4.filter(function (_ref32) {
          var options = _ref32.options;
          return (options === null || options === void 0 ? void 0 : options.position) === 'top';
        }).map(function (_ref33) {
          var type = _ref33.type;
            _ref33.options;
          return /*#__PURE__*/React.createElement(React.Fragment, null, type === 'post' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileSender, {
            onSendApply: /*#__PURE__*/function () {
              var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(messageContent) {
                var _depot$templates;
                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                      _context13.next = 2;
                      return sendMessage({
                        messageContent: messageContent,
                        depotName: depot === null || depot === void 0 ? void 0 : depot.name,
                        messageIdExtension: depot === null || depot === void 0 ? void 0 : depot.messageIdExtension,
                        template: depot === null || depot === void 0 || (_depot$templates = depot.templates) === null || _depot$templates === void 0 ? void 0 : _depot$templates['request_received']
                      });
                    case 2:
                      return _context13.abrupt("return", _context13.sent);
                    case 3:
                    case "end":
                      return _context13.stop();
                  }
                }, _callee13);
              }));
              return function (_x11) {
                return _ref34.apply(this, arguments);
              };
            }(),
            style: {
              marginTop: '8px'
            }
          })));
        });
      })), mode === 'view' && !!((_getCapabilityScenari13 = getCapabilityScenario()) !== null && _getCapabilityScenari13 !== void 0 && (_getCapabilityScenari13 = _getCapabilityScenari13.content) !== null && _getCapabilityScenari13 !== void 0 && (_getCapabilityScenari13 = _getCapabilityScenari13.workflows) !== null && _getCapabilityScenari13 !== void 0 && _getCapabilityScenari13.length) && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, (_getCapabilityScenari14 = getCapabilityScenario()) === null || _getCapabilityScenari14 === void 0 || (_getCapabilityScenari14 = _getCapabilityScenari14.content) === null || _getCapabilityScenari14 === void 0 || (_getCapabilityScenari14 = _getCapabilityScenari14.workflows) === null || _getCapabilityScenari14 === void 0 ? void 0 : _getCapabilityScenari14.map(function (workflow) {
        var _workflow$controls4;
        return workflow === null || workflow === void 0 || (_workflow$controls4 = workflow.controls) === null || _workflow$controls4 === void 0 ? void 0 : _workflow$controls4.filter(function (_ref35) {
          var options = _ref35.options;
          return (options === null || options === void 0 ? void 0 : options.position) === 'top';
        }).map(function (_ref36) {
          var type = _ref36.type;
            _ref36.options;
          return /*#__PURE__*/React.createElement(React.Fragment, null, type === 'post' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileSender, {
            onSendApply: /*#__PURE__*/function () {
              var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(messageContent) {
                var _workflow$templates;
                return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      _context14.next = 2;
                      return sendMessage({
                        messageContent: messageContent,
                        workflowName: workflow === null || workflow === void 0 ? void 0 : workflow.name,
                        messageIdExtension: workflow === null || workflow === void 0 ? void 0 : workflow.messageIdExtension,
                        template: workflow === null || workflow === void 0 || (_workflow$templates = workflow.templates) === null || _workflow$templates === void 0 ? void 0 : _workflow$templates['request_received']
                      });
                    case 2:
                      return _context14.abrupt("return", _context14.sent);
                    case 3:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              return function (_x12) {
                return _ref37.apply(this, arguments);
              };
            }(),
            style: {
              marginTop: '8px'
            }
          })));
        });
      })), mode === 'view' && !!((_getCapabilityScenari15 = getCapabilityScenario()) !== null && _getCapabilityScenari15 !== void 0 && (_getCapabilityScenari15 = _getCapabilityScenari15.content) !== null && _getCapabilityScenari15 !== void 0 && (_getCapabilityScenari15 = _getCapabilityScenari15.reports) !== null && _getCapabilityScenari15 !== void 0 && _getCapabilityScenari15.length) && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1,
        style: {
          marginTop: '8px'
        }
      }, (_getCapabilityScenari16 = getCapabilityScenario()) === null || _getCapabilityScenari16 === void 0 || (_getCapabilityScenari16 = _getCapabilityScenari16.content) === null || _getCapabilityScenari16 === void 0 || (_getCapabilityScenari16 = _getCapabilityScenari16.reports) === null || _getCapabilityScenari16 === void 0 ? void 0 : _getCapabilityScenari16.map(function (report) {
        var _capabilityReport$con, _capabilityReport$con2;
        console.log('REPORT');
        console.log('report', report);
        var capabilityReport = getCapabilityReport(report === null || report === void 0 ? void 0 : report.id);
        return !!capabilityReport && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$1, {
          item: true,
          key: 'workflowsHeading',
          style: {
            float: 'left',
            width: '100%',
            paddingLeft: '0',
            paddingBottom: '0px',
            marginBottom: '-4px'
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5",
          component: "h5",
          style: {
            fontSize: '16px',
            marginTop: '0px !important',
            marginBottom: '0px',
            color: 'rgba(0, 0, 0, 0.44)'
          }
        }, /*#__PURE__*/React.createElement("b", null, capabilityReport === null || capabilityReport === void 0 || (_capabilityReport$con = capabilityReport.content) === null || _capabilityReport$con === void 0 ? void 0 : _capabilityReport$con.name))), /*#__PURE__*/React.createElement(Grid$1, {
          item: true,
          key: 'name',
          style: {
            float: 'left',
            width: '100%',
            /*width:'calc(100% - 96px)',*/paddingLeft: '0',
            paddingBottom: '0px',
            marginTop: '0px',
            marginBottom: '0px'
          }
        }, /*#__PURE__*/React.createElement(ReportResultList, {
          feature: selectedFeature,
          report: {
            id: '_adhoc',
            content: _objectSpread2(_objectSpread2({}, capabilityReport === null || capabilityReport === void 0 ? void 0 : capabilityReport.content), {}, {
              query: {
                filters: capabilityReport === null || capabilityReport === void 0 || (_capabilityReport$con2 = capabilityReport.content) === null || _capabilityReport$con2 === void 0 || (_capabilityReport$con2 = _capabilityReport$con2.query) === null || _capabilityReport$con2 === void 0 || (_capabilityReport$con2 = _capabilityReport$con2.filters) === null || _capabilityReport$con2 === void 0 ? void 0 : _capabilityReport$con2.map(function (filter) {
                  var _scenario$content14;
                  return _objectSpread2(_objectSpread2({}, filter), {}, {
                    match: _objectSpread2(_objectSpread2({}, filter.match), {}, {
                      kitId: scenario === null || scenario === void 0 || (_scenario$content14 = scenario.content) === null || _scenario$content14 === void 0 ? void 0 : _scenario$content14.capabilityId,
                      scenarioName: "".concat(selectedFeature.getId(), "-").concat(scenario.id)
                    })
                  });
                })
              } /*,
                itemLayout: [
                 "{content.data.request}"
                ]*/
            })
          },

          searchTerm: searchTerm
          //size='small'
          ,
          reportTrigger: reportTrigger,
          setReportTrigger: setReportTrigger
        })));
      })), mode === 'view' && ((_getCapabilityScenari17 = getCapabilityScenario()) === null || _getCapabilityScenari17 === void 0 || (_getCapabilityScenari17 = _getCapabilityScenari17.content) === null || _getCapabilityScenari17 === void 0 || (_getCapabilityScenari17 = _getCapabilityScenari17.controls) === null || _getCapabilityScenari17 === void 0 ? void 0 : _getCapabilityScenari17.find(function (control) {
        var _control$options2;
        return (control === null || control === void 0 ? void 0 : control.type) === 'find' && (control === null || control === void 0 || (_control$options2 = control.options) === null || _control$options2 === void 0 ? void 0 : _control$options2.position) === 'bottom';
      })) && /*#__PURE__*/React.createElement(SearchBar, {
        ml: 8,
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm
      }));
    },
    ExtraCardActions: ['create', 'gallery'].includes(mode) ? function () {
      var _scenario$content15, _scenario$content16, _getCapabilityScenari18;
      return /*#__PURE__*/React.createElement(React.Fragment, null, mode === 'create' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "row",
        spacing: 1
      }, /*#__PURE__*/React.createElement(SpoketreeButton, {
        href: "".concat(urlPrefix, "/scenarios?filter=gallery")
      }, "Find Scenario")), mode === 'gallery' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "row",
        spacing: 1
      }, /*#__PURE__*/React.createElement(SpoketreeButton, {
        href: "/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/scenarios/create?cs=").concat(scenario === null || scenario === void 0 || (_scenario$content15 = scenario.content) === null || _scenario$content15 === void 0 ? void 0 : _scenario$content15.capabilityId, ":").concat(scenario === null || scenario === void 0 || (_scenario$content16 = scenario.content) === null || _scenario$content16 === void 0 ? void 0 : _scenario$content16.capabilityScenarioId)
      }, "Create ".concat((_getCapabilityScenari18 = getCapabilityScenario()) === null || _getCapabilityScenari18 === void 0 || (_getCapabilityScenari18 = _getCapabilityScenari18.content) === null || _getCapabilityScenari18 === void 0 ? void 0 : _getCapabilityScenari18.name))));
    } : undefined
  }), mode === 'view' && /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column",
    spacing: 1,
    style: {
      marginTop: '8px'
    }
  }, (_getCapabilityScenari19 = getCapabilityScenario()) === null || _getCapabilityScenari19 === void 0 || (_getCapabilityScenari19 = _getCapabilityScenari19.content) === null || _getCapabilityScenari19 === void 0 || (_getCapabilityScenari19 = _getCapabilityScenari19.depots) === null || _getCapabilityScenari19 === void 0 ? void 0 : _getCapabilityScenari19.map(function (depot) {
    var _depot$controls5;
    return depot === null || depot === void 0 || (_depot$controls5 = depot.controls) === null || _depot$controls5 === void 0 ? void 0 : _depot$controls5.filter(function (_ref38) {
      var options = _ref38.options;
      return (options === null || options === void 0 ? void 0 : options.position) === 'bottom';
    }).map(function (_ref39) {
      var type = _ref39.type;
        _ref39.options;
      return /*#__PURE__*/React.createElement(React.Fragment, null, type === 'post' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileSender, {
        onSendApply: /*#__PURE__*/function () {
          var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(messageContent) {
            var _depot$templates2;
            return _regeneratorRuntime().wrap(function _callee15$(_context15) {
              while (1) switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.next = 2;
                  return sendMessage({
                    messageContent: messageContent,
                    depotName: depot === null || depot === void 0 ? void 0 : depot.name,
                    messageIdExtension: depot === null || depot === void 0 ? void 0 : depot.messageIdExtension,
                    template: depot === null || depot === void 0 || (_depot$templates2 = depot.templates) === null || _depot$templates2 === void 0 ? void 0 : _depot$templates2['request_received']
                  });
                case 2:
                  return _context15.abrupt("return", _context15.sent);
                case 3:
                case "end":
                  return _context15.stop();
              }
            }, _callee15);
          }));
          return function (_x13) {
            return _ref40.apply(this, arguments);
          };
        }()
      })));
    });
  })), mode === 'view' && /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column",
    spacing: 1,
    style: {
      marginTop: '8px'
    }
  }, (_getCapabilityScenari20 = getCapabilityScenario()) === null || _getCapabilityScenari20 === void 0 || (_getCapabilityScenari20 = _getCapabilityScenari20.content) === null || _getCapabilityScenari20 === void 0 || (_getCapabilityScenari20 = _getCapabilityScenari20.workflows) === null || _getCapabilityScenari20 === void 0 ? void 0 : _getCapabilityScenari20.map(function (workflow) {
    var _workflow$controls5;
    return workflow === null || workflow === void 0 || (_workflow$controls5 = workflow.controls) === null || _workflow$controls5 === void 0 ? void 0 : _workflow$controls5.filter(function (_ref41) {
      var options = _ref41.options;
      return (options === null || options === void 0 ? void 0 : options.position) === 'bottom';
    }).map(function (_ref42) {
      var type = _ref42.type;
        _ref42.options;
      return /*#__PURE__*/React.createElement(React.Fragment, null, type === 'post' && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'fixed',
          bottom: 0,
          width: '100%',
          margin: '0 0 0 -8px',
          padding: '8px',
          backgroundColor: 'rgb(250, 250, 250)'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          //marginBottom: '64px',
          //margin: '0 0px 8px 8px',
          //width: '440px',//'calc(100% - 64px)',
          width: '100%' //'calc(100% - 16px)'
        }
      }, /*#__PURE__*/React.createElement(FileSender, {
        onSendApply: /*#__PURE__*/function () {
          var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(messageContent) {
            var _workflow$templates2;
            return _regeneratorRuntime().wrap(function _callee16$(_context16) {
              while (1) switch (_context16.prev = _context16.next) {
                case 0:
                  _context16.next = 2;
                  return sendMessage({
                    messageContent: messageContent,
                    workflowName: workflow === null || workflow === void 0 ? void 0 : workflow.name,
                    messageIdExtension: workflow === null || workflow === void 0 ? void 0 : workflow.messageIdExtension,
                    template: workflow === null || workflow === void 0 || (_workflow$templates2 = workflow.templates) === null || _workflow$templates2 === void 0 ? void 0 : _workflow$templates2['request_received']
                  });
                case 2:
                  return _context16.abrupt("return", _context16.sent);
                case 3:
                case "end":
                  return _context16.stop();
              }
            }, _callee16);
          }));
          return function (_x14) {
            return _ref43.apply(this, arguments);
          };
        }()
      }))));
    });
  }))));
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var useScenarios = function useScenarios(_) {
  var _useContext = useContext(Context$d),
    scenarios = _useContext.scenarios,
    putScenario = _useContext.putScenario,
    deleteScenario = _useContext.deleteScenario;
  return [scenarios, putScenario, deleteScenario];
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */

/*
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));
*/

var ScenarioFilters = (function (_ref) {
  var _scenario$content, _scenario$content2;
  var selected = _ref.selected,
    setSelected = _ref.setSelected,
    scenario = _ref.scenario;
  //const classes = useStyles();

  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useContext2 = useContext(Context$d),
    scenarios = _useContext2.scenarios;
  var handleClick = function handleClick(key) {
    console.info(key);
    setSelected(key);
  };
  return /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, [!!scenarios.length ? {
    key: 'mine',
    label: 'My Scenarios'
  } : undefined].concat([selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isEditable() ? {
    key: 'gallery',
    label: 'Scenario Gallery'
  } : undefined], [/*!['mine', 'gallery'].includes(selected) &&*/scenario ? {
    key: scenario === null || scenario === void 0 ? void 0 : scenario.id,
    label: scenario !== null && scenario !== void 0 && (_scenario$content = scenario.content) !== null && _scenario$content !== void 0 && _scenario$content.name ? scenario === null || scenario === void 0 || (_scenario$content2 = scenario.content) === null || _scenario$content2 === void 0 ? void 0 : _scenario$content2.name : scenario === null || scenario === void 0 ? void 0 : scenario.id
  } : undefined]).filter(function (item) {
    return !!item;
  }).map(function (_ref2) {
    var key = _ref2.key,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(Chip, {
      key: key,
      label: label,
      onClick: function onClick(_) {
        return handleClick(key);
      },
      variant: selected === key ? undefined : 'outlined',
      color: selected === key ? 'secondary' : undefined
    });
  }));
});

var PREFIX$k = 'Collection';
var classes$k = {
  root: "".concat(PREFIX$k, "-root"),
  columnsWrapper: "".concat(PREFIX$k, "-columnsWrapper"),
  fab: "".concat(PREFIX$k, "-fab"),
  todoWrapper: "".concat(PREFIX$k, "-todoWrapper"),
  icon: "".concat(PREFIX$k, "-icon")
};
var Root$h = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$k.root), {
    width: '100%',
    maxWidth: '472px'
    //height: '100%',
    //display: 'flex',
    //flexWrap: 'wrap',
    //justifyContent: 'space-around',
    //overflow: 'hidden',
    //backgroundColor: theme.palette.background.paper,
  }), _defineProperty(_ref2, "& .".concat(classes$k.columnsWrapper), {
    //margin: "0 auto",
    //columnWidth: theme.spacing(29),
    columnGap: "16px" //"0.5rem"
  }), _defineProperty(_ref2, "& .".concat(classes$k.fab), {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }), _defineProperty(_ref2, "& .".concat(classes$k.todoWrapper), {
    //: theme.spacing(29),
    //margin: "0 auto",
    breakInside: "avoid",
    pageBreakInside: "avoid",
    //padding: "0.5rem 0",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.standard
    })
    //paddingBottom:'4px'
  }), _defineProperty(_ref2, "& .".concat(classes$k.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var Collection$2 = function Collection(_ref3) {
  var _scenarios$sort, _$flatten;
  _objectDestructuringEmpty(_ref3);
  var navigate = useNavigate();
  var _useContext = useContext(CapabilitiesStore.Context);
    _useContext.findCapability;
    var mapCapabilities = _useContext.mapCapabilities;
  var _useContext2 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext2.selectedFeature;
  var _useScenarios = useScenarios(),
    _useScenarios2 = _slicedToArray(_useScenarios, 3),
    scenarios = _useScenarios2[0];
    _useScenarios2[1];
    _useScenarios2[2];
  var _useContext3 = useContext(ScenariosStore.Context),
    isScenariosReady = _useContext3.isScenariosReady;
  host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var _setSelectedFilter = _useState2[1];
  var getSelectedFilter = function getSelectedFilter() {
    return querystring$2('filter') ? querystring$2('filter') : !!(scenarios !== null && scenarios !== void 0 && scenarios.length) ? 'mine' : 'gallery';
  };
  var setSelectedFilter = function setSelectedFilter(filter) {
    _setSelectedFilter(filter);
    var pathname = "/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/scenarios");
    navigate({
      pathname: pathname,
      search: "?filter=".concat(filter)
    });
  };
  return !!isScenariosReady && /*#__PURE__*/React.createElement(Root$h, {
    className: classes$k.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'filters',
    style: {
      float: 'left',
      marginTop: '8px',
      width: 'calc(100% - 100px)'
    }
  }, /*#__PURE__*/React.createElement(ScenarioFilters, {
    selected: getSelectedFilter(),
    setSelected: setSelectedFilter
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'mine',
    style: {
      maxWidth: '472px',
      width: '100%',
      marginTop: '8px',
      marginBottom: '4px'
    }
  }, getSelectedFilter() === 'mine' && !!(scenarios !== null && scenarios !== void 0 && scenarios.length) && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, scenarios
  //?.sort((a, b) => getCapabilityScenario(a?.content?.capabilityScenarioId)?.content?.name.localeCompare(getCapabilityScenario(a?.content?.capabilityScenarioId)?.content?.name))
  === null || scenarios
  //?.sort((a, b) => getCapabilityScenario(a?.content?.capabilityScenarioId)?.content?.name.localeCompare(getCapabilityScenario(a?.content?.capabilityScenarioId)?.content?.name))
  === void 0 || (_scenarios$sort = scenarios
  //?.sort((a, b) => getCapabilityScenario(a?.content?.capabilityScenarioId)?.content?.name.localeCompare(getCapabilityScenario(a?.content?.capabilityScenarioId)?.content?.name))
  .sort(function (a, b) {
    var _a$content, _b$content;
    return a === null || a === void 0 || (_a$content = a.content) === null || _a$content === void 0 ? void 0 : _a$content.name.localeCompare(b === null || b === void 0 || (_b$content = b.content) === null || _b$content === void 0 ? void 0 : _b$content.name);
  })) === null || _scenarios$sort === void 0 ? void 0 : _scenarios$sort.map(function (scenario) {
    return /*#__PURE__*/React.createElement(ScenarioCard, {
      scenario: scenario
      //setScenario={putScenario}
      //deleteScenario={deleteScenario}
      ,
      actions: "list-actions",
      mode: "list"
    });
  })), getSelectedFilter() === 'gallery' && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, (_$flatten = lodash.flatten(
  //mapCapabilities((c) => c?.getScenarios()?.map(s => ({...s, capabilityId: c.id })))
  mapCapabilities(function (c) {
    return c;
  }).filter(function (c) {
    return !!c.getPublished();
  }).map(function (c) {
    var _c$getScenarios, _c$getScenarios2;
    return (c !== null && c !== void 0 && (_c$getScenarios = c.getScenarios()) !== null && _c$getScenarios !== void 0 && _c$getScenarios._items ? Object.values(c === null || c === void 0 || (_c$getScenarios2 = c.getScenarios()) === null || _c$getScenarios2 === void 0 ? void 0 : _c$getScenarios2._items) : []).map(function (i) {
      return i[0];
    }).map(function (i) {
      var _i$Version_Content;
      return {
        content: {
          //...i.Version_Content,
          capabilityId: c === null || c === void 0 ? void 0 : c.id,
          capabilityName: c === null || c === void 0 ? void 0 : c.getName(),
          capabilityScenarioId: i.E_SK.split(':').pop(),
          name: [c === null || c === void 0 ? void 0 : c.getName(), i === null || i === void 0 || (_i$Version_Content = i.Version_Content) === null || _i$Version_Content === void 0 ? void 0 : _i$Version_Content.name].join(' ')
        }
      };
    });
  }))) === null || _$flatten === void 0 || (_$flatten = _$flatten.sort(function (a, b) {
    var _a$content2, _b$content2;
    return a === null || a === void 0 || (_a$content2 = a.content) === null || _a$content2 === void 0 ? void 0 : _a$content2.name.localeCompare(b === null || b === void 0 || (_b$content2 = b.content) === null || _b$content2 === void 0 ? void 0 : _b$content2.name);
  })) === null || _$flatten === void 0 ? void 0 : _$flatten.map(function (scenario) {
    return /*#__PURE__*/React.createElement(ScenarioCard, {
      scenario: {
        content: _objectSpread2(_objectSpread2({}, scenario === null || scenario === void 0 ? void 0 : scenario.content), {}, {
          enabled: true
        })
      }
      //setScenario={setValue}
      ,
      mode: 'gallery'
      //highlighted={plugin.alias === scenario?.alias}
    });
  })))));
};
function querystring$2(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var PREFIX$j = 'CreateScenarioCard';
var classes$j = {
  root: "".concat(PREFIX$j, "-root"),
  paper: "".concat(PREFIX$j, "-paper"),
  avatar: "".concat(PREFIX$j, "-avatar"),
  card: "".concat(PREFIX$j, "-card"),
  fab: "".concat(PREFIX$j, "-fab"),
  lastCard: "".concat(PREFIX$j, "-lastCard"),
  input: "".concat(PREFIX$j, "-input"),
  opaqueInput: "".concat(PREFIX$j, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$j, "-inputRoot"),
  inputNotchedOutline: "".concat(PREFIX$j, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$j, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$j, "-inputLabelRoot"),
  link: "".concat(PREFIX$j, "-link")
};
var Root$g = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$j.root), {
    width: '100%',
    maxWidth: 472,
    flexGrow: 1,
    overflow: 'hidden',
    margin: 0,
    padding: 0 //'8px'//theme.spacing(0, 3),
  }), _defineProperty(_ref2, "& .".concat(classes$j.paper), {
    //maxWidth: 400,
    //margin: '8px',//`${theme.spacing(1)} auto`,
    padding: '16px' //theme.spacing(2),
  }), _defineProperty(_ref2, "& .".concat(classes$j.avatar), {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: '3px'
  }), _defineProperty(_ref2, "& .".concat(classes$j.card), {
    marginBottom: '16px',
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$j.fab), {
    position: 'fixed',
    bottom: '64px',
    //theme.spacing(2),
    right: '16px',
    //theme.spacing(2),
    zIndex: 9999
  }), _defineProperty(_ref2, "& .".concat(classes$j.lastCard), {
    marginBottom: 0
  }), _defineProperty(_ref2, "& .".concat(classes$j.input), {}), _defineProperty(_ref2, "& .".concat(classes$j.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    marginTop: '8px'
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$j.inputRoot), {
    '&$inputFocused $inputNotchedOutline': {
      borderColor: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$j.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$j.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$j.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$j.link), {
    color: theme.palette.secondary.main
  }), _ref2;
});
var CreateScenarioCard = (function (_ref3 /*googleMapDivRef*/) {
  var _getCapabilityScenari2, _getCapabilityScenari3, _getCapabilityScenari4, _getCapabilityScenari5, _getCapabilityScenari6;
  _objectDestructuringEmpty(_ref3);
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var _useContext2 = useContext(Context$c),
    findCapability = _useContext2.findCapability;
  var _useContext3 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext3.selectedFeature;
  var _useContext4 = useContext(Context$d),
    putScenario = _useContext4.putScenario;
  var _useContext5 = useContext(Context$8),
    scenarioName = _useContext5.scenarioName,
    setScenarioName = _useContext5.setScenarioName,
    isScenarioValid = _useContext5.isScenarioValid,
    reset = _useContext5.reset;
  var handleClickCreateScenario = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var scenario;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isAuthenticated) {
              _context.next = 3;
              break;
            }
            _context.next = 15;
            break;
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return putScenario({
              content: {
                name: scenarioName,
                capabilityId: capabilityId,
                capabilityScenarioId: capabilityScenarioId
              }
            });
          case 6:
            scenario = _context.sent;
            reset();
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            alert('Failed to create scenario');
            console.error(_context.t0);
          case 14:
            if (selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.getId() && scenario.id) {
              window.location.href = "".concat(host().marketUrl, "/plugin/exchange/features/").concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/scenarios/").concat(scenario.id);
            }
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function handleClickCreateScenario(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  useRef(null);
  var cs = useQueryParam('cs');
  //const redirect = useQueryParam('redirect');

  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    capabilityId = _useState2[0],
    setCapabilityId = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    capabilityScenarioId = _useState4[0],
    setCapabilityScenarioId = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    redirectUrl = _useState6[0],
    setRedirectUrl = _useState6[1];
  useEffect(function (_) {
    (function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_) {
        var _cs$split, _cs$split2, _capabilityId, _capabilityScenarioId, _redirectUrl;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!!selectedFeature) {
                if (!cs) ; else {
                  _cs$split = cs.split(':'), _cs$split2 = _slicedToArray(_cs$split, 3), _capabilityId = _cs$split2[0], _capabilityScenarioId = _cs$split2[1], _redirectUrl = _cs$split2[2];
                  setCapabilityId(_capabilityId);
                  setCapabilityScenarioId(_capabilityScenarioId);
                  setRedirectUrl(_redirectUrl);
                }
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    })()();
  }, [cs, selectedFeature]);
  var getCapabilityScenario = function getCapabilityScenario( /*capabilityId, capabilityScenarioId*/
  ) {
    var _capability$getScenar, _capability$getScenar2;
    console.log('getCapabilityScenario');
    console.log(capabilityId, capabilityScenarioId);
    var capability = findCapability(capabilityId);
    var capabilityScenarios = (capability !== null && capability !== void 0 && (_capability$getScenar = capability.getScenarios()) !== null && _capability$getScenar !== void 0 && _capability$getScenar._items ? Object.values(capability === null || capability === void 0 || (_capability$getScenar2 = capability.getScenarios()) === null || _capability$getScenar2 === void 0 ? void 0 : _capability$getScenar2._items) : []).map(function (i) {
      return i[0];
    }).map(function (i) {
      return {
        id: i.E_SK.split(':').pop(),
        content: i.Version_Content
      };
    });
    var capabilityScenario = capabilityScenarios === null || capabilityScenarios === void 0 ? void 0 : capabilityScenarios.find(function (scenario) {
      return scenario.id === capabilityScenarioId;
    });
    console.log('capabilityScenario');
    console.log(capabilityScenario);
    return capabilityScenario;
  };
  useEffect(function (_) {
    (function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_) {
        var _getCapabilityScenari;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", setScenarioName("My ".concat((_getCapabilityScenari = getCapabilityScenario()) === null || _getCapabilityScenari === void 0 || (_getCapabilityScenari = _getCapabilityScenari.content) === null || _getCapabilityScenari === void 0 ? void 0 : _getCapabilityScenari.name)));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    })()();
  }, [(_getCapabilityScenari2 = getCapabilityScenario()) === null || _getCapabilityScenari2 === void 0 || (_getCapabilityScenari2 = _getCapabilityScenari2.content) === null || _getCapabilityScenari2 === void 0 ? void 0 : _getCapabilityScenari2.name]);
  return /*#__PURE__*/React.createElement(Root$g, {
    className: classes$j.root
  }, !!capabilityId && !!capabilityScenarioId && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes$j.root,
    elevation: 0,
    variant: "outlined" /*style={{...(highlighted ? { borderWidth: 'thick', borderColor: 'limegreen' }: {})}}*/
  }, /*#__PURE__*/React.createElement(CardContent, {
    style: {
      /*backgroundColor:'#f8f8f8',*/width: '100%',
      marginBottom: '0px'
    },
    classes: {
      root: /*isEditing() ? classes.topCardContentRoot_edit : */classes$j.topCardContentRoot
    }
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'name',
    style: {
      float: 'left',
      width: '100%',
      /*width:'calc(100% - 96px)',*/paddingLeft: '0',
      paddingTop: '0'
    }
  }, /*#__PURE__*/React.createElement(EditableText, {
    label: "",
    value: "Create a ".concat((_getCapabilityScenari3 = getCapabilityScenario()) === null || _getCapabilityScenari3 === void 0 || (_getCapabilityScenari3 = _getCapabilityScenari3.content) === null || _getCapabilityScenari3 === void 0 ? void 0 : _getCapabilityScenari3.name),
    variant: "h6",
    component: "p"
  })), /*#__PURE__*/React.createElement(WorkflowStepCard
  //stepNumber={1}
  , {
    stepTitle: "".concat((_getCapabilityScenari4 = getCapabilityScenario()) === null || _getCapabilityScenari4 === void 0 || (_getCapabilityScenari4 = _getCapabilityScenari4.content) === null || _getCapabilityScenari4 === void 0 ? void 0 : _getCapabilityScenari4.name, " Details"),
    stepComponents: [/*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '8px'
      }
    }, /*#__PURE__*/React.createElement(EditableTextField, {
      Icon: TextFieldsIcon,
      label: 'Name',
      placeholder: "".concat((_getCapabilityScenari5 = getCapabilityScenario()) === null || _getCapabilityScenari5 === void 0 || (_getCapabilityScenari5 = _getCapabilityScenari5.content) === null || _getCapabilityScenari5 === void 0 ? void 0 : _getCapabilityScenari5.name, " Name"),
      value: scenarioName,
      setValue: setScenarioName,
      autoFocus: true,
      autoComplete: "off"
    }))]
  }))), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: redirectUrl ? redirectUrl : "".concat(host().marketUrl, "/plugin/exchange/features/").concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/scenarios")
  }, "Cancel"), isScenarioValid() && /*#__PURE__*/React.createElement(SpoketreeButton, {
    onClick: handleClickCreateScenario
  }, "Create ", (_getCapabilityScenari6 = getCapabilityScenario()) === null || _getCapabilityScenari6 === void 0 || (_getCapabilityScenari6 = _getCapabilityScenari6.content) === null || _getCapabilityScenari6 === void 0 ? void 0 : _getCapabilityScenari6.name))))));
});

var PREFIX$i = 'Create';
var classes$i = {
  root: "".concat(PREFIX$i, "-root"),
  icon: "".concat(PREFIX$i, "-icon")
};
var Root$f = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$i.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$i.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesScenariosCreate = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var theme = useTheme$1();
  useNavigate();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedFeatureStore.Context);
    _useContext.selectedFeature;
  return (
    /*#__PURE__*/
    /*selectedFeature &&*/
    React.createElement(Root$f, {
      className: classes$i.root
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: 'createFeature',
      style: {
        maxWidth: '472px',
        width: '100%',
        marginTop: '8px',
        marginBottom: '4px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: 'createFeature',
      className: classes$i.todoWrapper
      //style={{ width: isMobile || isListView ? "100%" : null }}
      ,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(CreateScenarioCard, null)))))
  );
});

var useScenario = function useScenario(scenarioId) {
  var _useState = useState(scenarioId),
    _useState2 = _slicedToArray(_useState, 2),
    _scenarioId = _useState2[0],
    setScenarioId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    scenario = _useState4[0],
    setScenario = _useState4[1];
  var _useContext = useContext(Context$d),
    scenarios = _useContext.scenarios,
    findScenario = _useContext.findScenario;
  useEffect(function () {
    console.log('kkk');
    console.log(_scenarioId);
    console.log(scenarios);
    console.log(findScenario);
    console.log(setScenario);
    if (_scenarioId && scenarios !== null && scenarios !== void 0 && scenarios.length && findScenario) {
      var _scenario = findScenario(_scenarioId);
      if (_scenario) {
        setScenario(_scenario);
      }
    }
  }, [_scenarioId, scenarios, findScenario, setScenario]);
  return [scenario, setScenarioId];
};

var Context$3 = /*#__PURE__*/createContext([]);
var Provider$3 = function Provider(_ref) {
  var children = _ref.children,
    scenarioId = _ref.scenarioId;
  var _useScenario = useScenario(scenarioId),
    _useScenario2 = _slicedToArray(_useScenario, 2),
    selectedScenario = _useScenario2[0];
    _useScenario2[1];
  var value = {
    selectedScenario: selectedScenario
  };
  return /*#__PURE__*/React.createElement(Context$3.Provider, {
    value: value
  }, children);
};
var Consumer$3 = Context$3.Consumer;
var SelectedScenarioStore = {
  Context: Context$3,
  Provider: Provider$3,
  Consumer: Consumer$3
};

var PREFIX$h = 'Item';
var classes$h = {
  root: "".concat(PREFIX$h, "-root"),
  icon: "".concat(PREFIX$h, "-icon")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$e = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$h.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$h.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesScenariosItem = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var theme = useTheme$1();
  var navigate = useNavigate();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useContext2 = useContext(SelectedScenarioStore.Context),
    selectedScenario = _useContext2.selectedScenario;
  var urlPrefix = host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFilter = _useState2[0],
    _setSelectedFilter = _useState2[1];
  var setSelectedFilter = function setSelectedFilter(filter) {
    _setSelectedFilter(filter);
    var pathname = null;
    if (filter === (selectedScenario === null || selectedScenario === void 0 ? void 0 : selectedScenario.id)) {
      pathname = "".concat(urlPrefix, "/scenarios/").concat(selectedScenario === null || selectedScenario === void 0 ? void 0 : selectedScenario.id);
    } else {
      pathname = "".concat(urlPrefix, "/scenarios");
    }
    navigate({
      pathname: pathname,
      search: "?filter=".concat(filter)
    });
  };
  useEffect(function (_) {
    (function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", querystring$1('filter') ? querystring$1('filter') : _setSelectedFilter(selectedScenario === null || selectedScenario === void 0 ? void 0 : selectedScenario.id));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    })()();
  }, [selectedScenario === null || selectedScenario === void 0 ? void 0 : selectedScenario.id]);
  var mode = useQueryParam('mode', 'view');
  return (selectedScenario === null || selectedScenario === void 0 ? void 0 : selectedScenario.id) && /*#__PURE__*/React.createElement(Root$e, null, selectedFeature && selectedScenario && /*#__PURE__*/React.createElement("div", {
    className: classes$h.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'list',
    style: {
      float: 'left',
      marginTop: '8px',
      width: 'calc(100% - 100px)'
    }
  }, /*#__PURE__*/React.createElement(ScenarioFilters, {
    selected: selectedFilter,
    setSelected: setSelectedFilter,
    scenario: selectedScenario
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'kit',
    style: {
      width: '100%',
      minWidth: '232px',
      maxWidth: '472px',
      marginTop: '8px',
      marginBottom: '40px'
    }
  }, /*#__PURE__*/React.createElement(ScenarioCard, {
    scenario: selectedScenario,
    mode: mode
  })))));
});
function querystring$1(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var CompositeSelectedScenarioProvider = (function (_ref) {
  var featureId = _ref.featureId,
    scenarioId = _ref.scenarioId,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, featureId && scenarioId && /*#__PURE__*/React.createElement(Provider$f, {
    featureId: featureId
  }, /*#__PURE__*/React.createElement(Provider$8, null, /*#__PURE__*/React.createElement(Provider$d, null, /*#__PURE__*/React.createElement(Provider$3, {
    scenarioId: scenarioId
  }, children)))));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var FeaturesScenariosItemProvider = (function (_ref) {
  var children = _ref.children,
    itemId = _ref.itemId,
    subitemId = _ref.subitemId;
  console.log('IIII');
  console.log(itemId, subitemId);
  return /*#__PURE__*/React.createElement(CompositeSelectedScenarioProvider, {
    featureId: itemId,
    scenarioId: subitemId
  }, children);
});

var PREFIX$g = 'SolutionDetails';
var classes$g = {
  mediaRoot: "".concat(PREFIX$g, "-mediaRoot"),
  editorRoot: "".concat(PREFIX$g, "-editorRoot"),
  editorPaper: "".concat(PREFIX$g, "-editorPaper"),
  editorForm: "".concat(PREFIX$g, "-editorForm"),
  editorButton: "".concat(PREFIX$g, "-editorButton"),
  link: "".concat(PREFIX$g, "-link")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
styled('div')(function (_ref) {
  var _ref2;
  _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$g.mediaRoot), {
    //height: '110px',
  }), _defineProperty(_ref2, "& .".concat(classes$g.editorRoot), {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref2, "& .".concat(classes$g.editorPaper), {
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), _defineProperty(_ref2, "& .".concat(classes$g.editorForm), {
    padding: 8,
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$g.editorButton), {
    padding: 8
  }), _defineProperty(_ref2, "& .".concat(classes$g.link), {
    color: 'rgba(0, 0, 0, 0.87)',
    //theme.palette.secondary.main
    textDecoration: 'underline',
    fontSize: '1.125rem',
    fontFamily: 'Roboto,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    fontWeight: '500',
    lineHeight: '1.6'
  }), _ref2;
});
({
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
});

var PREFIX$f = 'SolutionCard';
var classes$f = {
  root: "".concat(PREFIX$f, "-root"),
  checked: "".concat(PREFIX$f, "-checked"),
  root2: "".concat(PREFIX$f, "-root2"),
  media: "".concat(PREFIX$f, "-media"),
  counterButtonWrapper: "".concat(PREFIX$f, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$f, "-checkboxRoot"),
  checkboxRootColorfulPickup: "".concat(PREFIX$f, "-checkboxRootColorfulPickup"),
  checkboxRootDelivery: "".concat(PREFIX$f, "-checkboxRootDelivery"),
  checkboxRootColorfulDelivery: "".concat(PREFIX$f, "-checkboxRootColorfulDelivery"),
  formControl: "".concat(PREFIX$f, "-formControl"),
  packingHoursEdit: "".concat(PREFIX$f, "-packingHoursEdit"),
  timeEdit: "".concat(PREFIX$f, "-timeEdit"),
  timeView: "".concat(PREFIX$f, "-timeView"),
  dayOfWeekEdit: "".concat(PREFIX$f, "-dayOfWeekEdit"),
  shopTypeEdit: "".concat(PREFIX$f, "-shopTypeEdit"),
  expand: "".concat(PREFIX$f, "-expand"),
  expandOpen: "".concat(PREFIX$f, "-expandOpen"),
  topCardContentRoot: "".concat(PREFIX$f, "-topCardContentRoot"),
  topCardContentRoot_edit: "".concat(PREFIX$f, "-topCardContentRoot_edit"),
  topCardContentContainerRoot: "".concat(PREFIX$f, "-topCardContentContainerRoot"),
  paper: "".concat(PREFIX$f, "-paper")
};
styled(CardActions)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px'
});
var StyledButton = styled(Button)({
  borderRadius: '2px',
  backgroundColor: '#f1f1f1',
  color: '#202124',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#e1e1e1'
  }
});
styled(StyledButton)({
  backgroundColor: '#fbbc05',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#f9a825'
  }
});
styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#2196f3',
    '&:hover': {
      backgroundColor: 'rgba(76, 175, 80, 0.08)'
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#2196f3'
  }
});

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$d = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$f.root2), {
    maxWidth: '454px' //472px
    //padding: '8px',
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$f.media), {
    height: '110px'
  }), _defineProperty(_ref2, "& .".concat(classes$f.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$f.checkboxRoot), {
    verticalAlign: 'top',
    //margin: `auto ${theme.spacing(1.5)}px`,
    //marginTop: theme.spacing(0),
    //marginTop: '3px',
    //marginLeft: '4px !important',
    marginTop: '-2px',
    //marginLeft:'8px',
    marginLeft: '10px',
    marginRight: '3px',
    padding: "0 !important",
    //paddingTop: '9px !important',
    //paddingBottom: '9px !important',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$f.checkboxRootColorfulPickup), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$f.checkboxRootDelivery), {
    marginRight: '-7px',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$f.checkboxRootColorfulDelivery), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$f.formControl), {
    backgroundColor: 'lightBlue'
  }), _defineProperty(_ref2, "& .".concat(classes$f.packingHoursEdit), {
    width: '64px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$f.timeEdit), {
    width: '92px',
    height: '24px',
    marginTop: '-1px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$f.timeView), {
    width: '92px',
    height: '24px',
    marginTop: '2px'
    //color: 'rgba(0, 0, 0, 0.54) !important'
  }), _defineProperty(_ref2, "& .".concat(classes$f.dayOfWeekEdit), {
    width: '80px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$f.shopTypeEdit), {
    paddingLeft: '8px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$f.expand), _defineProperty({
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    padding: 0,
    marginTop: '32px'
  }, "marginLeft", '4px')), _defineProperty(_ref2, "& .".concat(classes$f.expandOpen), {
    transform: 'rotate(180deg)',
    padding: 0,
    marginTop: '32px',
    marginLeft: '4px'
  }), _defineProperty(_ref2, "& .".concat(classes$f.topCardContentRoot), {
    //padding: 0,
    //margin: 0
    //paddingBottom: '17px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$f.topCardContentRoot_edit), {
    //paddingBottom: '8px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$f.topCardContentContainerRoot), {
    padding: 0,
    margin: 0
  }), _defineProperty(_ref2, "& .".concat(classes$f.paper), {/*
                                                           borderStyle: "solid",
                                                           borderWidth: theme.spacing(0.1),
                                                           borderColor: theme.custom.palette.itemBorderColor,
                                                           */
  }), _ref2;
});
var SolutionCard = function SolutionCard(_ref3) {
  _ref3.actions;
    _ref3.condensed;
    var solution = _ref3.solution,
    _ref3$mode = _ref3.mode,
    mode = _ref3$mode === void 0 ? 'view' : _ref3$mode;
  useNavigate();
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var _useContext2 = useContext(Context$5),
    putSolution = _useContext2.putSolution;
  var changeSolutionContent = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(changed) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('solution:');
            console.log(solution);
            _context.next = 4;
            return putSolution({
              id: solution.id,
              content: _objectSpread2(_objectSpread2({}, solution.content), changed)
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function changeSolutionContent(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var _useContext3 = useContext(SpoketreeAuthStore.Context);
    _useContext3.authenticationEmail;
  var _useContext4 = useContext(Context$5);
    _useContext4.putSolution;
    var deleteSolution = _useContext4.deleteSolution;
  var resourceItemUrl = (host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id) : '/plugin/exchange/feature') + "/solutions/".concat(solution.id);
  var cardImageDefault = 'https://images.unsplash.com/photo-1605712916066-e143c317df72?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2674&q=80';
  var cardImageAlbum = "spoketree/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id, "/solutions/").concat(solution.id, "/photos/card");
  var cardImageQuery = 'business';
  return /*#__PURE__*/React.createElement(Root$d, {
    className: classes$f.root
  }, /*#__PURE__*/React.createElement(SpoketreeCard, {
    mode: mode,
    editable: selectedCapability.isEditable(),
    resourceType: "solution",
    resourceObject: solution,
    resourcePropertiesStrategy: 'content',
    putResource: putSolution,
    deleteResource: deleteSolution,
    resourceItemUrl: resourceItemUrl,
    resourceCollectionUrl: resourceCollectionUrl,
    resourceCreateUrl: resourceCreateUrl,
    cardImageDefault: cardImageDefault,
    cardImageAlbum: cardImageAlbum,
    cardImageQuery: cardImageQuery,
    ExtraCardcontent: function ExtraCardcontent(_ref6) {
      var _solution$content, _solution$content2;
      _ref6.getProperty;
        _ref6.setProperty;
        _ref6.isEditing;
      return mode !== 'list' && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, ['view', 'edit'].includes(mode) && !!(solution !== null && solution !== void 0 && (_solution$content = solution.content) !== null && _solution$content !== void 0 && _solution$content.solutions) && /*#__PURE__*/React.createElement(Stack$2, {
        direction: "column",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'name',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/paddingLeft: '0',
          paddingBottom: '0px',
          marginBottom: '-4px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        component: "h5",
        style: {
          fontSize: '16px',
          marginTop: '0px',
          marginBottom: '0px',
          color: 'rgba(0, 0, 0, 0.44)'
        }
      }, /*#__PURE__*/React.createElement("b", null, "Solutions"))), /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'name',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/paddingLeft: '0',
          paddingBottom: '16px',
          marginBottom: '-4px'
        }
      }, /*#__PURE__*/React.createElement(SolutionsList, {
        readOnly: mode !== 'edit',
        items: solution === null || solution === void 0 || (_solution$content2 = solution.content) === null || _solution$content2 === void 0 ? void 0 : _solution$content2.solutions,
        setItems: function setItems(solutions) {
          return changeSolutionContent({
            solutions: solutions
          });
        }
      }))));
    }
  }));
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var useSolutions = function useSolutions(_) {
  var _useContext = useContext(Context$5),
    solutions = _useContext.solutions,
    putSolution = _useContext.putSolution,
    deleteSolution = _useContext.deleteSolution;
  return [solutions, putSolution, deleteSolution];
};

var PREFIX$e = 'Collection';
var classes$e = {
  root: "".concat(PREFIX$e, "-root"),
  columnsWrapper: "".concat(PREFIX$e, "-columnsWrapper"),
  fab: "".concat(PREFIX$e, "-fab"),
  todoWrapper: "".concat(PREFIX$e, "-todoWrapper"),
  icon: "".concat(PREFIX$e, "-icon")
};
var Root$c = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$e.root), {
    width: '100%',
    maxWidth: '472px'
    //height: '100%',
    //display: 'flex',
    //flexWrap: 'wrap',
    //justifyContent: 'space-around',
    //overflow: 'hidden',
    //backgroundColor: theme.palette.background.paper,
  }), _defineProperty(_ref2, "& .".concat(classes$e.columnsWrapper), {
    //margin: "0 auto",
    //columnWidth: theme.spacing(29),
    columnGap: "16px" //"0.5rem"
  }), _defineProperty(_ref2, "& .".concat(classes$e.fab), {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }), _defineProperty(_ref2, "& .".concat(classes$e.todoWrapper), {
    //: theme.spacing(29),
    //margin: "0 auto",
    breakInside: "avoid",
    pageBreakInside: "avoid",
    //padding: "0.5rem 0",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.standard
    })
    //paddingBottom:'4px'
  }), _defineProperty(_ref2, "& .".concat(classes$e.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var Collection$1 = function Collection(_ref3) {
  _objectDestructuringEmpty(_ref3);
  useNavigate();
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useSolutions = useSolutions(),
    _useSolutions2 = _slicedToArray(_useSolutions, 3),
    solutions = _useSolutions2[0],
    putSolution = _useSolutions2[1];
    _useSolutions2[2];
  var urlPrefix = host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var _useState = useState(querystring('filter') ? querystring('filter') : 'solutions'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFilter = _useState2[0];
    _useState2[1];
  return /*#__PURE__*/React.createElement(Root$c, {
    className: classes$e.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && !!(solutions !== null && solutions !== void 0 && solutions.length) && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'create button',
    style: {
      float: 'left',
      marginTop: '8px',
      width: 'calc(100% - 100px)'
    }
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "".concat(urlPrefix, "/solutions/create")
  }, "Create Solution")), false  , /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'list',
    style: {
      maxWidth: '472px',
      width: '100%',
      marginTop: '8px',
      marginBottom: '4px'
    }
  }, selectedFilter === 'solutions' && !!(solutions !== null && solutions !== void 0 && solutions.length) && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, solutions
  //?.sort((a, b) => kitPlugins[a?.content?.pluginAlias]?.name.localeCompare(kitPlugins[b?.content?.pluginAlias]?.name))
  === null || solutions
  //?.sort((a, b) => kitPlugins[a?.content?.pluginAlias]?.name.localeCompare(kitPlugins[b?.content?.pluginAlias]?.name))
  === void 0 ? void 0 : solutions
  //?.sort((a, b) => kitPlugins[a?.content?.pluginAlias]?.name.localeCompare(kitPlugins[b?.content?.pluginAlias]?.name))
  .map(function (solution) {
    return /*#__PURE__*/React.createElement(SolutionCard, {
      solution: solution
      //setSolution={putSolution}
      //deleteSolution={deleteSolution}
      ,
      actions: "list-actions",
      mode: "list"
    });
  })), (selectedFilter === 'new' || !(solutions !== null && solutions !== void 0 && solutions.length)) && /*#__PURE__*/React.createElement(Stack$2, {
    spacing: 1
  }, (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && /*#__PURE__*/React.createElement(SolutionCard, {
    setSolution: putSolution,
    mode: "create"
  })))));
};
function querystring(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  var results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var PREFIX$d = 'CreateSolutionCard';
var classes$d = {
  root: "".concat(PREFIX$d, "-root"),
  paper: "".concat(PREFIX$d, "-paper"),
  avatar: "".concat(PREFIX$d, "-avatar"),
  card: "".concat(PREFIX$d, "-card"),
  fab: "".concat(PREFIX$d, "-fab"),
  lastCard: "".concat(PREFIX$d, "-lastCard"),
  input: "".concat(PREFIX$d, "-input"),
  opaqueInput: "".concat(PREFIX$d, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$d, "-inputRoot"),
  inputNotchedOutline: "".concat(PREFIX$d, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$d, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$d, "-inputLabelRoot"),
  link: "".concat(PREFIX$d, "-link")
};
var Root$b = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$d.root), {
    width: '100%',
    maxWidth: 472,
    flexGrow: 1,
    overflow: 'hidden',
    margin: 0,
    padding: 0 //'8px'//theme.spacing(0, 3),
  }), _defineProperty(_ref2, "& .".concat(classes$d.paper), {
    //maxWidth: 400,
    //margin: '8px',//`${theme.spacing(1)} auto`,
    padding: '16px' //theme.spacing(2),
  }), _defineProperty(_ref2, "& .".concat(classes$d.avatar), {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: '3px'
  }), _defineProperty(_ref2, "& .".concat(classes$d.card), {
    marginBottom: '16px',
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$d.fab), {
    position: 'fixed',
    bottom: '64px',
    //theme.spacing(2),
    right: '16px',
    //theme.spacing(2),
    zIndex: 9999
  }), _defineProperty(_ref2, "& .".concat(classes$d.lastCard), {
    marginBottom: 0
  }), _defineProperty(_ref2, "& .".concat(classes$d.input), {}), _defineProperty(_ref2, "& .".concat(classes$d.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    marginTop: '8px'
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$d.inputRoot), {
    '&$inputFocused $inputNotchedOutline': {
      borderColor: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$d.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$d.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$d.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$d.link), {
    color: theme.palette.secondary.main
  }), _ref2;
});
var CreateSolutionCard = (function (_ref3 /*googleMapDivRef*/) {
  _objectDestructuringEmpty(_ref3);
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var _useContext2 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext2.selectedFeature;
  var _useContext3 = useContext(Context$5),
    putSolution = _useContext3.putSolution;
  var _useContext4 = useContext(Context$9),
    solutionName = _useContext4.solutionName,
    setSolutionName = _useContext4.setSolutionName,
    isSolutionValid = _useContext4.isSolutionValid,
    reset = _useContext4.reset;
  var handleClickCreateSolution = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var solution;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isAuthenticated) {
              _context.next = 3;
              break;
            }
            _context.next = 15;
            break;
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return putSolution({
              content: {
                name: solutionName,
                image: 'https://images.unsplash.com/photo-1605712916066-e143c317df72?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2674&q=80'
              }
            });
          case 6:
            solution = _context.sent;
            reset();
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            alert('Failed to create solution');
            console.error(_context.t0);
          case 14:
            if (selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.getId() && solution.id) {
              window.location.href = "".concat(host().marketUrl, "/plugin/exchange/features/").concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/solutions/").concat(solution.id);
            }
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function handleClickCreateSolution(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  useRef(null);
  return /*#__PURE__*/React.createElement(Root$b, {
    className: classes$d.root
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes$d.root,
    elevation: 0,
    variant: "outlined" /*style={{...(highlighted ? { borderWidth: 'thick', borderColor: 'limegreen' }: {})}}*/
  }, /*#__PURE__*/React.createElement(CardContent, {
    style: {
      /*backgroundColor:'#f8f8f8',*/width: '100%',
      marginBottom: '0px'
    },
    classes: {
      root: /*isEditing() ? classes.topCardContentRoot_edit : */classes$d.topCardContentRoot
    }
  }, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "column",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'name',
    style: {
      float: 'left',
      width: '100%',
      /*width:'calc(100% - 96px)',*/paddingLeft: '0',
      paddingTop: '0'
    }
  }, /*#__PURE__*/React.createElement(EditableText, {
    label: "",
    value: 'Create Solution',
    variant: "h6",
    component: "p"
  })), /*#__PURE__*/React.createElement(WorkflowStepCard
  //stepNumber={1}
  , {
    stepTitle: "Solution Details"
    //stepDescription="Provide a name for your solution."
    ,
    stepComponents: [/*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '8px'
      }
    }, /*#__PURE__*/React.createElement(EditableTextField, {
      Icon: TextFieldsIcon,
      label: 'Name',
      placeholder: 'Solution Name',
      value: solutionName,
      setValue: setSolutionName,
      autoFocus: true,
      autoComplete: "off"
    })))]
  }))), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Stack$2, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/solutions")
  }, "Cancel"), isSolutionValid() && /*#__PURE__*/React.createElement(SpoketreeButton, {
    onClick: handleClickCreateSolution
  }, "Create Solution")))));
});

var PREFIX$c = 'Create';
var classes$c = {
  root: "".concat(PREFIX$c, "-root"),
  icon: "".concat(PREFIX$c, "-icon")
};
var Root$a = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$c.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$c.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesSolutionsCreate = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var _useContext = useContext(SelectedFeatureStore.Context);
    _useContext.selectedFeature;
  return (
    /*#__PURE__*/
    /*selectedFeature &&*/
    React.createElement(Root$a, {
      className: classes$c.root
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: 'createSolution',
      style: {
        maxWidth: '472px',
        width: '100%',
        marginTop: '8px',
        marginBottom: '4px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: 'createSolution',
      className: classes$c.todoWrapper,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(CreateSolutionCard, null)))))
  );
});

var useSolution = function useSolution(solutionId) {
  var _useState = useState(solutionId),
    _useState2 = _slicedToArray(_useState, 2),
    _solutionId = _useState2[0],
    setSolutionId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    solution = _useState4[0],
    setSolution = _useState4[1];
  var _useContext = useContext(Context$5),
    solutions = _useContext.solutions,
    findSolution = _useContext.findSolution;
  useEffect(function () {
    if (_solutionId && solutions !== null && solutions !== void 0 && solutions.length && findSolution) {
      var _solution = findSolution(_solutionId);
      if (_solution) {
        setSolution(_solution);
      }
    }
  }, [_solutionId, solutions, findSolution, setSolution]);
  return [solution, setSolutionId];
};

var Context$2 = /*#__PURE__*/createContext([]);
var Provider$2 = function Provider(_ref) {
  var children = _ref.children,
    solutionId = _ref.solutionId;
  var _useSolution = useSolution(solutionId),
    _useSolution2 = _slicedToArray(_useSolution, 2),
    selectedSolution = _useSolution2[0];
    _useSolution2[1];
  var value = {
    selectedSolution: selectedSolution
  };
  return /*#__PURE__*/React.createElement(Context$2.Provider, {
    value: value
  }, children);
};
var Consumer$2 = Context$2.Consumer;
var SelectedSolutionStore = {
  Context: Context$2,
  Provider: Provider$2,
  Consumer: Consumer$2
};

var PREFIX$b = 'Item';
var classes$b = {
  root: "".concat(PREFIX$b, "-root"),
  icon: "".concat(PREFIX$b, "-icon")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$9 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$b.root), {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$b.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesSolutionsItem = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var theme = useTheme$1();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useContext2 = useContext(SelectedSolutionStore.Context),
    selectedSolution = _useContext2.selectedSolution;
  var urlPrefix = host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var mode = useQueryParam('mode', 'view');
  console.log('selectedSolution', selectedSolution);
  return /*#__PURE__*/React.createElement(Root$9, {
    className: classes$b.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'list',
    style: {
      float: 'left',
      marginTop: '8px',
      width: 'calc(100% - 100px)'
    }
  }, /*#__PURE__*/React.createElement(SpoketreeButton, {
    href: "".concat(urlPrefix, "/solutions")
  }, "List")), selectedSolution && /*#__PURE__*/React.createElement("div", {
    className: classes$b.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'solution',
    style: {
      width: '100%',
      minWidth: '232px',
      maxWidth: '472px',
      marginTop: '8px',
      marginBottom: '0'
    }
  }, /*#__PURE__*/React.createElement(SolutionCard, {
    solution: selectedSolution,
    mode: mode //'view'
  }))))));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var CompositeSelectedSolutionProvider = (function (_ref) {
  var featureId = _ref.featureId,
    solutionId = _ref.solutionId,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, featureId && solutionId && /*#__PURE__*/React.createElement(Provider$f, {
    featureId: featureId
  }, /*#__PURE__*/React.createElement(Provider$9, null, /*#__PURE__*/React.createElement(Provider$5, null, /*#__PURE__*/React.createElement(Provider$d, null, /*#__PURE__*/React.createElement(Provider$e, null, /*#__PURE__*/React.createElement(Provider$2, {
    solutionId: solutionId
  }, children)))))));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var FeaturesSolutionsItemProvider = (function (_ref) {
  var children = _ref.children,
    itemId = _ref.itemId,
    subitemId = _ref.subitemId;
  return /*#__PURE__*/React.createElement(CompositeSelectedSolutionProvider, {
    featureId: itemId,
    solutionId: subitemId
  }, children);
});

var PREFIX$a = 'FeatureReportsCard';
var classes$a = {
  root: "".concat(PREFIX$a, "-root"),
  media: "".concat(PREFIX$a, "-media"),
  counterButtonWrapper: "".concat(PREFIX$a, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$a, "-checkboxRoot"),
  action: "".concat(PREFIX$a, "-action")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$8 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$a.root), {
    maxWidth: 472
    //padding: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$a.media), {
    height: '110px'
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$a.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$a.checkboxRoot), {
    verticalAlign: 'top',
    margin: "auto ".concat(theme.spacing(1.5)),
    //marginTop: theme.spacing(0),
    marginTop: '3px',
    marginLeft: '4px !important',
    padding: "0 !important",
    color: "".concat(theme.custom.palette.notesCheckbox, " !important"),
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$a.action), {
    margin: theme.spacing(3, 0, 2)
  }), _ref2;
});
var FeatureReportsCard = function FeatureReportsCard(_ref3) {
  _ref3.setSelectedPanelId;
  var theme = useTheme$1();
  useMediaQuery$1(theme.breakpoints.down('md'));
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var handleClick = function handleClick(e) {
    window.location.href = host().marketUrl + "/plugin/exchange/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/reports/create");
  };

  //const shopCount = principalShops ? principalShops.length : 0;

  var _callToAction$paragra = {
      callToAction: 'Create Report',
      paragraphs: ['Create reports to view messages in your Exchange']
    },
    callToAction = _callToAction$paragra.callToAction,
    paragraphs = _callToAction$paragra.paragraphs; /*(
                                                   shopCount === 0 ? ({
                                                    callToAction: 'Create your online shop',
                                                    paragraphs: [
                                                      'Creating an online shop is simple on Spoketree.'
                                                    ]
                                                   }) : (
                                                    shopCount === 1 ? ({
                                                      callToAction: 'Manage your shop',
                                                      paragraphs: [
                                                        'Managing an online shop is simple on Spoketree.'
                                                      ]
                                                    }) : ({
                                                      callToAction: 'Manage your shops',
                                                      paragraphs: [
                                                      ]
                                                    })
                                                   )
                                                   );*/

  //const CardActionArea = CardActionArea
  var CardActionArea = function CardActionArea(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/React.createElement("div", null, children);
  };
  return /*#__PURE__*/React.createElement(Root$8, null,
  /*#__PURE__*/
  //process.env.REACT_APP_SPOKETREE_RELEASE_PHASE !== 'ALPHA_LEAN' && 
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes$a.root,
    elevation: 0,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(CardActionArea, {
    href: "/plugin/exchange/features/create"
  }, /*#__PURE__*/React.createElement(CardMedia$1, {
    className: classes$a.media,
    image: "https://images.unsplash.com/photo-1461773518188-b3e86f98242f?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=472&q=80",
    title: "create-exchange-feature"
  })), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(CardActionArea, {
    href: "/plugin/exchange/features/create"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textSecondary",
    component: "p",
    style: {
      marginBottom: '8px'
    }
  }, "Spoketree Reports"), paragraphs.map(function (paragraph, i) {
    return /*#__PURE__*/React.createElement(Typography, {
      key: i,
      variant: "body2",
      color: "textSecondary",
      component: "p",
      style: {
        marginBottom: '8px'
      }
    }, paragraph);
  }))), /*#__PURE__*/React.createElement(CardActions /*disableSpacing style={{marginTop:'-24px',padding:'0 16px 0px'}}*/, null, /*#__PURE__*/React.createElement(SpoketreeButton, {
    onClick: handleClick
  }, callToAction)))));
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var useReports = function useReports(_) {
  var _useContext = useContext(Context$b),
    reports = _useContext.reports;
  return [reports];
};

var PREFIX$9 = 'Collection';
var classes$9 = {
  root: "".concat(PREFIX$9, "-root"),
  columnsWrapper: "".concat(PREFIX$9, "-columnsWrapper"),
  fab: "".concat(PREFIX$9, "-fab"),
  todoWrapper: "".concat(PREFIX$9, "-todoWrapper"),
  icon: "".concat(PREFIX$9, "-icon")
};
var Root$7 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$9.columnsWrapper), {
    //margin: "0 auto",
    //columnWidth: theme.spacing(29),
    columnGap: "16px" //"0.5rem"
  }), _defineProperty(_ref2, "& .".concat(classes$9.fab), {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }), _defineProperty(_ref2, "& .".concat(classes$9.todoWrapper), {
    //: theme.spacing(29),
    //margin: "0 auto",
    breakInside: "avoid",
    pageBreakInside: "avoid",
    //padding: "0.5rem 0",
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.standard
    })
    //paddingBottom:'4px'
  }), _defineProperty(_ref2, "& .".concat(classes$9.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var Collection = function Collection(_ref3) {
  var _reports$sort;
  _objectDestructuringEmpty(_ref3);
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  var _useReports = useReports(),
    _useReports2 = _slicedToArray(_useReports, 1),
    reports = _useReports2[0];
  var urlPrefix = host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  return /*#__PURE__*/React.createElement(Root$7, {
    className: classes$9.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, !!(reports !== null && reports !== void 0 && reports.length) && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: "reports",
    style: {
      width: '100%',
      minWidth: '232px',
      maxWidth: '472px' /*,marginLeft:'8px',marginRight:'8px'*/,
      marginTop: '8px',
      marginBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes$9.root,
    elevation: 0,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textSecondary",
    component: "p",
    style: {
      marginBottom: '8px'
    }
  }, "Reports"), /*#__PURE__*/React.createElement(List, null, reports === null || reports === void 0 || (_reports$sort = reports.sort(function (a, b) {
    return a.content.name.localeCompare(b.content.name);
  })) === null || _reports$sort === void 0 ? void 0 : _reports$sort.map(function (report, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(ListItem$1, null, /*#__PURE__*/React.createElement(ListItemAvatar$1, null, /*#__PURE__*/React.createElement(Avatar, null, /*#__PURE__*/React.createElement(ReportIcon, null))), /*#__PURE__*/React.createElement(ListItemButton, {
      component: "a",
      href: "".concat(urlPrefix, "/reports/").concat(report.id)
    }, /*#__PURE__*/React.createElement(ListItemText$1, {
      primary: report.content.name
    }))), false  );
  }))))), (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'newshp',
    style: {
      width: '100%',
      minWidth: '232px',
      maxWidth: '472px' /*,marginLeft:'8px',marginRight:'8px'*/,
      marginTop: '8px',
      marginBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement(FeatureReportsCard, null))));
};

var PREFIX$8 = 'CreateReportCard';
var classes$8 = {
  root: "".concat(PREFIX$8, "-root"),
  paper: "".concat(PREFIX$8, "-paper"),
  avatar: "".concat(PREFIX$8, "-avatar"),
  card: "".concat(PREFIX$8, "-card"),
  fab: "".concat(PREFIX$8, "-fab"),
  lastCard: "".concat(PREFIX$8, "-lastCard"),
  input: "".concat(PREFIX$8, "-input"),
  opaqueInput: "".concat(PREFIX$8, "-opaqueInput"),
  inputRoot: "".concat(PREFIX$8, "-inputRoot"),
  inputNotchedOutline: "".concat(PREFIX$8, "-inputNotchedOutline"),
  inputFocused: "".concat(PREFIX$8, "-inputFocused"),
  inputLabelRoot: "".concat(PREFIX$8, "-inputLabelRoot"),
  link: "".concat(PREFIX$8, "-link")
};
var Root$6 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$8.root), {
    width: '100%',
    maxWidth: 472,
    flexGrow: 1,
    overflow: 'hidden',
    margin: 0,
    padding: 0 //'8px'//theme.spacing(0, 3),
  }), _defineProperty(_ref2, "& .".concat(classes$8.paper), {
    //maxWidth: 400,
    //margin: '8px',//`${theme.spacing(1)} auto`,
    padding: '16px' //theme.spacing(2),
  }), _defineProperty(_ref2, "& .".concat(classes$8.avatar), {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: '3px'
  }), _defineProperty(_ref2, "& .".concat(classes$8.card), {
    marginBottom: '16px',
    width: '100%'
  }), _defineProperty(_ref2, "& .".concat(classes$8.fab), {
    position: 'fixed',
    bottom: '64px',
    //theme.spacing(2),
    right: '16px',
    //theme.spacing(2),
    zIndex: 9999
  }), _defineProperty(_ref2, "& .".concat(classes$8.lastCard), {
    marginBottom: 0
  }), _defineProperty(_ref2, "& .".concat(classes$8.input), {}), _defineProperty(_ref2, "& .".concat(classes$8.opaqueInput), {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    //padding: 0,
    //marginLeft: '8px',
    //marginRight: '8px',
    marginTop: '8px'
    //width: '98%'
  }), _defineProperty(_ref2, "& .".concat(classes$8.inputRoot), {
    '&$inputFocused $inputNotchedOutline': {
      borderColor: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$8.inputNotchedOutline), {}), _defineProperty(_ref2, "& .".concat(classes$8.inputFocused), {}), _defineProperty(_ref2, "& .".concat(classes$8.inputLabelRoot), {
    '&$inputFocused': {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$8.link), {
    color: theme.palette.secondary.main
  }), _ref2;
});
var CreateReportCard = (function (_ref3 /*googleMapDivRef*/) {
  _objectDestructuringEmpty(_ref3);
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var _useContext2 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext2.selectedFeature;
  var _useContext3 = useContext(Context$b),
    putReport = _useContext3.putReport;
  var _useContext4 = useContext(Context$6),
    reportName = _useContext4.reportName,
    setReportName = _useContext4.setReportName,
    isReportValid = _useContext4.isReportValid,
    reset = _useContext4.reset;
  var handleClickCreateReport = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var report;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isAuthenticated) {
              _context.next = 3;
              break;
            }
            _context.next = 15;
            break;
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return putReport({
              content: {
                name: reportName,
                query: defaultQuery //{}//reportQuery
              }
            });
          case 6:
            report = _context.sent;
            reset();
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            alert('Failed to create report');
            console.error(_context.t0);
          case 14:
            if (selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.getId() && report.id) {
              window.location.href = "".concat(host().marketUrl, "/plugin/exchange/features/").concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(), "/reports/").concat(report.id);
            }
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function handleClickCreateReport(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var bottomRef = useRef(null);
  return /*#__PURE__*/React.createElement(Root$6, {
    className: classes$8.root
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textSecondary",
    component: "p",
    style: {
      marginBottom: '8px'
    }
  }, "Create a report"), /*#__PURE__*/React.createElement(WorkflowStepCard
  //stepNumber={1}
  , {
    stepTitle: "Report Details"
    //stepDescription="Provide a name for your report."
    ,
    stepComponents: [/*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '8px'
      }
    }, /*#__PURE__*/React.createElement(EditableTextField, {
      Icon: TextFieldsIcon,
      label: 'Name',
      placeholder: 'Report Name',
      value: reportName,
      setValue: setReportName,
      autoFocus: true,
      autoComplete: "off"
    })))]
  }), isReportValid() &&
  /*#__PURE__*/
  //isTermsAccepted && 
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    variant: "contained",
    "aria-label": "add to favorites",
    onClick: handleClickCreateReport
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: '4px'
    }
  }), "Create Report")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '64px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: bottomRef
  }));
});

var PREFIX$7 = 'Create';
var classes$7 = {
  root: "".concat(PREFIX$7, "-root"),
  icon: "".concat(PREFIX$7, "-icon")
};
var Root$5 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$7.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$7.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesReportsCreate = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var theme = useTheme$1();
  useNavigate();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedFeatureStore.Context);
    _useContext.selectedFeature;
  return (
    /*#__PURE__*/
    /*selectedFeature &&*/
    React.createElement(Root$5, {
      className: classes$7.root
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: 'createFeature',
      style: {
        maxWidth: '472px',
        width: '100%',
        marginTop: '8px',
        marginBottom: '4px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: 'createFeature',
      className: classes$7.todoWrapper
      //style={{ width: isMobile || isListView ? "100%" : null }}
      ,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(CreateReportCard, null)))))
  );
});

var useReport = function useReport(reportId) {
  var _useState = useState(reportId),
    _useState2 = _slicedToArray(_useState, 2),
    _reportId = _useState2[0],
    setReportId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    report = _useState4[0],
    setReport = _useState4[1];
  var _useContext = useContext(Context$b),
    reports = _useContext.reports,
    findReport = _useContext.findReport;
  useEffect(function () {
    if (_reportId && reports !== null && reports !== void 0 && reports.length && findReport) {
      var _report = findReport(_reportId);
      if (_report) {
        setReport(_report);
      }
    }
  }, [_reportId, reports, findReport, setReport]);
  return [report, setReportId];
};

var Context$1 = /*#__PURE__*/createContext([]);
var Provider$1 = function Provider(_ref) {
  var children = _ref.children,
    reportId = _ref.reportId;
  var _useReport = useReport(reportId),
    _useReport2 = _slicedToArray(_useReport, 2),
    selectedReport = _useReport2[0];
    _useReport2[1];
  var value = {
    selectedReport: selectedReport
  };
  return /*#__PURE__*/React.createElement(Context$1.Provider, {
    value: value
  }, children);
};
var Consumer$1 = Context$1.Consumer;
var SelectedReportStore = {
  Context: Context$1,
  Provider: Provider$1,
  Consumer: Consumer$1
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$4 = styled('div')(function (_ref) {
  _ref.theme;
  return _defineProperty({}, ".MuiTableCell-root", {
    padding: '6px',
    fontSize: '.875rem'
  });
});
function TablePaginationActions(props) {
  var theme = useTheme$1();
  var count = props.count,
    page = props.page,
    rowsPerPage = props.rowsPerPage,
    onPageChange = props.onPageChange;
  var handleFirstPageButtonClick = function handleFirstPageButtonClick(event) {
    onPageChange(event, 0);
  };
  var handleBackButtonClick = function handleBackButtonClick(event) {
    onPageChange(event, page - 1);
  };
  var handleNextButtonClick = function handleNextButtonClick(event) {
    onPageChange(event, page + 1);
  };
  var handleLastPageButtonClick = function handleLastPageButtonClick(event) {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexShrink: 0,
      ml: 2.5
    }
  }, /*#__PURE__*/React.createElement(IconButton$1, {
    onClick: handleFirstPageButtonClick,
    disabled: page === 0,
    "aria-label": "first page"
  }, theme.direction === 'rtl' ? /*#__PURE__*/React.createElement(LastPageIcon, null) : /*#__PURE__*/React.createElement(FirstPageIcon, null)), /*#__PURE__*/React.createElement(IconButton$1, {
    onClick: handleBackButtonClick,
    disabled: page === 0,
    "aria-label": "previous page"
  }, theme.direction === 'rtl' ? /*#__PURE__*/React.createElement(KeyboardArrowRight, null) : /*#__PURE__*/React.createElement(KeyboardArrowLeft, null)), /*#__PURE__*/React.createElement(IconButton$1, {
    onClick: handleNextButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
    "aria-label": "next page"
  }, theme.direction === 'rtl' ? /*#__PURE__*/React.createElement(KeyboardArrowLeft, null) : /*#__PURE__*/React.createElement(KeyboardArrowRight, null)), /*#__PURE__*/React.createElement(IconButton$1, {
    onClick: handleLastPageButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
    "aria-label": "last page"
  }, theme.direction === 'rtl' ? /*#__PURE__*/React.createElement(FirstPageIcon, null) : /*#__PURE__*/React.createElement(LastPageIcon, null)));
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};
var ReportResultTable = function ReportResultTable(_ref3) {
  var _report$content, _ref7;
  _ref3.featureId;
    var report = _ref3.report;
  var theme = useTheme$1();
  var _useContext = useContext(UISessionStore.Context);
    _useContext.isNavBarOpen;
  useMediaQuery$1(theme.breakpoints.down('sm')); // 0px
  var isTablet = useMediaQuery$1(theme.breakpoints.up("sm")); // 600px
  var isLaptop = useMediaQuery$1(theme.breakpoints.up("md")); // 960px
  var isLaptopL = useMediaQuery$1(theme.breakpoints.up("lg")); // 1280px
  var is4K = useMediaQuery$1(theme.breakpoints.up("xl")); // 1920px
  var width = is4K ? "1888px" : isLaptopL ? "1248px" : isLaptop ? "928px" : isTablet ? "568px" : "100%";
  var _false = false,
    isListView = _false.isListView; //useContext(UISettingsContext);
  width = isListView ? isLaptop || isLaptopL ? theme.spacing(75) : "100%" : width;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    reportTrigger = _useState2[0],
    setReportTrigger = _useState2[1];
  var _useReportResult = useReportResult({
      report: report,
      trigger: reportTrigger
    }),
    reportResult = _useReportResult.reportResult;
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    messages = _useState4[0],
    setMessages = _useState4[1];
  useEffect(function (_) {
    (function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        var _JSON$parse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setMessages(reportResult ? (_JSON$parse = JSON.parse(reportResult)) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.messages) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.sort(function (a, b) {
                return a.lastModified.localeCompare(b.lastModified);
              })) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.reverse() : []);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    })()();
  }, [reportResult]);
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    page = _useState6[0],
    setPage = _useState6[1];
  var _useState7 = useState(5),
    _useState8 = _slicedToArray(_useState7, 2),
    rowsPerPage = _useState8[0],
    setRowsPerPage = _useState8[1];

  // Avoid a layout jump when reaching the last page with empty rows.
  var emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - messages.length) : 0;
  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
  };
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  var reportQuery = report ? typeof report.content.query === 'string' ? JSON.parse(report === null || report === void 0 || (_report$content = report.content) === null || _report$content === void 0 ? void 0 : _report$content.query) : report.content.query : undefined;
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedMessage = _useState10[0],
    setSelectedMessage = _useState10[1];

  // https://mui.com/material-ui/react-menu/
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    anchorEl_Consumed = _useState14[0],
    setAnchorEl_Consumed = _useState14[1];
  var open_Consumed = Boolean(anchorEl_Consumed);
  var handleItemMenuClick_Consumed = function handleItemMenuClick_Consumed(event, message) {
    setAnchorEl_Consumed(event.currentTarget);
    setSelectedMessage(message);
  };
  var handleItemMenuClose_Consumed = function handleItemMenuClose_Consumed() {
    setAnchorEl_Consumed(null);
    setSelectedMessage(null);
  };
  var _useContext2 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext2.selectedFeature;
  var handleMessageResend = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var filter, moveApi;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            filter = lodash.find(reportQuery === null || reportQuery === void 0 ? void 0 : reportQuery.filters, function (filter) {
              var _selectedMessage$filt2;
              return filter.key === (selectedMessage === null || selectedMessage === void 0 || (_selectedMessage$filt2 = selectedMessage.filter) === null || _selectedMessage$filt2 === void 0 ? void 0 : _selectedMessage$filt2.key);
            }); // spoketree-exchange-api:message-transition:_copy
            moveApi = makeAPI("spoketree-exchange-message-transition", "/features/".concat(selectedFeature.getId(), "/transitions/_move"));
            _context3.next = 4;
            return moveApi.create({
              source: _objectSpread2(_objectSpread2({}, filter === null || filter === void 0 ? void 0 : filter.match), {}, {
                objectId: selectedMessage === null || selectedMessage === void 0 ? void 0 : selectedMessage.id
              }),
              target: _objectSpread2(_objectSpread2({}, filter === null || filter === void 0 ? void 0 : filter.match), {}, {
                objectId: selectedMessage === null || selectedMessage === void 0 ? void 0 : selectedMessage.id,
                exchangePhase: 'produced'
              })
            });
          case 4:
            _context3.sent;
            // trigger report reload by changing the value of reportTrigger
            setReportTrigger(reportTrigger + 1);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleMessageResend() {
      return _ref6.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Root$4, null, !(messages !== null && messages !== void 0 && messages.length) && /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: 'grey',
      padding: '16px'
    }
  }, "There are no items to display"), !!(messages !== null && messages !== void 0 && messages.length) && /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper$1
  }, /*#__PURE__*/React.createElement(Table, {
    sx: {
      minWidth: 472
    },
    size: "small",
    "aria-label": "report results"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      minWidth: '16px'
    }
  }, "Label"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "ID"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Size"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Last Modified"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }))), /*#__PURE__*/React.createElement(TableBody, null, (_ref7 = rowsPerPage > 0 ? messages === null || messages === void 0 ? void 0 : messages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : messages) === null || _ref7 === void 0 ? void 0 : _ref7.map(function (message) {
    var _message$filter2, _message$filter3, _filter$match, _filter$match2;
    var filter = lodash.find(reportQuery === null || reportQuery === void 0 ? void 0 : reportQuery.filters, function (filter) {
      var _message$filter;
      return filter.key === (message === null || message === void 0 || (_message$filter = message.filter) === null || _message$filter === void 0 ? void 0 : _message$filter.key);
    });
    return /*#__PURE__*/React.createElement(TableRow, {
      key: "".concat(message === null || message === void 0 || (_message$filter2 = message.filter) === null || _message$filter2 === void 0 ? void 0 : _message$filter2.key, "-").concat(message === null || message === void 0 ? void 0 : message.id)
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      style: {
        minWidth: '16px',
        maxWidth: '64px'
      }
    }, /*#__PURE__*/React.createElement(Chip$1, {
      style: {
        paddingTop: '1px',
        textTransform: 'capitalize'
      },
      size: "small",
      color: "secondary",
      label: message === null || message === void 0 || (_message$filter3 = message.filter) === null || _message$filter3 === void 0 ? void 0 : _message$filter3.label
    })), /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      style: {
        minWidth: '48px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        //maxWidth: isMobile ? '100px' : (isTablet ? '200px' : '100%'),
        //whiteSpace: "nowrap",
        //overflow: "hidden",
        //textOverflow: "ellipsis"
        fontSize: '.875rem'
      }
    }, message === null || message === void 0 ? void 0 : message.id)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        minWidth: '96px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        //maxWidth: isMobile ? '100px' : (isTablet ? '200px' : '100%'),
        //whiteSpace: "nowrap",
        //overflow: "hidden",
        //textOverflow: "ellipsis"
        fontSize: '.875rem'
      }
    }, convertBytes(message.size)))), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Chip$1, {
      style: {
        paddingTop: '1px',
        textTransform: 'capitalize'
      },
      size: "small",
      color: (filter === null || filter === void 0 || (_filter$match = filter.match) === null || _filter$match === void 0 ? void 0 : _filter$match.exchangePhase) === 'produced' ? 'warning' : 'success',
      label: (filter === null || filter === void 0 || (_filter$match2 = filter.match) === null || _filter$match2 === void 0 ? void 0 : _filter$match2.exchangePhase) === 'produced' ? 'pending' : 'sent'
    })), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        //maxWidth: isMobile ? '100px' : (isTablet ? '200px' : '100%'),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: '.75rem'
      }
    }, new Date(message.lastModified).toLocaleString().split(',').join(' '))), (filter === null || filter === void 0 ? void 0 : filter.match.exchangePhase) === 'consumed' && /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      style: {
        maxWidth: '24px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: '24px'
      }
    }, /*#__PURE__*/React.createElement(IconButton$1, {
      color: "secondary",
      style: {
        padding: 0,
        paddingLeft: '1px',
        marginRight: '2px'
      }
      //onClick={event => filter?.match?.exchangePhase === 'produced' ? handleItemMenuClick_Produced(event, message) : handleItemMenuClick_Consumed(event, message)}
      ,
      onClick: function onClick(event) {
        return handleItemMenuClick_Consumed(event, message);
      }
    }, /*#__PURE__*/React.createElement(MenuIcon, {
      fontSize: "inherit"
    }))), /*#__PURE__*/React.createElement(Menu$1, {
      id: "consumed-menu",
      "aria-labelledby": "consumed-menu-button",
      anchorEl: anchorEl_Consumed,
      open: open_Consumed,
      onClose: handleItemMenuClose_Consumed,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      onClick: function onClick(event) {
        handleMessageResend();
        handleItemMenuClose_Consumed();
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(SendIcon, {
      fontSize: "small"
    })), /*#__PURE__*/React.createElement(ListItemText, null, "Reset")))));
  }), emptyRows > 0 && /*#__PURE__*/React.createElement(TableRow, {
    style: {
      height: 53 * emptyRows
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 3
  }))), /*#__PURE__*/React.createElement(TableFooter, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TablePagination, {
    rowsPerPageOptions: [5, 10, 20, 50, 100, {
      label: 'All',
      value: -1
    }] //isMobile ? [] : [5, 10, 20, 50, 100, { label: 'All', value: -1 }]}
    //resultRowsPerPage={9999}
    ,
    colSpan: 5,
    count: messages === null || messages === void 0 ? void 0 : messages.length,
    rowsPerPage: rowsPerPage,
    page: page,
    SelectProps: {
      inputProps: {
        'aria-label': 'rows per page'
      },
      native: true
    },
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    ActionsComponent: TablePaginationActions
  }))))));
};
var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
function convertBytes(x) {
  var l = 0,
    n = parseInt(x, 10) || 0;
  while (n >= 1024 && ++l) {
    n = n / 1024;
  }
  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];
}

var PREFIX$6 = 'ReportCard';
var classes$6 = {
  root: "".concat(PREFIX$6, "-root"),
  checked: "".concat(PREFIX$6, "-checked"),
  root2: "".concat(PREFIX$6, "-root2"),
  media: "".concat(PREFIX$6, "-media"),
  counterButtonWrapper: "".concat(PREFIX$6, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$6, "-checkboxRoot"),
  checkboxRootColorfulPickup: "".concat(PREFIX$6, "-checkboxRootColorfulPickup"),
  checkboxRootDelivery: "".concat(PREFIX$6, "-checkboxRootDelivery"),
  checkboxRootColorfulDelivery: "".concat(PREFIX$6, "-checkboxRootColorfulDelivery"),
  formControl: "".concat(PREFIX$6, "-formControl"),
  packingHoursEdit: "".concat(PREFIX$6, "-packingHoursEdit"),
  timeEdit: "".concat(PREFIX$6, "-timeEdit"),
  timeView: "".concat(PREFIX$6, "-timeView"),
  dayOfWeekEdit: "".concat(PREFIX$6, "-dayOfWeekEdit"),
  shopTypeEdit: "".concat(PREFIX$6, "-shopTypeEdit"),
  expand: "".concat(PREFIX$6, "-expand"),
  expandOpen: "".concat(PREFIX$6, "-expandOpen"),
  topCardContentRoot: "".concat(PREFIX$6, "-topCardContentRoot"),
  topCardContentRoot_edit: "".concat(PREFIX$6, "-topCardContentRoot_edit"),
  topCardContentContainerRoot: "".concat(PREFIX$6, "-topCardContentContainerRoot"),
  resultCardContentRoot: "".concat(PREFIX$6, "-resultCardContentRoot"),
  resultCardContentRoot_edit: "".concat(PREFIX$6, "-resultCardContentRoot_edit"),
  paper: "".concat(PREFIX$6, "-paper")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$3 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$6.root2), {
    //maxWidth: '472px',
    //padding: '8px',
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$6.media), {
    height: '110px'
  }), _defineProperty(_ref2, "& .".concat(classes$6.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$6.checkboxRoot), {
    verticalAlign: 'top',
    //margin: `auto ${theme.spacing(1.5)}`,
    //marginTop: theme.spacing(0),
    //marginTop: '3px',
    //marginLeft: '4px !important',
    marginTop: '-2px',
    //marginLeft:'8px',
    marginLeft: '10px',
    marginRight: '3px',
    padding: "0 !important",
    //paddingTop: '9px !important',
    //paddingBottom: '9px !important',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$6.checkboxRootColorfulPickup), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$6.checkboxRootDelivery), {
    marginRight: '-7px',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$6.checkboxRootColorfulDelivery), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$6.formControl), {
    backgroundColor: 'lightBlue'
  }), _defineProperty(_ref2, "& .".concat(classes$6.packingHoursEdit), {
    width: '64px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$6.timeEdit), {
    width: '92px',
    height: '24px',
    marginTop: '-1px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$6.timeView), {
    width: '92px',
    height: '24px',
    marginTop: '2px'
    //color: 'rgba(0, 0, 0, 0.54) !important'
  }), _defineProperty(_ref2, "& .".concat(classes$6.dayOfWeekEdit), {
    width: '80px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$6.shopTypeEdit), {
    paddingLeft: '8px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$6.expand), _defineProperty({
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    padding: 0,
    marginTop: '32px'
  }, "marginLeft", '4px')), _defineProperty(_ref2, "& .".concat(classes$6.expandOpen), {
    transform: 'rotate(180deg)',
    padding: 0,
    marginTop: '32px',
    marginLeft: '4px'
  }), _defineProperty(_ref2, "& .".concat(classes$6.topCardContentRoot), {
    //padding: 0,
    //margin: 0
    //paddingBottom: '17px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$6.topCardContentRoot_edit), {
    //paddingBottom: '8px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$6.topCardContentContainerRoot), {
    padding: 0,
    margin: 0
  }), _defineProperty(_ref2, "& .".concat(classes$6.resultCardContentRoot), {
    margin: 0,
    padding: 0,
    paddingBottom: '0 !important'
  }), _defineProperty(_ref2, "& .".concat(classes$6.resultCardContentRoot_edit), {
    margin: 0,
    padding: 0,
    paddingBottom: '0 !important'
  }), _defineProperty(_ref2, ".MuiCardContent-root", _defineProperty({}, "&:last-child", {
    //paddingBottom: '0 !important'
  })), _defineProperty(_ref2, "& .".concat(classes$6.paper), {/*
                                                            borderStyle: "solid",
                                                            borderWidth: theme.spacing(0.1),
                                                            borderColor: theme.custom.palette.itemBorderColor,
                                                            */
  }), _defineProperty(_ref2, ".MuiTable-root", {
    display: 'table',
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    minWidth: '0 !important'
  }), _defineProperty(_ref2, ".MuiCardContent-root", {
    padding: 0
  }), _ref2;
});
var ReportCard = function ReportCard(_ref3) {
  _ref3.actions;
    var condensed = _ref3.condensed,
    report = _ref3.report,
    _ref3$mode = _ref3.mode,
    mode = _ref3$mode === void 0 ? 'view' : _ref3$mode;
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext.selectedFeature;
  host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId()) : '/plugin/exchange/feature';
  var _useState = useState(!condensed),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useContext2 = useContext(Context$b),
    putReport = _useContext2.putReport,
    deleteReport = _useContext2.deleteReport;
  var changeReportContent = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(changed) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('report:');
            console.log(report);
            _context.next = 4;
            return putReport({
              id: report.id,
              content: _objectSpread2(_objectSpread2({}, report.content), changed)
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function changeReportContent(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var _React$useState = React.useState('list'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedView = _React$useState2[0],
    setSelectedView = _React$useState2[1];
  var handleChange = function handleChange(event, newView) {
    setSelectedView(newView);
  };
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  console.log('report:', report);
  var resourceItemUrl = (host().isMultiTenantName ? '/plugin/exchange/features/' + (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id) : '/plugin/exchange/feature') + "/reports/".concat(report.id);
  var cardImageDefault = 'https://images.unsplash.com/photo-1605712916066-e143c317df72?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2674&q=80';
  var cardImageAlbum = "spoketree/features/".concat(selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id, "/reports/").concat(report.id, "/photos/card");
  var cardImageQuery = 'business';
  return /*#__PURE__*/React.createElement(Root$3, {
    className: classes$6.root
  }, /*#__PURE__*/React.createElement(SpoketreeCard, {
    mode: mode,
    editable: selectedCapability.isEditable(),
    resourceType: "report",
    resourceObject: report,
    resourcePropertiesStrategy: 'content',
    putResource: putReport,
    deleteResource: deleteReport,
    resourceItemUrl: resourceItemUrl,
    resourceCollectionUrl: resourceCollectionUrl,
    resourceCreateUrl: resourceCreateUrl,
    cardImageDefault: cardImageDefault,
    cardImageAlbum: cardImageAlbum,
    cardImageQuery: cardImageQuery,
    ExtraCardcontent: function ExtraCardcontent(_ref5) {
      _ref5.getProperty;
        _ref5.setProperty;
        var isEditing = _ref5.isEditing;
      return mode !== 'list' && /*#__PURE__*/React.createElement(Stack, {
        direction: "column",
        spacing: 1
      }, isEditing() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'query',
        style: {
          float: 'left',
          width: '100%',
          /*width:'calc(100% - 96px)',*/paddingLeft: '0',
          paddingBottom: '8px'
        }
      }, /*#__PURE__*/React.createElement(Card, {
        style: {
          padding: '16px'
        },
        className: classes$6.root,
        elevation: 0,
        variant: "outlined"
      }, /*#__PURE__*/React.createElement(CardContent, {
        style: {
          /*backgroundColor:'#f8f8f8',*/width: '100%',
          marginBottom: '0px'
        },
        classes: {
          root: isEditing() ? classes$6.topCardContentRoot_edit : classes$6.topCardContentRoot
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: '#f0f0f0',
          margin: '-16px -16px 0',
          padding: '8px 8px 4px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        gutterBottom: true,
        variant: "h5",
        component: "h2",
        style: {
          color: '#444'
        }
      }, "Query")), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '8px -12px -8px',
          padding: '8px 8px 4px'
        }
      }, /*#__PURE__*/React.createElement(EditableText, {
        editable: isEditing(),
        editKey: 'query'
        //Icon={QueryIcon}
        //label={`Query`}
        ,
        inputLabel: "Query",
        value: typeof report.content.query === 'string' ? report.content.query : JSON.stringify(report.content.query),
        valueDisplayExpression: function valueDisplayExpression(json) {
          var result = '';
          if (json) {
            try {
              var query = JSON.parse(json);
              var filters = query.filters;
              if (filters !== null && filters !== void 0 && filters.length) {
                result = lodash.uniq(filters.map(function (filter) {
                  return filter.label;
                })).join(', ');
              }
            } catch (error) {
              result = error.message;
            }
          } else {
            result = '';
          }
          return result;
        },
        setValue: /*#__PURE__*/function () {
          var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(query) {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return changeReportContent({
                    query: query
                  });
                case 2:
                  return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref6.apply(this, arguments);
          };
        }(),
        dialogTitle: "".concat(report.content.query ? 'Change the' : 'Add a', " query")
        //tabLabel={`IAM User ID`}
        ,
        createValueInstruction: "Add a query",
        inputInstruction: "Type a query here",
        type: "pre",
        multiline: true
      })))))), /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'resultsView',
        style: {
          float: 'left',
          width: '100%',
          paddingTop: '8px',
          /*width:'calc(100% - 96px)',*/paddingLeft: '4px',
          paddingBottom: '0'
        }
      }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
        size: "small",
        value: selectedView,
        onChange: handleChange,
        exclusive: true,
        "aria-label": "Views"
      }, /*#__PURE__*/React.createElement(ToggleButton, {
        value: "table",
        key: "table"
      }, /*#__PURE__*/React.createElement(TableIcon, null)), /*#__PURE__*/React.createElement(ToggleButton, {
        value: "list",
        key: "list"
      }, /*#__PURE__*/React.createElement(ListIcon, null)))), /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        xs: true,
        style: {
          float: 'left',
          width: '100%',
          padding: 0,
          margin: 0
        }
      }, /*#__PURE__*/React.createElement(Grid$1, {
        container: true,
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Grid$1, {
        item: true,
        key: 'name',
        style: {
          float: 'left',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Card, {
        className: classes$6.root,
        elevation: 0,
        variant: "outlined",
        style: {
          marginTop: '8px'
        }
      }, /*#__PURE__*/React.createElement(CardContent, {
        style: {
          /*backgroundColor:'#f8f8f8',*/width: '100%',
          marginBottom: '0px'
        },
        classes: {
          root: isEditing() ? classes$6.resultCardContentRoot_edit : classes$6.resultCardContentRoot
        }
      }, selectedView === 'table' && /*#__PURE__*/React.createElement(ReportResultTable, {
        featureId: selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.getId(),
        report: report
      }), selectedView === 'list' && /*#__PURE__*/React.createElement(ReportResultList, {
        feature: selectedFeature,
        report: report
      })))))));
    }
    /*ExtraCardActions={mode === 'view' && (
      () => <>
        <Stack direction="row" spacing={1}>
        </Stack>
      </>
    )}*/
  }));
};

var PREFIX$5 = 'Item';
var classes$5 = {
  root: "".concat(PREFIX$5, "-root"),
  icon: "".concat(PREFIX$5, "-icon")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$2 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$5.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$5.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
var FeaturesReportsItem = (function (_ref3) {
  _ref3.page;
    _ref3.panel;
    _ref3.panelKey;
    _ref3.selectedPanelKey;
  var theme = useTheme$1();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedReportStore.Context),
    selectedReport = _useContext.selectedReport;
  useQueryParam('mode', 'view');
  return /*#__PURE__*/React.createElement(Root$2, null, selectedReport && /*#__PURE__*/React.createElement("div", {
    className: classes$5.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: 'report',
    style: {
      /*maxWidth:'472px',*/width: '100%',
      marginTop: '8px',
      marginBottom: '0'
    }
  }, /*#__PURE__*/React.createElement(ReportCard, {
    report: selectedReport,
    mode: "edit"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '400px'
    }
  })));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var CompositeSelectedReportProvider = (function (_ref) {
  var featureId = _ref.featureId,
    reportId = _ref.reportId,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, featureId && reportId && /*#__PURE__*/React.createElement(Provider$f, {
    featureId: featureId
  }, /*#__PURE__*/React.createElement(Provider$6, null, /*#__PURE__*/React.createElement(Provider$b, null, /*#__PURE__*/React.createElement(Provider$1, {
    reportId: reportId
  }, children)))));
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var FeaturesReportsItemProvider = (function (_ref) {
  var children = _ref.children,
    itemId = _ref.itemId,
    subitemId = _ref.subitemId;
  console.log('reports item provider');
  return /*#__PURE__*/React.createElement(CompositeSelectedReportProvider, {
    featureId: itemId,
    reportId: subitemId
  }, children);
});

var PREFIX$4 = 'PartyCard';
var classes$4 = {
  root: "".concat(PREFIX$4, "-root"),
  checked: "".concat(PREFIX$4, "-checked"),
  root2: "".concat(PREFIX$4, "-root2"),
  media: "".concat(PREFIX$4, "-media"),
  counterButtonWrapper: "".concat(PREFIX$4, "-counterButtonWrapper"),
  checkboxRoot: "".concat(PREFIX$4, "-checkboxRoot"),
  checkboxRootColorfulPickup: "".concat(PREFIX$4, "-checkboxRootColorfulPickup"),
  checkboxRootDelivery: "".concat(PREFIX$4, "-checkboxRootDelivery"),
  checkboxRootColorfulDelivery: "".concat(PREFIX$4, "-checkboxRootColorfulDelivery"),
  formControl: "".concat(PREFIX$4, "-formControl"),
  packingHoursEdit: "".concat(PREFIX$4, "-packingHoursEdit"),
  timeEdit: "".concat(PREFIX$4, "-timeEdit"),
  timeView: "".concat(PREFIX$4, "-timeView"),
  dayOfWeekEdit: "".concat(PREFIX$4, "-dayOfWeekEdit"),
  shopTypeEdit: "".concat(PREFIX$4, "-shopTypeEdit"),
  expand: "".concat(PREFIX$4, "-expand"),
  expandOpen: "".concat(PREFIX$4, "-expandOpen"),
  topCardContentRoot: "".concat(PREFIX$4, "-topCardContentRoot"),
  topCardContentRoot_edit: "".concat(PREFIX$4, "-topCardContentRoot_edit"),
  topCardContentContainerRoot: "".concat(PREFIX$4, "-topCardContentContainerRoot"),
  paper: "".concat(PREFIX$4, "-paper")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$4.root2), {
    maxWidth: '472px'
    //padding: '8px',
    //marginLeft: '8px',
    //marginRight: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$4.media), {
    height: '110px'
  }), _defineProperty(_ref2, "& .".concat(classes$4.counterButtonWrapper), {
    //    float: 'left'
    paddingTop: '8px'
  }), _defineProperty(_ref2, "& .".concat(classes$4.checkboxRoot), {
    verticalAlign: 'top',
    //margin: `auto ${theme.spacing(1.5)}`,
    //marginTop: theme.spacing(0),
    //marginTop: '3px',
    //marginLeft: '4px !important',
    marginTop: '-2px',
    //marginLeft:'8px',
    marginLeft: '10px',
    marginRight: '3px',
    padding: "0 !important",
    //paddingTop: '9px !important',
    //paddingBottom: '9px !important',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$4.checkboxRootColorfulPickup), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$4.checkboxRootDelivery), {
    marginRight: '-7px',
    color: '#2196f3 !important',
    //`${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",
      //"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    }
  }), _defineProperty(_ref2, "& .".concat(classes$4.checkboxRootColorfulDelivery), {
    marginTop: '-3px',
    marginRight: '-7px'
  }), _defineProperty(_ref2, "& .".concat(classes$4.formControl), {
    backgroundColor: 'lightBlue'
  }), _defineProperty(_ref2, "& .".concat(classes$4.packingHoursEdit), {
    width: '64px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$4.timeEdit), {
    width: '92px',
    height: '24px',
    marginTop: '-1px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800',
    textDecoration: 'none'
  }), _defineProperty(_ref2, "& .".concat(classes$4.timeView), {
    width: '92px',
    height: '24px',
    marginTop: '2px'
    //color: 'rgba(0, 0, 0, 0.54) !important'
  }), _defineProperty(_ref2, "& .".concat(classes$4.dayOfWeekEdit), {
    width: '80px',
    height: '24px',
    marginTop: '4px',
    //marginLeft: '4px',
    //marginRight: '4px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$4.shopTypeEdit), {
    paddingLeft: '8px',
    color: '#2196f3',
    fontWeight: '800'
  }), _defineProperty(_ref2, "& .".concat(classes$4.expand), _defineProperty({
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    padding: 0,
    marginTop: '32px'
  }, "marginLeft", '4px')), _defineProperty(_ref2, "& .".concat(classes$4.expandOpen), {
    transform: 'rotate(180deg)',
    padding: 0,
    marginTop: '32px',
    marginLeft: '4px'
  }), _defineProperty(_ref2, "& .".concat(classes$4.topCardContentRoot), {
    //padding: 0,
    //margin: 0
    //paddingBottom: '17px !important',
    marginRight: '16px',
    paddingTop: '0px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$4.topCardContentRoot_edit), {
    //paddingBottom: '8px !important',
    marginRight: '16px',
    paddingTop: '16px',
    paddingBottom: '0px !important'
  }), _defineProperty(_ref2, "& .".concat(classes$4.topCardContentContainerRoot), {
    padding: 0,
    margin: 0
  }), _defineProperty(_ref2, "& .".concat(classes$4.paper), {/*
                                                           borderStyle: "solid",
                                                           borderWidth: theme.spacing(0.1),
                                                           borderColor: theme.custom.palette.itemBorderColor,
                                                           */
  }), _ref2;
});

/*
const useStyles = makeStyles(theme => ({
  itemContainerWithBorder: {
    borderWidth: theme.spacing(0.1),
    borderStyle: "solid",
    //borderWidth: `${theme.spacing(0.1)} 0 ${theme.spacing(0.1)} 0`,
    borderWidth: theme.spacing(0.1),
    //borderColor: theme.palette.divider
    borderColor: theme.custom.palette.itemBorderColor,
  },
  itemContainerWithoutBorder: {
    //width:'100%',
    //borderStyle: "solid",
    //borderWidth: `${theme.spacing(0.1)} 0 ${theme.spacing(0.1)} 0`,
    //borderColor: "transparent"
  },
  itemWrapper: {
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    marginLeft: theme.spacing(2),
    //marginRight: theme.spacing(1),
    //minHeight: theme.spacing(4)
  },
  inputRoot: {
    //flex: 1
  },
  checkboxRoot: {
    verticalAlign: 'top',
    margin: `auto ${theme.spacing(1.5)}`,
    marginTop: theme.spacing(0),
    padding: "0 !important",
    color: `${theme.custom.palette.notesCheckbox} !important`,
    "&:hover": {
      color: "#1890ff !important",//"rgba(0, 0, 0, 0.87)",//"#ffffff",
      opacity: 1
    },
  },
  textEmpty: {
    // ...theme.custom.fontFamily.metropolis,
    fontWeight: 500,
    fontSize: "0.875rem",
    verticalAlign: "middle"
  },
  textIncomplete: {
    fontWeight: 400,
    fontSize: "0.875rem",
    verticalAlign: "middle"
  },
  textComplete: {
    //textDecoration: "line-through",
    //textDecorationColor: theme.palette.text.primary,
    fontWeight: 400,
    fontSize: "0.875rem",
    verticalAlign: "middle"
  },
  closeButtonWrapper: {
    verticalAlign:'top',
    margin: "auto 0",
  },
  linkRoot: {
    //flex: 1,
    //textDecoration: "line-through",
    //textDecorationColor: "#1890ff !important",//theme.palette.text.primary,
    '&:hover': {
      color: "#1890ff !important",//theme.palette.text.primary,
      textDecoration: 'none !important'
    },
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: "0.875rem",
    verticalAlign: "middle",
    cursor: "pointer"
  },
  '&:hover': {
    color: "#1890ff !important",//theme.palette.text.primary,
    textDecoration: 'none'
  },
  linkFirst: {
    //textDecoration: "underline",
    //textDecorationColor: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: "0.875rem",
    verticalAlign: "middle",
    color: `${theme.palette.text.secondary} !important`,
  },
  linkFirstComplete: {
    //textDecoration: "line-through",
    //textDecorationColor: theme.palette.text.primary,
    color: `${theme.palette.text.primary} !important`,
    fontWeight: 500,
    fontSize: "0.875rem",
    verticalAlign: "middle"
  },
  textTopLeft: {
    textDecoration: "none",
    textDecorationColor: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "0.875rem",//"1.125rem",//"0.875rem",
    verticalAlign: "top",
    color: `${theme.palette.text.primary} !important`,
    opacity:0.95,
    marginLeft: '8px',
    marginTop: '8px',
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap', 
    overflow: 'hidden',
    maxWidth: '200px'
  },
  textBottomLeft: {
    textDecoration: "none",
    textDecorationColor: theme.palette.text.primary,
    fontWeight: 300,
    fontSize: "2.5rem",//"0.675rem",
    verticalAlign: "top",
    color: `${theme.palette.text.primary} !important`,
  },
  textBottomRight: {
    //textDecoration: "none",
    //textDecorationColor: theme.palette.text.primary,
    fontWeight: 300,
    fontSize: "0.675rem",
    verticalAlign: "top",
    color: `${theme.palette.text.primary} !important`,
    //marginTop: '6px'
  },
  counterButtonWrapper: {
    float: 'left'
  },
  itemPartWrapper: {
    float: 'left'
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  quantityButtonsWrapper: {
    display: "flex",
    flexDirection: "row",
    flexWrap: 'nowrap',
    //display: 'inline-block',
    width: '100%',
    //minWidth: '160px'
    //marginBottom: "-8px"
  },
  avatar: {
    float: 'left',
    //width: theme.spacing(2),
    //height: theme.spacing(2),
    //marginRight: '8px'
  },
  chipWarning: {
    // ...theme.custom.fontFamily.metropolis,
    fontSize: theme.typography.overline.fontSize,
    color: '#efefef',
    backgroundColor: theme.palette.warning.main,//theme.custom.palette.labelBackground
    opacity: 0.5,
    fontWeight:600
  },
  chipInfo: {
    // ...theme.custom.fontFamily.metropolis,
    fontSize: theme.typography.overline.fontSize,
    color: '#efefef',
    backgroundColor: theme.palette.secondary.main,//theme.custom.palette.labelBackground
    opacity: 0.75,
    fontWeight:600
  }
}));
*/

function JoinContentList (_ref) {
  var joins = _ref.joins;
  var makeList = function makeList(joins) {
    var list = joins.sort()
    //.filter(({ content }) => !!content)
    .map(function (join) {
      return {
        text: [/* topLeft */join.partyId, /* bottomLeft */'', /* bottomRight */'', /* topRight */''],
        data: {
          join: join
        }
      };
    });
    return list;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, joins && /*#__PURE__*/React.createElement(List, {
    sx: {
      width: '100%',
      maxWidth: 360,
      bgcolor: 'background.paper'
    }
  }, makeList(joins).map(function (_ref2, index) {
    var _ref2$text = _slicedToArray(_ref2.text, 4);
      _ref2$text[0];
      _ref2$text[1];
      _ref2$text[2];
      _ref2$text[3];
      var join = _ref2.data.join;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem$1, {
      key: index
    }, /*#__PURE__*/React.createElement(ListItemAvatar$1, null, /*#__PURE__*/React.createElement(Avatar, null, /*#__PURE__*/React.createElement(PersonIcon, null))), /*#__PURE__*/React.createElement(ListItemText$1, {
      primary: 'User',
      secondary: join.partyId
    })), joins.length != index + 1 && /*#__PURE__*/React.createElement(Divider, {
      key: "divider-".concat(index),
      variant: "inset",
      component: "li"
    }));
  })));
}

/*
function ContentListItem({
  index,
  topLeft,
  bottomLeft,
  bottomRight,
  topRight,
  isChecked,
  product,
  ordered,
  onCheck
}) {
  const classes = useStyles();
  //const theme = useTheme();
  //const [isFocussed, setFocussed] = useState(false);
  const [isHovered, setHovered] = useState(false);

  const [open, setOpen] = useState(false);
  const openDialog = (e) => {
    e.preventDefault();
    console.log('openDialog');
    setOpen(true);
  };
  const handleClose = () => {
    console.log('handleClose');
    setOpen(false);
  };
  //const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>{
      <Paper 
        //elevation={isHovered || isEditMode ? 4 : 2}
        style={{height:`${ITEM_IMAGE_HEIGHT}px`,marginTop: '8px'}}
        className={classes.itemContainerWithBorder
          //isFocussed
            //? classes.itemContainerWithBorder
            //: classes.itemContainerWithoutBorder
        }
        //onMouseEnter={() => setHovered(true)}
        //onMouseLeave={() => setHovered(false)}
      >
        <ClickAwayListener onClickAway={isEditMode ? (() => onAfterEdit()) : () => { }}>
          <div 
            //style={{backgroundColor:"rgba(183, 165, 141, 0.15)"}}
          >
            <div className={classes.itemWrapper} style={{marginLeft:0}}>
              <div className={classes.quantityButtonsWrapper}>
                <div 
                  className={classes.counterButtonWrapper}
                  style={{width:'100%',marginRight:'6px',marginTop:'2px'}}
                  >
                  <Grid container direction="column" justifyContent="flex-start" alignItems="stretch" style={{height:'100%'}}>
                    <Grid item>
                      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
                        <Grid item style={{float:'left',width:'50%'}}>
                          <HashLink style={{cursor:'pointer',textDecoration:'none'}} variant="body2" color="textPrimary" onClick={openDialog} to="#card">
                            <Typography className={classes.textTopLeft}>{ topLeft }</Typography>
                          </HashLink>
                        </Grid>
                        {
                        //<Grid item style={{flexGrow:1}} /><Grid item style={{float:'right',padding:0,marginTop:'-2px',marginRight:`0px`}}>{topRight}</Grid>
                        }
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" style={{height:'18px'}}>
                        <Grid item style={{float:'left',marginLeft:'4px'}}>
                          {(typeof bottomLeft === 'string') ? (
                            <Typography className={classes.textBottomLeft}>{ bottomLeft }</Typography>
                          ) : (
                            <div style={{marginLeft:'4px'}}>{bottomLeft}</div>
                          )}
                        </Grid>
                        {
                        //<Grid item style={{flexGrow:1}} /><Grid item style={{float:'right',padding:0,marginTop:'-4px',marginRight:'-4px'}}>{bottomRight}</Grid>
                        }
                      </Grid>
                    </Grid>
                    <Grid item style={{flexGrow:1}} />
                    {<>
                      <Grid item>
                        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
                          <Grid item style={{flexGrow:1}} />
                          <Grid item style={{float:'right',padding:0,marginTop: product?.content?.quantityAvailable > 0 ? '10px' : '-2px',marginRight:`0px`}}>
                            {topRight}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" style={{height:'18px',marginBottom:'8px',marginLeft:'2px'}}>
                          {
                          //<Grid item style={{float:'left',marginLeft:'4px'}}>{(typeof bottomLeft === 'string') ? (<Typography className={classes.textBottomLeft}>{ bottomLeft }</Typography>) : (bottomLeft)}</Grid>
                          }
                          <Grid item style={{flexGrow:1}} />
                          <Grid item style={{float:'right',padding:0,marginTop:'-4px',marginRight:'-4px'}}>
                            {bottomRight}
                          </Grid>
                        </Grid>
                      </Grid>
                    </>}
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </Paper>
    }</>
  );
}
*/

var PREFIX$3 = 'JoinsListView';
var classes$3 = {
  wrapper: "".concat(PREFIX$3, "-wrapper"),
  textTitle: "".concat(PREFIX$3, "-textTitle"),
  barWrapper: "".concat(PREFIX$3, "-barWrapper")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root$1 = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$3.wrapper), {
    display: "flex",
    flexDirection: "column",
    //borderColor: theme.custom.palette.itemBorderColor,
    //borderWidth: theme.spacing(0.1),
    //borderStyle: "solid"
    border: 0
  }), _defineProperty(_ref2, "& .".concat(classes$3.textTitle), {
    // ...theme.custom.fontFamily.metropolis,
    padding: theme.spacing(0, 2, 0, 2),
    fontWeight: 500,
    fontSize: "1rem",
    color: theme.palette.text.primary,
    lineHeight: theme.spacing(0.18)
  }), _defineProperty(_ref2, "& .".concat(classes$3.barWrapper), {
    display: "flex",
    flexDirection: "row",
    padding: theme.spacing(1, 2),
    justifyContent: "space-between"
  }), _ref2;
});
function JoinsListView (_ref3) {
  var list = _ref3.list;
    _ref3.selectedPanelId;
    _ref3.setSelectedPanelId;
  //const theme = useTheme();
  var initialExpanded = true;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(initialExpanded),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  return /*#__PURE__*/React.createElement(Root$1, {
    className: classes$3.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    key: "reports",
    style: {
      width: '100%',
      minWidth: '232px',
      maxWidth: '472px' /*,marginLeft:'8px',marginRight:'8px'*/,
      marginTop: '8px',
      marginBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement(Card, {
    style: {
      padding: '0'
    },
    className: classes$3.root,
    elevation: 0,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(CardContent, {
    style: {
      /*backgroundColor:'#f8f8f8',*/width: '100%',
      marginBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#f0f0f0',
      margin: '-16px -16px 0',
      padding: '8px 8px 4px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    gutterBottom: true,
    variant: "h5",
    component: "h2",
    style: {
      color: 'rgba(0, 0, 0, 0.44)'
    }
  }, list.title)), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '8px -12px -8px',
      padding: '8px 10px 0px'
    }
  }, /*#__PURE__*/React.createElement(JoinContentList, {
    joins: list.joins
  })))))));
}

var PREFIX$2 = 'Sharing';
var classes$2 = {
  root: "".concat(PREFIX$2, "-root"),
  icon: "".concat(PREFIX$2, "-icon")
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = styled('div')(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes$2.root), {
    //width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  }), _defineProperty(_ref2, "& .".concat(classes$2.icon), {
    color: 'rgba(255, 255, 255, 0.54)'
  }), _ref2;
});
function Alert(props) {
  return /*#__PURE__*/React.createElement(MuiAlert /*elevation={6}*/, _extends({
    variant: "filled"
  }, props));
}
var Row = styled(Paper)(function (_ref3) {
  var theme = _ref3.theme;
  return _objectSpread2(_objectSpread2({
    border: 0
  }, theme.typography.body2), {}, {
    //padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    boxShadow: 'none',
    textAlign: 'left'
  });
});
var FeaturesSharing = (function (_ref4) {
  var _selectedFeature$getE, _selectedFeature$getE2;
  _ref4.page;
    _ref4.panel;
    _ref4.panelKey;
    _ref4.selectedPanelKey;
  var theme = useTheme$1();
  useMediaQuery$1(theme.breakpoints.down('sm'));
  var _useContext = useContext(SelectedFeatureStore.Context),
    selectedFeatureId = _useContext.selectedFeatureId,
    selectedFeature = _useContext.selectedFeature;
  var _useContext2 = useContext(FeaturesStore.Context),
    createGrant = _useContext2.createGrant;
    _useContext2.createViewerRequest;
  useQueryParam('mode', 'view');
  useMediaQuery$1(theme.breakpoints.down('md'));
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeRoleAlias = _useState2[0],
    setActiveRoleAlias = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    createGrantDialogVisible = _useState4[0],
    setCreateGrantDialogVisible = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    grantedPartyId = _useState6[0],
    setGrantedPartyId = _useState6[1];
  var handleClickCreateGrant = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, roleAlias) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            createGrant({
              roleAlias: roleAlias,
              featureId: selectedFeatureId,
              partyId: grantedPartyId
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleClickCreateGrant(_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  useRef(null);
  var standardRoles = [{
    alias: 'r_creator',
    name: 'Creators'
  }, {
    alias: 'r_owner',
    name: 'Owners'
  }, {
    alias: 'r_viewer',
    name: 'Viewers',
    showAddButton: true
  }];
  var extensionRoles = selectedFeature !== null && selectedFeature !== void 0 && (_selectedFeature$getE = selectedFeature.getExtensions()) !== null && _selectedFeature$getE !== void 0 && (_selectedFeature$getE = _selectedFeature$getE.at(0)) !== null && _selectedFeature$getE !== void 0 && _selectedFeature$getE.roles ? selectedFeature === null || selectedFeature === void 0 || (_selectedFeature$getE2 = selectedFeature.getExtensions()) === null || _selectedFeature$getE2 === void 0 || (_selectedFeature$getE2 = _selectedFeature$getE2.at(0)) === null || _selectedFeature$getE2 === void 0 || (_selectedFeature$getE2 = _selectedFeature$getE2.roles) === null || _selectedFeature$getE2 === void 0 ? void 0 : _selectedFeature$getE2.map(function (role) {
    return _objectSpread2(_objectSpread2({}, role), {}, {
      showAddButton: true
    });
  }) : [];
  console.log(standardRoles);
  console.log(extensionRoles);
  var roles = [].concat(standardRoles, _toConsumableArray(extensionRoles));
  console.log('ROLES');
  console.log(roles);
  return (
    /*#__PURE__*/
    /*!selectedFeature || (selectedFeature.isEditable() || selectedFeature.isViewable()) && */
    React.createElement(Root, null, selectedFeature && (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && /*#__PURE__*/React.createElement("div", {
      className: classes$2.root,
      style: {
        width: '100%',
        marginTop: '0px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes$2.root,
      style: {
        width: '100%',
        marginTop: '0px'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      style: {
        width: '100%',
        maxWidth: '472px',
        paddingTop: '0px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      //}
      style: {
        //  columns: columnWidth + ' ' + (isListView ? 1 : numberOfColumns),
        width: '100%' //width
      }
    }, /*#__PURE__*/React.createElement(Stack$2, null, roles === null || roles === void 0 ? void 0 : roles.map(function (role) {
      var _selectedFeature$getJ;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack$2, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(JoinsListView, {
        list: {
          title: role.name ? role.name : function (s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
          }("".concat(role.alias.split('_')[1], "s")),
          joins: selectedFeature === null || selectedFeature === void 0 || (_selectedFeature$getJ = selectedFeature.getJoins()) === null || _selectedFeature$getJ === void 0 ? void 0 : _selectedFeature$getJ.filter(function (join) {
            return join.roleAlias === role.alias;
          })
        }
      })), role.showAddButton && /*#__PURE__*/React.createElement(Row, null, selectedFeature && (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isEditable()) && /*#__PURE__*/React.createElement(SpoketreeButton, {
        classes: {
          root: classes$2.actionButtonRoot,
          label: classes$2.actionButtonText
        },
        className: classes$2.action,
        style: {
          marginTop: '8px',
          marginRight: '8px'
        } //, fontWeight:800
        ,
        color: "secondary",
        size: "small",
        variant: "outlined",
        "aria-label": "create-exchange-feature",
        onClick: function onClick() {
          setActiveRoleAlias(role.alias);
          setCreateGrantDialogVisible(true);
        }
      }, /*#__PURE__*/React.createElement(PersonAddAltIcon, null), /*#__PURE__*/React.createElement("span", {
        style: {
          minWidth: '4px'
        }
      }), "Add ", role.alias.substr(2)))));
    }))))), /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '400px'
      }
    }))), selectedFeature && !(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isEditable()) && (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.isViewable()) && /*#__PURE__*/React.createElement("div", {
      className: classes$2.root,
      style: {
        width: '100%',
        marginTop: '8px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes$2.root,
      style: {
        width: '100%',
        marginTop: '0px'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      style: {
        width: '100%',
        maxWidth: '472px',
        paddingTop: '0px'
      }
    }, /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: 'review_alert',
      style: {
        float: 'left',
        width: '100%',
        /*width:'calc(100% - 96px)',*/paddingLeft: '0',
        marginTop: '0px',
        paddingTop: '0px',
        paddingBottom: '0px'
      }
    }, /*#__PURE__*/React.createElement(Alert, {
      severity: "success",
      variant: "outlined",
      style: {
        width: '100%'
      }
    }, "You have permission to view this Exchange")))))), false  , createGrantDialogVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SpoketreeDialog, {
      isVisible: createGrantDialogVisible,
      setIsVisible: setCreateGrantDialogVisible,
      title: "Add ".concat(activeRoleAlias.substr(2)),
      content: {
        text: "Grant the ".concat(activeRoleAlias.substr(2), " role to a user"),
        body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '8px',
            marginBottom: '8px'
          }
        }, /*#__PURE__*/React.createElement(EditableTextField, {
          Icon: PersonIcon,
          label: 'User ID',
          placeholder: 'Enter a Spoketree User ID',
          value: grantedPartyId,
          setValue: setGrantedPartyId,
          autoFocus: true,
          autoComplete: "off"
        }))))
      },
      buttons: ["Cancel", _defineProperty({}, "Add ".concat(lodash.startCase(activeRoleAlias.substr(2))), function () {
        var _Add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                handleClickCreateGrant(e, activeRoleAlias);
              case 1:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function Add(_x4) {
          return _Add.apply(this, arguments);
        }
        return Add;
      }())]
    })))
  );
});

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
//import _ from 'lodash';
var features = {
  FeaturesCollection: Collection$4,
  FeaturesCreate: FeaturesCreate,
  FeaturesItemFloating: FloatingActionButtons,
  FeaturesItemProvider: FeaturesItemProvider,
  FeaturesItemHeader: FeaturesItemHeader,
  FeaturesPropertiesSummary: FeaturesPropertiesSummary,
  FeaturesPropertiesDetail: FeaturesPropertiesDetail,
  FeaturesExtensionsCollection: Collection$3,
  FeaturesExtensionsCreate: FeaturesExtensionsCreate,
  FeaturesExtensionsItem: FeaturesExtensionsItem,
  FeaturesExtensionsItemProvider: FeaturesExtensionsItemProvider,
  FeaturesScenariosCollection: Collection$2,
  FeaturesScenariosCreate: FeaturesScenariosCreate,
  FeaturesScenariosItem: FeaturesScenariosItem,
  FeaturesScenariosItemProvider: FeaturesScenariosItemProvider,
  FeaturesSolutionsCollection: Collection$1,
  FeaturesSolutionsCreate: FeaturesSolutionsCreate,
  FeaturesSolutionsItem: FeaturesSolutionsItem,
  FeaturesSolutionsItemProvider: FeaturesSolutionsItemProvider,
  FeaturesReportsCollection: Collection,
  FeaturesReportsCreate: FeaturesReportsCreate,
  FeaturesReportsItem: FeaturesReportsItem,
  FeaturesReportsItemProvider: FeaturesReportsItemProvider,
  FeaturesSharing: FeaturesSharing
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var _pages = {
  terms_of_service: terms_of_service,
  features: features
};

var _excluded = ["children", "value", "index"];
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function TabPanel(props) {
  var children = props.children,
    value = props.value,
    index = props.index,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: "simple-tabpanel-".concat(index),
    "aria-labelledby": "simple-tab-".concat(index)
  }, other, {
    style: {
      width: '100%'
    }
  }), value === index && children
  /*<Box p={3}>
    <Typography>{children}</Typography>
  </Box>*/);
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};
function a11yProps(index) {
  return {
    id: "simple-tab-".concat(index),
    'aria-controls': "simple-tabpanel-".concat(index)
  };
}
var PageTabs = function PageTabs(_ref) {
  var _ref$fixed = _ref.fixed,
    fixed = _ref$fixed === void 0 ? true : _ref$fixed,
    value = _ref.value,
    onChange = _ref.onChange,
    page = _ref.page,
    pageKey = _ref.pageKey,
    panels = _ref.panels;
  var _useContext = useContext(Context$l),
    isAuthenticated = _useContext.isAuthenticated;
  var principalParty = useContext(PrincipalPartyStore.Context);
  var _useContext2 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext2.selectedFeature;
  //const { cartTotal } = useContext(CartStore.Context);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    style: {
      width: '100%',
      //maxWidth: '472px',
      position: fixed ? 'fixed' : undefined,
      top: fixed ? 48 : undefined,
      //marginLeft:'8px',
      //marginRight:'8px',
      margin: 0,
      background: '#fefefefe',
      zIndex: 2000
    },
    value: value,
    onChange: onChange,
    "aria-label": "top tabs",
    variant: "scrollable",
    scrollButtons: "auto",
    indicatorColor: "secondary",
    textColor: "secondary"
  }, Object.entries(panels).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2);
      _ref3[0];
      var deny = _ref3[1].deny;
    return !deny || !deny({
      isAuthenticated: isAuthenticated,
      principalParty: principalParty,
      selectedFeature: selectedFeature
    });
  }).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2);
      _ref5[0];
      var tab = _ref5[1].tab;
    return !!tab;
  }).map(function (_ref6, index) {
    var _ref7 = _slicedToArray(_ref6, 2),
      panelKey = _ref7[0],
      _ref7$1$tab = _ref7[1].tab,
      icon = _ref7$1$tab.icon,
      title = _ref7$1$tab.title;
    return /*#__PURE__*/React.createElement(Tab, _extends({
      icon: icon ? typeof icon === 'function' ? icon({
        principalParty: principalParty,
        cartTotal: cartTotal
      }) : icon : function (i) {
        return i ? i({}) : undefined;
      }(page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "TabIcon")]),
      label: title && /*#__PURE__*/React.createElement(Typography$1, {
        style: {
          fontSize: '11px'
        }
      }, typeof title === 'string' ? title : title({
        principalParty: principalParty,
        cartTotal: cartTotal
      }))
    }, a11yProps(panelKey), {
      key: panelKey,
      value: panelKey
      //style={{marginLeft:!index ? '-16px' : undefined}}
      ,
      style: {
        minWidth: '80px'
      }
    }));
  })));
};
var PagePanels = function PagePanels(_ref8) {
  var _ref8$fixed = _ref8.fixed,
    fixed = _ref8$fixed === void 0 ? true : _ref8$fixed,
    value = _ref8.value;
    _ref8.setValue;
    var pageKey = _ref8.pageKey,
    page = _ref8.page,
    panels = _ref8.panels;
    _ref8.pagePath;
    var itemId = _ref8.itemId;
    _ref8.Template;
    var AuthenticatedRoute = _ref8.AuthenticatedRoute;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
    _useLocation.search;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      /*maxWidth:'472px',*/marginTop: fixed ? '112px' : undefined,
      paddingTop: '8px',
      marginLeft: '8px',
      marginRight: '8px'
    }
  }, Object.entries(panels).map(function (_ref9, index) {
    var _ref10 = _slicedToArray(_ref9, 2),
      panelKey = _ref10[0];
      _ref10[1].icon;
    return /*#__PURE__*/React.createElement("div", {
      key: panelKey
    }, /*#__PURE__*/React.createElement(React.Fragment, null, page["".concat(capitalize(pageKey)).concat(capitalize(panelKey))] && (panels[panelKey].expanded || value === panelKey) && /*#__PURE__*/React.createElement(PanelContent, {
      page: page,
      panel: panels[panelKey],
      panelKey: panelKey,
      selectedPanelKey: value,
      PanelComponent: page["".concat(capitalize(pageKey)).concat(capitalize(panelKey))]
    })), /*#__PURE__*/React.createElement(React.Fragment, null, page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "Summary")] && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabPanel, _extends({
      value: value,
      index: panelKey
    }, a11yProps(index), {
      key: panelKey
    }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        float: 'left',
        width: '100%',
        marginTop: '0px'
      }
    }, /*#__PURE__*/React.createElement(PanelContent, {
      panelKey: panelKey,
      selectedPanelKey: value,
      page: page,
      panel: panels[panelKey],
      PanelComponent: page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "Detail")]
    }))))))), /*#__PURE__*/React.createElement(React.Fragment, null, page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "Collection")] && (panels[panelKey].expanded || value === panelKey) && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        float: 'left',
        width: '100%',
        marginTop: '0px'
      }
    }, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
      path: "/",
      key: "page-".concat(pageKey, "-collection"),
      element: /*#__PURE__*/React.createElement(PanelContent, {
        page: page,
        panel: panels[panelKey],
        panelKey: panelKey,
        selectedPanelKey: value,
        PanelComponent: page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "Collection")]
      })
    }), /*#__PURE__*/React.createElement(Route, {
      path: "create",
      key: "page-".concat(pageKey, "-").concat(itemId, "-").concat(panelKey, "-create"),
      element: /*#__PURE__*/React.createElement(AuthenticatedRoute, {
        key: "auth-page-".concat(pageKey, "-").concat(itemId, "-").concat(panelKey, "-create")
      }, /*#__PURE__*/React.createElement(PanelContent, {
        page: page,
        panelKey: '[create-page-panel] ' + pageKey + ":" + panelKey,
        PanelComponent: page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "Create")]
      }))
    }), /*#__PURE__*/React.createElement(Route, {
      path: ":subitemId",
      key: "page-".concat(pageKey, "-").concat(itemId, "-").concat(panelKey, "-item"),
      element: function () {
        var subitemId = _.split(pathname, '/').pop();
        var ItemProvider = page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "ItemProvider")];
        if (!ItemProvider) {
          console.log("Provider not defined: ".concat(capitalize(pageKey)).concat(capitalize(panelKey), "ItemProvider"));
        }
        var content = /*#__PURE__*/React.createElement(PanelContent, {
          page: page,
          panelKey: '[page-panel] ' + pageKey + ":" + panelKey,
          PanelComponent: page["".concat(capitalize(pageKey)).concat(capitalize(panelKey), "Item")]
        });
        return ItemProvider ? /*#__PURE__*/React.createElement(ItemProvider, {
          itemId: itemId,
          subitemId: subitemId
        }, content) : content;
      }()
    }))))));
  }));
};
var PanelContent = function PanelContent(_ref11) {
  var page = _ref11.page,
    panel = _ref11.panel,
    panelKey = _ref11.panelKey,
    selectedPanelKey = _ref11.selectedPanelKey,
    PanelComponent = _ref11.PanelComponent;
  return !!PanelComponent ? /*#__PURE__*/React.createElement(PanelComponent, {
    page: page,
    panel: panel,
    panelKey: panelKey,
    selectedPanelKey: selectedPanelKey
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: '8px'
    }
  }, "Panel component not defined: ".concat(panelKey));
};
var PluginRoutes = function PluginRoutes(_ref12) {
  var plugin = _ref12.plugin,
    AuthenticatedRoute = _ref12.AuthenticatedRoute;
    _ref12.UnauthenticatedRoute;
    _ref12.AuthPage;
    var Template = _ref12.Template;
  var _useLocation2 = useLocation(),
    pathname = _useLocation2.pathname,
    search = _useLocation2.search;
  var _useContext3 = useContext(Context$l);
    _useContext3.isAuthenticated;
  var principalParty = useContext(PrincipalPartyStore.Context);
  var _useContext4 = useContext(SelectedFeatureStore.Context),
    selectedFeature = _useContext4.selectedFeature;
  var pluginPath = '/plugin/exchange';
  var pages = plugin.pages({
    path: pluginPath,
    principalParty: principalParty,
    selectedFeature: selectedFeature
  });
  console.log('pathname: ' + pathname);
  console.log('pluginPath: ' + pluginPath);
  var mode = useQueryParam('mode', 'view');
  console.log('mode: ' + mode);
  return mode ? /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    key: "pages-default",
    element: /*#__PURE__*/React.createElement(Navigate, {
      replace: true,
      to: "".concat(Object.entries(pages)[0][0]).concat(search)
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":pageKey/*" // e.g. /plugin/community/user/PANEL
    ,
    element: /*#__PURE__*/React.createElement(PageConnector, {
      pages: pages,
      AuthenticatedRoute: AuthenticatedRoute,
      Template: Template
    })
  })) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
var PageConnector = function PageConnector(_ref13) {
  var pages = _ref13.pages,
    AuthenticatedRoute = _ref13.AuthenticatedRoute,
    Template = _ref13.Template;
  var _useParams = useParams(),
    pageKey = _useParams.pageKey;
  var _useLocation3 = useLocation(),
    pathname = _useLocation3.pathname,
    search = _useLocation3.search;
  var page = pages[pageKey];
  console.log(page);
  if (page) {
    var access = page.access,
      deny = page.deny,
      collection = page.collection,
      topPanels = page.panels;
    var pagePath = pageKey;
    var PageContainer = access === 'l_protected' ? function (_ref14) {
      var children = _ref14.children;
      return /*#__PURE__*/React.createElement(AuthenticatedRoute, null, children);
    } : function (_ref15) {
      var children = _ref15.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    };
    console.log('page: ');
    console.log(page);
    console.log(PageContainer);
    return /*#__PURE__*/React.createElement(PageContainer, null, (!deny || deny({
      isAuthenticated: isAuthenticated,
      selectedFeature: selectedFeature
    })) && (collection ? /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
      path: "/",
      key: "page-".concat(pageKey, "-collection"),
      element: /*#__PURE__*/React.createElement(Template
      //appBar={}
      , {
        pageContent: /*#__PURE__*/React.createElement(PanelContent, {
          page: page,
          panelKey: '[page] ' + pageKey,
          PanelComponent: _pages[pageKey]["".concat(capitalize(pageKey), "Collection")]
        })
      })
    }), /*#__PURE__*/React.createElement(Route, {
      path: "create",
      key: "page-".concat(pageKey, "-panels-create"),
      element: /*#__PURE__*/React.createElement(AuthenticatedRoute, null, /*#__PURE__*/React.createElement(Template
      //appBar={<ShopBar />}
      , {
        pageContent: /*#__PURE__*/React.createElement("div", {
          style: {
            width: 'calc(100% - 16px)',
            marginLeft: '8px'
          }
        }, /*#__PURE__*/React.createElement(PanelContent, {
          page: page,
          panelKey: '[create-page] ' + pageKey,
          PanelComponent: _pages[pageKey]["".concat(capitalize(pageKey), "Create")]
        }))
      }))
    }), /*#__PURE__*/React.createElement(Route, {
      path: ":itemId",
      key: "page-".concat(pageKey, "-panels-default"),
      element: /*#__PURE__*/React.createElement(Navigate, {
        replace: true,
        to: "".concat(pathname, "/").concat(Object.entries(collection.item.panels).filter(function (_ref16) {
          var _ref17 = _slicedToArray(_ref16, 2);
            _ref17[0];
            var item = _ref17[1];
          return !(item !== null && item !== void 0 && item.mode) || !mode && (item === null || item === void 0 ? void 0 : item.mode) === 'view' || (item === null || item === void 0 ? void 0 : item.mode) === mode;
        })[0][0]).concat(search)
      })
    }), /*#__PURE__*/React.createElement(Route, {
      path: ":itemId/:childPanelKey/*",
      element: /*#__PURE__*/React.createElement(ChildPanelConnector, {
        AuthenticatedRoute: AuthenticatedRoute,
        pagePath: pagePath,
        pageKey: pageKey,
        childPanels: collection.item.panels,
        Template: Template
      })
    })) : /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
      path: "/",
      key: "page-".concat(pageKey, "-panels-default"),
      element: topPanels ? /*#__PURE__*/React.createElement(Navigate, {
        replace: true,
        to: "".concat(Object.entries(topPanels).filter(function (_ref18) {
          var _ref19 = _slicedToArray(_ref18, 2);
            _ref19[0];
            var item = _ref19[1];
          return !(item !== null && item !== void 0 && item.mode) || !mode && (item === null || item === void 0 ? void 0 : item.mode) === 'view' || (item === null || item === void 0 ? void 0 : item.mode) === mode;
        })[0][0]).concat(search)
      }) : /*#__PURE__*/React.createElement(Template
      //appBar={<ShopBar />}
      , {
        pageContent: /*#__PURE__*/React.createElement("div", {
          style: {
            width: 'calc(100% - 16px)',
            marginLeft: '8px'
          }
        }, /*#__PURE__*/React.createElement(PanelContent, {
          page: page,
          panelKey: '[no-panels-page] ' + pageKey,
          PanelComponent: _pages[pageKey]
        }))
      })
    }), /*#__PURE__*/React.createElement(Route, {
      path: ":topPanelKey/*" // e.g. /plugin/exchange/features/f_567p8d/properties
      ,
      element: /*#__PURE__*/React.createElement(TopPanelConnector, {
        pagePath: pagePath,
        pageKey: pageKey,
        topPanels: topPanels,
        Template: Template
      })
    }))));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, "Welcome to Spoketree"), /*#__PURE__*/React.createElement("p", null, "Page not found"));
  }
};
var ChildPanelConnector = function ChildPanelConnector(_ref20) {
  var AuthenticatedRoute = _ref20.AuthenticatedRoute,
    pagePath = _ref20.pagePath,
    pageKey = _ref20.pageKey,
    childPanels = _ref20.childPanels,
    Template = _ref20.Template;
  var _useParams2 = useParams(),
    itemId = _useParams2.itemId,
    childPanelKey = _useParams2.childPanelKey;
  var _useLocation4 = useLocation();
    _useLocation4.pathname;
    _useLocation4.search;
  var navigate = useNavigate();
  var panels = Object.fromEntries(Object.entries(childPanels).filter(function (_ref21) {
    var _ref22 = _slicedToArray(_ref21, 2);
      _ref22[0];
      var item = _ref22[1];
    return !(item !== null && item !== void 0 && item.mode) || (item === null || item === void 0 ? void 0 : item.mode) === mode;
  }));
  var ItemProvider = _pages[pageKey]["".concat(capitalize(pageKey), "ItemProvider")];
  var ItemHeader = _pages[pageKey]["".concat(capitalize(pageKey), "ItemHeader")];
  //const ItemFloating = _pages[pageKey][`${capitalize(pageKey)}ItemFloating`];
  var itemComponent = /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: '16px'
    }
  }, /*#__PURE__*/React.createElement(PageTabs, {
    value: childPanelKey,
    onChange: function onChange(event, newValue) {
      navigate("/plugin/exchange/".concat(pagePath, "/").concat(itemId, "/").concat(newValue));
    },
    pageKey: pageKey,
    page: _pages[pageKey],
    panels: panels
  }), ItemHeader && /*#__PURE__*/React.createElement(ItemHeader, {
    itemId: itemId
  }), /*#__PURE__*/React.createElement(PagePanels, {
    pagePath: pagePath,
    itemId: itemId,
    value: childPanelKey,
    setValue: function setValue(value) {
      navigate(value ? "/plugin/exchange/".concat(pagePath, "/").concat(itemId, "/").concat(value) : "/".concat(pluginPath, "/").concat(pagePath, "/").concat(itemId));
    },
    pageKey: pageKey,
    page: _pages[pageKey],
    panels: panels,
    Template: Template,
    AuthenticatedRoute: AuthenticatedRoute
  }));
  var template = /*#__PURE__*/React.createElement(Template, {
    appBar: /*#__PURE__*/React.createElement(PageBar, null),
    pageContent: itemComponent
  });
  if (!ItemProvider) {
    console.log("Provider not defined: ".concat(capitalize(pageKey), "ItemProvider"));
  }
  return ItemProvider ? /*#__PURE__*/React.createElement(ItemProvider, {
    itemId: itemId
  }, template) : template;
};
var TopPanelConnector = function TopPanelConnector(_ref23) {
  var pagePath = _ref23.pagePath,
    pageKey = _ref23.pageKey,
    topPanels = _ref23.topPanels,
    Template = _ref23.Template;
  var _useParams3 = useParams(),
    topPanelKey = _useParams3.topPanelKey;
  var _useLocation5 = useLocation();
    _useLocation5.pathname;
    _useLocation5.search;
  var navigate = useNavigate();
  var Header = _pages[pageKey]["".concat(capitalize(pageKey), "Header")];
  var panels = Object.fromEntries(Object.entries(topPanels).filter(function (_ref24) {
    var _ref25 = _slicedToArray(_ref24, 2);
      _ref25[0];
      var item = _ref25[1];
    return !(item !== null && item !== void 0 && item.mode) || (item === null || item === void 0 ? void 0 : item.mode) === mode;
  }));
  var itemComponent = /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      overflow: 'hidden',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      backgroundColor: '#fff'
    }
  }, Header && /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      marginLeft: '8px',
      marginRight: '8px'
    }
  }, /*#__PURE__*/React.createElement(Header, null)), /*#__PURE__*/React.createElement(PageTabs, {
    fixed: false,
    value: topPanelKey,
    onChange: function onChange(event, newValue) {
      navigate("/plugin/exchange/".concat(pagePath, "/").concat(newValue));
    },
    pageKey: pageKey,
    page: _pages[pageKey],
    panels: panels
  }), /*#__PURE__*/React.createElement(PagePanels, {
    fixed: false,
    value: topPanelKey,
    pageKey: pageKey,
    page: _pages[pageKey],
    panels: panels
  }));
  var PageProvider = _pages[pageKey]["".concat(capitalize(pageKey), "PageProvider")];
  var template = /*#__PURE__*/React.createElement(Template, {
    appBar: function (_) {
      var Bar = _pages[pageKey]["".concat(capitalize(pageKey), "AppBar")];
      return Bar ? /*#__PURE__*/React.createElement(Bar, null) : undefined;
    }(),
    pageContent: itemComponent
  });
  if (!PageProvider) {
    console.log("Provider not defined: ".concat(capitalize(pageKey), "PageProvider"));
  }
  return PageProvider ? /*#__PURE__*/React.createElement(PageProvider, null, template) : template;
};

var Context = /*#__PURE__*/createContext(null);
var DARK_MODE_DEFAULT = false;
var LIST_VIEW_DEFAULT = false;
var Provider = function Provider(_ref) {
  var children = _ref.children;
  var _useState = useState(DARK_MODE_DEFAULT),
    _useState2 = _slicedToArray(_useState, 2),
    isDarkMode = _useState2[0],
    setDarkMode = _useState2[1];
  var _useState3 = useState(LIST_VIEW_DEFAULT),
    _useState4 = _slicedToArray(_useState3, 2),
    isListView = _useState4[0],
    setListView = _useState4[1];
  var settingsValue = {
    isDarkMode: isDarkMode,
    isListView: isListView,
    toggleDarkMode: function toggleDarkMode() {
      return (
        /*{
        console.log("toggleDarkMode");
        */
        setDarkMode(!isDarkMode) /*;
                                 }*/
      );
    },

    toggleView: function toggleView() {
      return setListView(!isListView);
    }
  };
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: settingsValue
  }, children);
};
var Consumer = Context.Consumer;
var UISettingsStore = {
  Provider: Provider,
  Consumer: Consumer,
  Context: Context
};

// import Fonts from "./assets/fonts";

var fontFamilyRoboto = {
  fontFamily: ["Roboto", "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
};
var fontFamilyMetropolis = {
  fontFamily: ["Metropolis", "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
  letterSpacing: "0.015rem"
};

// A custom theme for this app
var lightMuiTheme = createTheme(adaptV4Theme({
  type: "light",
  breakpoints: {
    values: {
      xs: 0,
      sm400: 400,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    primary: {
      main: "#FFF"
    },
    secondary: {
      main: blue[500],
      light: blue[50],
      //"#feefc3",
      '&$selected': {
        backgroundColor: 'blue[500]'
      }
    },
    state_ready: {
      main: 'red'
    },
    state_set: {
      main: 'orange'
    },
    state_go: {
      main: 'green'
    },
    /*info: {
      main: grey[700]
    },*/
    error: {
      main: red.A400
    },
    warning: {
      main: '#c77802' //'#ff9800'
    },

    background: {
      default: "#FFF",
      highlight: "#F1F3F4"
    },
    text: {
      disabled: "rgba(0, 0, 0, 0.26)",
      //"#222222",
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)"
      //'&$selected': blue[500]
    }
  },

  typography: _objectSpread2(_objectSpread2({}, fontFamilyRoboto), {}, {
    overline: {
      fontWeight: 500,
      fontSize: "0.7rem"
    },
    button: {
      textTransform: 'uppercase'
    }
  }),
  shape: {
    borderRadius: "0.5rem"
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100
  },
  mixins: {
    drawer: {
      minWidth: 200
    },
    tabs: {
      backgroundColor: "#FFF"
    }
  },
  overrides: {
    /*MuiCssBaseline: {
      "@global": {
        "@font-face": [
          Fonts.MetropolisRegular,
          Fonts.MetropolisBold,
          Fonts.RobotoRegular,
          Fonts.RobotoMedium,
          Fonts.RobotoBold
        ]
      }
    },*/
    MuiListItemText: {
      primary: _objectSpread2(_objectSpread2({}, fontFamilyMetropolis), {}, {
        fontWeight: 500,
        fontSize: "0.87rem"
      })
    }
  },
  custom: {
    fontFamily: {
      roboto: fontFamilyRoboto,
      metropolis: fontFamilyMetropolis
    },
    palette: {
      iconColor: "#5f6368",
      itemBorderColor: "#DDDDDD",
      iconHighlight: grey[900],
      notesCheckbox: grey[700],
      profilePopColor: "#FFF",
      noteBackground: {
        default: "#0000",
        red: "#F28B82",
        orange: "#FBBC04",
        yellow: "#FFF475",
        green: "#CCFF90",
        cyan: "#A7FFEB",
        lightblue: "#CBF0F8",
        darkblue: "#AECBFA",
        purple: "#D7AEFB",
        pink: "#FDCFE8",
        brown: "#E6C9A8",
        grey: "#E8EAED"
      },
      noteColorCheck: "#0007",
      labelBackground: "#0002"
    }
  }
}));
var darkMuiTheme = createTheme(adaptV4Theme({
  type: "dark",
  palette: {
    primary: {
      main: "#202124",
      backgroundColor: "#202124 !important"
    },
    secondary: {
      main: blue[500],
      light: "#41331C"
    },
    selected: {},
    error: {
      main: red.A400
    },
    background: {
      default: "#202124",
      highlight: "#535456"
      //selected: "#535456"
    },

    /*
    text: {
      primary: "red",
      secondary: "blue"
    }
    */
    text: {
      disabled: "#eee",
      primary: "#E8EAED",
      secondary: "#FFFFFFDE"
    }
    /*
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
    }*/
  },

  typography: _objectSpread2(_objectSpread2({}, fontFamilyRoboto), {}, {
    overline: {
      fontWeight: 500,
      fontSize: "0.7rem"
    }
  }),
  shape: {
    borderRadius: "0.5rem"
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100
  },
  mixins: {
    drawer: {
      minWidth: 280
    },
    tabs: {
      text: {
        primary: "#E8EAED",
        secondary: "#FFFFFFDE"
      }
    }
  },
  overrides: {
    /*
    MuiCssBaseline: {
      "@global": {
        "@font-face": [
          Fonts.MetropolisRegular,
          Fonts.MetropolisBold,
          Fonts.RobotoRegular,
          Fonts.RobotoMedium,
          Fonts.RobotoBold
        ]
      }
    },
    */
    MuiListItemText: {
      primary: _objectSpread2(_objectSpread2({}, fontFamilyMetropolis), {}, {
        fontWeight: 500,
        fontSize: "0.87rem"
      })
    }
  },
  custom: {
    fontFamily: {
      roboto: fontFamilyRoboto,
      metropolis: fontFamilyMetropolis
    },
    palette: {
      iconColor: "#949596",
      itemBorderColor: "#5F6368",
      iconHighlight: "#888A8B",
      notesCheckbox: "#5F6368",
      profilePopColor: "#2D2E30",
      noteBackground: {
        default: "#0000",
        red: "#5C2B29",
        orange: "#614A19",
        yellow: "#635D18",
        green: "#345920",
        cyan: "#16504B",
        lightblue: "#2D555E",
        darkblue: "#1E3A5F",
        purple: "#42275E",
        pink: "#5B2245",
        brown: "#442F19",
        grey: "#3C3F43"
      },
      noteColorCheck: "#FFF7",
      labelBackground: "#0002"
    }
  }
}));
var light = responsiveFontSizes(lightMuiTheme);
var dark = responsiveFontSizes(darkMuiTheme);

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var PersonalisedComponent = (function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(PersonalisedComponent$1, {
    children: children
  });
});
function PersonalisedComponent$1(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(ThemeControlledComponent, {
    children: children
  });
  /*
  return (
    <UISettingsStore.Provider>
      <ThemeControlledComponent children={children} />
    </UISettingsStore.Provider>
  );*/
}

function ThemeControlledComponent(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(UISettingsStore.Consumer, null, function (_ref4) {
    var isDarkMode = _ref4.isDarkMode;
    return /*#__PURE__*/React.createElement(StyledEngineProvider, {
      injectFirst: true
    }, /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: isDarkMode ? dark : light
    }, /*#__PURE__*/React.createElement(CssBaseline, null), children));
  });
}

var PREFIX$1 = 'BottomNavigation';
var classes$1 = {
  root: "".concat(PREFIX$1, "-root"),
  selected: "".concat(PREFIX$1, "-selected")
};
styled(BottomNavigation)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(classes$1.root), {
    color: theme.palette.text,
    "&$selected": {
      color: theme.palette.secondary.main
    }
  }), _defineProperty(_ref2, "& .".concat(classes$1.selected), {}), _ref2;
});

var featureView = {
  //path: `${path}/features/:featureId`,
  // https://spoketree.au/plugin/exchange/features/f_FFFFFFF
  panels: {
    properties: {
      //mode: "edit",
      access: 'l_protected',
      /*deny: ({ isAuthenticated, selectedFeature }) => (
        !isAuthenticated || 
        !(
          selectedFeature?.isEditable() ||
          selectedFeature?.isViewable()
        )
      ),*/
      deny: function deny(_ref) {
        var isAuthenticated = _ref.isAuthenticated,
          selectedFeature = _ref.selectedFeature;
        return !isAuthenticated || !(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isEditable() || selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isViewable());
      },
      tab: {
        icon: /*#__PURE__*/React.createElement(FeatureIcon, null),
        title: "Exchange"
      }
    },
    /*
    solutions: {
    deny: ({ isAuthenticated, selectedFeature }) => !isAuthenticated || !(selectedFeature?.isEditable() || selectedFeature?.isViewable()),
    access: 'l_protected',
    tab: {
      icon: <SolutionIcon />,
      title: 'Solutions'
    }
    },*/
    scenarios: {
      deny: function deny(_ref2) {
        var isAuthenticated = _ref2.isAuthenticated,
          selectedFeature = _ref2.selectedFeature;
        return !isAuthenticated || !(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isEditable() || selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isViewable());
      },
      access: 'l_protected',
      tab: {
        icon: /*#__PURE__*/React.createElement(ScenariosIcon, null),
        title: 'Scenarios'
      }
    },
    reports: {
      //expanded: true,
      /*deny: ({ isAuthenticated, selectedFeature }) => (
        !isAuthenticated || 
        !(
          selectedFeature?.isEditable() ||
          selectedFeature?.isViewable()
        )
      ),*/
      deny: function deny(_ref3) {
        var isAuthenticated = _ref3.isAuthenticated,
          selectedFeature = _ref3.selectedFeature;
        return !isAuthenticated || !(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isEditable() /* || selectedFeature?.isViewable()*/);
      },
      access: 'l_protected',
      tab: {
        icon: /*#__PURE__*/React.createElement(ReportsIcon, null),
        title: 'Reports'
      }
    },
    extensions: {
      deny: function deny(_ref4) {
        var isAuthenticated = _ref4.isAuthenticated,
          selectedFeature = _ref4.selectedFeature;
        return !isAuthenticated || !(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isEditable() /* || selectedFeature?.isViewable()*/);
      },
      access: 'l_protected',
      tab: {
        icon: /*#__PURE__*/React.createElement(ExtensionsIcon, null),
        title: 'Extensions'
      }
    },
    sharing: {
      deny: function deny(_ref5) {
        var isAuthenticated = _ref5.isAuthenticated,
          selectedFeature = _ref5.selectedFeature;
        return !isAuthenticated || !(selectedFeature !== null && selectedFeature !== void 0 && selectedFeature.isEditable() /* || selectedFeature?.isViewable()*/);
      },
      access: 'l_protected',
      tab: {
        icon: /*#__PURE__*/React.createElement(SharingIcon, null),
        title: 'Sharing'
      }
    }
  }
};
var plugin = {
  pages: function pages(_ref6) {
    var _host, _host2;
    _ref6.path;
      _ref6.principalParty;
      _ref6.selectedFeature;
    return _objectSpread2(_objectSpread2(_objectSpread2({}, ((_host = host()) === null || _host === void 0 ? void 0 : _host.isMultiTenantName) && {
      features: {
        tab: {
          icon: /*#__PURE__*/React.createElement(FeatureIcon, null),
          title: "Exchanges"
        },
        //path: `${path}/features`,
        collection: {
          item: featureView
        }
      }
    }), ((_host2 = host()) === null || _host2 === void 0 ? void 0 : _host2.isSingleTenantName) && {
      feature: _objectSpread2({
        tab: {
          icon: /*#__PURE__*/React.createElement(FeatureIcon, null),
          title: "Exchange"
        }
      }, featureView)
    }), {}, _defineProperty({
      /*
      capabilities: {
      tab: {
       icon: <CapabilityIcon />,
       title: "Capabilities"
      },
      target: '/plugin/capability/capabilities'
      },*/
      community: {
        tab: {
          icon: /*#__PURE__*/React.createElement(PersonIcon, null),
          title: "Profile"
        },
        target: '/plugin/community/user/about'
      },
      'terms_of_service': {}
    }, "terms_of_service", {}));
  }
};

var PREFIX = 'PluginComponent';
var classes = {
  content: "".concat(PREFIX, "-content"),
  contentShift: "".concat(PREFIX, "-contentShift")
};
var StyledPersonalisedComponent = styled(PersonalisedComponent)(function (_ref) {
  var _$concat, _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes.content), (_$concat = {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    /*TAG:NAV*/marginLeft: '164px'
  }, _defineProperty(_$concat, theme.breakpoints.down('md'), {
    marginLeft: '164px' //theme.spacing(2.5),
  }), _defineProperty(_$concat, "marginTop", '48px'), _defineProperty(_$concat, "marginBottom", '48px'), _$concat)), _defineProperty(_ref2, "& .".concat(classes.contentShift), {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    //marginLeft: theme.spacing(2.5),
    //marginRight: theme.spacing(2.5),
    marginTop: '48px',
    //36 + theme.spacing(2.5),
    marginBottom: '64px' //36 + theme.spacing(2.5)
  }), _ref2;
});

/*
class PluginComponent extends React.Component {
  render({ }) {
*/
var PluginComponent = function PluginComponent(_ref3) {
  var AuthenticatedRoute = _ref3.AuthenticatedRoute,
    UnauthenticatedRoute = _ref3.UnauthenticatedRoute,
    AuthPage = _ref3.AuthPage;
  var theme = useTheme$1();
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return /*#__PURE__*/React.createElement(StyledPersonalisedComponent, null, /*#__PURE__*/React.createElement(SpoketreeSolutionStore.Consumer, null, function (solution) {
    return /*#__PURE__*/React.createElement(UISessionStore.Consumer, null, function (_ref4) {
      var isNavBarOpen = _ref4.isNavBarOpen;
      return /*#__PURE__*/React.createElement(PluginOptionsStore.Consumer, null, function (options) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CreateFeatureStore.Provider, null, /*#__PURE__*/React.createElement(PluginRoutes, {
          plugin: plugin,
          AuthenticatedRoute: AuthenticatedRoute,
          UnauthenticatedRoute: UnauthenticatedRoute,
          AuthPage: AuthPage,
          Template: function Template(_ref5) {
            var appBar = _ref5.appBar,
              pageContent = _ref5.pageContent;
            return /*#__PURE__*/React.createElement(React.Fragment, null, appBar ? appBar : /*#__PURE__*/React.createElement(SpoketreeAppBar, null), /*!isMobile && */isNavBarOpen && /*#__PURE__*/React.createElement(SpoketreeNavigationDrawer, {
              plugin: plugin
            }), /*#__PURE__*/React.createElement("div", {
              style: {
                marginTop: '48px',
                //marginBottom: (isMobile ? '56px' : '8px'),
                marginBottom: '8px',
                marginLeft: !isMobile && isNavBarOpen ? '164px' : '0px'
              }
              /*className={isMobile || !isNavBarOpen ? classes.contentShift : classes.content}*/
            }, /*#__PURE__*/React.createElement("main", null, pageContent)), false   );
          }
        })));
      });
    });
  }));
};

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var subsystemSolution = {
  subsystem: {
    title: 'Spoketree Exchange'
  }
};

var index = {
  makePlugin: function makePlugin(_ref) {
    var path = _ref.path,
      auth = _ref.auth,
      solution = _ref.solution,
      options = _ref.options;
    console.log('spoketree-plugin-ui-exchange: makePlugin: env');
    console.log('REACT_APP_STAGE', process.env.REACT_APP_STAGE);
    return plugin$1.makePlugin({
      path: path,
      auth: auth,
      SpoketreeAuthStore: SpoketreeAuthStore,
      solution: _objectSpread2(_objectSpread2({}, solution), subsystemSolution),
      SpoketreeSolutionStore: SpoketreeSolutionStore,
      options: options,
      PluginOptionsStore: PluginOptionsStore,
      pluginModelStores: {
        public: [
          //CreateShopStore
        ],
        protected: [UISessionStore, UISettingsStore, PrincipalPartyStore, CapabilitiesStore, FeaturesStore]
      },
      PluginComponent: PluginComponent
    });
  }
};

export { index as default };
